/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A base 64 encoded file, transported as a string */
  Base64: { input: string; output: string; }
  /** Represents a monetary value in cents of USD. Transported as an int (e.g., 1000 for $10.00). */
  Cents: { input: import("@betterment/core").Money; output: import("@betterment/core").Money; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string.
   */
  Date: { input: string; output: Date; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC and any UTC offset other than 0 will be rejected.
   */
  DateTime: { input: Date; output: Date; }
  /** Represents HTML rendered content. Transported as a String. E.g.: "<b>Hello</b> world". */
  HTML: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * The unencoded legacy system identifier for a record. This provides for client-side backwards compatibility
   * when passing ID values from GraphQL contexts to REST-backed contexts. See: Description for `scalar ID`.
   */
  LegacyID: { input: number; output: number; }
  /**
   * The unencoded legacy system identifier for a record, when it exists as a string. This provides for client-side backwards
   * compatibility when passing string-based ID values from GraphQL contexts to
   * REST-backed contexts. See: Description for `scalar ID`.
   */
  LegacyUUID: { input: string; output: string; }
  /**
   * A location for a message. See https://github.com/Betterment/retail/blob/main/retail/app/graphql/types/message_location.rb
   * for a full list of supported locations.
   */
  MessageLocation: { input: any; output: any; }
  /** Represents a percent value. Transported as a Float. Ex: 50 represents 50%, and 0.5 represents 0.5%. */
  Percent: { input: number; output: number; }
  /** A Tax Identification Number */
  TIN: { input: string; output: string; }
  /** Represents a url. Transported as a String. E.g.: "https://example.com/some/where". */
  URL: { input: string; output: string; }
};

/** Autogenerated input type of AcceptAdvisoryRelationshipApprovalRequestMutation */
export type AcceptAdvisoryRelationshipApprovalRequestMutationInput = {
  /** Token for the ADV Part 2B agreement the user is signing */
  advPart2bAgreementToken?: InputMaybe<Scalars['String']['input']>;
  /** Token for the Betterment Advisor Network agreement the user is signing */
  advisorNetworkAgreementToken?: InputMaybe<Scalars['String']['input']>;
  /** ID of the approval request to accept */
  approvalRequestId: Scalars['ID']['input'];
  /** Token for the firm client agreement the user is signing */
  clientAgreementToken?: InputMaybe<Scalars['String']['input']>;
  /** Source of the approval request invitation (BETTERMENT_ADVISOR_NETWORK or STANDARD) */
  clientEnvelopeApprovalRequestSource: ClientEnvelopeApprovalRequestSource;
};

/** Autogenerated return type of AcceptAdvisoryRelationshipApprovalRequestMutation. */
export type AcceptAdvisoryRelationshipApprovalRequestMutationPayload = {
  __typename: 'AcceptAdvisoryRelationshipApprovalRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve AcceptAdvisoryRelationshipApprovalRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * AcceptAdvisoryRelationshipApprovalRequestMutation execution as type
   * AcceptAdvisoryRelationshipApprovalRequestMutationResult.
   */
  result?: Maybe<AcceptAdvisoryRelationshipApprovalRequestMutationResult>;
};

/** Advisory relationship acceptance result */
export type AcceptAdvisoryRelationshipApprovalRequestMutationResult = {
  __typename: 'AcceptAdvisoryRelationshipApprovalRequestMutationResult';
  /** Full name of the advisor */
  advisorName: Scalars['String']['output'];
  /** Whether all household members have accepted their advisor agreements */
  householdEnrolled: Scalars['Boolean']['output'];
};

/** Represent an option for account ownership during product onboarding */
export type AccountOwnershipOption = {
  /** The description of the option */
  description: Scalars['String']['output'];
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The ownership type of the option */
  ownershipType: LegalAccountOwnershipType;
};

/** Represent an option for account purpose during product onboarding */
export type AccountPurposeOption = {
  /** The default name of the account purpose option */
  defaultName: Scalars['String']['output'];
  /** The themed asset set for the icon used to represent this account purpose option. */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the concrete account purpose option type */
  name: Scalars['String']['output'];
};

/** A recommendation for what kind of account to open next. */
export type AccountRecommendation = {
  __typename: 'AccountRecommendation';
  /** Unique identifier for this recommendation */
  id: Scalars['ID']['output'];
  /** Whether this recommendation can be skipped to see alternatives */
  isSkipEligible: Scalars['Boolean']['output'];
  /** Disclosure HTML shown for this recommendation option. */
  optionDisclosure?: Maybe<Scalars['HTML']['output']>;
  /** The onboarding option for the account recommended. */
  productOnboardingOption: CheckingAccountCreationOption | FinancialCoachingOnboardingOption | FiveTwoNineGoalCreationOption | GoalCreationOption | PremiumOnboardingOption | Solo401kOnboardingOption;
};

/** Represents the user's ability to receive an account recommendation with extra LLM-generated explanations. */
export type AccountRecommendationOption = {
  __typename: 'AccountRecommendationOption';
  /** Disclosure HTML shown after the AI-generated explanation. */
  postExplanationDisclosure: Scalars['HTML']['output'];
  /** Disclosure HTML shown before the AI-generated explanation. */
  preExplanationDisclosure: Scalars['HTML']['output'];
  /** Calculate an account recommendation, optionally skipping a previous recommendation. */
  recommendation: AccountRecommendation;
};


/** Represents the user's ability to receive an account recommendation with extra LLM-generated explanations. */
export type AccountRecommendationOptionRecommendationArgs = {
  skippedRecommendation?: InputMaybe<Scalars['ID']['input']>;
};

/** Represent an option for account taxation type during product onboarding */
export type AccountTaxationOption = {
  __typename: 'AccountTaxationOption';
  /** The description of the option */
  description: Scalars['String']['output'];
  /** The ID for account taxation option */
  id: Scalars['ID']['output'];
  /** Availability of this option */
  isAvailable: Scalars['Boolean']['output'];
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The taxation type of the option */
  taxationType: LegalAccountTaxationType;
};

/** A user reward in its active period. */
export type ActiveReward = {
  __typename: 'ActiveReward';
  /** Long form description of the reward. */
  detailedDescription: Scalars['HTML']['output'];
  /** Legal disclosure copy. */
  disclosureDescription: Scalars['HTML']['output'];
  /** Description of the type of action that fulfillment requires. */
  fulfillmentConditionDescription: Scalars['String']['output'];
  /** Description of the type of reward. */
  fulfillmentRewardDescription: Scalars['String']['output'];
  /** The identifier for this reward. */
  id: Scalars['ID']['output'];
  /** Indicates if the reward is complete. */
  isCompleted: Scalars['Boolean']['output'];
  /** Message for the reward. */
  message?: Maybe<Message>;
  /** Name for this reward. */
  name: Scalars['String']['output'];
  /** Describes what will happen next for a given reward. */
  periodEndDescription?: Maybe<Scalars['String']['output']>;
  /** The date window during which the reward starts and ends. */
  promotionWindow: DateRange;
  /** Composition description associated to the name of the reward. */
  rewardCompositionDescription?: Maybe<Scalars['String']['output']>;
  /** Describes additional information about the state of the reward, for example if the reward is projected or is maxed out */
  rewardContextDescription?: Maybe<Scalars['String']['output']>;
  /** A collection of values and their descriptions pertaining to the reward. */
  rewardProgressStatuses: Array<RewardProgressStatus>;
  /** Describes what the value of the reward is e.g. '$50.00', '2% match', or '$5,000 managed free'. */
  rewardValueDescription: Scalars['String']['output'];
  /** Short form description of the reward. */
  shortDescription: Scalars['String']['output'];
  /** Link to full page of terms, conditions, and other relavant public info. */
  termsUrl: Scalars['URL']['output'];
  /** Collection of tiers for this reward. */
  tiers: Array<RewardTier>;
};

/** An option for selecting a date range for activity */
export type ActivityDateRangeOption = {
  __typename: 'ActivityDateRangeOption';
  /** The end date of the date range, inclusive. Can be null for the custom option. */
  endDateInclusive?: Maybe<Scalars['Date']['output']>;
  /** The display name of the date range option. */
  name: Scalars['String']['output'];
  /** The start date of the date range, inclusive. Can be null for the custom option. */
  startDateInclusive?: Maybe<Scalars['Date']['output']>;
};

/** The inputs used to filter transactional activity. */
export type ActivityFilterInput = {
  /** The account ids selected for which to filter. */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The selected activity item types by which to filter. */
  activityTypes?: InputMaybe<Array<ActivityItemTypeFilterOption>>;
  /** The end date for the date range. */
  endDateInclusive?: InputMaybe<Scalars['Date']['input']>;
  /** The start date for the date range. */
  startDateInclusive?: InputMaybe<Scalars['Date']['input']>;
};

/** An item of financial activity. */
export type ActivityItem = {
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** An activity item representing a change in a user's portfolio or its allocation */
export type ActivityItemAllocationChange = ActivityItem & {
  __typename: 'ActivityItemAllocationChange';
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** A description of the new allocation. */
  newPortfolioDescription: Scalars['String']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The connection type for ActivityItem. */
export type ActivityItemConnection = {
  __typename: 'ActivityItemConnection';
  /** A list of edges. */
  edges: Array<ActivityItemEdge>;
  /** A list of nodes. */
  nodes: Array<ActivityItemAllocationChange | ActivityItemDeposit | ActivityItemDividendGroup | ActivityItemFee | ActivityItemOrder | ActivityItemOther | ActivityItemRollover | ActivityItemTradeGroup | ActivityItemTransferGroup | ActivityItemWithdrawal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An activity item representing a deposit (money inflow) */
export type ActivityItemDeposit = ActivityItem & {
  __typename: 'ActivityItemDeposit';
  /** The amount of the activity item. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The ID of the deposit request */
  depositRequestId?: Maybe<Scalars['ID']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The sub account to which the deposit was made. */
  destinationAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** Indicates if the deposit can be canceled. */
  isCancelable: Scalars['Boolean']['output'];
  /**
   * The transaction memo, if any.
   * @deprecated Use transactionMemo field instead.
   */
  memo?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the deposit was returned */
  returned: Scalars['Boolean']['output'];
  /** The bank account from which the deposit was made. */
  sourceAccount?: Maybe<BankAccount>;
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The transaction memo, if any. */
  transactionMemo?: Maybe<ActivityTransactionMemo>;
};

/** An activity item representing an individual dividend */
export type ActivityItemDividend = {
  __typename: 'ActivityItemDividend';
  /** The amount of the dividend. */
  amount: Scalars['Cents']['output'];
  /** The security associated with the dividend. */
  security: SecurityFund | SecurityStock;
};

/** An activity item representing all dividends for a given date and account */
export type ActivityItemDividendGroup = ActivityItem & {
  __typename: 'ActivityItemDividendGroup';
  /** The amount of the dividend. */
  amount: Scalars['Cents']['output'];
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The individual dividends associated with the grouped dividend item. */
  dividends: Array<ActivityItemDividend>;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** An edge in a connection for activity items */
export type ActivityItemEdge = {
  __typename: 'ActivityItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ActivityItemAllocationChange | ActivityItemDeposit | ActivityItemDividendGroup | ActivityItemFee | ActivityItemOrder | ActivityItemOther | ActivityItemRollover | ActivityItemTradeGroup | ActivityItemTransferGroup | ActivityItemWithdrawal;
};

/** An activity item representing a fee */
export type ActivityItemFee = ActivityItem & {
  __typename: 'ActivityItemFee';
  /** The amount of the activity item. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** Reason for an on-demand advisory fee */
  feeReason?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** Input for identifying activity items by ID */
export type ActivityItemIdInput =
  /** The ID of a financial security order */
  { financialSecurityOrderId: Scalars['ID']['input']; };

/** The details of the order and resulting trading activity item */
export type ActivityItemOrder = ActivityItem & {
  __typename: 'ActivityItemOrder';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl?: Maybe<Scalars['URL']['output']>;
  /** The amount the order was submitted for */
  amountRequested?: Maybe<Scalars['Cents']['output']>;
  /** The actual amount that was traded. */
  amountTraded?: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The ID of the financial security order */
  financialSecurityOrderId?: Maybe<Scalars['ID']['output']>;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** Indicates if the order can be canceled. */
  isCancelable: Scalars['Boolean']['output'];
  /** The security that was bought or sold */
  security: SecurityFund | SecurityStock;
  /** The price per share for the order, if the order is complete */
  sharePrice?: Maybe<Scalars['Cents']['output']>;
  /** The number of shares the order was submitted for */
  sharesRequested?: Maybe<Scalars['String']['output']>;
  /** The actual number of shares that were traded. */
  sharesTraded?: Maybe<Scalars['String']['output']>;
  /**
   * The status of the order
   * @deprecated Use the statuses field instead.
   */
  status: ActivityItemStatus;
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The trade side for activity item trade (e.g. BUY or SELL) */
  tradeSide: ActivityItemTradeSide;
};

/** A default type for an activity item */
export type ActivityItemOther = ActivityItem & {
  __typename: 'ActivityItemOther';
  /** The amount of the activity item. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** An activity item representing a rollover into or out of betterment */
export type ActivityItemRollover = ActivityItem & {
  __typename: 'ActivityItemRollover';
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The stage of an activity item */
export enum ActivityItemStage {
  /** The activity item is in canceled status. */
  Canceled = 'CANCELED',
  /** The activity item is in completed status. */
  Completed = 'COMPLETED',
  /** The activity item is in failed status. */
  Failed = 'FAILED',
  /** The activity item is in initiated status. */
  Initiated = 'INITIATED',
  /** The activity item is in returned status. */
  Returned = 'RETURNED',
  /** The activity item is in sent status. */
  Sent = 'SENT'
}

/** The status of an activity item */
export type ActivityItemStatus = {
  __typename: 'ActivityItemStatus';
  /** A description of the status */
  description?: Maybe<Scalars['String']['output']>;
  /** The message displayed with the status of the activity item */
  message?: Maybe<Scalars['String']['output']>;
  /** The stage of the activity item */
  stage: ActivityItemStage;
  /** The time the status was set */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

/** The details of the trade activity item */
export type ActivityItemTrade = {
  __typename: 'ActivityItemTrade';
  /** The cents amount for the buy or sell trade */
  amount: Scalars['Cents']['output'];
  /** The security that was bought or sold */
  security: SecurityFund | SecurityStock;
  /** The price per share of the asset at the time of the trade */
  sharePrice: Scalars['Cents']['output'];
  /** The number of shares bought or sold */
  shares: Scalars['String']['output'];
  /**
   * The reason for the trade i.e. rebalance or tlh
   * @deprecated No longer supported. Use trade_attribution_v_2 instead
   */
  tradeAttribution?: Maybe<Scalars['String']['output']>;
  /** The reason for the trade, if there is one. Either a rebalance or tax loss harvesting or null. */
  tradeAttributionV2?: Maybe<ActivityItemTradeAttribution>;
  /** The trade side for activity item trade (e.g. BUY or SELL) */
  tradeSide: ActivityItemTradeSide;
};

/** The reason for the trade, if there is one. Either a rebalance or tax loss harvesting or null. */
export enum ActivityItemTradeAttribution {
  /** The attribution type for rebalance. */
  Rebalance = 'REBALANCE',
  /** The attribution type for tax_loss_harvest. */
  TaxLossHarvest = 'TAX_LOSS_HARVEST'
}

/** An activity item representing a Trade (transfer of assets) */
export type ActivityItemTradeGroup = ActivityItem & {
  __typename: 'ActivityItemTradeGroup';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl?: Maybe<Scalars['URL']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** The details for purchases associated with the trade(s) */
  purchases: Array<ActivityItemTrade>;
  /** The total amount of the purchases associated with the trade(s) */
  purchasesAmount: Scalars['Cents']['output'];
  /** The details for sales associated with the trade(s) */
  sales: Array<ActivityItemTrade>;
  /** The total amount of the sales associated with the trade(s) */
  salesAmount: Scalars['Cents']['output'];
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The trade side for activity item trade (e.g. BUY or SELL) */
export enum ActivityItemTradeSide {
  /** The buy side of a trade. */
  Buy = 'BUY',
  /** The sell side of a trade. */
  Sell = 'SELL'
}

/** The details of the trade activity item */
export type ActivityItemTransfer = {
  __typename: 'ActivityItemTransfer';
  /** The cents amount for individual transfer item */
  amount: Scalars['Cents']['output'];
  /**
   * The type of asset transferred (i.e. cash or security)
   * @deprecated No longer supported. Use asset_type_v_2 instead
   */
  assetType: Scalars['String']['output'];
  /** The type of asset transferred (i.e. cash or security) */
  assetTypeV2: ActivityItemTransferAssetType;
  /** The account to which the asset was transferred */
  destinationAccount?: Maybe<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /** The requested dollar amount for the transfer */
  requestedDollarTransferAmount?: Maybe<Scalars['Cents']['output']>;
  /** The security that was transferred */
  security?: Maybe<SecurityFund | SecurityStock>;
  /** The price per share of the asset at the time of the trade */
  sharePrice?: Maybe<Scalars['Cents']['output']>;
  /** The number of shares transferred */
  shares?: Maybe<Scalars['String']['output']>;
  /** The account from which the asset was transferred */
  sourceAccount?: Maybe<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /** The ID of the transfer request */
  transferRequestId?: Maybe<Scalars['ID']['output']>;
};

/** The asset type for activity item transfer (e.g. CASH or SECURITY) */
export enum ActivityItemTransferAssetType {
  /** The transfer is a cash type. */
  Cash = 'CASH',
  /** The transfer is a security type. */
  Security = 'SECURITY'
}

/** An activity item representing a transfer (money inflow) */
export type ActivityItemTransferGroup = ActivityItem & {
  __typename: 'ActivityItemTransferGroup';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl?: Maybe<Scalars['URL']['output']>;
  /** The amount of the activity item. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The sub account to which the transfer was made. */
  destinationAccount?: Maybe<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** Indicates if the transfer can be canceled. */
  isCancelable: Scalars['Boolean']['output'];
  /** Indicates if the transfer is a full transfer. */
  isFullTransfer: Scalars['Boolean']['output'];
  /** The sub account from which the transfer was made. */
  sourceAccount?: Maybe<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The individual transfers associated with the grouped transfer item. */
  transferItems: Array<ActivityItemTransfer>;
};

/** The transaction types by which the user can filter their activity. */
export enum ActivityItemTypeFilterOption {
  /** the type for allocation changes */
  AllocationChange = 'ALLOCATION_CHANGE',
  /** The type for deposits */
  Deposit = 'DEPOSIT',
  /** the type for dividend payments */
  DividendPayment = 'DIVIDEND_PAYMENT',
  /** The type for fees */
  Fees = 'FEES',
  /** the type for interest payments */
  InterestPayment = 'INTEREST_PAYMENT',
  /** The type for all unmapped activity */
  Other = 'OTHER',
  /** the type for trades due to rebalancing */
  Rebalance = 'REBALANCE',
  /** the type for trades due to tax loss harvesting */
  TaxLossHarvest = 'TAX_LOSS_HARVEST',
  /** The type for trading */
  Trade = 'TRADE',
  /** The type for transfers */
  Transfer = 'TRANSFER',
  /** The type for withdrawals */
  Withdrawal = 'WITHDRAWAL'
}

/** The transaction types by which the user can filter their activity. */
export enum ActivityItemTypeFilterOptionV2 {
  /** the type for allocation changes */
  AllocationChange = 'ALLOCATION_CHANGE',
  /** The type for deposits */
  Deposit = 'DEPOSIT',
  /** the type for dividend payments */
  DividendPayment = 'DIVIDEND_PAYMENT',
  /** The type for fees */
  Fees = 'FEES',
  /** the type for interest payments */
  InterestPayment = 'INTEREST_PAYMENT',
  /** The type for all unmapped activity */
  Other = 'OTHER',
  /** the type for trades due to rebalancing */
  Rebalance = 'REBALANCE',
  /** the type for trades due to tax loss harvesting */
  TaxLossHarvest = 'TAX_LOSS_HARVEST',
  /** The type for trading */
  Trade = 'TRADE',
  /** The type for transfers */
  Transfer = 'TRANSFER',
  /** The type for withdrawals */
  Withdrawal = 'WITHDRAWAL'
}

/** An activity item representing a withdrawal (money outflow) */
export type ActivityItemWithdrawal = ActivityItem & {
  __typename: 'ActivityItemWithdrawal';
  /** The amount of the activity item. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The bank account to which the withdrawal was made. */
  destinationAccount?: Maybe<BankAccount>;
  /**
   * The id of the item.
   * @deprecated There is no canonical identifier for activity items. To be removed once clients are not querying for them.
   */
  id: Scalars['ID']['output'];
  /** Indicates if the withdrawal can be canceled. */
  isCancelable: Scalars['Boolean']['output'];
  /** Indicates whether the withdrawal is a full withdrawal */
  isFullWithdrawal: Scalars['Boolean']['output'];
  /**
   * The transaction memo, if any.
   * @deprecated Use transactionMemo field instead.
   */
  memo?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the withdrawal was returned */
  returned: Scalars['Boolean']['output'];
  /** The sub account from which the withdrawal was made. */
  sourceAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The statuses of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The transaction memo, if any. */
  transactionMemo?: Maybe<ActivityTransactionMemo>;
  /** The ID of the withdrawal request */
  withdrawalRequestId?: Maybe<Scalars['ID']['output']>;
};

/** A transaction memo associated with an activity item. */
export type ActivityTransactionMemo = {
  __typename: 'ActivityTransactionMemo';
  /** The comment the user entered with the transaction memo. */
  comment: Scalars['String']['output'];
  /** The reason for the transaction memo. */
  reason: Scalars['String']['output'];
};

/** Autogenerated input type of AddEnvelopeExternalAccountsMutation */
export type AddEnvelopeExternalAccountsMutationInput = {
  /** The ID of the envelope to associate the external account(s) to. */
  envelopeId: Scalars['ID']['input'];
  /** The ExternalAccounts for which to configure an association with an envelope */
  externalAccountIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddEnvelopeExternalAccountsMutation. */
export type AddEnvelopeExternalAccountsMutationPayload = {
  __typename: 'AddEnvelopeExternalAccountsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve AddEnvelopeExternalAccountsMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the AddEnvelopeExternalAccountsMutation execution as type Envelope. */
  result?: Maybe<Envelope>;
};

/** A geographic State/Province/Territory element of a postal address. */
export type AddressState = {
  __typename: 'AddressState';
  /** The 2-character ANSI code for the State, Territory or Province (e.g. 'AK'). */
  code: Scalars['String']['output'];
  /** The full name of the State, Territory or Province (e.g. 'Alaska'). */
  name: Scalars['String']['output'];
};

/** Advice type for a given goal */
export type Advice = {
  /** The description of the advice for a given goal */
  description: Scalars['String']['output'];
};

/** An invitation to join an advised Solo 401(k) plan. */
export type AdvisedSoloFourOhOneKClientInvite = {
  __typename: 'AdvisedSoloFourOhOneKClientInvite';
  /** The advisor who sent the invitation. */
  advisor: InstitutionalAdvisor | PremiumAdvisor;
  /** When the token expires */
  expiresAt: Scalars['DateTime']['output'];
  /** The ID of the record representing the invitation. */
  id: Scalars['ID']['output'];
  /** Whether this invitation was sent to the plan owner or their spouse. */
  isSoloFourOhOneKPlanOwner: Scalars['Boolean']['output'];
  /** Solo 401(k) documents requiring signature, null if expired or no signing needed */
  signablePackage?: Maybe<SignablePackage>;
  /** The current status of the invite */
  status: AdvisedSoloFourOhOneKClientInviteStatus;
  /** Unique, short-lived token used to find an invitation. */
  token: Scalars['String']['output'];
};

/** The status of an advised Solo 401(k) client invite */
export enum AdvisedSoloFourOhOneKClientInviteStatus {
  /** The invite has been successfully completed */
  Complete = 'COMPLETE',
  /** The invite has been created but not yet processed */
  Created = 'CREATED',
  /** The invite processing has failed */
  Failed = 'FAILED',
  /** The invite is currently being processed */
  Processing = 'PROCESSING'
}

/** The advisor for the current user. */
export type Advisor = {
  /** The calendar link of the advisor */
  calendarLink?: Maybe<Scalars['URL']['output']>;
  /** The email address of the advisor */
  email: Scalars['String']['output'];
  /** The full name of the advisor */
  fullName: Scalars['String']['output'];
  /** A unique identifier of the advisor. */
  id: Scalars['ID']['output'];
  /** The logo of the advisor's firm */
  logo?: Maybe<ThemedAsset>;
};

/** Represents a user's intent to engage with the Betterment Advisor Network. */
export type AdvisorNetworkIntent = {
  __typename: 'AdvisorNetworkIntent';
  /** Whether the user's Betterment Advisor Network intent has expired */
  isExpired: Scalars['Boolean']['output'];
  /** The current status of the advisor network intent */
  status: AdvisorNetworkIntentStatus;
};

/** The status of a user's Betterment Advisor Network intent. */
export enum AdvisorNetworkIntentStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Engaged */
  Engaged = 'ENGAGED',
  /** Interested */
  Interested = 'INTERESTED',
  /** Invited */
  Invited = 'INVITED'
}

/** The agreement provided to a user to be signed. */
export type Agreement = {
  __typename: 'Agreement';
  /** The body of the agreement. */
  htmlBody: Scalars['HTML']['output'];
  /** The ID that maps to the existing agreement types: e.g. user_agreement, withholding_agreement, irs_form_agreement, etc */
  id: Scalars['ID']['output'];
};

/** Allocation breakdown of the portfolio for a given investment goal. */
export type AllocationBreakdown = {
  __typename: 'AllocationBreakdown';
  /** The display name for the allocation type. */
  label: Scalars['String']['output'];
  /** The percentage of the allocation type present in the portfolio. */
  percentage: Scalars['Int']['output'];
  /** The type of allocation within the portfolio. */
  type: AllocationType;
};

/** The type of allocation within an investment portfolio. */
export enum AllocationType {
  Bonds = 'BONDS',
  Cash = 'CASH',
  Other = 'OTHER',
  Stocks = 'STOCKS'
}

/** The 401(k) contributions for a specific year. */
export type AnnualFourOhOneKContributions = {
  __typename: 'AnnualFourOhOneKContributions';
  /** The 401(k) contribution amount and projection. */
  result: FourOhOneKContributions;
  /** A tax year. */
  taxYear: TaxYear;
};

/** The aggregate IRA contributions for a specific year. */
export type AnnualIraContributions = {
  __typename: 'AnnualIraContributions';
  /** The projected IRA contribution. */
  result: IraContributions;
  /** A unique identifier for an IraContributionsResult */
  taxYear: TaxYear;
};

/** User facing content providing investing and planning education/advice. */
export type Article = {
  __typename: 'Article';
  /** The author of this article. */
  author: ArticleAuthor;
  /** The primary content of this article. */
  bodyHtml: Scalars['String']['output'];
  /** The URL for the external web site representation for this article. */
  contentUrl: Scalars['String']['output'];
  /** The creation date of this article. */
  createdAt: Scalars['DateTime']['output'];
  /** The CTA related to the content in this article. */
  cta: ArticleCta;
  /** The Disclosures related to the content in this article. */
  disclosures?: Maybe<ArticleDisclosures>;
  /** The unique identifier for this article. */
  id: Scalars['ID']['output'];
  /** The human-readable description of the article's primary image. */
  imageAltText: Scalars['String']['output'];
  /** The URL to the article's primary image. */
  imageUrl: Scalars['String']['output'];
  /** The estimated time for reading this article in human-friendly format. */
  readDuration: Scalars['String']['output'];
  /** The "label" or "tag" of this article. */
  slug: Scalars['String']['output'];
  /** The secondary title of this article. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The primary title of this article. */
  title: Scalars['String']['output'];
  /** The updated date of this article. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The Author of a blog post. */
export type ArticleAuthor = {
  __typename: 'ArticleAuthor';
  /** The url for the avatar image for this ContentAuthor. */
  avatarUrl: Scalars['String']['output'];
  /** Full name of this ContentAuthor. */
  fullName: Scalars['String']['output'];
  /** The job title for this ContentAuthor. */
  jobTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * The CTA for in-app article posts which delivers dynamic relevant content and
 * routes based on users goals and accounts status.
 */
export type ArticleCta = {
  __typename: 'ArticleCta';
  /** The headline text that introduces the CTA. Example, it could be 'Upgrade to Premium for exclusive investing options.' */
  shortDescription: Scalars['String']['output'];
  /**
   * The text used for the CTA that links users to a relevant product feature.
   * Example, it could be 'Upgrade,' directing the user to the advice initiation flow.
   */
  title: Scalars['String']['output'];
  /** Destination path for the CTA title, which can be an absolute or relative URL. */
  url: Scalars['URL']['output'];
};

/** Disclosures for a given article. */
export type ArticleDisclosures = {
  __typename: 'ArticleDisclosures';
  /** The default disclosure to present for the given article. */
  defaultDisclosure?: Maybe<Scalars['String']['output']>;
  /** A disclosure for the given article. */
  entityDisclosure?: Maybe<Scalars['String']['output']>;
  /** A disclosure unique to the given article. */
  oneOffDisclosure?: Maybe<Scalars['String']['output']>;
  /** Additional (optional) disclosures for the given article. */
  optionalDisclosures?: Maybe<Array<Scalars['String']['output']>>;
};

/** A configuration of a scope of a collection of articles. */
export enum ArticlesScope {
  /** Performance */
  Performance = 'PERFORMANCE'
}

/** The asset allocation for a model portfolio option */
export type AssetAllocation = {
  /** The breakdown of asset type weights for the asset allocation */
  assetTypeWeights: Array<AssetTypeWeight>;
  /** The diversification of the asset allocation */
  diversification: AssetAllocationDiversification;
  /** The id of the asset allocation. Maps to the model_portfolio_risk_level ID */
  id: Scalars['ID']['output'];
  /** The risk of the asset allocation */
  risk: AssetAllocationRisk;
  /** The set of all security groups holdings/allocations for this asset allocation. */
  securityGroups: Array<SecurityGroup>;
  /**
   * The weighted securities contained in the asset allocation
   * @deprecated Use securityGroupHoldings instead.
   */
  securityWeights: Array<LegacyWeightedSecurity>;
};

/** The diversification of asset allocation */
export type AssetAllocationDiversification = {
  __typename: 'AssetAllocationDiversification';
  /** The disclosure of the asset allocation diversification */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The ID of the asset allocation diversification */
  id: Scalars['ID']['output'];
  /** The title of the asset allocation diversification */
  title: Scalars['String']['output'];
};

/** The risk of asset allocation */
export type AssetAllocationRisk = {
  __typename: 'AssetAllocationRisk';
  /** The description of the asset allocation risk */
  description: Scalars['String']['output'];
  /** The ID of the asset allocation risk */
  id: Scalars['ID']['output'];
  /** The title of the asset allocation risk */
  title: Scalars['String']['output'];
};

/** The weight of a given asset type */
export type AssetTypeWeight = {
  __typename: 'AssetTypeWeight';
  /** The percentage of the asset type in the model portfolio option. */
  percentage: Scalars['Percent']['output'];
  /** The type of asset. Primarily used for mapping to asset colors and texts. */
  type: AllocationType;
};

/** An auto adjust option for a model portfolio option. Determined based on purpose id. */
export type AutoAdjustOption = {
  __typename: 'AutoAdjustOption';
  /** The description of the auto adjust option. */
  body: Scalars['String']['output'];
  /** The ID of the auto adjust option. */
  id: Scalars['ID']['output'];
  /** Whether the auto adjust option is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The title of the auto adjust option. */
  title: Scalars['String']['output'];
};

/** Managed account-specific autoglide details. */
export type Autoglide = {
  __typename: 'Autoglide';
  /** Indicates that both the target type and account's portfolio are eligible for autoglide. */
  isEligible: Scalars['Boolean']['output'];
  /** Indicates that autoglide is enabled for the account. */
  isEnabled: Scalars['Boolean']['output'];
};

/** A projection of an account's balance over time. */
export type BalanceProjection = {
  __typename: 'BalanceProjection';
  /** The time series data for the projection. */
  timeSeries: Array<BalanceProjectionItem>;
};

/** A single data point in the time series of a balance projection. */
export type BalanceProjectionItem = {
  __typename: 'BalanceProjectionItem';
  /** The time the activity item took place. */
  date: Scalars['Date']['output'];
  /** The projected expected balance for the given date. */
  expected: Scalars['Cents']['output'];
  /** The projected net deposits as of the given date. */
  netDeposits: Scalars['Cents']['output'];
  /** The projected optimistic balance for the given date. */
  optimistic: Scalars['Cents']['output'];
  /** The projected pessimistic balance for the given date. */
  pessimistic: Scalars['Cents']['output'];
};

/** A bank account that can be used for funding/withdrawing from other accounts at Betterment. */
export type BankAccount = TransferableAccount & {
  __typename: 'BankAccount';
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** The available balance of the account. */
  balance?: Maybe<Scalars['Cents']['output']>;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique id for the external account. */
  id: Scalars['ID']['output'];
  /** A JSON string matching the shape returned by our legacy rest endpoints */
  legacyObject: Scalars['String']['output'];
  /** The display name for the external account */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** Relationship of a legal account beneficiary to the legal account holder */
export enum BeneficiaryRelationship {
  /** Legal entity (e.g., charity) */
  Entity = 'ENTITY',
  /** Family member/friend */
  Friend = 'FRIEND',
  /** Spouse */
  Spouse = 'SPOUSE'
}

/** The title and instructions copy for updating beneficiaries of the given legal or checking account */
export type BeneficiaryUpdateInstructions = {
  __typename: 'BeneficiaryUpdateInstructions';
  /** Beneficiary instructions copy according to the account type */
  instructions: Scalars['HTML']['output'];
  /** Title copy for editing beneficiaries according to the account type */
  title: Scalars['String']['output'];
};

/** The Betterment Advisor Network service option. */
export type BettermentAdvisorNetworkOption = FinancialServiceOption & {
  __typename: 'BettermentAdvisorNetworkOption';
  /** HTML-formatted description explaining the benefits and features of the advisor service. */
  description: Scalars['HTML']['output'];
  /** Fee disclosure information for this service option. */
  feeDisclosure: Scalars['String']['output'];
  /** A unique identifier for the option, used for client-side caching and analytics tracking. */
  id: Scalars['ID']['output'];
  /** A themed asset (supporting light/dark mode) representing the advised service visually. */
  image: ThemedAsset;
  /** Minimum balance disclosure information for this service option. */
  minimumBalanceDisclosure: Scalars['String']['output'];
  /** Scheduled event configuration details for Betterment Advisor Network. */
  scheduledEventConfiguration: ScheduledEventConfiguration;
  /** The service fee for this option. */
  serviceFee: Scalars['String']['output'];
  /** The display title of the advisor service */
  title: Scalars['String']['output'];
};


/** The Betterment Advisor Network service option. */
export type BettermentAdvisorNetworkOptionScheduledEventConfigurationArgs = {
  scheduleEvent: Scalars['String']['input'];
};

/** The Betterment Premium advised service option. */
export type BettermentPremiumOption = FinancialServiceOption & {
  __typename: 'BettermentPremiumOption';
  /** HTML-formatted description explaining the benefits and features of the advisor service. */
  description: Scalars['HTML']['output'];
  /** Fee disclosure information for this service option. */
  feeDisclosure: Scalars['String']['output'];
  /** A unique identifier for the option, used for client-side caching and analytics tracking. */
  id: Scalars['ID']['output'];
  /** A themed asset (supporting light/dark mode) representing the advised service visually. */
  image: ThemedAsset;
  /** Minimum balance disclosure information for this service option. */
  minimumBalanceDisclosure: Scalars['String']['output'];
  /** Scheduled event configuration details for Betterment Premium. */
  scheduledEventConfiguration: ScheduledEventConfiguration;
  /** The service fee for this option. */
  serviceFee: Scalars['String']['output'];
  /** The display title of the advisor service */
  title: Scalars['String']['output'];
};


/** The Betterment Premium advised service option. */
export type BettermentPremiumOptionScheduledEventConfigurationArgs = {
  scheduleEvent: Scalars['String']['input'];
};

/**
 * Bond portfolio yields. These are aggregate values calculated based on the target
 * portfolio holdings. They represent a calculated yield for all the bonds in the
 * portfolio, weighted by their allocation in the portfolio.
 */
export type BondPortfolioYields = {
  __typename: 'BondPortfolioYields';
  /** Overall after-tax yield. This is the bond yield after accounting for taxes on interest income. */
  afterTaxYield: Scalars['Percent']['output'];
  /** An explanation of after-tax yield, its relevance to your investment decisions, and the impact it has on your investment. */
  afterTaxYieldExplanation: Scalars['String']['output'];
  /**
   * Bond yield is the return an investor can expect to earn on a bond investment
   * each year over its term to maturity. This value represents the yield before
   * accounting for taxes on interest income.
   */
  blendedSecYield: Scalars['Percent']['output'];
  /**
   * Bond yield is the return an investor can expect to earn on a bond investment
   * each year over its term to maturity. This value represents the yield before
   * accounting for taxes on interest income.
   */
  blendedSecYieldExplanation: Scalars['String']['output'];
  /**
   * Bond yield is the return an investor can expect to earn on a bond investment
   * each year over its term to maturity. This value represents the yield before
   * accounting for taxes on interest income.
   * @deprecated Use blendedSecYield instead.
   */
  yield: Scalars['Percent']['output'];
};

/** Autogenerated input type of CancelTransactionRequestMutation */
export type CancelTransactionRequestMutationInput = {
  /** The ID of the request to cancel. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelTransactionRequestMutation. */
export type CancelTransactionRequestMutationPayload = {
  __typename: 'CancelTransactionRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CancelTransactionRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CancelTransactionRequestMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** Autogenerated input type of CapturePackageSignatureMutation */
export type CapturePackageSignatureMutationInput = {
  /** The ID of the signable package (Solo 401k Plan) */
  signablePackageId: Scalars['ID']['input'];
};

/** Autogenerated return type of CapturePackageSignatureMutation. */
export type CapturePackageSignatureMutationPayload = {
  __typename: 'CapturePackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CapturePackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CapturePackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccount = EnvelopeAccount & LegalSubAccount & PerformanceAccount & TransferableAccount & {
  __typename: 'CashAccount';
  /** The name describing the account, e.g. a traditional IRA or a bonds portfolio. */
  accountDescription: Scalars['String']['output'];
  /** The financial activity for the cash account. */
  activityConnection: ActivityItemConnection;
  /** The cash APY details for the account. */
  apy: CashApy;
  /** A collection of articles for education and advice for the cash account. */
  articles: Array<Article>;
  /** The balance of the account. */
  balance: Scalars['Cents']['output'];
  /** The balance projection for the account. */
  balanceProjection?: Maybe<BalanceProjection>;
  /** Checking accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleCheckingAccounts: Array<CheckingAccount>;
  /** External accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleExternalAccounts: Array<ExternalAccount>;
  /** The envelope that contains the given account. */
  envelope: Envelope;
  /** FDIC insurance details for the account. */
  fdicInsurance: CashFdicInsurance;
  /** Whether the account has reached the maximum number of bank accounts allowed by operations. */
  hasReachedOpsBankAccountLimit: Scalars['Boolean']['output'];
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /** Whether the account is closed. */
  isClosed: Scalars['Boolean']['output'];
  /** Whether the legal sub account is an eligible destination for a recurring deposit. */
  isRecurringDepositEligible: Scalars['Boolean']['output'];
  /**
   * The legacy goal ID for the account.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /**
   * The legacy ID for this instance of a LegalSubAccount
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /**
   * The name representing the account.
   * @deprecated Use account_description instead.
   */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The performance of the account. */
  performance: Performance;
  /**
   * The performance totals for the account.
   * @deprecated Use `performance#totals` instead.
   */
  performanceTotals: PerformanceTotals;
  /** A reason-to-believe used to motivate the user to initiate a recurring deposit. */
  recurringDepositMotivation?: Maybe<RecurringDepositMotivation>;
  /** All recurring transaction configs involving this cash account. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** The options to initiate a transaction involving this account. */
  transactionOptions: Array<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountArticlesArgs = {
  scope?: InputMaybe<ArticlesScope>;
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** APY details for a given goal */
export type CashApy = {
  __typename: 'CashApy';
  /** Accompanying explanation with additional details for the APY */
  explanation: Scalars['String']['output'];
  /** Whether or not the given goal is currently receiving an APY boost based on any promotions. */
  isBoostActive: Scalars['Boolean']['output'];
  /** Whether or not the given goal is eligible for an APY boost based on any promotions. */
  isBoostEligible: Scalars['Boolean']['output'];
  /** The APY for the given account. */
  rate: Scalars['String']['output'];
};

/** FDIC insurance details for a cash account. */
export type CashFdicInsurance = {
  __typename: 'CashFdicInsurance';
  /** The amount covered by FDIC insurance for the given cash account */
  amount: Scalars['String']['output'];
  /** Accompanying explanation of the amount covered by FDIC insurance */
  explanation: Scalars['String']['output'];
};

/** The option to initiate a donation. */
export type CharitableDonationOption = TransactionOption & {
  __typename: 'CharitableDonationOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** A checking account held by NBKC, and made available to Betterment through Helix. */
export type CheckingAccount = EnvelopeAccount & TransferableAccount & {
  __typename: 'CheckingAccount';
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The envelope holding the item. Beware not to use this field to access complex
   * data about an envelope's items cyclically, such that a user with a very high
   * number of items could end up executing an operation with a dramatically high
   * runtime complexity.
   */
  envelope: Envelope;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The ID of the checking account. */
  id: Scalars['ID']['output'];
  /**
   * The ID for the account, as recognized by our legacy REST APIs.
   * @deprecated Use the legacyId on CheckingAccountRemote instead.
   */
  legacyId: Scalars['LegacyID']['output'];
  /** The name representing the account. */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /**
   * The checking account data held by Helix. If null, Helix is experiencing
   * downtime and we are unable to present data about the account to the user.
   */
  remote?: Maybe<RemoteCheckingAccount>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** Represent data concerns of a user opening a checking goal */
export type CheckingAccountCreationOption = ProductOnboardingOption & {
  __typename: 'CheckingAccountCreationOption';
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Whether the user is in the manual identity review step of checking account creation. */
  isInManualReview: Scalars['Boolean']['output'];
  /**
   * Whether the user is in the manual identity review step of checking account
   * creation, and the user needs to complete multidoc upload to complete the
   * manual identity review.
   */
  isInManualReviewWithDocumentsRequired: Scalars['Boolean']['output'];
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** Whether the user needs to complete Socure document verification before beginning to create a checking account. */
  requiresDocumentVerification: Scalars['Boolean']['output'];
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** Represent data concerns of a user opening a checking goal */
export type CheckingAccountCreationOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/** A beneficiary for a checking account */
export type CheckingBeneficiary = {
  __typename: 'CheckingBeneficiary';
  /** The beneficiary's date of birth */
  dateOfBirth: Scalars['Date']['output'];
  /** The beneficiary's first name */
  firstName: Scalars['String']['output'];
  /** The checking beneficiary's ID; used for caching purposes */
  id: Scalars['ID']['output'];
  /** The beneficiary's last name */
  lastName: Scalars['String']['output'];
  /** The beneficiary's tax id (SSN/EIN) */
  taxId: Scalars['TIN']['output'];
};

/** Input object representing a Beneficiary on a Checking Account. */
export type CheckingBeneficiaryInput = {
  /** Date of birth of the beneficiary. May be null if the beneficiary is a trust. */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** First name of the beneficiary. */
  firstName: Scalars['String']['input'];
  /** Last name of the beneficiary. */
  lastName: Scalars['String']['input'];
  /** SSN/TIN of the beneficiary. */
  taxId: Scalars['TIN']['input'];
};

/** A Checking Customer profile for the current Investing User. */
export type CheckingCustomer = {
  __typename: 'CheckingCustomer';
  /** The Checking Account associated with this Checking Customer with the provided {id}. */
  account: RemoteCheckingAccount;
  /** A collection of the Checking Accounts directly or jointly held by this Checking Customer. */
  accounts: Array<RemoteCheckingAccount>;
  /** The Checking Customer's beneficiary. */
  beneficiary?: Maybe<CheckingBeneficiary>;
  /** The title and instructions copy for updating beneficiaries of the given checking account */
  beneficiaryUpdateInstructions: BeneficiaryUpdateInstructions;
  /** The Debit Card associated with this Checking Customer. */
  card: DebitCard;
  /** The Debit Card associated with this Checking Customer that is pending verification. */
  cardPendingVerification?: Maybe<DebitCard>;
  /** Flag indicating that this Checking Customer's profile is locked. */
  isLocked: Scalars['Boolean']['output'];
};


/** A Checking Customer profile for the current Investing User. */
export type CheckingCustomerAccountArgs = {
  id: Scalars['ID']['input'];
};

/** Result Union for Query.checkingCustomer query, returns either CheckingCustomer or UnavailableRecord. */
export type CheckingCustomerResult = CheckingCustomer | RecordNotFoundResult | RecordUnavailableResult;

/** The account record maintained by Helix for transfering money to and from the user's Betterment checking account. */
export type CheckingExternalAccount = TransferableAccount & {
  __typename: 'CheckingExternalAccount';
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** The available balance of the account. */
  balance?: Maybe<Scalars['Cents']['output']>;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique id for the account. */
  id: Scalars['ID']['output'];
  /** The displayable name of the external account maintained by Helix/CorePro */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** The advisor fee structure - can be asset-based (bps), fixed (dollar amount), or tiered */
export type ClientEnvelopeApprovalAdvisorFee = ClientEnvelopeApprovalRateBasedFee | ClientEnvelopeApprovalTieredFee;

/** An agreement document that must be reviewed/signed for client envelope approval */
export type ClientEnvelopeApprovalAgreement = {
  __typename: 'ClientEnvelopeApprovalAgreement';
  /** Signature token for the agreement (nil for static agreements like BAN) */
  token?: Maybe<Scalars['String']['output']>;
  /** URL to the agreement document */
  url: Scalars['String']['output'];
};

/** Collection of agreements required for client envelope approval */
export type ClientEnvelopeApprovalAgreements = {
  __typename: 'ClientEnvelopeApprovalAgreements';
  /** The advisor's ADV Part 2B agreement (optional) */
  advPart2bAgreement?: Maybe<ClientEnvelopeApprovalAgreement>;
  /** Betterment Advisor Network agreement (only for BAN invites) */
  banAgreement?: Maybe<ClientEnvelopeApprovalAgreement>;
  /** The firm's client agreement (optional) */
  clientAgreement?: Maybe<ClientEnvelopeApprovalAgreement>;
};

/** A single tier in a tiered fee structure */
export type ClientEnvelopeApprovalFeeTier = {
  __typename: 'ClientEnvelopeApprovalFeeTier';
  /** Asset range for this tier (e.g., '$0 - $100,000' or '$100,000+') */
  range: Scalars['String']['output'];
  /** Fee rate for this tier (e.g., '75 bps' or '$50') */
  rate: Scalars['String']['output'];
};

/** Advisory firm information for client envelope approval */
export type ClientEnvelopeApprovalFirm = {
  __typename: 'ClientEnvelopeApprovalFirm';
  /** URL to the firm's logo image */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the advisory firm */
  name: Scalars['String']['output'];
};

/** Asset-based or fixed fee rate */
export type ClientEnvelopeApprovalRateBasedFee = {
  __typename: 'ClientEnvelopeApprovalRateBasedFee';
  /** Fee rate as string (e.g., '75 bps' or '$50') */
  rate: Scalars['String']['output'];
};

/** Data for a client envelope approval request */
export type ClientEnvelopeApprovalRequest = {
  __typename: 'ClientEnvelopeApprovalRequest';
  /** Whether the approval request has been accepted */
  accepted: Scalars['Boolean']['output'];
  /** Advisor fee structure (nil if no billing plan configured) */
  advisorFee?: Maybe<ClientEnvelopeApprovalAdvisorFee>;
  /** Collection of agreements to review/sign */
  agreements: ClientEnvelopeApprovalAgreements;
  /** Source of the approval request invitation */
  clientEnvelopeApprovalRequestSource: ClientEnvelopeApprovalRequestSource;
  /** Whether the approval request is expired or cancelled */
  expiredOrCancelled: Scalars['Boolean']['output'];
  /** Advisory firm information */
  firm: ClientEnvelopeApprovalFirm;
  /** Approval request ID */
  id: Scalars['ID']['output'];
  /** Platform fee in basis points as string */
  platformFee: Scalars['String']['output'];
};

/** Source of the client envelope approval request invitation */
export enum ClientEnvelopeApprovalRequestSource {
  /** Invitation through Betterment Advisor Network */
  BettermentAdvisorNetwork = 'BETTERMENT_ADVISOR_NETWORK',
  /** Standard approval request invitation */
  Standard = 'STANDARD'
}

/** Tiered fee structure with multiple rate brackets */
export type ClientEnvelopeApprovalTieredFee = {
  __typename: 'ClientEnvelopeApprovalTieredFee';
  /** The method for applying tiered rates */
  calculationMethod: TieredFeeCalculationMethod;
  /** Array of fee tiers */
  tiers: Array<ClientEnvelopeApprovalFeeTier>;
};

/** Autogenerated input type of CompleteDraftPurposeFlowMutation */
export type CompleteDraftPurposeFlowMutationInput = {
  /** The ID of the draft envelope to update (optional, for upsert) */
  draftEnvelopeId?: InputMaybe<Scalars['ID']['input']>;
  /** The image data for the purpose. */
  imageData?: InputMaybe<Scalars['Base64']['input']>;
  /** The image type for the purpose. */
  imageType?: InputMaybe<Scalars['String']['input']>;
  /** The name of the purpose. */
  name: Scalars['String']['input'];
  /** The product category of the purpose, which is used to derive the asset type. */
  productCategory: ProductCategory;
  /** The input for the specific purpose type. */
  purposeInput: UpdatePurposeInput;
  /** The sub type of the purpose. */
  purposeSubType: Scalars['String']['input'];
  /** The target amount in cents. */
  targetAmount?: InputMaybe<Scalars['Cents']['input']>;
};

/** Autogenerated return type of CompleteDraftPurposeFlowMutation. */
export type CompleteDraftPurposeFlowMutationPayload = {
  __typename: 'CompleteDraftPurposeFlowMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CompleteDraftPurposeFlowMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CompleteDraftPurposeFlowMutation execution as type DraftEnvelope. */
  result?: Maybe<DraftEnvelope>;
};

/** Autogenerated input type of CompleteTaxCoordinatedAccountCreationFlowMutation */
export type CompleteTaxCoordinatedAccountCreationFlowMutationInput = {
  /** The new account to create and associate with a Tax Coordinated Portfolio. */
  accountCreationInput: TaxCoordinatedAccountCreationInput;
};

/** Autogenerated return type of CompleteTaxCoordinatedAccountCreationFlowMutation. */
export type CompleteTaxCoordinatedAccountCreationFlowMutationPayload = {
  __typename: 'CompleteTaxCoordinatedAccountCreationFlowMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CompleteTaxCoordinatedAccountCreationFlowMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CompleteTaxCoordinatedAccountCreationFlowMutation execution as type Envelope. */
  result?: Maybe<Envelope>;
};

/** Autogenerated input type of ConfirmIdentityVerificationChallengeMutation */
export type ConfirmIdentityVerificationChallengeMutationInput = {
  /** ID of the identity verification challenge to respond to */
  challengeId: Scalars['ID']['input'];
  /** Customer's response to the verification challenge */
  response: IdentityVerificationChallengeResponse;
};

/** Autogenerated return type of ConfirmIdentityVerificationChallengeMutation. */
export type ConfirmIdentityVerificationChallengeMutationPayload = {
  __typename: 'ConfirmIdentityVerificationChallengeMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ConfirmIdentityVerificationChallengeMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the ConfirmIdentityVerificationChallengeMutation
   * execution as type IdentityVerificationChallenge.
   */
  result?: Maybe<IdentityVerificationChallenge>;
};

/** The type of contribution */
export enum ContributionType {
  /** The contributor is an employee contributing to a 401(k) */
  FourOhOneKEmployee = 'FOUR_OH_ONE_K_EMPLOYEE',
  /** The contributor is an employer contributing to a solo 401(k) */
  FourOhOneKEmployer = 'FOUR_OH_ONE_K_EMPLOYER',
  /** The contributor is the owner of an IRA */
  IraTaxYearContribution = 'IRA_TAX_YEAR_CONTRIBUTION',
  /** The contributor is making an indirect IRA rollover contribution */
  Rollover = 'ROLLOVER'
}

/** Represents a contribution type option */
export type ContributionTypeOption = {
  __typename: 'ContributionTypeOption';
  /** The contribution limit for this contribution type option */
  contributionLimitAmount: Scalars['Cents']['output'];
  /** The role of the contributor */
  contributionType: ContributionType;
  /** The current amount on contributions that have been made to this contribution type option */
  currentContributionAmount: Scalars['Cents']['output'];
  /** A description of the type of contribution. */
  description: Scalars['String']['output'];
  /** The contribution eligibility status */
  eligibilityStatus: TaxYearContributionTypeEligibilityStatus;
  /** The remaining amount of contributions that can be made to this contribution type option */
  remainingContributionAmount: Scalars['Cents']['output'];
  /** The tax year of the contribution option */
  taxYear?: Maybe<TaxYear>;
};

/** Represents a contribution type selection option specific to a tax year. */
export type ContributionTypeSelectionOption = {
  __typename: 'ContributionTypeSelectionOption';
  /** Detailed information answering common questions about the contribution tax year options */
  contributionLimitsRules: Scalars['HTML']['output'];
  /** The contribution type options for the parent sub account */
  contributionTypeOptions: Array<ContributionTypeOption>;
  /** The description of the contribution type options */
  contributionTypeSelectionDescription: Scalars['String']['output'];
  /** Copy explaining the contribution limits for the parent sub account */
  taxYearSelectionDescription: Scalars['String']['output'];
  /** HTML content for the disclosure */
  taxYearSelectionGuidance: Scalars['HTML']['output'];
};

/** Autogenerated input type of CreateAccountRecommendationExplanationMutation */
export type CreateAccountRecommendationExplanationMutationInput = {
  /** The id of the AccountRecommendation to explain. */
  recommendationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAccountRecommendationExplanationMutation. */
export type CreateAccountRecommendationExplanationMutationPayload = {
  __typename: 'CreateAccountRecommendationExplanationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateAccountRecommendationExplanationMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateAccountRecommendationExplanationMutation execution as type HTML. */
  result?: Maybe<Scalars['HTML']['output']>;
};

/** Autogenerated input type of CreateDirectTradingAccountMutation */
export type CreateDirectTradingAccountMutationInput = {
  /** The agreements that the user has accepted */
  acceptedAgreements?: InputMaybe<Array<TermsAndAgreementsOption>>;
  /**
   * Selected Investing Experience Level. This will update the user's investing
   * experience level separately from the account creation.
   */
  investingExperienceLevel?: InputMaybe<InvestingExperienceLevel>;
  /**
   * The securities lending enrollment status to change to. This will update the
   * user's security lending enrollment in Custody, but will not run if the account
   * is not created or if the enrollment value is not given.
   */
  isSecurityLendingEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ownership type of the account to be created */
  ownershipType: LegalAccountOwnershipType;
  /** The secondary user (existing or new) for the joint account */
  secondaryUser?: InputMaybe<SecondaryUserInput>;
  /** The trust details (new or existing) for the trust account */
  trust?: InputMaybe<TrustInput>;
};

/** Autogenerated return type of CreateDirectTradingAccountMutation. */
export type CreateDirectTradingAccountMutationPayload = {
  __typename: 'CreateDirectTradingAccountMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateDirectTradingAccountMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateDirectTradingAccountMutation execution as type DirectTradingAccount. */
  result?: Maybe<DirectTradingAccount>;
};

/** Autogenerated return type of CreateDocumentVerificationTokenMutation. */
export type CreateDocumentVerificationTokenMutationPayload = {
  __typename: 'CreateDocumentVerificationTokenMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateDocumentVerificationTokenMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateDocumentVerificationTokenMutation execution as type String. */
  result?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEmployeeContributionConfigurationChangeRequestMutation */
export type CreateEmployeeContributionConfigurationChangeRequestMutationInput = {
  /** List of contribution change requests. */
  contributionChanges: Array<EmployeeContributionConfigurationChangeInput>;
};

/** Autogenerated return type of CreateEmployeeContributionConfigurationChangeRequestMutation. */
export type CreateEmployeeContributionConfigurationChangeRequestMutationPayload = {
  __typename: 'CreateEmployeeContributionConfigurationChangeRequestMutationPayload';
  /**
   * The user-displayable errors produced while attempting to resolve
   * CreateEmployeeContributionConfigurationChangeRequestMutation.
   */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * CreateEmployeeContributionConfigurationChangeRequestMutation execution as type
   * PayrollContributionConfigConnection.
   */
  result?: Maybe<PayrollContributionConfigConnection>;
};


/** Autogenerated return type of CreateEmployeeContributionConfigurationChangeRequestMutation. */
export type CreateEmployeeContributionConfigurationChangeRequestMutationPayloadResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateFinancialSecurityOrderRequestMutation */
export type CreateFinancialSecurityOrderRequestMutationInput = {
  /** The account within which to perform the trade */
  accountId: FinancialSecurityOrderRequestAccountIdInput;
  /** Determines if the order is a buy or sell */
  direction: FinancialSecurityOrderRequestDirection;
  /** estimated dollar amount calculated for a share-based request */
  estimatedMoneyAmount?: InputMaybe<Scalars['Cents']['input']>;
  /** estimated shares calculated for a dollar-based request */
  estimatedShares?: InputMaybe<Scalars['Float']['input']>;
  /** Custody's security id for the security to buy or sell */
  financialSecurityId: Scalars['ID']['input'];
  /** Indicates the customer intended to sell all of their existing shares of the chosen security */
  sellAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** share price used for estimations for the order request */
  sharePriceAtRequest?: InputMaybe<Scalars['Cents']['input']>;
  /** Provides a dollar amount or share value for the order based on customer inputs */
  value: FinancialSecurityOrderRequestValueInput;
};

/** Autogenerated return type of CreateFinancialSecurityOrderRequestMutation. */
export type CreateFinancialSecurityOrderRequestMutationPayload = {
  __typename: 'CreateFinancialSecurityOrderRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFinancialSecurityOrderRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the CreateFinancialSecurityOrderRequestMutation
   * execution as type FinancialSecurityOrderRequest.
   */
  result?: Maybe<FinancialSecurityOrderRequest>;
};

/** Autogenerated input type of CreatePersonalReferralInvitationMutation */
export type CreatePersonalReferralInvitationMutationInput = {
  /** The email address of the person to invite */
  email: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePersonalReferralInvitationMutation. */
export type CreatePersonalReferralInvitationMutationPayload = {
  __typename: 'CreatePersonalReferralInvitationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreatePersonalReferralInvitationMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreatePersonalReferralInvitationMutation execution as type ReferralInvitation. */
  result?: Maybe<ReferralInvitation>;
};

/** Autogenerated input type of CreateRecurringTransactionConfigMutation */
export type CreateRecurringTransactionConfigMutationInput = {
  /** The amount, in cents, of the recurring transaction. */
  amountCents: Scalars['Int']['input'];
  /** ID of the destination account. */
  destinationId: Scalars['ID']['input'];
  /** The frequency of the recurring transaction config */
  frequency: RecurringTransactionFrequencyInput;
  /** ID of the source account. */
  sourceId: Scalars['ID']['input'];
  /** The contribution year, or nil for an IRA contribution. */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateRecurringTransactionConfigMutation. */
export type CreateRecurringTransactionConfigMutationPayload = {
  __typename: 'CreateRecurringTransactionConfigMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateRecurringTransactionConfigMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateRecurringTransactionConfigMutation execution as type RecurringTransactionConfig. */
  result?: Maybe<RecurringTransactionConfig>;
};

/** Autogenerated input type of CreateSolo401kInterestSubmissionsMutation */
export type CreateSolo401kInterestSubmissionsMutationInput = {
  /** If the plan has after tax contributions */
  hasAfterTaxContributions: Scalars['Boolean']['input'];
  /** If the plan has outstanding loans */
  hasOutstandingLoans: Scalars['Boolean']['input'];
  /** If the plan has roth employer contributions */
  hasRothEmployerContributions: Scalars['Boolean']['input'];
  /** The associated plan details */
  planDetails?: InputMaybe<Solo401kInterestPlanDetails>;
  /** Type of plan */
  planType: Solo401kInterestPlanType;
};

/** Autogenerated return type of CreateSolo401kInterestSubmissionsMutation. */
export type CreateSolo401kInterestSubmissionsMutationPayload = {
  __typename: 'CreateSolo401kInterestSubmissionsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateSolo401kInterestSubmissionsMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateSolo401kInterestSubmissionsMutation execution as type Solo401kInterestRequest. */
  result?: Maybe<Solo401kInterestRequest>;
};

/** Autogenerated input type of CreateTransactionMemoMutation */
export type CreateTransactionMemoMutationInput = {
  /** A more detailed note for the memo, to be viewed in activity. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The ID for the memo creation option. */
  id: Scalars['ID']['input'];
  /** The ID for the chosen reason option. */
  reasonId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTransactionMemoMutation. */
export type CreateTransactionMemoMutationPayload = {
  __typename: 'CreateTransactionMemoMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateTransactionMemoMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateTransactionMemoMutation execution as type User. */
  result?: Maybe<User>;
};

/** Autogenerated input type of CreateTransactionRequestMutation */
export type CreateTransactionRequestMutationInput = {
  /** The amount, in cents, of the transaction, or a boolean denoting that the transaction is a full transfer. */
  amount: TransactionRequestAmountInput;
  /** The contribution type, if contributing to a solo 401k. */
  contributionType?: InputMaybe<Solo401kContributionType>;
  /** ID of the destination account. */
  destinationId: Scalars['ID']['input'];
  /** ID of the source account. */
  sourceId: Scalars['ID']['input'];
  /** The contribution year, or nil for an IRA contribution. */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateTransactionRequestMutation. */
export type CreateTransactionRequestMutationPayload = {
  __typename: 'CreateTransactionRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateTransactionRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateTransactionRequestMutation execution as type TransactionRequest. */
  result?: Maybe<TransactionRequest>;
};

/** Autogenerated input type of CreateUserActivityCsvExportMutation */
export type CreateUserActivityCsvExportMutationInput = {
  /** Filters to apply to the activity search. */
  filters?: InputMaybe<ActivityFilterInput>;
};

/** Autogenerated return type of CreateUserActivityCsvExportMutation. */
export type CreateUserActivityCsvExportMutationPayload = {
  __typename: 'CreateUserActivityCsvExportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateUserActivityCsvExportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateUserActivityCsvExportMutation execution as type CsvExport. */
  result?: Maybe<CsvExport>;
};

/** Advice for a given crypto goal */
export type CryptoAdvice = Advice & {
  __typename: 'CryptoAdvice';
  /** The description of the advice for a given goal */
  description: Scalars['String']['output'];
};

/** Portfolio details for a given crypto goal */
export type CryptoPortfolio = Portfolio & {
  __typename: 'CryptoPortfolio';
  /** The strategy for the goal's portfolio */
  strategy: PortfolioStrategy;
  /**
   * The themed asset set for all holdings image url
   * @deprecated No longer supporting this portfolio type
   */
  tokenIcons: Array<ThemedAsset>;
};

/** Active record that represents data exported as a CSV */
export type CsvExport = {
  __typename: 'CsvExport';
  /** Unique identifier of the csv export */
  id: Scalars['ID']['output'];
  /** The generation status of the csv file */
  status: CsvExportStatus;
};

/** The status of a csv export */
export enum CsvExportStatus {
  /** The csv export generation was canceled */
  Canceled = 'CANCELED',
  /** The csv export has been generated successfully */
  Complete = 'COMPLETE',
  /** The csv export generation failed */
  Failed = 'FAILED',
  /** The csv export is being generated */
  Generating = 'GENERATING'
}

/** The asset allocation for a customizable (flexpo) model portfolio option */
export type CustomizableAssetAllocation = AssetAllocation & {
  __typename: 'CustomizableAssetAllocation';
  /** The breakdown of asset type weights for the asset allocation */
  assetTypeWeights: Array<AssetTypeWeight>;
  /** The diversification of the asset allocation */
  diversification: AssetAllocationDiversification;
  /** The id of the asset allocation. Maps to the model_portfolio_risk_level ID */
  id: Scalars['ID']['output'];
  /** The risk of the asset allocation */
  risk: AssetAllocationRisk;
  /** The set of all security groups holdings/allocations for this asset allocation. */
  securityGroups: Array<SecurityGroup>;
  /**
   * The weighted securities contained in the asset allocation
   * @deprecated Use securityGroupHoldings instead.
   */
  securityWeights: Array<LegacyWeightedSecurity>;
};

/** A time period. */
export type DateRange = {
  __typename: 'DateRange';
  /** The final date of the time period. */
  end: Scalars['Date']['output'];
  /** The beginning date of the time period. */
  start: Scalars['Date']['output'];
};

/** A time period. */
export type DateRangeInput = {
  /** The final date of the time period. */
  end: Scalars['Date']['input'];
  /** The beginning date of the time period. */
  start: Scalars['Date']['input'];
};

/** Date range options used to filter certain queries. */
export enum DateRangeOption {
  /** All time */
  AllTime = 'ALL_TIME',
  /** Custom */
  Custom = 'CUSTOM',
  /** Past five years */
  PastFiveYears = 'PAST_FIVE_YEARS',
  /** Past month */
  PastMonth = 'PAST_MONTH',
  /** Past three months */
  PastThreeMonths = 'PAST_THREE_MONTHS',
  /** Past three years */
  PastThreeYears = 'PAST_THREE_YEARS',
  /** Past two years */
  PastTwoYears = 'PAST_TWO_YEARS',
  /** Past week */
  PastWeek = 'PAST_WEEK',
  /** Past year */
  PastYear = 'PAST_YEAR',
  /** Today */
  Today = 'TODAY',
  /** Year to date */
  YearToDate = 'YEAR_TO_DATE'
}

/** A Debit Card associated with a Checking Customer/Checking Account. */
export type DebitCard = {
  __typename: 'DebitCard';
  /** Record identifier for the given Debit Card. */
  id: Scalars['ID']['output'];
  /** The ID for the Debit Card, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** Code if this Debit Card is currently locked. */
  lockTypeCode: DebitCardLockTypeCode;
  /** Lifecycle/Activation status for the given Debit Card. */
  status: DebitCardStatus;
};

/** The Lock TypeCode for a Checking Customer's Debit Card that has been Locked. */
export enum DebitCardLockTypeCode {
  /** Customer locked */
  CustomerLocked = 'CUSTOMER_LOCKED',
  /** System locked */
  SystemLocked = 'SYSTEM_LOCKED',
  /** Unlocked */
  Unlocked = 'UNLOCKED'
}

/** Indicator for the Debit Card's current lifecycle Status. */
export enum DebitCardStatus {
  Archived = 'ARCHIVED',
  AutoReissuedPendingVerification = 'AUTO_REISSUED_PENDING_VERIFICATION',
  Denied = 'DENIED',
  Expired = 'EXPIRED',
  Hotlisted = 'HOTLISTED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  PendingVerification = 'PENDING_VERIFICATION',
  Reissued = 'REISSUED',
  ReissuedPendingVerification = 'REISSUED_PENDING_VERIFICATION',
  Verified = 'VERIFIED'
}

/** The option to edit 401k account deferral settings. */
export type DeferralSetting = {
  __typename: 'DeferralSetting';
  /** The account for the deferral setting. */
  account: SubAccount;
  /** The employer associated with the deferral setting. */
  employer: Employer;
  /** The id of the deferral setting. */
  id: Scalars['ID']['output'];
  /** The ID for the deferral setting, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** A description of the tax benefits for contributing to the 401k account. */
  taxBenefitsExplanation: Scalars['String']['output'];
  /** The value of the deferral, as either a currency amount or a percentage. */
  value: PayrollContributionConfigValue;
};

/** The option to edit 401k account deferral settings. */
export type DeferralSettingsEditOption = TransactionOption & {
  __typename: 'DeferralSettingsEditOption';
  /** The editable deferral settings. */
  deferralSettings: Array<DeferralSetting>;
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** A description of the tax benefits for contributing to different 401k accounts. */
  taxBenefitsExplanation: Scalars['HTML']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** Autogenerated return type of DeleteCheckingBeneficiaryMutation. */
export type DeleteCheckingBeneficiaryMutationPayload = {
  __typename: 'DeleteCheckingBeneficiaryMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DeleteCheckingBeneficiaryMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DeleteCheckingBeneficiaryMutation execution as type CheckingCustomerResult. */
  result?: Maybe<CheckingCustomerResult>;
};

/** Autogenerated input type of DeletePurposeMutation */
export type DeletePurposeMutationInput = {
  /** The ID of the envelope to remove purpose from */
  purposeId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePurposeMutation. */
export type DeletePurposeMutationPayload = {
  __typename: 'DeletePurposeMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DeletePurposeMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DeletePurposeMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** Autogenerated input type of DeleteRecurringTransactionConfigMutation */
export type DeleteRecurringTransactionConfigMutationInput = {
  /** The ID of the config to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRecurringTransactionConfigMutation. */
export type DeleteRecurringTransactionConfigMutationPayload = {
  __typename: 'DeleteRecurringTransactionConfigMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DeleteRecurringTransactionConfigMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DeleteRecurringTransactionConfigMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** Autogenerated return type of DeleteTrustedContactMutation. */
export type DeleteTrustedContactMutationPayload = {
  __typename: 'DeleteTrustedContactMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DeleteTrustedContactMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DeleteTrustedContactMutation execution as type User. */
  result?: Maybe<User>;
};

/** An investment account that is used for direct trading */
export type DirectTradingAccount = EnvelopeAccount & LegalSubAccount & PerformanceAccount & TransferableAccount & {
  __typename: 'DirectTradingAccount';
  /** The name describing the account, e.g. a traditional IRA or a bonds portfolio. */
  accountDescription: Scalars['String']['output'];
  /** The financial activity for the Direct Trading account. */
  activityConnection: ActivityItemConnection;
  /** The balance of the account balance (including pending). */
  balance: Scalars['Cents']['output'];
  /** Checking accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleCheckingAccounts: Array<CheckingAccount>;
  /** External accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleExternalAccounts: Array<ExternalAccount>;
  /** Order availability for the given financial security. */
  buyOrderBlockedAvailabilityMessage?: Maybe<Scalars['String']['output']>;
  /**
   * The balance of cash currently held in the account.
   * @deprecated Use fields in cash_balances instead
   */
  cashBalance: Scalars['Cents']['output'];
  /** Cash balance values for direct trading account */
  cashBalances: DirectTradingCashBalances;
  /** The envelope that contains the given account. */
  envelope: Envelope;
  /** Search available financial securities. */
  financialSecuritiesSearch: Array<FinancialSecurityFund | FinancialSecurityStock>;
  /** A financial security for the account. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** Whether the account has reached the maximum number of bank accounts allowed by operations. */
  hasReachedOpsBankAccountLimit: Scalars['Boolean']['output'];
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /** Whether the account is closed. */
  isClosed: Scalars['Boolean']['output'];
  /** Whether the legal sub account is an eligible destination for a recurring deposit. */
  isRecurringDepositEligible: Scalars['Boolean']['output'];
  /**
   * The legacy ID for this account.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /**
   * The name representing the account.
   * @deprecated Use account_description instead.
   */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** Pending inflow amount from custody balance API */
  pendingInflowAmount: Scalars['Cents']['output'];
  /** Pending orders for this account */
  pendingOrders: Array<ActivityItemOrder>;
  /** The performance of the account. */
  performance: Performance;
  /** A position in the given security in this account, if one is held in the account. */
  securityPosition?: Maybe<DirectTradingSecurityPosition>;
  /** The security positions held within the account. */
  securityPositions: Array<DirectTradingSecurityPosition>;
  /** Order availability for the given financial security. */
  sellOrderBlockedAvailabilityMessage?: Maybe<Scalars['String']['output']>;
  /** The options to initiate a transaction involving this account. */
  transactionOptions: Array<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountBuyOrderBlockedAvailabilityMessageArgs = {
  financialSecurityId: Scalars['ID']['input'];
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountFinancialSecuritiesSearchArgs = {
  searchTerm: Scalars['String']['input'];
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountFinancialSecurityArgs = {
  id: Scalars['ID']['input'];
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountSecurityPositionArgs = {
  id: Scalars['ID']['input'];
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountSellOrderBlockedAvailabilityMessageArgs = {
  financialSecurityId: Scalars['ID']['input'];
};

/** Cash balance values for direct trading account */
export type DirectTradingCashBalances = {
  __typename: 'DirectTradingCashBalances';
  /** boolean to determine if there's any pending cash balance. */
  anyPending: Scalars['Boolean']['output'];
  /** Cash balance customer can use as buying power */
  availableBalance: Scalars['Cents']['output'];
  /** Cash total balance, using pending inflow/outflow in calculation */
  totalBalance: Scalars['Cents']['output'];
};

/** Advice about the user's household investable assets for non-advised DirectTradingAccounts */
export type DirectTradingInvestableAssetsAdvice = {
  __typename: 'DirectTradingInvestableAssetsAdvice';
  /** The main advice text displayed to the user. */
  advice: Scalars['String']['output'];
  /** Additional advice shown when the user expands 'Show more'. */
  expandableAdvice?: Maybe<Scalars['String']['output']>;
};

/** Input object for validating secondary user details on a direct trading joint account. */
export type DirectTradingJointAccountSecondaryUserValidationInput = {
  /** Postal address of the secondary user. */
  address: PostalAddressInput;
  /** Date of birth of the secondary user. */
  dateOfBirth: Scalars['Date']['input'];
  /** First name of the secondary user. */
  firstName: Scalars['String']['input'];
  /** Last name of the secondary user. */
  lastName: Scalars['String']['input'];
  /** Middle name of the secondary user. */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the secondary user. */
  phoneNumber: Scalars['String']['input'];
};

/** The held position of a given security for a direct trading account. */
export type DirectTradingSecurityPosition = {
  __typename: 'DirectTradingSecurityPosition';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /**
   * The average cost for the security position
   * @deprecated Use averageCostV2 instead.
   */
  averageCost: Scalars['Cents']['output'];
  /** The average cost for the security position */
  averageCostV2?: Maybe<Scalars['Cents']['output']>;
  /** The financial security being held. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** Whether the position returns include pending cost basis, e.g., due to a pending ACATS transfer. */
  hasPendingCostBasis: Scalars['Boolean']['output'];
  /** Whether there are pending orders for this position */
  hasPendingOrders: Scalars['Boolean']['output'];
  /** The pending orders for this position. */
  pendingOrders: Array<ActivityItemOrder>;
  /**
   * The security being held.
   * @deprecated Use financialSecurity instead.
   */
  security: SecurityStock;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** Today's return percent for the security position */
  todaysReturn?: Maybe<DirectTradingSecurityPositionReturn>;
  /**
   * Today's return for the security position.
   * @deprecated Use todaysReturn#amount instead.
   */
  todaysReturnAmount: Scalars['Cents']['output'];
  /**
   * Today's return percent for the security position.
   * @deprecated Use todaysReturn#percent instead.
   */
  todaysReturnPercent: Scalars['Percent']['output'];
  /**
   * The total cost of the security position.
   * @deprecated Use totalCostV2 instead.
   */
  totalCost: Scalars['Cents']['output'];
  /** The total cost of the security position. */
  totalCostV2?: Maybe<Scalars['Cents']['output']>;
  /** The total return percent for the security position */
  totalReturn?: Maybe<DirectTradingSecurityPositionReturn>;
  /**
   * The total return amount for the security position.
   * @deprecated Use totalReturn#amount instead.
   */
  totalReturnAmount: Scalars['Cents']['output'];
  /**
   * Today's return percent for the security position.
   * @deprecated Use totalReturn#percent instead.
   */
  totalReturnPercent: Scalars['Percent']['output'];
};

/** A gain/loss return for a position held by the user. */
export type DirectTradingSecurityPositionReturn = {
  __typename: 'DirectTradingSecurityPositionReturn';
  /** The return expressed as an amount. */
  amount: Scalars['Cents']['output'];
  /** The return expressed as a percent. */
  percent: Scalars['Percent']['output'];
};

/** Input object for validating trust details for a direct trading account. */
export type DirectTradingTrustDetailsValidationInput = {
  /** The date the trust was established. */
  establishedDateTime: Scalars['Date']['input'];
  /** The legal name of the trust. */
  legalName: Scalars['String']['input'];
  /** The mailing address of the trust. */
  mailingAddress: PostalAddressInput;
  /** The nickname of the trust. */
  nickname: Scalars['String']['input'];
  /** The US state where the trust was organized (2-letter state code). */
  stateOfOrganization: Scalars['String']['input'];
  /** The 9-digit taxpayer identification number. */
  taxpayerIdentificationNumber: Scalars['String']['input'];
  /** The type of taxpayer identification number. */
  taxpayerIdentificationNumberType: TaxpayerIdentificationNumberType;
};

/** Financial and legal disclosures */
export type Disclosures = {
  __typename: 'Disclosures';
  /**
   * The general advertising disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  advertisingDisclosure: Scalars['String']['output'];
  /** The Betterment Advisor Network disclosure */
  advisorNetworkDisclosure: Scalars['String']['output'];
  /** The after-tax yield disclosure */
  afterTaxYieldDisclosure: Scalars['String']['output'];
  /** The APY daily rate disclosure */
  apyDailyRateDisclosure: Scalars['String']['output'];
  /** The blended 30 day yield disclosure */
  blended30DayYieldDisclosure: Scalars['String']['output'];
  /**
   * The bond investing disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  bondInvestingDisclosure: Scalars['String']['output'];
  /**
   * The brokerage services disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  brokerageServicesDisclosure: Scalars['String']['output'];
  /**
   * The general Cash Reserve disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  cashReserveDisclosures: Scalars['String']['output'];
  /**
   * The general checking disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  checkingDisclosure: Scalars['String']['output'];
  /**
   * A checking disclosure without cash details
   * @deprecated Use comprehensiveDisclosure instead
   */
  checkingDisclosureEcrDecoupled: Scalars['String']['output'];
  /** The Comprehensive Disclosure */
  comprehensiveDisclosure: Scalars['String']['output'];
  /**
   * Explains how direct trading account balances are calculated, including cash,
   * current investment values, pending deposits and trades.
   */
  directTradingAccountPerformanceDisclosure: Scalars['String']['output'];
  /**
   * The general everyday checking disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  everydayCheckingDisclosure: Scalars['String']['output'];
  /** The general FDIC disclosure */
  fdicDisclosure: Scalars['String']['output'];
  /**
   * The investment advisor disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  investmentAdvisorDisclosure: Scalars['String']['output'];
  /**
   * The investment in securities disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  investmentInSecuritiesDisclosure: Scalars['String']['output'];
  /** Provides explanation for money-weighted rate of return calculations. */
  moneyWeightedReturnExplanation: Scalars['String']['output'];
  /**
   * Explains how Betterment calculates and reports portfolio performance,
   * including Time-Weighted Return (TWR) and Internal Rate of Return (IRR)
   * methodologies. Details how performance calculations account for trades,
   * dividends, fees, and market conditions, along with explanations of educational
   * fund benchmarks.
   */
  performanceDisclosure: Scalars['String']['output'];
  /**
   * The general pricing disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  pricingDisclosure: Scalars['String']['output'];
  /** The projection returns assumptions disclosure. */
  projectionReturnsAssumptionsDisclosure: Scalars['String']['output'];
  /**
   * The projection returns assumptions disclosure.
   * @deprecated Use projectionReturnsAssumptionsDisclosure instead
   */
  projectionReturnsAssumptionsDisclosureIncludingConnectedAccountsImpact: Scalars['String']['output'];
  /**
   * The projection returns assumptions disclosure title
   * @deprecated Use non-server-driven copy instead.
   */
  projectionReturnsAssumptionsDisclosureTitle: Scalars['String']['output'];
  /** The projection returns assumptions disclosure. */
  projectionReturnsDisclosure: Scalars['String']['output'];
  /**
   * The projection returns assumptions disclosure.
   * @deprecated Use projectionReturnsAssumptionsDisclosure instead
   */
  projectionReturnsDisclosureIncludingConnectedAccountsImpact: Scalars['String']['output'];
  /** The disclosure for uploading custom purpose images */
  purposeCustomImageDisclosure: Scalars['String']['output'];
  /**
   * The retail entity disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  retailEntityDisclosure: Scalars['String']['output'];
  /**
   * The retail rollover banner disclosure
   * @deprecated Use comprehensiveDisclosure instead
   */
  rolloverBannerDisclosure?: Maybe<Scalars['String']['output']>;
  /** The SEC yield disclosure */
  secYieldDisclosure: Scalars['String']['output'];
  /** A short bond disclosure with yield data for Target Income BlackRock Portfolios */
  shortBondDisclosure: Scalars['String']['output'];
  /** The answer to the question: What is tax loss harvesting? */
  taxLossHarvestingExplanation: Scalars['HTML']['output'];
  /** Provides explanation for time-weighted rate of return calculations. */
  timeWeightedReturnExplanation: Scalars['String']['output'];
};

/** Autogenerated input type of DismissUserActivityCsvExportBannerMutation */
export type DismissUserActivityCsvExportBannerMutationInput = {
  /** The ID of the user activity csv export to dismiss. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissUserActivityCsvExportBannerMutation. */
export type DismissUserActivityCsvExportBannerMutationPayload = {
  __typename: 'DismissUserActivityCsvExportBannerMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DismissUserActivityCsvExportBannerMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DismissUserActivityCsvExportBannerMutation execution as type CsvExport. */
  result?: Maybe<CsvExport>;
};

/** A recoverable error that can be displaying to the User. */
export type DisplayableError = {
  __typename: 'DisplayableError';
  /** A human-readable error message to display to the user explaining the error and remediating actions. */
  message: Scalars['String']['output'];
  /** The path, the Operation entity or Input value that is the source of the error. */
  path: Array<Scalars['String']['output']>;
};

/** Metadata for a single document */
export type Document = {
  __typename: 'Document';
  /** An HTML string describing when a document will be available */
  availabilityMessageHtml?: Maybe<Scalars['String']['output']>;
  /** The date of the document */
  date: Scalars['DateTime']['output'];
  /** A description of the document */
  description?: Maybe<Scalars['String']['output']>;
  /** A detailed description of the document */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the document, or a legal account ID in the case of documents without a unique ID */
  id: Scalars['ID']['output'];
  /** The name of the document */
  name: Scalars['String']['output'];
  /** The available file types for the document */
  types: Array<DocumentFileType>;
};

/** Tax documents category */
export type DocumentCategory = {
  __typename: 'DocumentCategory';
  /** The disclosure for a given document category */
  disclosure?: Maybe<DocumentCategoryDisclosure>;
  /** An object containing the options to filter this category by */
  filter?: Maybe<DocumentFilter>;
  /** A unique identifier for this category */
  id: Scalars['ID']['output'];
  /** The name of this category */
  name: Scalars['String']['output'];
};

/** Tax documents disclosure type */
export type DocumentCategoryDisclosure = {
  __typename: 'DocumentCategoryDisclosure';
  /** The CTA that expands the disclosure */
  expandDisclosureCta?: Maybe<Scalars['String']['output']>;
  /** The long version of the disclosure */
  fullDisclosure?: Maybe<Scalars['String']['output']>;
  /** The short version of the disclosure */
  shortDisclosure: Scalars['String']['output'];
};

/** Tax documents category group */
export type DocumentCategoryGroup = {
  __typename: 'DocumentCategoryGroup';
  /** A list of subcategories */
  categories: Array<DocumentCategory>;
  /** The category group name */
  name: Scalars['String']['output'];
};

/** Tax documents category or category group */
export type DocumentCategoryOrCategoryGroup = DocumentCategory | DocumentCategoryGroup;

/** Data for a single document */
export type DocumentFile = {
  __typename: 'DocumentFile';
  /** The base 64 encoded data of the file */
  data: Scalars['Base64']['output'];
  /** The name of the document */
  name: Scalars['String']['output'];
};

/** The possible types for a document file */
export enum DocumentFileType {
  /** A CSV file */
  Csv = 'CSV',
  /** A PDF file */
  Pdf = 'PDF'
}

/** The options to filter a category by */
export type DocumentFilter = {
  __typename: 'DocumentFilter';
  /** An option designated as the default selection on the filter */
  defaultOption?: Maybe<DocumentFilterOption>;
  /** The name of the filter */
  name: Scalars['String']['output'];
  /** A list of options for the filter */
  options: Array<DocumentFilterOption>;
};

/** An object containing the start and end date, inclusive, for the filter */
export type DocumentFilterOption = {
  __typename: 'DocumentFilterOption';
  /** The end date for the filter, inclusive */
  endDateInclusive: Scalars['Date']['output'];
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The start date for the filter, inclusive */
  startDateInclusive: Scalars['Date']['output'];
};

/** Document verification status values returned from Socure. */
export enum DocumentVerificationStatus {
  /** Document verification passed, identity accepted */
  Accept = 'ACCEPT',
  /** Document verification failed, user must resubmit documents */
  Resubmit = 'RESUBMIT',
  /** Document verification requires manual review */
  Review = 'REVIEW'
}

/** The list of documents and an unavailability message, if any */
export type DocumentsResult = {
  __typename: 'DocumentsResult';
  /** The list of documents */
  documents: Array<Document>;
  /** An HTML string explaining why there are no documents available */
  unavailabilityMessageHtml?: Maybe<Scalars['String']['output']>;
};

/** DocuSign signing ceremony details for a document package */
export type DocusignSignature = {
  __typename: 'DocusignSignature';
  /** DocuSign client identifier for the signing ceremony */
  clientId: Scalars['String']['output'];
  /** Signing status: 'pending' (generating), 'ready' (URL available), or 'error' (failed) */
  status: Scalars['String']['output'];
  /** DocuSign signing ceremony URL, null unless status is 'ready' */
  url?: Maybe<Scalars['String']['output']>;
};

/** A draft envelope used for editing purposes before committing changes. */
export type DraftEnvelope = EditableEnvelope & {
  __typename: 'DraftEnvelope';
  /** The editable purpose of this envelope. */
  editablePurpose?: Maybe<DraftPurposeEmergencyFund | DraftPurposeMajorPurchase | DraftPurposeRetirementGrowth | DraftPurposeRetirementIncome>;
  /** The unique ID of the envelope. */
  id: Scalars['ID']['output'];
};

/** Draft envelope account for goal creation flow */
export type DraftEnvelopeAccount = {
  __typename: 'DraftEnvelopeAccount';
  /** Icon of the draft envelope account */
  icon: ThemedAsset;
  /** Name of the draft envelope account */
  name: Scalars['String']['output'];
};

/** A draft emergency fund purpose that can be edited before being committed. */
export type DraftPurposeEmergencyFund = EditablePurpose & EditablePurposeEmergencyFund & {
  __typename: 'DraftPurposeEmergencyFund';
  /** The buffer percentage to add on top of monthly expenses. */
  buffer: Scalars['Percent']['output'];
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The amount of monthly expenses. */
  monthlyExpensesAmount: Scalars['Cents']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
};

/** A draft major purchase purpose that can be edited before being committed. */
export type DraftPurposeMajorPurchase = EditablePurpose & EditablePurposeMajorPurchase & {
  __typename: 'DraftPurposeMajorPurchase';
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
  /** The target date by which to achieve the major purchase. */
  targetDate: Scalars['Date']['output'];
};

/** A draft retirement growth purpose that can be edited before being committed. */
export type DraftPurposeRetirementGrowth = EditablePurpose & EditablePurposeRetirementGrowth & {
  __typename: 'DraftPurposeRetirementGrowth';
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The age at which the user plans to retire. */
  retirementAge: Scalars['Int']['output'];
  /** The zip code where the user plans to retire. */
  retirementZip: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
  /** The desired monthly spending amount in retirement. */
  targetMonthlySpendingAmount: Scalars['Cents']['output'];
};

/** A draft retirement income purpose that can be edited before being committed. */
export type DraftPurposeRetirementIncome = EditablePurpose & EditablePurposeRetirementIncome & {
  __typename: 'DraftPurposeRetirementIncome';
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
};

/**
 * Information about the drift for a given portfolio. Drift describes how much a portfolio's
 *       asset allocation has changed from its target allocation due to the performance of the underlying assets.
 *       Drift is the difference between the portfolio's target allocation and its
 * current allocation, expressed as a percentage.
 */
export type Drift = {
  __typename: 'Drift';
  /** An explanation of drift, and how it relates to the portfolio's target allocation. */
  explanation: Scalars['HTML']['output'];
  /**
   * Betterment portfolios have a predefined drift threshold. When drift exceeds
   * this value, rebalancing will occur if enabled. This value indicates if drift
   * is above the defined threshold.
   */
  isAboveThreshold: Scalars['Boolean']['output'];
  /** The overall portfolio drift percent (from target). */
  percent: Scalars['Percent']['output'];
};

/** An envelope that can be edited. */
export type EditableEnvelope = {
  /** The editable purpose of this envelope. */
  editablePurpose?: Maybe<DraftPurposeEmergencyFund | DraftPurposeMajorPurchase | DraftPurposeRetirementGrowth | DraftPurposeRetirementIncome>;
  /** The unique ID of the envelope. */
  id: Scalars['ID']['output'];
};

/** A purpose that can be edited, either an existing purpose or a draft. */
export type EditablePurpose = {
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
};

/** An emergency fund purpose that can be edited. */
export type EditablePurposeEmergencyFund = {
  /** The buffer percentage to add on top of monthly expenses. */
  buffer: Scalars['Percent']['output'];
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The amount of monthly expenses. */
  monthlyExpensesAmount: Scalars['Cents']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
};

/** A major purchase purpose that can be edited. */
export type EditablePurposeMajorPurchase = {
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
  /** The target date by which to achieve the major purchase. */
  targetDate: Scalars['Date']['output'];
};

/** A retirement growth purpose that can be edited. */
export type EditablePurposeRetirementGrowth = {
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The age at which the user plans to retire. */
  retirementAge: Scalars['Int']['output'];
  /** The zip code where the user plans to retire. */
  retirementZip: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
  /** The desired monthly spending amount in retirement. */
  targetMonthlySpendingAmount: Scalars['Cents']['output'];
};

/** A retirement income purpose that can be edited. */
export type EditablePurposeRetirementIncome = {
  /** The unique ID of the editable purpose. */
  id: Scalars['ID']['output'];
  /** The Base64 encoded image data for the purpose */
  imageData?: Maybe<Scalars['Base64']['output']>;
  /** The image type for the purpose */
  imageType?: Maybe<Scalars['String']['output']>;
  /** Whether this purpose can be deleted. */
  isDeletionEligible: Scalars['Boolean']['output'];
  /** The name of the purpose. */
  name: Scalars['String']['output'];
  /** The sub-type (advice type) of the purpose */
  purposeSubType: Scalars['String']['output'];
  /** The target amount for the purpose */
  targetAmount?: Maybe<Scalars['Cents']['output']>;
};

/** A category of EducationArticles. */
export enum EducationArticleCategoryType {
  B4B = 'B4B',
  Cash = 'CASH',
  Crypto = 'CRYPTO',
  Investing = 'INVESTING',
  Performance = 'PERFORMANCE',
  Summary = 'SUMMARY'
}

/** Type that describes the result of a send email action. */
export type EmailDispatch = {
  __typename: 'EmailDispatch';
  /** The currently logged in user. */
  user: User;
  /** Was an email sent as a result of this user request? */
  wasEmailSent: Scalars['Boolean']['output'];
};

/** Represents emergency fund coverage data for a user creating a goal based account */
export type EmergencyFundCoverage = {
  __typename: 'EmergencyFundCoverage';
  /** Percentage amount to treat as emergency fund buffer */
  buffer: Scalars['Percent']['output'];
  /** Text explaining the emergency fund buffer, as it relates to allocation */
  description?: Maybe<Scalars['String']['output']>;
  /** A set of messages for the user. */
  messages: Array<Message>;
  /** Available options for emergency fund coverage */
  options: Array<EmergencyFundCoverageOption>;
};


/** Represents emergency fund coverage data for a user creating a goal based account */
export type EmergencyFundCoverageMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** Represents a single option for emergency fund coverage */
export type EmergencyFundCoverageOption = {
  __typename: 'EmergencyFundCoverageOption';
  /** Amount of money to be saved in the emergency fund */
  amount: Scalars['Cents']['output'];
  /** Number of months of expenses plus buffer */
  bufferedMonths: Scalars['Float']['output'];
  /** A unique identifier for the coverage option. */
  id: Scalars['ID']['output'];
  /** Number of months of expenses to be saved in the emergency fund */
  months: Scalars['Int']['output'];
};

/** A variant of EmergencyFundCoverage. */
export enum EmergencyFundCoverageVariant {
  Cash = 'CASH',
  Investing = 'INVESTING'
}

/** An emergency fund purpose creation option */
export type EmergencyFundPurposeCreationOption = PurposeCreationOptionInterface & {
  __typename: 'EmergencyFundPurposeCreationOption';
  /** The default monthly expenses amount for emergency fund calculation */
  defaultMonthlyExpenses: Scalars['Cents']['output'];
  /** The default name for this purpose */
  defaultName: Scalars['String']['output'];
  /** A description of the purpose creation option */
  description?: Maybe<Scalars['String']['output']>;
  /** HTML disclosure text for the emergency fund purpose */
  disclosure: Scalars['String']['output'];
  /** The emergency fund coverage calculation for different savings targets and buffer */
  emergencyFundCoverage: EmergencyFundCoverage;
  /** A unique identifier for the purpose creation option */
  id: Scalars['ID']['output'];
  /** The legacy advice type identifier */
  legacyAdviceTypeId: Scalars['String']['output'];
  /** The display name of the purpose creation option */
  name: Scalars['String']['output'];
  /** The image icon and image key representing this purpose option */
  purposeAsset: PurposeAsset;
  /** The recommendation message for monthly expenses amount */
  recommendation: Message;
};


/** An emergency fund purpose creation option */
export type EmergencyFundPurposeCreationOptionEmergencyFundCoverageArgs = {
  monthlyExpensesCents: Scalars['Int']['input'];
  variant?: InputMaybe<EmergencyFundCoverageVariant>;
};

/** Input object for updating an emergency fund purpose */
export type EmergencyFundUpdateInput = {
  /** The buffer percentage to add on top of monthly expenses */
  bufferPercent?: InputMaybe<Scalars['Int']['input']>;
  /** The amount of monthly expenses */
  monthlyExpensesAmount?: InputMaybe<Scalars['Cents']['input']>;
};

/** An employee user */
export type Employee = {
  __typename: 'Employee';
  /** A unique identifier for an Employee */
  id: Scalars['ID']['output'];
  /** The ID for the deferral setting, as recognized by our legacy REST APIs. */
  legacyId: Scalars['String']['output'];
  /** The frequency of the employee's pay. */
  payFrequency: Scalars['String']['output'];
  /** The number of remaining payrolls in the current year. */
  remainingAnnualPayrolls: Scalars['Int']['output'];
  /** The employee's annual salary in cents. */
  salary: Scalars['Cents']['output'];
};

/** Input values for an employee contribution configuration change request. */
export type EmployeeContributionConfigurationChangeInput = {
  /** The type of employee contribution rate for base pay periods (amount or percent). */
  baseType: EmployeeContributionRateType;
  /** The value for base pay periods (e.g., 500 = 5.00%, or 1000 = $10.00). */
  baseValue: Scalars['Int']['input'];
  /** Benefit type */
  benefitType: Scalars['String']['input'];
  /** The type of employee contribution rate for bonus pay periods (amount or percent). */
  bonusType?: InputMaybe<EmployeeContributionRateType>;
  /** The value for bonus pay periods (e.g., 500 = 5.00%, or 1000 = $10.00). */
  bonusValue?: InputMaybe<Scalars['Int']['input']>;
  /** The employee ID. */
  employeeId: Scalars['ID']['input'];
  /** The legal account ID. */
  legalAccountId: Scalars['ID']['input'];
};

/** The type of employee contribution rate, either amount or percent. */
export enum EmployeeContributionRateType {
  /** A fixed dollar contribution amount */
  Amount = 'AMOUNT',
  /** A contribution rate specified as a percentage */
  Percent = 'PERCENT'
}

/** An employer of the user; a plan sponsor for the user's employee benefits plan. */
export type Employer = {
  __typename: 'Employer';
  /** The postal address for the employer. */
  address?: Maybe<PostalAddress>;
  /** The configuration for the employer's 401(k) contributions. */
  contributionConfig?: Maybe<EmployerFourOhOneKContributionConfig>;
  /** The federal tax identification number (TIN) for the employer. */
  federalTaxIdNumber?: Maybe<Scalars['TIN']['output']>;
  /** Provides data for the employers 401(k) contributions. */
  fourOhOneKContributions?: Maybe<EmployerFourOhOneKContributionsResult>;
  /** A unique identifier for an Employer */
  id: Scalars['ID']['output'];
  /** The ID of the employer, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** The name of the employer. */
  name: Scalars['String']['output'];
  /** The solo 401(k) plan associated with this employer. */
  soloFourOhOneKPlan?: Maybe<SoloFourOhOneKPlan>;
};

/** The employer's 401(k) contribution configuration. */
export type EmployerFourOhOneKContributionConfig = {
  __typename: 'EmployerFourOhOneKContributionConfig';
  /** The call to action description for employer contributions. */
  ctaDescription?: Maybe<Scalars['String']['output']>;
  /** The description for discretionary employer contributions with tiers. */
  discretionaryWithTiersDescription?: Maybe<Scalars['String']['output']>;
  /** Employer contributions frequency. */
  frequency: EmployerFourOhOneKContributionFrequency;
  /** Indicates whether the employer's contributions have a vesting schedule. */
  hasVesting: Scalars['Boolean']['output'];
  /** A unique identifier for an EmployerFourOhOneKContributionConfig */
  id: Scalars['ID']['output'];
  /** Indicates whether the employer's contributions include student loan payments. */
  includesStudentLoanPayments: Scalars['Boolean']['output'];
  /** Indicates whether the employer's contributions are discretionary. */
  isDiscretionary: Scalars['Boolean']['output'];
  /** Indicates whether the employer's contributions are non-elective. */
  isNonElective: Scalars['Boolean']['output'];
  /** The maximum amount the employer will contribute. */
  limit: Scalars['Cents']['output'];
  /** The long description for employer contributions. */
  longDescription: Scalars['String']['output'];
  /** The short description for employer contributions. */
  shortDescription: Scalars['String']['output'];
};

/** The frequency of employer 401(k) contributions */
export enum EmployerFourOhOneKContributionFrequency {
  /** Annually */
  Annual = 'ANNUAL',
  /** Bi-monthly */
  BiMonthly = 'BI_MONTHLY',
  /** Bi-weekly */
  BiWeekly = 'BI_WEEKLY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Semi-Annually */
  SemiAnnual = 'SEMI_ANNUAL',
  /** Semi-Monthly */
  SemiMonthly = 'SEMI_MONTHLY',
  /** Weekly */
  Weekly = 'WEEKLY'
}

/** The employer 401(k) contributions for a user. */
export type EmployerFourOhOneKContributions = {
  __typename: 'EmployerFourOhOneKContributions';
  /** The amount of employer 401(k) contributions received. */
  amount: Scalars['Cents']['output'];
  /** The current balance after gains/losses of employer 401(k) contributions. */
  balance: Scalars['Cents']['output'];
  /** A unique identifier for an EmployerFourOhOneKContributions */
  id: Scalars['ID']['output'];
  /** A breakdown of contributions by type. */
  lineItems: Array<FourOhOneKContributionsLineItem>;
  /** A projection of future employer 401(k) contributions. */
  projection?: Maybe<EmployerFourOhOneKContributionsProjection>;
  /** The vested amount and percent of employer 401(k) contributions. */
  vested?: Maybe<EmployerFourOhOneKContributionsVested>;
};

/** A projection of 401(K) contributions. */
export type EmployerFourOhOneKContributionsProjection = {
  __typename: 'EmployerFourOhOneKContributionsProjection';
  /** A unique identifier for an FourOhOneKContributionsProjection */
  id: Scalars['ID']['output'];
  /** Total employer contributions for the given time period. */
  total: Scalars['Cents']['output'];
  /** Projected upcoming employer contributions for the given time period. */
  upcoming: Scalars['Cents']['output'];
};

/** The 401(k) contributions for a user. */
export type EmployerFourOhOneKContributionsResult = {
  __typename: 'EmployerFourOhOneKContributionsResult';
  /** All Employer 401(k) contributions. */
  allTime: EmployerFourOhOneKContributions;
  /** A unique identifier for an EmployerFourOhOneKContributionsResult */
  id: Scalars['ID']['output'];
  /** This year Employer 401(k) contributions. */
  thisYear: EmployerFourOhOneKContributions;
};

/** Vesting information about the user's employer's 401k contributions */
export type EmployerFourOhOneKContributionsVested = {
  __typename: 'EmployerFourOhOneKContributionsVested';
  /** The vested amount of employer 401(k) contributions. */
  amount: Scalars['Cents']['output'];
  /** The vested percent of employer 401(k) contributions. */
  percent: Scalars['Percent']['output'];
};

/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'items', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type Envelope = {
  __typename: 'Envelope';
  /** The accounts contained within and organized by the envelope. */
  accounts: Array<CashAccount | CheckingAccount | DirectTradingAccount | ExternalAccountEnvelopeAssociation | Five29Account | ManagedAccount>;
  /** A description of the items contained within and organized by the envelope. */
  accountsDescription?: Maybe<Scalars['String']['output']>;
  /** The financial activity for accounts within the envelope. */
  activityConnection: ActivityItemConnection;
  /** A collection of articles for education and advice for the envelope. */
  articles: Array<Article>;
  /** The balance of the envelope; null if no available balance to show. */
  balance?: Maybe<Scalars['Cents']['output']>;
  /**
   * The balance projection for the envelope.
   * @deprecated Always returns null; use Purpose#projection instead, for envelope-level projections for accounts.
   */
  balanceProjection?: Maybe<BalanceProjection>;
  /** Auditing all messages to journal and filter messages based on location */
  currentMarketingMessage?: Maybe<MarketingMessage>;
  /** Whether the envelope has a recurring transaction configured into one of the accounts it holds. */
  hasRecurringTransaction: Scalars['Boolean']['output'];
  /**
   * The icon used to represent the envelope.
   * @deprecated Use `purpose.image` instead.
   */
  icon: ThemedAsset;
  /** The id of the envelope. */
  id: Scalars['ID']['output'];
  /** A collection of all of the legal sub accounts (sub accounts of a legal account) within the envelope. */
  legalSubAccounts: Array<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /** Messages associated with the envelope. */
  messages: Array<Message>;
  /**
   * A sum of all expected/planned inflows and outflows involving accounts in the
   * envelope, for envelopes that support the calculation. This value includes the
   * sum of the monthly net amounts of all configured recurring deposits, recurring
   * transfers, recurring withdrawals, expected employee contributions (if an
   * account is a 401k), and planned external account contributions.
   */
  monthlyNetRecurringCashflows?: Maybe<Scalars['Cents']['output']>;
  /**
   * The name of the envelope. This name is typically a user-defined name that describes the purpose of the envelope.
   * @deprecated Use `purpose.name` instead.
   */
  name: Scalars['String']['output'];
  /**
   * The position of the envelope in the display order. This represents the
   * user-customized ordering of envelopes for display purposes. A null value
   * indicates no custom ordering has been set for this envelope.
   */
  orderPosition?: Maybe<Scalars['Int']['output']>;
  /** All payroll contribution configs for the accounts within this envelope. */
  payrollContributionConfigs: Array<PayrollContributionConfig>;
  /** Performance totals for the envelope. */
  performanceTotals?: Maybe<PerformanceTotals>;
  /** The envelope's purpose. */
  purpose?: Maybe<PurposeEmergencyFund | PurposeMajorPurchase | PurposeRetirementGrowth | PurposeRetirementIncome>;
  /** All recurring transaction configs for the accounts within this envelope. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** The status of the envelope. */
  status?: Maybe<EnvelopeStatus>;
  /**
   * The total annual recurring inflows amount for the envelope, for envelopes
   * where that calculation is currently supported. This value represents the
   * user's current planned external contributions (which they edit directly), as
   * well as the total planned contributions for all of the sub accounts in the
   * envelope. When the user has directly edited a planned contribution amount for
   * a sub account, that value is used to represent the inflows for the sub
   * account; otherwise, the inflows for a sub account include expected employee
   * contributions (if a 401k), and the sum of all monthly recurring deposits and
   * transfers (but not withdrawals).
   */
  totalAnnualRecurringInflows?: Maybe<Scalars['Cents']['output']>;
  /**
   * The total monthly recurring inflows amount for the envelope, for envelopes
   * where that calculation is currently supported. This value includes current
   * values for all "auto deposits" as relevant to the projections domain,
   * _including_ expected employee contributions and external planned
   * contributions.This value does not include planned recurring withdrawals or
   * recurring transfers.
   * @deprecated Clients no longer have any use for this value, which previously was planned to be used as the default input value for recurring deposits in the purpose forecaster experience. Instead, the clients should pass a monthly recurring deposit value as the input, and use monthlyNetRecurringCashflows for all other contextual information related to recurring transactions in Forecaster.
   */
  totalMonthlyRecurringInflows?: Maybe<Scalars['Cents']['output']>;
  /**
   * The total monthly recurring outflows amount for the envelope, for envelopes
   * where that calculation is currently supported. This value does not include
   * configured recurring deposits or transfers.
   * @deprecated Clients no longer have any use for this value, which previously was planned to be used as the default input value for recurring withdrawals in the purpose forecaster experience. Instead, the clients should pass a monthly recurring withdrawal value as the input, and use monthlyNetRecurringCashflows for all other contextual information related to recurring transactions in Forecaster.
   */
  totalMonthlyRecurringOutflows?: Maybe<Scalars['Cents']['output']>;
  /** The options to initiate a transaction involving this envelope. */
  transactionOptions: Array<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
};


/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'items', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type EnvelopeActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'items', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type EnvelopeArticlesArgs = {
  scope?: InputMaybe<ArticlesScope>;
};


/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'items', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type EnvelopeCurrentMarketingMessageArgs = {
  input: MarketingMessagesInput;
};


/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'items', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type EnvelopeMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** A top-level financial account within an envelope. */
export type EnvelopeAccount = {
  /**
   * The envelope holding the item. Beware not to use this field to access complex
   * data about an envelope's items cyclically, such that a user with a very high
   * number of items could end up executing an operation with a dramatically high
   * runtime complexity.
   */
  envelope: Envelope;
  /** The icon used to represent the account. */
  icon: ThemedAsset;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
};

/** Input type for updating the order position of an envelope */
export type EnvelopeOrderInput = {
  /** The ID of the envelope */
  envelopeId: Scalars['ID']['input'];
  /** The position of the envelope in the display order */
  orderPosition: Scalars['Int']['input'];
};

/** The status summary for a Goal. */
export type EnvelopeStatus = {
  __typename: 'EnvelopeStatus';
  /** The short description for the status (E.g., "On track") */
  shortDescription: Scalars['String']['output'];
  /** The style of the status. */
  style: EnvelopeStatusStyle;
};

/** The style of the goal status. */
export enum EnvelopeStatusStyle {
  /** Danger */
  Danger = 'DANGER',
  /** Neutral */
  Neutral = 'NEUTRAL',
  /** Success */
  Success = 'SUCCESS'
}

/** Estimated date for a trade request */
export type EstimatedTradeDate = {
  __typename: 'EstimatedTradeDate';
  /** Estimated date of the trade completion */
  date: Scalars['Date']['output'];
  /** Human readable description of the trade completion timing */
  description: Scalars['String']['output'];
};

/** Estimated time range for a trade request */
export type EstimatedTradeTimeRange = {
  __typename: 'EstimatedTradeTimeRange';
  /** Human readable description of the trade completion day */
  dayDescription: Scalars['String']['output'];
  /** Estimated end time of the trade completion window */
  endTime: Scalars['DateTime']['output'];
  /** Estimated start time of the trade completion window */
  startTime: Scalars['DateTime']['output'];
  /** Human readable description of the trade completion time window */
  timeRangeDescription: Scalars['String']['output'];
};

/** Estimated timing of a trade request */
export type EstimatedTradeTiming = EstimatedTradeDate | EstimatedTradeTimeRange;

/**
 * A fund's expense ratio is its annual fee, measured as a percent of the
 * investment in the fund. This value is expressed as a percentage of the total
 * assets in the portfolio.
 */
export type ExpenseRatio = {
  __typename: 'ExpenseRatio';
  /** An explanation of expense ratio and the impact it has on your investment. */
  explanation: Scalars['String']['output'];
  /**
   * In the context of a portfolio, this is the expense ratio in aggregate for all
   * funds in the portfolio, calculated by taking the weighted average of the
   * expense ratios of each fund in the portfolio. In the context of a fund, this
   * is the fund's expense ratio.
   */
  value: Scalars['Percent']['output'];
};

/** Account purposes that uses expenses data for target settings */
export type ExpensesBasedPurposeOption = AccountPurposeOption & {
  __typename: 'ExpensesBasedPurposeOption';
  /** The Default Monthly Amount Calculated for the User */
  defaultMonthlyExpenses: Scalars['Cents']['output'];
  /** The default name of the account purpose option */
  defaultName: Scalars['String']['output'];
  /** Disclosure provided to the user */
  disclosure: Scalars['HTML']['output'];
  /** The themed asset set for the icon used to represent this account purpose option. */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the concrete account purpose option type */
  name: Scalars['String']['output'];
  /** Recommendation provided to user regarding their target */
  recommendation: Message;
};

/** An external financial account for an Investor. */
export type ExternalAccount = SomebodysExternalAccount & {
  __typename: 'ExternalAccount';
  /** The redacted account number for the given External Account. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** The account type display name for the given External Account. */
  accountType: Scalars['String']['output'];
  /** A description for the account, including account type and redacted account number. */
  accountTypeAndRedactedAccountNumber: Scalars['String']['output'];
  /** The current account balance for this External Account. */
  balance: Scalars['Cents']['output'];
  /** The envelope that this external account is associated with. */
  envelope?: Maybe<Envelope>;
  /** A list of Envelopes that are eligible for this external account to be added to */
  envelopeOptions: Array<Envelope>;
  /** The goal that this external account is associated with. */
  goal?: Maybe<Goal>;
  /**
   * Whether the external account can display a breakdown of all of its holdings.
   * @deprecated This field is temporary, only until it is replaced by a more complete modeling of external account holdings.
   */
  hasHoldings: Scalars['Boolean']['output'];
  /** Indicates that a rollover process has started for funds transfer into a Betterment account. */
  hasPendingRollover: Scalars['Boolean']['output'];
  /** The icon for the account. */
  icon: ThemedAsset;
  /** The unique id for the external account. */
  id: Scalars['ID']['output'];
  /** The name of the institution that holds the account. */
  institutionName: Scalars['String']['output'];
  /**
   * The overarching investment type that best describes the account. Can be
   * `diversified` to represent complex accounts with multiple or complex financial instruments.
   */
  investmentType?: Maybe<Scalars['String']['output']>;
  /**
   * Is this External Account hidden from display?
   * @deprecated Use isVisible instead.
   */
  isHidden: Scalars['Boolean']['output'];
  /**
   * An account which is not held on the Betterment platform
   *         (ie the funds are not invested by or managed by Betterment in any material way),
   *         but for which we have a special integration setup that allows for
   * certain kinds of actions like deposits facilitated by custody.
   */
  isIntegrated: Scalars['Boolean']['output'];
  /** Is this External Account manually synchronized? */
  isManual: Scalars['Boolean']['output'];
  /** Is this External Account manually synchronized? */
  isManuallySynced: Scalars['Boolean']['output'];
  /** Whether the account is visible in aggregation views and data. */
  isVisible: Scalars['Boolean']['output'];
  /** A description of when the account was last updated. */
  lastUpdatedAtDisplay?: Maybe<Scalars['String']['output']>;
  /** The ID for the account, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** Non-dismissable information displayed to users. */
  messages: Array<Message>;
  /** The name for the External Account. */
  name: Scalars['String']['output'];
  /** The owner of the account. This is not always the same as the connector of the account. */
  ownerName: Scalars['String']['output'];
  /**
   * The subtype of the external account that encapsulates more specific financial
   * data that varies depending on the type of account.
   */
  subtype: ExternalAccountSubtypeBasic | ExternalAccountSubtypeEmployerSponsored | ExternalAccountSubtypeIra;
  /** If present, the external account can be transferred to Betterment either through rollover or taxable transfer. */
  transactionOption?: Maybe<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
};


/** An external financial account for an Investor. */
export type ExternalAccountMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** Details about plan contributions for an employer sponsored external account. */
export type ExternalAccountEmployerMatch = {
  __typename: 'ExternalAccountEmployerMatch';
  /** The max an employer will contribute to the account. */
  employerContributionMax?: Maybe<Scalars['Percent']['output']>;
  /** The percentage the employer will match. */
  employerContributionPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The id of the the employer match. */
  id: Scalars['ID']['output'];
  /** The match type for the employer match. */
  matchType: Scalars['String']['output'];
};

/**
 * The relationship between an external account and an envelope. External accounts
 * are unique in the Betterment system in that they can belong to an envelope, or
 * exist independently from an envelope. When an external account belongs to an
 * envelope, the connection from the envelope to that account is represented by this type.
 */
export type ExternalAccountEnvelopeAssociation = EnvelopeAccount & {
  __typename: 'ExternalAccountEnvelopeAssociation';
  /** The external account represented by this envelope item. */
  account: ExternalAccount | TheirExternalAccount;
  /**
   * The envelope holding the item. Beware not to use this field to access complex
   * data about an envelope's items cyclically, such that a user with a very high
   * number of items could end up executing an operation with a dramatically high
   * runtime complexity.
   */
  envelope: Envelope;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The name representing the account. */
  name: Scalars['String']['output'];
};

/** Details about plan contributions for an employer sponsored external account */
export type ExternalAccountPlanContributions = {
  __typename: 'ExternalAccountPlanContributions';
  /** Details about the employer match for the external account. */
  employerMatch: ExternalAccountEmployerMatch;
  /** The id of the external account plan contribution. */
  id: Scalars['ID']['output'];
  /** The planned annual contributions for the external account. */
  plannedAnnualContributions: Scalars['Cents']['output'];
  /** Whether the external account supports Roth contributions. */
  supportsRothContributions?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represent an external account subtype that encapsulates more specific financial
 * data that varies depending on the type of account. This data can be used for
 * aggregation and advice purposes.
 */
export type ExternalAccountSubtype = {
  /** The id of the external account subtype. */
  id: Scalars['ID']['output'];
  /** The name of the external account subtype. */
  name: Scalars['String']['output'];
};

/** Subtype details for a basic external account. */
export type ExternalAccountSubtypeBasic = ExternalAccountSubtype & {
  __typename: 'ExternalAccountSubtypeBasic';
  /** The id of the external account subtype. */
  id: Scalars['ID']['output'];
  /** The name of the external account subtype. */
  name: Scalars['String']['output'];
};

/** Subtype details for an employer sponsored external account. */
export type ExternalAccountSubtypeEmployerSponsored = ExternalAccountSubtype & {
  __typename: 'ExternalAccountSubtypeEmployerSponsored';
  /** The id of the external account subtype. */
  id: Scalars['ID']['output'];
  /** Whether employer sponsor is the user's current employer. */
  isCurrentEmployer: Scalars['Boolean']['output'];
  /** The name of the external account subtype. */
  name: Scalars['String']['output'];
  /** Details about plan contributions for the employer sponsored external account. */
  planContributions: ExternalAccountPlanContributions;
};

/** Subtype details for an IRA external account. */
export type ExternalAccountSubtypeIra = ExternalAccountSubtype & {
  __typename: 'ExternalAccountSubtypeIra';
  /** The id of the external account subtype. */
  id: Scalars['ID']['output'];
  /** The name of the external account subtype. */
  name: Scalars['String']['output'];
  /** The planned annual contributions for the external account. */
  plannedAnnualContributions: Scalars['Cents']['output'];
};

/** Input structure for an External Account Where query. */
export type ExternalAccountsWhereInput = {
  /** An ID for the envelope whom external accounts are related with. */
  envelopeId?: InputMaybe<Scalars['ID']['input']>;
  /** A boolean representing if it is possible to use an external account as a bank account. */
  isBankAccountEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean representing if an external account is visible. */
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The option to fully transfer a taxable external account. */
export type ExternalTransferOption = TransactionOption & {
  __typename: 'ExternalTransferOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** Externally Advised Plan Portfolio details for a given goal. */
export type ExternallyAdvisedPlanPortfolio = Portfolio & {
  __typename: 'ExternallyAdvisedPlanPortfolio';
  /** The allocation breakdown of the portfolio for the given investment goal. */
  allocationBreakdown: Array<AllocationBreakdown>;
  /** A value used for client-side caching purposes. */
  id: Scalars['ID']['output'];
  /** The QDIA (default portfolio set by an advisor) set for a given goal's portfolio. */
  qdiaFund: LegacySecurity;
  /** The strategy for the goal's portfolio */
  strategy: PortfolioStrategy;
  /**
   * The current target weights of securities for a given goal's portfolio.
   * @deprecated Implement and use SecurityGroupHolding instead.
   */
  weightedSecurities: Array<LegacyWeightedSecurity>;
};

/** The type of user feedback */
export enum FeedbackType {
  /** Something is confusing */
  Confusing = 'CONFUSING',
  /** I like something */
  Like = 'LIKE',
  /** Something isn't working or seems wrong */
  NotWorking = 'NOT_WORKING',
  /** I have a suggestion */
  Suggestion = 'SUGGESTION'
}

/** Represent data concerns of a user signing up for financial coaching */
export type FinancialCoachingOnboardingOption = ProductOnboardingOption & {
  __typename: 'FinancialCoachingOnboardingOption';
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** Represent data concerns of a user signing up for financial coaching */
export type FinancialCoachingOnboardingOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/**
 * Financial information about the user (e.g., tax status/information, income
 * details, etc), used for financial planning and advice.
 */
export type FinancialProfile = {
  __typename: 'FinancialProfile';
  /** The user's annual pretax income. */
  annualPretaxIncome: Scalars['Cents']['output'];
  /**
   * Personalized advice about the user's household investable assets for
   * direct-trading accounts. Returns null for users without a direct-trading
   * account or advised users.
   */
  directTradingInvestableAssetsAdvice?: Maybe<DirectTradingInvestableAssetsAdvice>;
  /** The user's federal tax bracket percentage. */
  federalTaxBracket?: Maybe<Scalars['Percent']['output']>;
  /** The user's investable assets for the household. */
  householdInvestableAssets: Scalars['Cents']['output'];
  /** The unique ID of the financial profile. */
  id: Scalars['ID']['output'];
  /** The User's selected Investing Experience Level */
  investingExperience?: Maybe<InvestingExperienceLevel>;
  /** The number of dependents the user expects to have during retirement. */
  numberOfDependents: Scalars['Int']['output'];
  /** The user's profession information including employment status and occupation. */
  profession: Profession;
  /**
   * Personalized retirement assumptions for the current user, as defined while
   * setting up a personalized retirement plan. This can be null if the retirement
   * goal is not yet personalized.
   */
  retirementAssumptions?: Maybe<FinancialProfileRetirementAssumptions>;
  /** The user's spouse, as specified by the user. */
  spouse?: Maybe<Spouse>;
  /**
   * The user's tax filing status. See documentation by the IRS for more information:
   * https://apps.irs.gov/app/understandingTaxes/teacher/hows_mod05.jsp
   */
  taxFilingStatus: TaxFilingStatus;
};

/** Financial and personal assumptions about the user's expectations for their retirement. */
export type FinancialProfileRetirementAssumptions = {
  __typename: 'FinancialProfileRetirementAssumptions';
  /**
   * The total amount of eligible deductions claimed before calculating adjusted
   * gross income (AGI) on an annual tax return. Includes expenses like student
   * loan interest, retirement contributions, and educator expenses. Available to
   * all filers, regardless of whether they itemize.
   */
  annualAboveTheLineDeductionsAmount: Scalars['Cents']['output'];
  /**
   * The total income of all household members, minus certain deductions, used to
   * calculate federal income tax. Includes wages, salaries, and other taxable
   * income. Available to all filers, regardless of whether they itemize.
   */
  annualAdjustedGrossIncomeAmount?: Maybe<Scalars['Cents']['output']>;
  /** The expected rate of inflation each year. */
  annualInflation: Scalars['Percent']['output'];
  /**
   * The total amount of eligible deductible expenses a taxpayer chooses to report
   * individually (itemize) on their annual tax return instead of taking the
   * standard deduction. Includes categories such as medical expenses, state and
   * local taxes, mortgage interest, and charitable contributions.
   */
  annualItemizedDeductionsAmount: Scalars['Cents']['output'];
  /**
   * The total income of all household members, minus certain deductions, used to
   * calculate federal income tax. Includes wages, salaries, and other taxable
   * income. Available to all filers, regardless of whether they itemize.
   */
  annualModifiedAdjustedGrossIncomeAmount?: Maybe<Scalars['Cents']['output']>;
  /** The user's expected amount of other income during retirement. */
  annualOtherRetirementIncome: Scalars['Cents']['output'];
  /** The expected annual growth rate of the user's salary after inflation. */
  annualSalaryGrowthAfterInflation: Scalars['Percent']['output'];
  /**
   * The zip code the user plans to live in during retirement, which impacts
   * guidance around recommended spending during retirement.
   */
  retirementZip: Scalars['String']['output'];
  /** The user's expectation for how much expected rate of inflation each year. */
  socialSecurityPayout: Scalars['Percent']['output'];
  /** Retirement assumptions specific to the current user (as opposed to, for example, the user's spouse). */
  userAssumptions: FinancialProfileRetirementUserAssumptions;
};

/**
 * Retirement assumptions for the user's financial profile, that is specific to a
 * single human (specifically, either the current user, or their spouse)
 */
export type FinancialProfileRetirementUserAssumptions = {
  __typename: 'FinancialProfileRetirementUserAssumptions';
  /**
   * The user's current age.
   * @deprecated Use `User.currentAge` instead.
   */
  currentAge: Scalars['Int']['output'];
  /** The age at which the user expects to no longer need spending. */
  lifeExpectancyAge: Scalars['Int']['output'];
  /** The age at which the person is expected to retire. */
  retirementAge: Scalars['Int']['output'];
  /** The annual social security benefit expected to be paid out to the person. */
  socialSecurityAnnualBenefit: Scalars['Cents']['output'];
  /** The age at which the person is expected to start receiving social security benefits. */
  socialSecurityStartAge: Scalars['Int']['output'];
};

/** A financial security representing a single stock or fund (ETF, mutual fund). */
export type FinancialSecurity = {
  /** The description of the financial security. */
  description?: Maybe<Scalars['String']['output']>;
  /** Fundamentals data for financial security */
  fundamentals: FinancialSecurityFundamentalsFund | FinancialSecurityFundamentalsStock;
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of company for the financial security. */
  name: Scalars['String']['output'];
  /** Price history for the given security */
  priceHistory: FinancialSecurityPriceHistory;
  /** Price performance for the given security */
  pricePerformance: FinancialSecurityPricePerformance;
  /** The security type of the financial security */
  securityType?: Maybe<FinancialSecuritySecurityType>;
  /** Statistics data for financial security */
  statistics: FinancialSecurityStatistics;
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};


/** A financial security representing a single stock or fund (ETF, mutual fund). */
export type FinancialSecurityPriceHistoryArgs = {
  dateRangeOption?: DateRangeOption;
};


/** A financial security representing a single stock or fund (ETF, mutual fund). */
export type FinancialSecurityPricePerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** The instance of the company profile for a given financial security */
export type FinancialSecurityCompanyProfile = {
  __typename: 'FinancialSecurityCompanyProfile';
  /** The URL of the company logo asset */
  logo?: Maybe<ThemedAsset>;
};

/** A fund instance of FinancialSecurityInterface. */
export type FinancialSecurityFund = FinancialSecurity & {
  __typename: 'FinancialSecurityFund';
  /** The description of the financial security. */
  description?: Maybe<Scalars['String']['output']>;
  /** Fundamentals data for financial security */
  fundamentals: FinancialSecurityFundamentalsFund | FinancialSecurityFundamentalsStock;
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of the fund. */
  name: Scalars['String']['output'];
  /** Portfolio of the fund */
  portfolio: FinancialSecurityFundPortfolio;
  /** Price history for the given security */
  priceHistory: FinancialSecurityPriceHistory;
  /** Price performance for the given security */
  pricePerformance: FinancialSecurityPricePerformance;
  /**
   * A prospectus is a written document used in finance to inform the public of the
   * relevant details about an offering of securities, such as stocks, bonds, and
   * mutual funds. The prospectus is part of a company's registration statement,
   * which is filed with the SEC. Betterment does not host the prospectus; this is
   * a link to the fund's prospectus on the fund company's website.
   */
  prospectusUrl: Scalars['URL']['output'];
  /** The security type of the financial security */
  securityType?: Maybe<FinancialSecuritySecurityType>;
  /** Statistics data for financial security */
  statistics: FinancialSecurityStatistics;
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};


/** A fund instance of FinancialSecurityInterface. */
export type FinancialSecurityFundPriceHistoryArgs = {
  dateRangeOption?: DateRangeOption;
};


/** A fund instance of FinancialSecurityInterface. */
export type FinancialSecurityFundPricePerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** Portfolio for a financial security fund */
export type FinancialSecurityFundPortfolio = {
  __typename: 'FinancialSecurityFundPortfolio';
  /** Holdings for the fund */
  holdings: Array<FinancialSecurityFundPortfolioHolding>;
};

/** The instance of a specific holding within a financial security fund portfolio */
export type FinancialSecurityFundPortfolioHolding = {
  __typename: 'FinancialSecurityFundPortfolioHolding';
  /** Date this was last retrieve */
  currentAsOf?: Maybe<Scalars['Date']['output']>;
  /** Display name for holding */
  name: Scalars['String']['output'];
  /** The financial security reference */
  security?: Maybe<FinancialSecurityFund | FinancialSecurityStock>;
  /** Security symbol for holding */
  symbol?: Maybe<Scalars['String']['output']>;
  /** The weight percentage of the holding within its portfolio */
  weight: Scalars['Percent']['output'];
};

/** Fundamentals for a single stock or fund (ETF, mutual fund). */
export type FinancialSecurityFundamentals = {
  /**
   * General information about the security
   * @deprecated Use descriptionMaybe instead.
   */
  description: Scalars['String']['output'];
  /** General information about the security */
  descriptionMaybe?: Maybe<Scalars['String']['output']>;
};

/** A Dividend Yield fundamentals type. */
export type FinancialSecurityFundamentalsDividendYield = {
  __typename: 'FinancialSecurityFundamentalsDividendYield';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Percent']['output'];
};

/** A Dividends Amount fundamentals type. */
export type FinancialSecurityFundamentalsDividendsAmount = {
  __typename: 'FinancialSecurityFundamentalsDividendsAmount';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Cents']['output'];
};

/** An earnings per share fundamentals type. */
export type FinancialSecurityFundamentalsEarningsPerShare = {
  __typename: 'FinancialSecurityFundamentalsEarningsPerShare';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Cents']['output'];
};

/** An EBITDA fundamentals type. */
export type FinancialSecurityFundamentalsEbitda = {
  __typename: 'FinancialSecurityFundamentalsEbitda';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Cents']['output'];
};

/** An Expense Ratio fundamentals type. */
export type FinancialSecurityFundamentalsExpenseRatio = {
  __typename: 'FinancialSecurityFundamentalsExpenseRatio';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Percent']['output'];
};

/** Fundamentals data for a financial security fund. */
export type FinancialSecurityFundamentalsFund = FinancialSecurityFundamentals & {
  __typename: 'FinancialSecurityFundamentalsFund';
  /** The annual fundamentals metrics */
  annual: FinancialSecurityFundamentalsFundAnnual;
  /**
   * General information about the security
   * @deprecated Use descriptionMaybe instead.
   */
  description: Scalars['String']['output'];
  /** General information about the security */
  descriptionMaybe?: Maybe<Scalars['String']['output']>;
  /**
   * Annual dividend as a percentage of the security's price
   * @deprecated Use dividendYieldMaybe instead.
   */
  dividendYield: FinancialSecurityFundamentalsDividendYield;
  /**
   * Annual dividend as a percentage of the security's price
   * @deprecated Use annual.dividend_yield instead.
   */
  dividendYieldMaybe?: Maybe<FinancialSecurityFundamentalsDividendYield>;
  /**
   * The most recent dividend payment per share
   * @deprecated Use dividendsAmountMaybe instead.
   */
  dividendsAmount: FinancialSecurityFundamentalsDividendsAmount;
  /**
   * The most recent dividend payment per share
   * @deprecated Remove usage, as dividend amount is ambiguous
   */
  dividendsAmountMaybe?: Maybe<FinancialSecurityFundamentalsDividendsAmount>;
  /**
   * The annual fee, as a percentage of assets, that funds charge their shareholders
   * @deprecated Use expenseRatioMaybe instead.
   */
  expenseRatio: FinancialSecurityFundamentalsExpenseRatio;
  /** The annual fee, as a percentage of assets, that funds charge their shareholders */
  expenseRatioMaybe?: Maybe<FinancialSecurityFundamentalsExpenseRatio>;
  /** The total market value of the company's outstanding shares */
  marketCap: FinancialSecurityFundamentalsMarketCap;
  /** The total market value of the company's outstanding shares */
  marketCapMaybe?: Maybe<FinancialSecurityFundamentalsMarketCap>;
  /** The trailing twelve months fundamentals metrics */
  trailingTwelveMonths: FinancialSecurityFundamentalsFundTrailingTwelveMonths;
};

/** Annual metrics for the given financial security */
export type FinancialSecurityFundamentalsFundAnnual = {
  __typename: 'FinancialSecurityFundamentalsFundAnnual';
  /** Annual dividend as a percentage of the security's price */
  dividendYield?: Maybe<FinancialSecurityFundamentalsDividendYield>;
};

/** Trailing twelve months metrics for the given financial security */
export type FinancialSecurityFundamentalsFundTrailingTwelveMonths = {
  __typename: 'FinancialSecurityFundamentalsFundTrailingTwelveMonths';
  /** TTM dividend as a percentage of the security's price */
  dividendYield?: Maybe<FinancialSecurityFundamentalsDividendYield>;
};

/** A Market Cap fundamentals type. */
export type FinancialSecurityFundamentalsMarketCap = {
  __typename: 'FinancialSecurityFundamentalsMarketCap';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Cents']['output'];
};

/** A Price to Earnings Ratio fundamentals type. */
export type FinancialSecurityFundamentalsPriceToEarningsRatio = {
  __typename: 'FinancialSecurityFundamentalsPriceToEarningsRatio';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Float']['output'];
};

/** A Revenue fundamentals type. */
export type FinancialSecurityFundamentalsRevenue = {
  __typename: 'FinancialSecurityFundamentalsRevenue';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Cents']['output'];
};

/** A Shares Outstanding fundamentals type. */
export type FinancialSecurityFundamentalsSharesOutstanding = {
  __typename: 'FinancialSecurityFundamentalsSharesOutstanding';
  /** The current as of date for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the fundamental type */
  name: Scalars['String']['output'];
  /** The value of the fundamental */
  value: Scalars['Float']['output'];
};

/** Fundamentals data for a financial security stock. */
export type FinancialSecurityFundamentalsStock = FinancialSecurityFundamentals & {
  __typename: 'FinancialSecurityFundamentalsStock';
  /** The annual fundamentals metrics */
  annual: FinancialSecurityFundamentalsStockAnnual;
  /**
   * General information about the security
   * @deprecated Use descriptionMaybe instead.
   */
  description: Scalars['String']['output'];
  /** General information about the security */
  descriptionMaybe?: Maybe<Scalars['String']['output']>;
  /**
   * Annual dividend as a percentage of the security's price
   * @deprecated Use dividendYieldMaybe instead.
   */
  dividendYield: FinancialSecurityFundamentalsDividendYield;
  /**
   * Annual dividend as a percentage of the security's price
   * @deprecated Use annual.dividend_yield instead.
   */
  dividendYieldMaybe?: Maybe<FinancialSecurityFundamentalsDividendYield>;
  /**
   * The most recent dividend payment per share
   * @deprecated Use dividendsAmountMaybe instead.
   */
  dividendsAmount: FinancialSecurityFundamentalsDividendsAmount;
  /**
   * The most recent dividend payment per share
   * @deprecated Remove usage, as dividend amount is ambiguous
   */
  dividendsAmountMaybe?: Maybe<FinancialSecurityFundamentalsDividendsAmount>;
  /**
   * The company's earnings allocated to each outstanding share
   * @deprecated Use earningsPerShareMaybe instead.
   */
  earningsPerShare: FinancialSecurityFundamentalsEarningsPerShare;
  /**
   * The company's earnings allocated to each outstanding share
   * @deprecated Use annual.earnings_per_share instead.
   */
  earningsPerShareMaybe?: Maybe<FinancialSecurityFundamentalsEarningsPerShare>;
  /**
   * Earnings Before Interest, Taxes, Depreciation, and Amortization
   * @deprecated Use ebitdaMaybe instead.
   */
  ebitda: FinancialSecurityFundamentalsEbitda;
  /**
   * Earnings Before Interest, Taxes, Depreciation, and Amortization
   * @deprecated Use annual.ebitda instead.
   */
  ebitdaMaybe?: Maybe<FinancialSecurityFundamentalsEbitda>;
  /**
   * The total market value of the company's outstanding shares
   * @deprecated Use marketCapMaybe instead.
   */
  marketCap: FinancialSecurityFundamentalsMarketCap;
  /** The total market value of the company's outstanding shares */
  marketCapMaybe?: Maybe<FinancialSecurityFundamentalsMarketCap>;
  /**
   * The ratio of the security's share price to its earnings per share
   * @deprecated Use priceToEarningsRatioMaybe instead.
   */
  priceToEarningsRatio: FinancialSecurityFundamentalsPriceToEarningsRatio;
  /** The ratio of the security's share price to its earnings per share */
  priceToEarningsRatioMaybe?: Maybe<FinancialSecurityFundamentalsPriceToEarningsRatio>;
  /**
   * Total revenue generated by the company
   * @deprecated Use revenueMaybe instead.
   */
  revenue: FinancialSecurityFundamentalsRevenue;
  /**
   * Total revenue generated by the company
   * @deprecated Use annual.revenue instead.
   */
  revenueMaybe?: Maybe<FinancialSecurityFundamentalsRevenue>;
  /**
   * The total number of shares currently held by all shareholders
   * @deprecated Use sharesOutstandingMaybe instead.
   */
  sharesOutstanding: FinancialSecurityFundamentalsSharesOutstanding;
  /** The total number of shares currently held by all shareholders */
  sharesOutstandingMaybe?: Maybe<FinancialSecurityFundamentalsSharesOutstanding>;
  /** The trailing twelve months fundamentals metrics */
  trailingTwelveMonths: FinancialSecurityFundamentalsStockTrailingTwelveMonths;
};

/** Annual metrics for the given financial security */
export type FinancialSecurityFundamentalsStockAnnual = {
  __typename: 'FinancialSecurityFundamentalsStockAnnual';
  /** Annual dividend as a percentage of the security's price */
  dividendYield?: Maybe<FinancialSecurityFundamentalsDividendYield>;
  /** The company's earnings allocated to each outstanding share */
  earningsPerShare?: Maybe<FinancialSecurityFundamentalsEarningsPerShare>;
  /** Earnings Before Interest, Taxes, Depreciation, and Amortization */
  ebitda?: Maybe<FinancialSecurityFundamentalsEbitda>;
  /** Total revenue generated by the company */
  revenue?: Maybe<FinancialSecurityFundamentalsRevenue>;
};

/** Trailing twelve months metrics for the given financial security */
export type FinancialSecurityFundamentalsStockTrailingTwelveMonths = {
  __typename: 'FinancialSecurityFundamentalsStockTrailingTwelveMonths';
  /** TTM dividend as a percentage of the security's price */
  dividendYield?: Maybe<FinancialSecurityFundamentalsDividendYield>;
  /** The company's earnings allocated to each outstanding share */
  earningsPerShare?: Maybe<FinancialSecurityFundamentalsEarningsPerShare>;
  /** Earnings Before Interest, Taxes, Depreciation, and Amortization */
  ebitda?: Maybe<FinancialSecurityFundamentalsEbitda>;
  /** Total revenue generated by the company */
  revenue?: Maybe<FinancialSecurityFundamentalsRevenue>;
};

/** The result of creating a custody single security order request */
export type FinancialSecurityOrderRequest = {
  __typename: 'FinancialSecurityOrderRequest';
  /** the custody single security order request id */
  id: Scalars['ID']['output'];
};

/** eligible account ids for financial security orders */
export type FinancialSecurityOrderRequestAccountIdInput =
  /** id if order is for direct trading account */
  { directTradingAccountId: Scalars['ID']['input']; };

/** Determines if the order request is to buy or sell the security */
export enum FinancialSecurityOrderRequestDirection {
  /** Buy */
  Buy = 'BUY',
  /** Sell */
  Sell = 'SELL'
}

/** dollar amount or number of shares requested for order request */
export type FinancialSecurityOrderRequestValueInput =
  /** dollar amount value requested */
  { amount: Scalars['Cents']['input']; shares?: never; }
  |  /** amount of shares requested */
  { amount?: never; shares: Scalars['Float']['input']; };

/** The price history for a given financial security */
export type FinancialSecurityPriceHistory = {
  __typename: 'FinancialSecurityPriceHistory';
  /** The returns for the price history */
  returns: FinancialSecurityPriceReturns;
  /** The price points for the price history */
  timeSeries: Array<FinancialSecurityPricePoint>;
};

/** The price performance for a given financial security */
export type FinancialSecurityPricePerformance = {
  __typename: 'FinancialSecurityPricePerformance';
  /** The specified date range option */
  dateRange: DateRange;
  /** The returns for the specified date range option */
  returns: FinancialSecurityPriceReturns;
  /** The price points for the price performance */
  timeSeries: Array<FinancialSecurityPricePerformancePricePoint>;
};

/** The instance of a price point in the price performance for a financial security */
export type FinancialSecurityPricePerformancePricePoint = {
  __typename: 'FinancialSecurityPricePerformancePricePoint';
  /** The price for the performance price point */
  amount: Scalars['Cents']['output'];
  /** The date time for the performance price point */
  dateTime: Scalars['DateTime']['output'];
  /** The formatted date time for the performance price point in Eastern Time */
  formattedDateTime: Scalars['String']['output'];
  /** The returns for the price performance */
  returns: FinancialSecurityPriceReturns;
};

/** The instance of a price point in the price history for a financial security */
export type FinancialSecurityPricePoint = {
  __typename: 'FinancialSecurityPricePoint';
  /** The price for the price point */
  amount: Scalars['Cents']['output'];
  /** The date time for the price point */
  dateTime: Scalars['DateTime']['output'];
};

/** The returns type for a given set of time series data */
export type FinancialSecurityPriceReturns = {
  __typename: 'FinancialSecurityPriceReturns';
  /** The return amount for the time series data */
  amount: Scalars['Cents']['output'];
  /** The return percentage for the time series data */
  percentage: Scalars['Percent']['output'];
};

/** The security type of the financial security. */
export enum FinancialSecuritySecurityType {
  /** Equity */
  Equity = 'EQUITY',
  /** Etf */
  Etf = 'ETF',
  /** Mutual_fund */
  MutualFund = 'MUTUAL_FUND'
}

/** Statistics for a single stock or fund */
export type FinancialSecurityStatistics = {
  __typename: 'FinancialSecurityStatistics';
  /** Latest price information for the financial security */
  latestPrice: FinancialSecurityStatisticsLatestPrice;
  /** Statistics for Today */
  today?: Maybe<FinancialSecurityStatisticsComponentIntraDay>;
  /** Statistics for the past 1 year */
  year: FinancialSecurityStatisticsComponentDays;
};

/** Specific instance of financial security statistic component type for a time range of many days. */
export type FinancialSecurityStatisticsComponentDays = {
  __typename: 'FinancialSecurityStatisticsComponentDays';
  /** The current as of date and time for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Range of prices recorded for today
   * @deprecated Use priceRangeMaybe instead
   */
  priceRange: PriceRange;
  /** Range of prices recorded for today */
  priceRangeMaybe?: Maybe<PriceRange>;
};

/** Specific instance of financial security statistic component type. */
export type FinancialSecurityStatisticsComponentIntraDay = {
  __typename: 'FinancialSecurityStatisticsComponentIntraDay';
  /** The current as of date and time for when we received this information */
  currentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Price security open price
   * @deprecated Use openPriceMaybe instead
   */
  openPrice: Scalars['Cents']['output'];
  /** Price security open price */
  openPriceMaybe?: Maybe<Scalars['Cents']['output']>;
  /**
   * Price security last closed at
   * @deprecated Use previousClosePriceMaybe instead
   */
  previousClosePrice: Scalars['Cents']['output'];
  /** Price security last closed at */
  previousClosePriceMaybe?: Maybe<Scalars['Cents']['output']>;
  /**
   * Range of prices recorded for time period
   * @deprecated Use priceRangeMaybe instead
   */
  priceRange: PriceRange;
  /** Range of prices recorded for time period */
  priceRangeMaybe?: Maybe<PriceRange>;
  /**
   * Volume for time period
   * @deprecated Use volumeMaybe instead
   */
  volume: Scalars['Cents']['output'];
  /** Volume for time period */
  volumeMaybe?: Maybe<Scalars['Cents']['output']>;
};

/** Latest pricing information for the financial security */
export type FinancialSecurityStatisticsLatestPrice = {
  __typename: 'FinancialSecurityStatisticsLatestPrice';
  /** The latest known price for this financial security */
  amount: Scalars['Cents']['output'];
  /** The current as of datetime for the retrieval of the latest price */
  currentAsOf: Scalars['DateTime']['output'];
  /** The current as of datetime formatted as 'HH:MMam ET on mm/dd/yy' */
  formattedCurrentAsOf: Scalars['String']['output'];
  /** The returns for the latest price */
  returns: FinancialSecurityPriceReturns;
};

/** A stock instance of FinancialSecurityInterface. */
export type FinancialSecurityStock = FinancialSecurity & {
  __typename: 'FinancialSecurityStock';
  /** The company profile for the given equity */
  companyProfile: FinancialSecurityCompanyProfile;
  /** The description of the financial security. */
  description?: Maybe<Scalars['String']['output']>;
  /** Fundamentals data for financial security */
  fundamentals: FinancialSecurityFundamentalsFund | FinancialSecurityFundamentalsStock;
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of the company for the stock. */
  name: Scalars['String']['output'];
  /** Price history for the given security */
  priceHistory: FinancialSecurityPriceHistory;
  /** Price performance for the given security */
  pricePerformance: FinancialSecurityPricePerformance;
  /** The security type of the financial security */
  securityType?: Maybe<FinancialSecuritySecurityType>;
  /** Statistics data for financial security */
  statistics: FinancialSecurityStatistics;
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};


/** A stock instance of FinancialSecurityInterface. */
export type FinancialSecurityStockPriceHistoryArgs = {
  dateRangeOption?: DateRangeOption;
};


/** A stock instance of FinancialSecurityInterface. */
export type FinancialSecurityStockPricePerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** A financial service option available to the user. */
export type FinancialServiceOption = {
  /** HTML-formatted description explaining the benefits and features of the advisor service. */
  description: Scalars['HTML']['output'];
  /** Fee disclosure information for this service option. */
  feeDisclosure: Scalars['String']['output'];
  /** A unique identifier for the option, used for client-side caching and analytics tracking. */
  id: Scalars['ID']['output'];
  /** A themed asset (supporting light/dark mode) representing the advised service visually. */
  image: ThemedAsset;
  /** Minimum balance disclosure information for this service option. */
  minimumBalanceDisclosure: Scalars['String']['output'];
  /** The service fee for this option. */
  serviceFee: Scalars['String']['output'];
  /** The display title of the advisor service */
  title: Scalars['String']['output'];
};

/** A firm associated with an advisor */
export type Firm = {
  __typename: 'Firm';
  /** The token for the active client agreement document */
  defaultClientAgreementToken?: Maybe<Scalars['String']['output']>;
  /** The URL of the active client agreement document */
  defaultClientAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the firm */
  name: Scalars['String']['output'];
};

/** An account intended to be integrated with a 529 account at Ascensus. */
export type Five29Account = EnvelopeAccount & LegalSubAccount & PayrollContributionConfigAccount & TransferableAccount & {
  __typename: 'Five29Account';
  /**
   * The connected remote Ascensus 529 account, integrated with the Betterment
   * account. If null, this integration requires additional setup.
   */
  accountConnection?: Maybe<Five29AccountConnection>;
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** The financial activity for the 529 account. */
  activityConnection: ActivityItemConnection;
  /** The display account number of the Ascensus account. */
  ascensusAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Checking accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleCheckingAccounts: Array<CheckingAccount>;
  /** External accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleExternalAccounts: Array<ExternalAccount>;
  /** The full name of the beneficiary of the account. */
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** Whether the account has reached the maximum number of bank accounts allowed by operations. */
  hasReachedOpsBankAccountLimit: Scalars['Boolean']['output'];
  /** The icon used to represent the account. */
  icon: ThemedAsset;
  /** The unique id for the account. */
  id: Scalars['ID']['output'];
  /** Whether the account is closed. */
  isClosed: Scalars['Boolean']['output'];
  /** Whether the legal sub account is an eligible destination for a recurring deposit. */
  isRecurringDepositEligible: Scalars['Boolean']['output'];
  /** Whether the account has completed initial setup. */
  isSetupComplete: Scalars['Boolean']['output'];
  /**
   * The ID of the legacy goal that this account is associated with.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /**
   * The legacy ID for the 529 account, as recognized by our legacy REST APIs.
   * @deprecated Deprecated for its ambiguity between legacy goal ids and legacy sub account ids. Use legacyGoalId or legacySubAccountId instead.
   */
  legacyId: Scalars['LegacyID']['output'];
  /**
   * The legacy ID for this instance of a LegalSubAccount
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};


/** An account intended to be integrated with a 529 account at Ascensus. */
export type Five29AccountActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An Ascensus 529 account integrated into a Betterment account. */
export type Five29AccountConnection = {
  __typename: 'Five29AccountConnection';
  /** The redacted account number of the account. */
  accountNumber: Scalars['String']['output'];
  /** The name of the type of the account. */
  accountTypeName: Scalars['String']['output'];
  /** The balance of the account. */
  balance: Scalars['Cents']['output'];
  /** Whether the account has a pending SSO connection. */
  hasPendingSsoConnection: Scalars['Boolean']['output'];
  /** The icon of the financial institution holding the account. */
  icon: ThemedAsset;
  /** The ID of the account. */
  id: Scalars['ID']['output'];
  /** Whether the account is frozen and cannot be used for transactions. */
  isFrozen: Scalars['Boolean']['output'];
  /** The name of the account. */
  name: Scalars['String']['output'];
};

/** Represent data concerns of a user opening a 529 goal */
export type FiveTwoNineGoalCreationOption = ProductOnboardingOption & {
  __typename: 'FiveTwoNineGoalCreationOption';
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the user is eligible to open a 529 goal */
  isEligible: Scalars['Boolean']['output'];
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** Represent data concerns of a user opening a 529 goal */
export type FiveTwoNineGoalCreationOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/** The 401(k) contributions for a user. */
export type FourOhOneKContributions = {
  __typename: 'FourOhOneKContributions';
  /** The amount of 401(k) contributions. */
  amount: Scalars['Cents']['output'];
  /** The remaining amount the user can contribute to their 401(k) for the year. */
  amountRemainingToLimit: Scalars['Cents']['output'];
  /** A unique identifier for a FourOhOneKContributions */
  id: Scalars['ID']['output'];
  /** A breakdown of contributions by type. */
  lineItems: Array<FourOhOneKContributionsLineItem>;
  /** A projection of future 401(k) contributions. */
  projection?: Maybe<FourOhOneKContributionsProjection>;
};

/** Expected 401(k) contribution breakdown. */
export type FourOhOneKContributionsLineItem = {
  __typename: 'FourOhOneKContributionsLineItem';
  /** The amount of the expected 401(k) contributions breakdown. */
  amount: Scalars['Cents']['output'];
  /** A unique identifier for a FourOhOneKContributionsLineItem */
  id: Scalars['ID']['output'];
  /** The name of the expected 401(k) contributions breakdown. */
  name: Scalars['String']['output'];
};

/** A projection of 401(K) contributions. */
export type FourOhOneKContributionsProjection = {
  __typename: 'FourOhOneKContributionsProjection';
  /** Deprecated in favor of deferral_settings_edit_option_v_2. */
  deferralSettingsEditOption: DeferralSettingsEditOption;
  /** The option to edit deferral settings. */
  deferralSettingsEditOptionV2?: Maybe<DeferralSettingsEditOption>;
  /** A unique identifier for an FourOhOneKContributionsProjection */
  id: Scalars['ID']['output'];
  /** Messages associated with the projection. */
  messages: Array<Message>;
  /** Recurring transactions that contribute to the projection. */
  recurringInflows: Array<RecurringTransactionConfig>;
  /** Total contributions for the given time period. */
  total: Scalars['Cents']['output'];
  /** Projected upcoming contributions for the given time period. */
  upcoming: Scalars['Cents']['output'];
};


/** A projection of 401(K) contributions. */
export type FourOhOneKContributionsProjectionMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** The 401(k) contributions for a user. */
export type FourOhOneKContributionsResult = {
  __typename: 'FourOhOneKContributionsResult';
  /** All 401(k) contributions. */
  allTime: FourOhOneKContributions;
  /** A unique identifier for a FourOhOneKContributionsResult */
  id: Scalars['ID']['output'];
  /** 401(k) contributions this year. */
  thisYear: AnnualFourOhOneKContributions;
};

/**
 * A single instance type that holds all the data related to a users 401k student
 * loan payment match benefit feature. This includes eligibility details, details
 * about the attestation process by which they certify the payments they have made,
 * and the details of the employer offering the benefit.
 */
export type FourOhOneKStudentLoanMatchBenefit = {
  __typename: 'FourOhOneKStudentLoanMatchBenefit';
  /**
   * The curent time attestation record that is visible to the user.From Jan 15th -
   * Dec 1st this will always be the attestion for the previous year. It will
   * switch to the current year on Dec 1st, and remain that year until Jan 15th. It
   * will be null if the user is not currently eligible to make any attestations this year
   */
  currentAttestation?: Maybe<StudentLoanPaymentAttestation>;
  /**
   * The users current estimated payment. This represents how much the user
   * estimates they will pay in student loans for the whole calendar year
   */
  currentLoanPaymentEstimate?: Maybe<StudentLoanPaymentEstimate>;
  /** Since there will only be one benefit node per user, this id is shared with the current user record */
  id: Scalars['ID']['output'];
  /**
   * Indicates if attestation window is currently open and they have not attested
   * yet. From January 15 - November 30 this will be false as we only allow
   * attestations to occur from December 1 through January 14. If window is open,
   * this will be true only if they have not yet attested.
   */
  isAttestationEligible: Scalars['Boolean']['output'];
  /** User-facing messages relating to 401(k) match on student loan payments */
  messages: Array<Message>;
};


/**
 * A single instance type that holds all the data related to a users 401k student
 * loan payment match benefit feature. This includes eligibility details, details
 * about the attestation process by which they certify the payments they have made,
 * and the details of the employer offering the benefit.
 */
export type FourOhOneKStudentLoanMatchBenefitMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** Account Purposes that are not specific to a target */
export type GeneralPurposeOption = AccountPurposeOption & {
  __typename: 'GeneralPurposeOption';
  /** The default name of the account purpose option */
  defaultName: Scalars['String']['output'];
  /** The Default Target Date */
  defaultTargetDate: Scalars['Date']['output'];
  /** The themed asset set for the icon used to represent this account purpose option. */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the concrete account purpose option type */
  name: Scalars['String']['output'];
};

/** A Goal for saving/investing intent for the current User. */
export type Goal = {
  __typename: 'Goal';
  /** A description of the type or number of accounts associated with the goal. */
  accountsDescription?: Maybe<Scalars['String']['output']>;
  /** The advice for the given Goal. */
  advice?: Maybe<CryptoAdvice>;
  /** APY details for the given Goal. */
  apy?: Maybe<CashApy>;
  /** Balances for a goal. */
  balances: GoalBalances;
  /** The envelope representing the goal. */
  envelope: Envelope;
  /**
   * A collection of ExternalAccounts for the given Goal.
   * @deprecated Use envelope.accounts to get ExternalAccountEnvelopeAssociations instead.
   */
  externalAccounts: Array<ExternalAccount>;
  /** FDIC Insurance details for the given Goal. */
  fdicInsurance?: Maybe<CashFdicInsurance>;
  /** Whether the goal's sub accounts contain a 401(k) sub account */
  has401kSubAccount: Scalars['Boolean']['output'];
  /** Whether the goal's sub accounts contain an IRA sub account */
  hasIraSubAccount: Scalars['Boolean']['output'];
  /**
   * Flag representing that the given Goal contains any of the following recurring transactions: automatic deposit,
   *       recurring transfers, automatic withdrawal, and 401k contributions.
   */
  hasRecurringTransaction: Scalars['Boolean']['output'];
  /** Whether the goal's sub accounts contain a traditional or roth IRA sub account */
  hasTraditionalOrRothIraSubAccount: Scalars['Boolean']['output'];
  /** The themed asset set for the icon used to represent this goal. */
  icon: ThemedAsset;
  /** The unique Identifier for the given Goal. */
  id: Scalars['ID']['output'];
  /** The themed asset set for the small image used to represent this goal. */
  image: ThemedAsset;
  /** Flag indicating that whether the goal is included in performance calculations. */
  isPerformanceEligible: Scalars['Boolean']['output'];
  /** Flag indicating that the given Goal has been fully setup. */
  isSetupComplete: Scalars['Boolean']['output'];
  /** The ID for the goal, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** A set of messages for the goal. */
  messages: Array<Message>;
  /** The name of the goal. */
  name: Scalars['String']['output'];
  /** The performance totals of the given Goal. */
  performance?: Maybe<PerformanceTotals>;
  /** The portfolio for the given Goal. */
  portfolio?: Maybe<CryptoPortfolio | ExternallyAdvisedPlanPortfolio | InvestmentPortfolio>;
  /** The status summary for the given Goal. */
  statusSummary: GoalStatusSummary;
  /** A collection of SubAccounts for the given Goal. */
  subAccounts: Array<SubAccount>;
};


/** A Goal for saving/investing intent for the current User. */
export type GoalMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** Balances for a goal. */
export type GoalBalances = {
  __typename: 'GoalBalances';
  /** The balance of the goal including pending transactions and excluding external accounts. */
  excludingExternalAccounts: Scalars['Cents']['output'];
  /** The balance of the goal including both pending transactions and external accounts. */
  includingExternalAccounts: Scalars['Cents']['output'];
};

/** A Goal Creation Intent for a User */
export type GoalCreationIntent = {
  __typename: 'GoalCreationIntent';
  /** The identifier for what kind of advice this goal will receive, limited to user-selectable options. */
  adviceTypeId: Scalars['String']['output'];
  /** The themed asset set for the icon used to represent this goal creation intent. */
  icon: ThemedAsset;
  /** The unique Identifier for the given Goal. */
  id: Scalars['ID']['output'];
  /** Flag indicating if the given Goal was selected by the User. */
  isUserSelected: Scalars['Boolean']['output'];
  /** The Name of the given Goal. */
  name: Scalars['String']['output'];
};

/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOption = ProductOnboardingOption & {
  __typename: 'GoalCreationOption';
  /** All available account ownership options */
  accountOwnershipOption: IndividualOwnershipOption | JointOwnershipOption | TrustOwnershipOption;
  /** A single account ownership option */
  accountOwnershipOptions: Array<IndividualOwnershipOption | JointOwnershipOption | TrustOwnershipOption>;
  /** All available account ownership options */
  accountPurposeOption: ExpensesBasedPurposeOption | GeneralPurposeOption | TargetBasedPurposeOption;
  /** A single account ownership option */
  accountPurposeOptions: Array<ExpensesBasedPurposeOption | GeneralPurposeOption | TargetBasedPurposeOption>;
  /** A single account taxation option */
  accountTaxationOption: AccountTaxationOption;
  /** All available account taxation options */
  accountTaxationOptions: Array<AccountTaxationOption>;
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** Draft envelope account data for the goal creation flow */
  draftEnvelopeAccount?: Maybe<DraftEnvelopeAccount>;
  /** The emergency fund coverage calculation for an add account creation flow */
  emergencyFundCoverage?: Maybe<EmergencyFundCoverage>;
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** A single model portfolio option */
  modelPortfolioOption: ModelPortfolioOption;
  /** All available model portfolio options */
  modelPortfolioOptions: Array<ModelPortfolioOption>;
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** Indicator for showing TCP Setup steps in account creation */
  recommendTaxCoordination: Scalars['Boolean']['output'];
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Boolean indicating if the investing experience step should be shown */
  showInvestingExperience: Scalars['Boolean']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /**
   * Terms and agreements
   * @deprecated Use the new top level terms and agreements field instead
   */
  termsAndAgreements: Array<LegacyTermsAndAgreements>;
  /** State of product unavailability for this goal creation option */
  unavailability?: Maybe<ProductUnavailability>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionAccountOwnershipOptionArgs = {
  id: Scalars['ID']['input'];
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionAccountPurposeOptionArgs = {
  id: Scalars['ID']['input'];
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionAccountTaxationOptionArgs = {
  id: Scalars['ID']['input'];
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionDraftEnvelopeAccountArgs = {
  ownershipType: LegalAccountOwnershipType;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionEmergencyFundCoverageArgs = {
  monthlyExpensesCents: Scalars['Int']['input'];
  variant?: InputMaybe<EmergencyFundCoverageVariant>;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionModelPortfolioOptionArgs = {
  id: Scalars['ID']['input'];
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionModelPortfolioOptionsArgs = {
  accountPurposeId: Scalars['ID']['input'];
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionRecommendTaxCoordinationArgs = {
  accountType: LegalAccountTypeInput;
};


/** Represent data concerns of a user creating a goal based account */
export type GoalCreationOptionTermsAndAgreementsArgs = {
  accountOwnershipOptionId: Scalars['ID']['input'];
};

/** The style of the goal status display name */
export enum GoalStatusStyle {
  /** Danger */
  Danger = 'DANGER',
  /** Neutral */
  Neutral = 'NEUTRAL',
  /** Success */
  Success = 'SUCCESS'
}

/** The status summary for a Goal. */
export type GoalStatusSummary = {
  __typename: 'GoalStatusSummary';
  /** The display color in hexadecimal format for a Goal. */
  color?: Maybe<Scalars['String']['output']>;
  /** The human-readable status name for a Goal. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The style of the current goal status. */
  style: GoalStatusStyle;
};

/** A categorization of list of goals that can be queried for independently */
export enum GoalsCategory {
  /** Cash */
  Cash = 'CASH',
  /** Investing */
  Investing = 'INVESTING',
  /** Student debt */
  StudentDebt = 'STUDENT_DEBT'
}

/** A type of benefit on a user or their related accounts */
export type Grant = {
  /** A URL to page containing any legal language around the terms and conditions of the grant. */
  disclosureUrl: Scalars['String']['output'];
  /** A human readable comma delimited description of what accounts or account types the grant applies to. */
  grantedEntitiesDescription: Scalars['String']['output'];
  /** A human readable description of the benefit that the grant confers on the user or their accounts. */
  rewardDescription: Scalars['String']['output'];
  /** A human readable description of the originating action that caused the grant to exist. */
  sourceDescription: Scalars['String']['output'];
  /** A human readable description of the state of the grant (e.g. 'Active', 'Pending', 'Upcoming', 'Complete'). */
  status: Scalars['String']['output'];
};

/** The performance of a given security over specified time periods. */
export type HistoricalPerformance = {
  __typename: 'HistoricalPerformance';
  /** The performance benchmark percent of a security in a given time period. */
  benchmarkPercent?: Maybe<Scalars['Int']['output']>;
  /** The returns (represented as a percentage) of a security in a given time period */
  percent?: Maybe<Scalars['Int']['output']>;
  /** The time period of a given security's performance data (e.g. '5 years') */
  timePeriod: Scalars['String']['output'];
};

/** Represents an identity verification challenge sent by a CX agent */
export type IdentityVerificationChallenge = {
  __typename: 'IdentityVerificationChallenge';
  /**
   * Name of the CX agent who initiated this challenge. Helps customers confirm
   * they are speaking with legitimate Betterment support.
   */
  agentName: Scalars['String']['output'];
  /** When this challenge was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * When this challenge expires (typically 3 minutes after creation). After this
   * time, the challenge cannot be resolved and will be marked as timeout.
   */
  expiresAt: Scalars['DateTime']['output'];
  /** Unique identifier for this verification challenge */
  id: Scalars['ID']['output'];
  /** Current status of the challenge */
  status: IdentityVerificationChallengeStatus;
};

/** Response values for identity verification challenges */
export enum IdentityVerificationChallengeResponse {
  /** Customer approves the identity verification request */
  Approved = 'APPROVED',
  /** Customer declines the identity verification request */
  Declined = 'DECLINED'
}

/** Status values for identity verification challenges */
export enum IdentityVerificationChallengeStatus {
  /** Customer has approved the verification request */
  Approved = 'APPROVED',
  /** Challenge has been cancelled by an agent */
  Cancelled = 'CANCELLED',
  /** Customer has declined the verification request */
  Declined = 'DECLINED',
  /** Challenge is active and waiting for customer response */
  Pending = 'PENDING',
  /** Challenge has expired without customer response */
  Timeout = 'TIMEOUT'
}

/** An individual account ownership option */
export type IndividualOwnershipOption = AccountOwnershipOption & {
  __typename: 'IndividualOwnershipOption';
  /** The description of the option */
  description: Scalars['String']['output'];
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The ownership type of the option */
  ownershipType: LegalAccountOwnershipType;
};

/** Autogenerated return type of InitiateStudentLoanPaymentBenefitAttestationMutation. */
export type InitiateStudentLoanPaymentBenefitAttestationMutationPayload = {
  __typename: 'InitiateStudentLoanPaymentBenefitAttestationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve InitiateStudentLoanPaymentBenefitAttestationMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * InitiateStudentLoanPaymentBenefitAttestationMutation execution as type
   * FourOhOneKStudentLoanMatchBenefit.
   */
  result?: Maybe<FourOhOneKStudentLoanMatchBenefit>;
};

/** The advisor for a given user. This advisor is part of an institional firm and not related to Betterment. */
export type InstitutionalAdvisor = Advisor & {
  __typename: 'InstitutionalAdvisor';
  /** The calendar link of the advisor */
  calendarLink?: Maybe<Scalars['URL']['output']>;
  /** The email address of the advisor */
  email: Scalars['String']['output'];
  /** The firm the advisor belongs to */
  firm: Firm;
  /** The full name of the advisor */
  fullName: Scalars['String']['output'];
  /** A unique identifier of the advisor. */
  id: Scalars['ID']['output'];
  /** The logo of the advisor's firm */
  logo?: Maybe<ThemedAsset>;
  /** The phone number of the advisor */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** The available investing experience option levels. */
export enum InvestingExperienceLevel {
  /** advanced */
  Advanced = 'ADVANCED',
  /** limited */
  Limited = 'LIMITED',
  /** moderate */
  Moderate = 'MODERATE',
  /** new */
  New = 'NEW'
}

/** Portfolio details for a given investing goal. */
export type InvestmentPortfolio = Portfolio & {
  __typename: 'InvestmentPortfolio';
  /** The allocation breakdown of the portfolio for the given investment goal. */
  allocationBreakdown: Array<AllocationBreakdown>;
  /** The portfolio icon */
  icon?: Maybe<ThemedAsset>;
  /** Indicates if auto adjust is available for the goal's portfolio. */
  isAutoAdjustAvailable: Scalars['Boolean']['output'];
  /** Indicates if auto adjust is enabled for the goal's portfolio. */
  isAutoAdjustEnabled: Scalars['Boolean']['output'];
  /** The relative risk for the given investment Goal. */
  relativeRisk?: Maybe<RelativeRisk>;
  /** The name of the risk level for the goal's portfolio. */
  riskLevelName?: Maybe<Scalars['String']['output']>;
  /** The strategy for the goal's portfolio */
  strategy: PortfolioStrategy;
};

/** A benefit to have a fraction of a users's IRA contributions in a given period matched. */
export type IraContributionMatchGrant = Grant & {
  __typename: 'IraContributionMatchGrant';
  /** The date window during which IRA contributions will be matched. */
  contributionWindow: DateRange;
  /** A URL to page containing any legal language around the terms and conditions of the grant. */
  disclosureUrl: Scalars['String']['output'];
  /** The display ready dollar amount of earned match that will be deposited on the projected payment date. */
  earnedMatchAmount: Scalars['Cents']['output'];
  /** A human readable comma delimited description of what accounts or account types the grant applies to. */
  grantedEntitiesDescription: Scalars['String']['output'];
  /** The identifier for this grant record. */
  id: Scalars['ID']['output'];
  /** The percentage of IRA contributions that are matched. */
  match: Scalars['Percent']['output'];
  /** The display ready dollar amount that is currently eligible to be matched. */
  matchEligibleAmount?: Maybe<Scalars['Cents']['output']>;
  /**
   * The display ready dollar amount of unvested match that will be deposit on the projected payment date.
   * @deprecated Replaced with earned_match_amount, which has a more accurate name. This has been updated to use unvested_match_amount
   * for mobile backward compatibility
   */
  projectedMatchAmountV2: Scalars['Cents']['output'];
  /**
   * The display ready dollar amount of projected match of future transactions that will be
   *  deposited on the projected payment date.
   */
  projectedMatchAmountV3: Scalars['Cents']['output'];
  /** The date upon which the projected match amount will be vested in a user's accounts. */
  projectedPaymentDate: Scalars['Date']['output'];
  /** A human readable description of the benefit that the grant confers on the user or their accounts. */
  rewardDescription: Scalars['String']['output'];
  /** A human readable description of the originating action that caused the grant to exist. */
  sourceDescription: Scalars['String']['output'];
  /** A human readable description of the state of the grant (e.g. 'Active', 'Pending', 'Upcoming', 'Complete'). */
  status: Scalars['String']['output'];
  /** The display ready dollar amount that has been matched as a benefit of this grant. */
  totalMatchedAmount: Scalars['Cents']['output'];
};

/** dollar match grant status states. */
export enum IraContributionMatchGrantStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Revoked = 'REVOKED',
  Upcoming = 'UPCOMING'
}

/** Input structure for a IRA Contribution Match Grant Where query. */
export type IraContributionMatchGrantsWhereInput = {
  /**
   * A boolean representing if the grant is current in its contribution window.
   * deprecated: Replaced with status, which accepts an array of types
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A array filtering through multiple statuses of the grants */
  statuses?: InputMaybe<Array<IraContributionMatchGrantStatus>>;
};

/** The aggregate IRA contributions for a user. */
export type IraContributions = {
  __typename: 'IraContributions';
  /** The aggregated amount of IRA contributions. */
  amount: Scalars['Cents']['output'];
  /** A unique identifier for an IraContributionsResult */
  id: Scalars['ID']['output'];
  /** A breakdown of contributions by type. */
  lineItems: Array<IraContributionsLineItem>;
  /** A projection of future IRA contributions. */
  projection?: Maybe<IraContributionsProjection>;
};

/** Filter conditions for the IRA contributions by year.  */
export type IraContributionsByYearWhere = {
  /** If provided, filters the result to only include years eligible or ineligible for contribution. */
  isEligibleForContributions?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, filters the result to exclude years not specified. */
  taxYears?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Expected IRA contribution breakdown. */
export type IraContributionsLineItem = {
  __typename: 'IraContributionsLineItem';
  /** The amount of the expected IRA contributions breakdown. */
  amount: Scalars['Cents']['output'];
  /** A unique identifier for an IraContributionsLineItem */
  id: Scalars['ID']['output'];
  /** The name of the expected IRA contributions breakdown. */
  name: Scalars['String']['output'];
};

/** A projection of IRA contributions. */
export type IraContributionsProjection = {
  __typename: 'IraContributionsProjection';
  /** A unique identifier for an IraContributionsProjection */
  id: Scalars['ID']['output'];
  /** Messages associated with the projection. */
  messages: Array<Message>;
  /** Recurring transactions that contribute to the projection. */
  recurringInflows: Array<RecurringTransactionConfig>;
  /** Projected total contributions for the given time period. */
  total: Scalars['Cents']['output'];
  /** Projected upcoming contributions for the given time period. */
  upcoming: Scalars['Cents']['output'];
};


/** A projection of IRA contributions. */
export type IraContributionsProjectionMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** The aggregate IRA contributions for a user. */
export type IraContributionsResult = {
  __typename: 'IraContributionsResult';
  /** All IRA contributions. */
  allTime: IraContributions;
  /** IRA contributions by year. */
  byYear: Array<AnnualIraContributions>;
  /** A unique identifier for an IraContributionsResult */
  id: Scalars['ID']['output'];
};


/** The aggregate IRA contributions for a user. */
export type IraContributionsResultByYearArgs = {
  where?: InputMaybe<IraContributionsByYearWhere>;
};

/** An invitation to a User to become a Joint Holder on a Checking Account. */
export type JointAccountInvitation = {
  __typename: 'JointAccountInvitation';
  /** The unique identifier for the given Joint Account Invitation. */
  id: Scalars['ID']['output'];
  /**
   * The unique identifier for the given Joint Account Invitation.
   * @deprecated Use id instead.
   */
  invitationId: Scalars['ID']['output'];
  /** The current lifecycle Status for the given Joint Account Invitation. */
  status: JointAccountInvitationStatus;
};

/** The lifecycle Status of a Joint Holder Account Invitation */
export enum JointAccountInvitationStatus {
  AccountClosed = 'ACCOUNT_CLOSED',
  AccountCreated = 'ACCOUNT_CREATED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  InviteSent = 'INVITE_SENT',
  SecondaryInKyc = 'SECONDARY_IN_KYC',
  SecondaryKycVerified = 'SECONDARY_KYC_VERIFIED'
}

/** A joint account ownership option */
export type JointOwnershipOption = AccountOwnershipOption & {
  __typename: 'JointOwnershipOption';
  /** The description of the option */
  description: Scalars['String']['output'];
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** All users that the current user has opened joint accounts with */
  jointAccountHolders: Array<OtherUser>;
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The ownership type of the option */
  ownershipType: LegalAccountOwnershipType;
};

/** Aggregation of Asset holdings and summary information in a given Portfolio strategy */
export type LegacyAllocationAssets = {
  __typename: 'LegacyAllocationAssets';
  /** Collection of AssetClasses in the given Portfolio strategy */
  assets: Array<LegacySuperAssetClass>;
  /** Header copy content for displaying this aggregation */
  header: Scalars['String']['output'];
  /** Aggregate of detailed Asset holdings information for the given Portfolio strategy */
  holdingsPageInfo?: Maybe<LegacyHoldingsPageInfo>;
  /** Informational copy with details about this aggregation */
  info?: Maybe<Scalars['String']['output']>;
  /** Display name for the Named Portfolio details, if applicable */
  namedPortfolioDisplayName?: Maybe<Scalars['String']['output']>;
  /** Sub-header copy content for displaying this aggregation */
  subHeader?: Maybe<Scalars['String']['output']>;
};

/** Summary aggregate for Asset class types in a given Portfolio strategy */
export type LegacyAssetClass = {
  __typename: 'LegacyAssetClass';
  /** Holdings percentage for this Asset class within given the Portfolio strategy */
  holdingsAmount: Scalars['String']['output'];
  /** Aggregation of the Securities held within the Asset class within the given Portfolio strategy */
  securityGroupDetails: LegacySecurityGroupDetails;
  /** Tickers display reference for the Asset class */
  tickersDisplay: Scalars['String']['output'];
  /** Title for the Asset class */
  title: Scalars['String']['output'];
};

/** Holdings details for a given PortfolioStrategyOption */
export type LegacyHoldingsPageInfo = {
  __typename: 'LegacyHoldingsPageInfo';
  /** Collection of AssetClasses within this PortfolioStrategyOption */
  assetClasses: Array<LegacySuperAssetClass>;
  /** General information for the holdings in the PortfolioStrategyOption */
  info: Scalars['String']['output'];
};

/**
 * DEPRECATED, as this type violates our schema design principles for redundant
 * type/field names, and for naming/structuring data in a way that implies a visual presentation.
 *
 * Legacy description: Aggregate of sub-options for the given Portfolio strategy.
 */
export type LegacyNamedOptions = {
  __typename: 'LegacyNamedOptions';
  /** Content copy for the sub-options */
  bottomSheetContent: Scalars['String']['output'];
  /** Header content copy for the sub-options */
  bottomSheetHeader: Scalars['String']['output'];
  /** Collection of sub-option names for the given Portfolio strategy */
  namedOptions: Array<Scalars['String']['output']>;
};

/** Legacy portfolio details for REST endpoints. */
export type LegacyPortfolioDetails = {
  __typename: 'LegacyPortfolioDetails';
  /** Whether auto-adjust is enabled for the portfolio */
  isAutoAdjustEnabled: Scalars['Boolean']['output'];
  /** The risk level index of the portfolio */
  riskIndex: Scalars['Int']['output'];
  /** The slug identifier of the portfolio strategy */
  slug: Scalars['String']['output'];
  /** The subtype of the portfolio, if applicable */
  subType?: Maybe<Scalars['String']['output']>;
};

/**
 * DEPRECATED, as this type violates our schema design principles for redundant
 * type/field names, and for naming/structuring data in a way that implies a visual presentation.
 *
 * Legacy description: Informational details for the given Portfolio Strategy.
 */
export type LegacyPortfolioInfoRow = {
  __typename: 'LegacyPortfolioInfoRow';
  /** Data disclosure copy for the info row */
  dataDisclosure?: Maybe<Scalars['String']['output']>;
  /** Detailed copy for the info row */
  info: Scalars['String']['output'];
  /** Title for the info row */
  title: Scalars['String']['output'];
  /** Sub-header copy for the info row */
  trailingSubHeader?: Maybe<Scalars['String']['output']>;
  /** Value for the info row */
  value: Scalars['String']['output'];
};

/**
 * DEPRECATED, as this type violates our schema design principle that schema
 * additions should be written so as to not be modeled directly after legacy REST interfaces.
 *
 * Legacy description: The Portfolio strategy option details for a ProposedGoal/Goal
 */
export type LegacyPortfolioStrategyOption = {
  __typename: 'LegacyPortfolioStrategyOption';
  /** After-tax yield for the given portfolio strategy */
  afterTaxYield?: Maybe<Scalars['String']['output']>;
  /** Aggregate of the Assets in the given Portfolio strategy */
  allocationAssets: LegacyAllocationAssets;
  /** Flag for denoting this Portfolio strategy is eligible for Autoglide */
  autoglideEligible: Scalars['Boolean']['output'];
  /** Comparison description for the given portfolio strategy */
  comparisonDescription?: Maybe<Scalars['String']['output']>;
  /** Full description copy for the given Portfolio strategy */
  description: Scalars['HTML']['output'];
  /** Disclosure copy for the given Portfolio strategy */
  disclosuresHtml?: Maybe<Scalars['String']['output']>;
  /** Emphasis copy for the given Portfolio strategy */
  emphasisText?: Maybe<Scalars['String']['output']>;
  /** The themed asset used to represent this portfolio strategy */
  icon: ThemedAsset;
  /**
   * A derived ID for the Portfolio strategy composed of the `slug` and `subType`
   * fields and the Query's arguments to establish a "unique-enough" identifier to
   * facilitate Client fetch, comparison and graph caching capabilities as
   * described in: https://graphql.org/learn/global-object-identification/ [
   * DEPRECATION NOTE: This is to facilitate best-practice use in the GraphQL Pilot
   * 1 client implementation and may be removed in the future. ]
   */
  id: Scalars['ID']['output'];
  /** Flag for denoting this is a new Portfolio strategy option */
  isNew: Scalars['Boolean']['output'];
  /** Flag for denoting that this portfolio is unavailable to a user, but should still be displayed in the user interface. */
  isUnavailable: Scalars['Boolean']['output'];
  /** A set of messages for the user. */
  messages: Array<Message>;
  /** The Portfolio strategy name */
  name: Scalars['String']['output'];
  /** Aggregate of sub-options for the given Portfolio strategy */
  namedOptions?: Maybe<LegacyNamedOptions>;
  /** The primary Asset Class Type display name with allocation percentage */
  portfolioDisplayName: Scalars['String']['output'];
  /** Collection of informational details for the given Portfolio Strategy */
  portfolioInfoRows: Array<LegacyPortfolioInfoRow>;
  /** The secondary Asset Class Type display name with allocation percentage */
  portfolioSecondaryDisplayName: Scalars['String']['output'];
  /** Principal risk for the given portfolio strategy */
  principalRisk?: Maybe<Scalars['String']['output']>;
  /** Recommendation copy for the given Portfolio strategy */
  recommendationDetails: Scalars['String']['output'];
  /** The recommended Risk Index for the given Portfolio strategy */
  recommendedRiskIndex: Scalars['Int']['output'];
  /** Simple description copy for the given Portfolio strategy */
  shortDescription: Scalars['String']['output'];
  /** Reference identifier for the given Portfolio strategy */
  slug: Scalars['String']['output'];
  /** Sub-type reference identifier for the given Portfolio strategy */
  subType?: Maybe<Scalars['String']['output']>;
  /** Description of whether the given portfolio strategy is recommended for tax purposes */
  taxRecommendationDescription?: Maybe<Scalars['String']['output']>;
  /** Message to be displayed in order to allow user to take action to allow for option to be available again. */
  unavailableActionMessage?: Maybe<Scalars['String']['output']>;
  /** Yield for the given portfolio strategy */
  yield?: Maybe<Scalars['String']['output']>;
};


/**
 * DEPRECATED, as this type violates our schema design principle that schema
 * additions should be written so as to not be modeled directly after legacy REST interfaces.
 *
 * Legacy description: The Portfolio strategy option details for a ProposedGoal/Goal
 */
export type LegacyPortfolioStrategyOptionMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** The security for the given weight in a portfolio. DEPRECATED. Use SecurityGroup instead. */
export type LegacySecurity = {
  __typename: 'LegacySecurity';
  /** The category of a given security (e.g. 'Large Blend') */
  category: Scalars['String']['output'];
  /** The general gross expense percent represented as an amount in cents per 1000 dollars. */
  expenseAmount: Scalars['Cents']['output'];
  /** The general gross expense percent of a given security */
  expensePercent: Scalars['Int']['output'];
  /** The high level group of funds the security belongs to (target date funds, stocks, or bonds) */
  grandparentGroupName: Scalars['String']['output'];
  /** The performance of a given security over specified time periods. */
  historicalPerformances: Array<HistoricalPerformance>;
  /** A value used for client-side caching purposes. */
  id: Scalars['ID']['output'];
  /** The inception date of a given security. */
  inceptionDate: Scalars['Date']['output'];
  /** The name of the given security. */
  name: Scalars['String']['output'];
  /** The group of funds the security belongs to (international stocks, us stocks, etc.) */
  parentGroupName: Scalars['String']['output'];
  /** The URL to the prospectus of a given security. */
  prospectusUrl: Scalars['String']['output'];
  /** The slug for the given security. Used by the client to submit which securities it would like to set allocations for. */
  slug: Scalars['String']['output'];
  /** The symbol of a given security (ticker symbol) */
  symbol: Scalars['String']['output'];
};

/** Aggregation of the Securities held within the Asset class within the given Portfolio strategy */
export type LegacySecurityGroupDetails = {
  __typename: 'LegacySecurityGroupDetails';
  /** Explanation content copy for the Asset class within the SecurityGroup */
  assetClassExplanation: Scalars['String']['output'];
  /** Data disclosure content copy for the SecurityGroup */
  dataDisclosure: Scalars['String']['output'];
  /** Explanation content copy for the SecurityGroup */
  explanationHeader: Scalars['String']['output'];
  /** Header content copy for the SecurityGroup */
  header: Scalars['String']['output'];
  /** Collection of Tickers that make up the Assets within this SecurityGroup */
  tickerDetails: Array<Ticker>;
  /** Explanation content copy for the Tickers within the SecurityGroup */
  tickersExplanation: Scalars['String']['output'];
};

/** Aggregation of Asset classes with presentation decoration for a given Portfolio strategy */
export type LegacySuperAssetClass = {
  __typename: 'LegacySuperAssetClass';
  /** Color hint for rendering the given Asset class */
  colorHex: Scalars['String']['output'];
  /** Collection of Assets held within this Asset class for the given Portfolio strategy */
  holdings: Array<LegacyAssetClass>;
  /** Name of the Asset class type */
  name: Scalars['String']['output'];
  /** Weighting of the Asset class within the given Portfolio strategy */
  weight: Scalars['Int']['output'];
};

/** The required terms and agreements needed for a user to open an account */
export type LegacyTermsAndAgreements = {
  __typename: 'LegacyTermsAndAgreements';
  /** The Agreements for Users. */
  agreements: Array<Agreement>;
  /** Additional Disclosure(s). */
  disclosure: Array<Scalars['HTML']['output']>;
  /** Image for the Terms and Agreements */
  image?: Maybe<ThemedAsset>;
  /** The body provided terms for that legal account. */
  terms: Scalars['HTML']['output'];
  /** Title of the Terms and Agreements */
  title: Scalars['String']['output'];
};

/**
 * The type of OmniTransfer transaction option presented to a user. Marked as
 * legacy to indicate that future development in the `TransferOption` type and the
 * OmniTransfer flow should be done in a way that's agnostic to differences between
 * transfer types.
 */
export enum LegacyTransferType {
  /** Deposit */
  Deposit = 'DEPOSIT',
  /** Transfer */
  Transfer = 'TRANSFER',
  /** Withdrawal */
  Withdrawal = 'WITHDRAWAL'
}

/** The current target weights of securities for a given goal's portfolio. DEPRECATED. Use SecurityGroupWeight instead. */
export type LegacyWeightedSecurity = {
  __typename: 'LegacyWeightedSecurity';
  /**
   * The weight the user has set for a given security. All allocations for a given portfolio must sum up to 100%.
   * @deprecated Use SecurityGroupHolding instead.
   */
  allocationPercent: Scalars['Int']['output'];
  /**
   * A value used for client-side caching purposes.
   * @deprecated Use SecurityGroupHolding instead.
   */
  id: Scalars['ID']['output'];
  /**
   * The security for the given weight in a portfolio.
   * @deprecated Use SecurityGroupHolding instead.
   */
  security: LegacySecurity;
};

/** A legal account holding assets in the client's investing and banking sub-accounts */
export type LegalAccount = {
  __typename: 'LegalAccount';
  /** The account number for a given legal account */
  accountNumber: Scalars['String']['output'];
  /** The title and instructions copy for updating beneficiaries of the given legal account */
  beneficiaryUpdateInstructions: BeneficiaryUpdateInstructions;
  /** A legal account's contingent beneficiaries */
  contingentBeneficiaries: Array<LegalAccountBeneficiary>;
  /** The display name for a given legal account */
  displayName: Scalars['String']['output'];
  /** The ID for the legal account. */
  id: Scalars['ID']['output'];
  /** The ID for the legal account, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** The type of ownership for the account */
  ownershipType: LegalAccountOwnershipType;
  /** A legal account's primary beneficiaries */
  primaryBeneficiaries: Array<LegalAccountBeneficiary>;
  /** The type of account, as recognized by the IRS for tax purposes. */
  taxationType: LegalAccountTaxationType;
};

/** A beneficiary for a legal account */
export type LegalAccountBeneficiary = {
  __typename: 'LegalAccountBeneficiary';
  /** The beneficiary's date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** The beneficiary's distribution share */
  distributionShare: Scalars['Percent']['output'];
  /** The beneficiary's full name */
  fullName: Scalars['String']['output'];
  /** The ID for the beneficiary. */
  id: Scalars['ID']['output'];
  /** A beneficiary's relation to the legal account holder */
  relationship: BeneficiaryRelationship;
  /** A beneficiary's Tax ID/EIN when it is a trust */
  taxId?: Maybe<Scalars['TIN']['output']>;
};

/** Input structure for a Beneficiary on a Legal Account. */
export type LegalAccountBeneficiaryInput = {
  /** Date of birth of the beneficiary. May be null if the beneficiary is a trust */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Full name of the beneficiary */
  fullName: Scalars['String']['input'];
  /** Relationship of the beneficiary to the account holder */
  relationship: BeneficiaryRelationship;
  /** A beneficiary's Tax ID/EIN when it is a non-human entity */
  taxId?: InputMaybe<Scalars['TIN']['input']>;
};

/** The type of owner of the account. Currently, only TAXABLE accounts can be owned as JOINT or TRUST. */
export enum LegalAccountOwnershipType {
  /** Owned by an individual user */
  Individual = 'INDIVIDUAL',
  /** Jointly owned */
  Joint = 'JOINT',
  /** Owned by a trust */
  Trust = 'TRUST'
}

/** The type of account as recognized by the IRS for tax purposes. */
export enum LegalAccountTaxationType {
  /** Holding 529 account */
  Holding_529 = 'HOLDING_529',
  /** HSA (Health Savings Account) */
  Hsa = 'HSA',
  /** Roth 401k */
  Roth_401K = 'ROTH_401K',
  /** Roth IRA (Roth Individual Retirement Arrangement) */
  RothIra = 'ROTH_IRA',
  /** SEP IRA (Simplified Employee Pension Individual Retirement Arrangement) */
  SepIra = 'SEP_IRA',
  /** Taxable account */
  Taxable = 'TAXABLE',
  /** Traditional 401k */
  Traditional_401K = 'TRADITIONAL_401K',
  /** Traditional IRA (Traditional Individual Retirement Arrangement) */
  TraditionalIra = 'TRADITIONAL_IRA'
}

/**
 * Legal account type could only be either taxation type or ownership type. Not
 * both. Taxation type is mainly applicable to Retirement related legal accounts
 * where the ownership type is individual taxableand the taxation type further
 * defines the account by taxability. E.g. Roth IRA vs. Traditional IRA.
 */
export type LegalAccountTypeInput =
  /** The ownership type of the account */
  { ownershipType: LegalAccountOwnershipType; taxationType?: never; }
  |  /** The taxation type of the account */
  { ownershipType?: never; taxationType: LegalAccountTaxationType; };

/** A sub account of a LegalAccount */
export type LegalSubAccount = {
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** Checking accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleCheckingAccounts: Array<CheckingAccount>;
  /** External accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleExternalAccounts: Array<ExternalAccount>;
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** Whether the account has reached the maximum number of bank accounts allowed by operations. */
  hasReachedOpsBankAccountLimit: Scalars['Boolean']['output'];
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /** Whether the account is closed. */
  isClosed: Scalars['Boolean']['output'];
  /** Whether the legal sub account is an eligible destination for a recurring deposit. */
  isRecurringDepositEligible: Scalars['Boolean']['output'];
  /**
   * The legacy ID for this instance of a LegalSubAccount
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** The name of the account */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** Wrapper input type for legal sub accounts. */
export type LegalSubAccountInput = {
  /** A boolean indicating whether or not to include closed sub accounts. Defaults to false. */
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A major purchase purpose creation option */
export type MajorPurchasePurposeCreationOption = PurposeCreationOptionInterface & {
  __typename: 'MajorPurchasePurposeCreationOption';
  /** The default name for this purpose */
  defaultName: Scalars['String']['output'];
  /** The default target date range for the major purchase */
  defaultTargetDate: Scalars['Date']['output'];
  /** An explanation of the default target date */
  defaultTargetDateExplanation: Scalars['String']['output'];
  /** A description of the purpose creation option */
  description?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the purpose creation option */
  id: Scalars['ID']['output'];
  /** The legacy advice type identifier */
  legacyAdviceTypeId: Scalars['String']['output'];
  /** The display name of the purpose creation option */
  name: Scalars['String']['output'];
  /** The image icon and image key representing this purpose option */
  purposeAsset: PurposeAsset;
};

/** Input object for updating a major purchase purpose */
export type MajorPurchaseUpdateInput = {
  /** The target date for the major purchase */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};

/** The option to manage recurring transactions. */
export type ManageRecurringTransactionsOption = TransactionOption & {
  __typename: 'ManageRecurringTransactionsOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** An investing-focused account managed by Betterment. */
export type ManagedAccount = EnvelopeAccount & PerformanceAccount & {
  __typename: 'ManagedAccount';
  /** The name describing the account, e.g. a traditional IRA or a bonds portfolio. */
  accountDescription: Scalars['String']['output'];
  /** The financial activity for the managed account. */
  activityConnection: ActivityItemConnection;
  /** A collection of articles for education and advice for the managed account. */
  articles: Array<Article>;
  /** The asset allocation for the account. */
  assetAllocation: CustomizableAssetAllocation | RiskBasedAssetAllocation | YieldBasedAssetAllocation;
  /** The autoglide eligibility and status for the account. */
  autoglide: Autoglide;
  /** The balance of the account. */
  balance: Scalars['Cents']['output'];
  /**
   * The balance projection for the account.
   * @deprecated Use projection instead.
   */
  balanceProjection?: Maybe<BalanceProjection>;
  /** Returning the crypto assets recommendations for the betterment crypto investing portfolio */
  cryptoAssetsRecommendation?: Maybe<Scalars['String']['output']>;
  /**
   * The envelope holding the item. Beware not to use this field to access complex
   * data about an envelope's items cyclically, such that a user with a very high
   * number of items could end up executing an operation with a dramatically high
   * runtime complexity.
   */
  envelope: Envelope;
  /** True if the account has ever been funded, even if current balance is $0. */
  hasEverBeenFunded: Scalars['Boolean']['output'];
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /** If the account has a bonds-only portfolio. */
  isBondsOnlyPortfolio: Scalars['Boolean']['output'];
  /** If the account is an IRA or 401(k). */
  isRetirementAccount: Scalars['Boolean']['output'];
  /** Whether the account is tax-coordinated. */
  isTaxCoordinated: Scalars['Boolean']['output'];
  /** Whether the account is eligible for tax-coordination setup (e.g. retirement_growth advice type). */
  isTaxCoordinationEligible: Scalars['Boolean']['output'];
  /**
   * The ID for the goal related to this account, as recognized by our legacy REST APIs.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /**
   * The ID for the managed account (identical to the legacy Goal ID), as recognized by our legacy REST APIs.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacyId: Scalars['LegacyID']['output'];
  /** Messages associated with the envelope account. */
  messages: Array<Message>;
  /** A warning about the minimum fee for the account. */
  minFeeWarning?: Maybe<Message>;
  /**
   * A sum of all expected/planned inflows and outflows involving sub accounts in
   * the account, for envelopes that support the calculation. This value includes
   * the sum of the monthly net amounts of all configured recurring deposits,
   * recurring transfers, recurring withdrawals, and expected employee
   * contributions (if an account is a 401k).
   */
  monthlyNetRecurringCashflows: Scalars['Cents']['output'];
  /**
   * The name representing the account.
   * @deprecated Use account_description instead.
   */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** All payroll contribution configs for this account's sub accounts. */
  payrollContributionConfigs: Array<PayrollContributionConfig>;
  /** The performance of the account. */
  performance: Performance;
  /**
   * The performance history for the account.
   * @deprecated Use `performance#history` instead.
   */
  performanceHistory: PerformanceHistory;
  /**
   * The performance totals for the account.
   * @deprecated Use `performance#totals` instead.
   */
  performanceTotals: PerformanceTotals;
  /** Portfolio metadata, performance, etc. */
  portfolio: RiskLevelBasedPortfolio | SelfDirectedPortfolio;
  /** A projected future for the managed account. */
  projection?: Maybe<ManagedAccountProjection>;
  /** A reason-to-believe used to motivate the user to initiate a recurring deposit into one of this account's sub accounts. */
  recurringDepositMotivation?: Maybe<RecurringDepositMotivation>;
  /** All recurring transaction configs for this account's sub accounts. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** The security group positions for the account. */
  securityGroupPositions: Array<SecurityGroupPosition>;
  /** A collection of accounts in a Betterment-managed portfolio. */
  subAccounts: Array<ManagedSubAccount>;
  /** The options to initiate a transaction involving this account. */
  transactionOptions: Array<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountArticlesArgs = {
  scope?: InputMaybe<ArticlesScope>;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountPerformanceHistoryArgs = {
  dateRangeOption?: DateRangeOption;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountPerformanceTotalsArgs = {
  dateRangeOption?: InputMaybe<DateRangeOption>;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountProjectionArgs = {
  input?: InputMaybe<ManagedAccountProjectionInput>;
};

/** A projected future for an account, including a balance time series. */
export type ManagedAccountProjection = {
  __typename: 'ManagedAccountProjection';
  /** A time-series of the expected balances for the account. */
  balanceTimeSeries: Array<BalanceProjectionItem>;
};

/** Input values for a customized projection for an eligible managed account. */
export type ManagedAccountProjectionInput = {
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of a one-time contribution to the account made by the user today.
   */
  adHocInflow: Scalars['Cents']['input'];
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of monthly recurring contributions to the account.
   */
  monthlyRecurringInflows: Scalars['Cents']['input'];
};

/**
 * A portfolio held in a managed account. Could be a Betterment portfolio strategy
 * (e.g. Core, Innovative Technology, etc.), an advisor custom portfolio, advised
 * 401(k), or flexible portfolio. There are two types of managed portfolios:
 * risk-based and self-directed. A risk-based portfolio is a portfolio that is made
 * up of more than 1 risk level (i.e. 101 stock allocations, named risk levels,
 * etc.). A self-directed portfolio is a portfolio that is based on the user's own
 * investment choices (flexible portfolio or advised 401(k)).
 */
export type ManagedPortfolio = {
  /**
   * A description of the configuration of the portfolio, typically including
   * details like the portfolio strategy name, and details about the risk level
   * (e.g., "Core portfolio (90% stocks)").
   */
  configurationDescription: Scalars['String']['output'];
  /**
   * The portfolio strategy's legal disclosure contains information about the
   * portfolio strategy, including the investment strategy, risks, features, and
   * construction methodology. This is a link to the legal disclosure for the
   * portfolio strategy.
   */
  disclosureUrl?: Maybe<Scalars['URL']['output']>;
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** Contains the portfolio's expense ratio details. */
  expenseRatio: ExpenseRatio;
  /** Indicates if there is a pending portfolio change request for this portfolio. */
  hasPendingPortfolioChangeRequest: Scalars['Boolean']['output'];
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the user can edit the target allocation of the portfolio. */
  isAllocationEditable: Scalars['Boolean']['output'];
  /** Whether this portfolio uses the Crypto ETF strategy. */
  isCryptoPortfolio: Scalars['Boolean']['output'];
  /** Whether the user is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
};

/** A sub-account of a Betterment-managed account. */
export type ManagedSubAccount = LegalSubAccount & PayrollContributionConfigAccount & TransferableAccount & {
  __typename: 'ManagedSubAccount';
  /** The name describing the account. */
  accountDescription: Scalars['String']['output'];
  /** The balance of the sub account. */
  balance: Scalars['Cents']['output'];
  /** Checking accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleCheckingAccounts: Array<CheckingAccount>;
  /** External accounts that are able to be linked as bank accounts to this account's account group. */
  bankAccountEligibleExternalAccounts: Array<ExternalAccount>;
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** Whether the account has reached the maximum number of bank accounts allowed by operations. */
  hasReachedOpsBankAccountLimit: Scalars['Boolean']['output'];
  /** The icon used to represent the sub account. */
  icon: ThemedAsset;
  /** The unique ID for the given account. */
  id: Scalars['ID']['output'];
  /** Whether the account is closed. */
  isClosed: Scalars['Boolean']['output'];
  /** Whether the legal sub account is an eligible destination for a recurring deposit. */
  isRecurringDepositEligible: Scalars['Boolean']['output'];
  /**
   * The legacy ID for this instance of a LegalSubAccount
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** The managed account holding the sub account. */
  managedAccount: ManagedAccount;
  /** The name of the sub account. */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};


/** A sub-account of a Betterment-managed account. */
export type ManagedSubAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};

/** The type for a market business schedule */
export type MarketSchedule = {
  __typename: 'MarketSchedule';
  /** The close of the market business day. May be null if not a market business day. */
  closeAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date of the market day */
  date: Scalars['Date']['output'];
  /** The next market business day */
  nextBusinessDay: MarketSchedule;
  /** The open of the market business day. May be null if not a market business day. */
  openAt?: Maybe<Scalars['DateTime']['output']>;
  /** The previous market business day */
  previousBusinessDay: MarketSchedule;
};

/** A MarketingMessage. */
export type MarketingMessage = {
  __typename: 'MarketingMessage';
  /** Flag representing that the given MarketingMessage has been clicked. */
  clicked: Scalars['Boolean']['output'];
  /** The date and time that the given MarketingMessage was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the given MarketingMessage. */
  description: Scalars['String']['output'];
  /** The date and time that the given MarketingMessage expires. */
  expiresAt: Scalars['DateTime']['output'];
  /** Extras for the given MarketingMessage. */
  extras?: Maybe<MarketingMessageExtras>;
  /** The unique Identifier for the given MarketingMessage. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The image url of the given MarketingMessage. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Flag representing that the given MarketingMessage is dismissible. */
  isDismissible: Scalars['Boolean']['output'];
  /** The link text of the given MarketingMessage. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** Flag representing that the given MarketingMessage has been pinned. */
  pinned: Scalars['Boolean']['output'];
  /** The title of the given MarketingMessage. */
  title?: Maybe<Scalars['String']['output']>;
  /** The url of the given MarketingMessage. */
  url?: Maybe<Scalars['String']['output']>;
  /** Flag representing that the given MarketingMessage has been viewed. */
  viewed: Scalars['Boolean']['output'];
};

/** Extra attributes for a MarketingMessage. */
export type MarketingMessageExtras = {
  __typename: 'MarketingMessageExtras';
  /** The card system of the given MarketingMessage. */
  cardSystem: Scalars['String']['output'];
  /** The category of the given MarketingMessage. */
  category: Scalars['String']['output'];
  /** The disclosure link of the given MarketingMessage. */
  disclosureLink?: Maybe<Scalars['String']['output']>;
  /** The footer disclosure of the given MarketingMessage. */
  footerDisclosure?: Maybe<Scalars['String']['output']>;
  /** The full disclosure of the given MarketingMessage. */
  fullDisclosure?: Maybe<Scalars['String']['output']>;
  /** The goal identifier of the given MarketingMessage. */
  goalIdentifier?: Maybe<Scalars['String']['output']>;
  /** The image alt text of the given MarketingMessage. */
  imageAltText?: Maybe<Scalars['String']['output']>;
  /** The interruptive message of the given MarketingMessage. */
  interruptiveMessage?: Maybe<Scalars['String']['output']>;
  /** The link target of the given MarketingMessage. */
  linkTarget?: Maybe<Scalars['String']['output']>;
  /** The name of the given MarketingMessage. */
  name: Scalars['String']['output'];
  /** The short disclosure of the given MarketingMessage. */
  shortDisclosure?: Maybe<Scalars['String']['output']>;
};

/** Extra attributes for a MarketingMessage. */
export type MarketingMessageExtrasInput = {
  /** The card system of the given MarketingMessage. */
  cardSystem: Scalars['String']['input'];
  /** The category of the given MarketingMessage. */
  category: Scalars['String']['input'];
  /** The disclosure link of the given MarketingMessage. */
  disclosureLink?: InputMaybe<Scalars['String']['input']>;
  /** The footer disclosure of the given MarketingMessage. */
  footerDisclosure?: InputMaybe<Scalars['String']['input']>;
  /** The full disclosure of the given MarketingMessage. */
  fullDisclosure?: InputMaybe<Scalars['String']['input']>;
  /** The goal identifier of the given MarketingMessage. */
  goalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The image alt text of the given MarketingMessage. */
  imageAltText?: InputMaybe<Scalars['String']['input']>;
  /** The interruptive message of the given MarketingMessage. */
  interruptiveMessage?: InputMaybe<Scalars['String']['input']>;
  /** The link target of the given MarketingMessage. */
  linkTarget?: InputMaybe<Scalars['String']['input']>;
  /** The name of the given MarketingMessage. */
  name: Scalars['String']['input'];
  /** The short disclosure of the given MarketingMessage. */
  shortDisclosure?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for a MarketingMessage. */
export type MarketingMessageInput = {
  /** Flag representing that the given MarketingMessage has been clicked. */
  clicked: Scalars['Boolean']['input'];
  /** The date and time that the given MarketingMessage was created. */
  createdAt: Scalars['DateTime']['input'];
  /** The description of the given MarketingMessage. */
  description: Scalars['String']['input'];
  /** The date and time that the given MarketingMessage expires. */
  expiresAt: Scalars['DateTime']['input'];
  /** Extras for the given MarketingMessage. */
  extras: MarketingMessageExtrasInput;
  /** The unique Identifier for the given MarketingMessage. */
  id: Scalars['ID']['input'];
  /** The image url of the given MarketingMessage. */
  imageUrl: Scalars['String']['input'];
  /** Flag representing that the given MarketingMessage is dismissible. */
  isDismissible: Scalars['Boolean']['input'];
  /** The link text of the given MarketingMessage. */
  linkText: Scalars['String']['input'];
  /** Flag representing that the given MarketingMessage has been pinned. */
  pinned: Scalars['Boolean']['input'];
  /** The title of the given MarketingMessage. */
  title: Scalars['String']['input'];
  /** The url of the given MarketingMessage. */
  url: Scalars['String']['input'];
  /** Flag representing that the given MarketingMessage has been viewed. */
  viewed: Scalars['Boolean']['input'];
};

/** Wrapper input type for filtering and auditing marketing messages. */
export type MarketingMessagesInput = {
  /** The location of the marketing messages. */
  location: Scalars['String']['input'];
  /** An array of marketing messages. */
  marketingMessages: Array<MarketingMessageInput>;
};

/** The ability to create a memo for a specific transaction */
export type MemoCreationOption = {
  __typename: 'MemoCreationOption';
  /** An identifier representing the unique option presented to the user to create a for this transaction memo. */
  id: Scalars['ID']['output'];
  /** The selectable options for the reason the transaction was taken. */
  reasonOptions: Array<MemoReasonOption>;
  /** A down-cased description of the type of transaction (e.g., 'deposit', 'withdrawal') */
  transactionTypeName: Scalars['String']['output'];
};

/** A selectable reason for a memo. */
export type MemoReasonOption = {
  __typename: 'MemoReasonOption';
  /** A readable description of the reason. */
  description: Scalars['String']['output'];
  /** The id for the selectable reason. */
  id: Scalars['ID']['output'];
};

/** A message to display to the user. */
export type Message = {
  __typename: 'Message';
  /** The body of the message. */
  body: Scalars['HTML']['output'];
  /** The CTA of the message. */
  cta?: Maybe<MessageCtaLink | MessageCtaModal>;
  /** The unique identifier for the message. */
  id: Scalars['ID']['output'];
  /** Whether the message can be dismissed. */
  isDismissible: Scalars['Boolean']['output'];
  /** The style of the message. */
  style: MessageStyle;
  /** The title of the message. */
  title?: Maybe<Scalars['String']['output']>;
  /** The tracking name for the message. */
  trackingName?: Maybe<Scalars['String']['output']>;
};

/** CTA for a message */
export type MessageCta = {
  /** The text for the CTA. */
  text: Scalars['String']['output'];
};

/** CTA link for a message. */
export type MessageCtaLink = MessageCta & {
  __typename: 'MessageCtaLink';
  /** The text for the CTA. */
  text: Scalars['String']['output'];
  /** The themed asset set for all holdings image url */
  url: Scalars['URL']['output'];
};

/** CTA modal for a message. */
export type MessageCtaModal = MessageCta & {
  __typename: 'MessageCtaModal';
  /** The content for the modal of the CTA. */
  content: Scalars['HTML']['output'];
  /** The text for the CTA. */
  text: Scalars['String']['output'];
};

/** The style of the message. */
export enum MessageStyle {
  /** A message that communicates advice or guidance, intended to be displayed as a guidance box. */
  Advice = 'ADVICE',
  /** A message that communicates an error state, intended to be displayed as a red banner. */
  Error = 'ERROR',
  /** A message that communicates a general information state, intended to be displayed as a blue banner. */
  Info = 'INFO',
  /** A message that communicates success state, intended to be displayed as a green banner. */
  Success = 'SUCCESS',
  /** A message that communicates a general information state, intended to be displayed as a yellow banner. */
  Warning = 'WARNING'
}

/** Provides a model portfolio option for a given goal */
export type ModelPortfolioOption = {
  __typename: 'ModelPortfolioOption';
  /** The asset allocations for the model portfolio option */
  assetAllocations: Array<CustomizableAssetAllocation | RiskBasedAssetAllocation | YieldBasedAssetAllocation>;
  /** The dividend yield for the model portfolio option */
  dividendYield: Scalars['Percent']['output'];
  /** The expense ratio for the model portfolio option */
  expenseRatio: Scalars['Percent']['output'];
  /** The icon for the model portfolio option */
  icon: ThemedAsset;
  /** The ID of the model portfolio option */
  id: Scalars['ID']['output'];
  /** Denotes the recommended portfolio option */
  isRecommended: Scalars['Boolean']['output'];
  /** Whether the option is part of the Socially Responsible Investing (SRI) set of portfolios */
  isSociallyResponsibleInvesting: Scalars['Boolean']['output'];
  /** A long description of the model portfolio option */
  longDescription: Scalars['HTML']['output'];
  /** The display name of the model portfolio option */
  name: Scalars['String']['output'];
  /** The recommended asset allocation for the model portfolio option */
  recommendedAllocation: CustomizableAssetAllocation | RiskBasedAssetAllocation | YieldBasedAssetAllocation;
  /** A short description of the model portfolio option */
  shortDescription: Scalars['String']['output'];
};

/** The money-weighted (also known as the 'internal') rate of return for an investment or set of investments */
export type MoneyWeightedRateOfReturn = {
  __typename: 'MoneyWeightedRateOfReturn';
  /** The annualized rate of return */
  annualized?: Maybe<Scalars['Percent']['output']>;
  /** The rate of return for the whole period */
  cumulative?: Maybe<Scalars['Percent']['output']>;
};

/** The entrypoint for all retail schema mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** Accept an advisory relationship approval request by signing required agreements */
  acceptAdvisoryRelationshipApprovalRequest: AcceptAdvisoryRelationshipApprovalRequestMutationPayload;
  /** Add an external account to an envelope */
  addEnvelopeExternalAccounts: AddEnvelopeExternalAccountsMutationPayload;
  /** Cancels a deposit or withdrawal request. */
  cancelTransactionRequest: CancelTransactionRequestMutationPayload;
  /** Captures the signature for a signable package (e.g., Solo 401k Plan documents). */
  capturePackageSignature: CapturePackageSignatureMutationPayload;
  /** Completes the draft purpose flow by creating/updating the purpose and associated envelope */
  completeDraftPurposeFlow: CompleteDraftPurposeFlowMutationPayload;
  /** Completes the solo 401k client envelope flow by creating 401k plans and marking the invite complete */
  completeSolo401kClientEnvelopeFlow: SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload;
  /** Creates a new account and associates it with an existing or new tax coordinated portfolio. */
  completeTaxCoordinatedAccountCreationFlowMutation: CompleteTaxCoordinatedAccountCreationFlowMutationPayload;
  /** Confirms a customer's response to an identity verification challenge from a CX agent. */
  confirmIdentityVerificationChallenge: ConfirmIdentityVerificationChallengeMutationPayload;
  /** Generate AI explanation for a specific recommendation */
  createAccountRecommendationExplanation: CreateAccountRecommendationExplanationMutationPayload;
  /**
   * Creates a new direct trading account, updates the user investing experience
   * level, and updates the user's securities lending enrollment if the user chooses
   * to. If the account is not created, the two other steps will not run. The
   * expected output will be the created direct trading account."
   */
  createDirectTradingAccount: CreateDirectTradingAccountMutationPayload;
  /** Creates a document verification token for Socure identity verification */
  createDocumentVerificationToken: CreateDocumentVerificationTokenMutationPayload;
  /** Creates a request to change an employee's payroll contribution configuration. */
  createEmployeeContributionConfigurationChangeRequest: CreateEmployeeContributionConfigurationChangeRequestMutationPayload;
  /** Creates a single security order request record */
  createFinancialSecurityOrderRequest: CreateFinancialSecurityOrderRequestMutationPayload;
  /** Creates a personal referral invitation. */
  createPersonalReferralInvitation: CreatePersonalReferralInvitationMutationPayload;
  /** Creates a recurring deposit, withdrawal, or transfer between a supported source and destination account. */
  createRecurringTransactionConfig: CreateRecurringTransactionConfigMutationPayload;
  /** Creates a Solo401k interest submission record with the given form submission values */
  createSolo401kInterestSubmissions: CreateSolo401kInterestSubmissionsMutationPayload;
  /** Creates a memo for an existing transaction. */
  createTransactionMemo: CreateTransactionMemoMutationPayload;
  /** Creates a deposit, withdrawal, or transfer between a supported source account and destination account. */
  createTransactionRequest: CreateTransactionRequestMutationPayload;
  /** Creates a user activity CSV export. */
  createUserActivityCsvExport: CreateUserActivityCsvExportMutationPayload;
  /** Deactivates a beneficiary on a checking account */
  deleteCheckingBeneficiary: DeleteCheckingBeneficiaryMutationPayload;
  /** Deletes the purpose from an envelope account. */
  deletePurpose: DeletePurposeMutationPayload;
  /** Deletes a recurring transaction config owned by the current user. */
  deleteRecurringTransactionConfig: DeleteRecurringTransactionConfigMutationPayload;
  /** Deletes the trusted contact for the current user. */
  deleteTrustedContact: DeleteTrustedContactMutationPayload;
  /** Dismisses the download banner for a user activity csv export. */
  dismissUserActivityCsvExportBanner: DismissUserActivityCsvExportBannerMutationPayload;
  /**
   * Initiates a users student loan payment attestation based on a calculated plan
   * year. This creates both attestation and attestation entries based on the users
   * employee information. The plan year is calculated off the current date where
   * Dec 1 <= now <= December 31 will be now.year and January 1 <= now <= January
   * 14 will be now.year - 1. This can only be used within the aformentioned dates
   * or an error will occur.
   */
  initiateStudentLoanPaymentBenefitAttestation: InitiateStudentLoanPaymentBenefitAttestationMutationPayload;
  /** Processes Capitalize window events for the current user going through the rollover flow. */
  processCapitalizeWindowEvent: ProcessCapitalizeWindowEventMutationPayload;
  /** Removes an their external account from the associated envelope. */
  removeTheirExternalAccountEnvelope: RemoveTheirExternalAccountEnvelopeMutationPayload;
  /** Resends a personal referral invitation. */
  resendPersonalReferralInvitation: ResendPersonalReferralInvitationMutationPayload;
  /** Revokes a mobile token, marking it as expired and deactivating associated push tokens. */
  revokeMobileToken: RevokeMobileTokenMutationPayload;
  /** Sends an email in which the user can verify their email address. */
  sendEmailVerificationEmail: SendEmailVerificationEmailMutationPayload;
  /** Emails instructions to the user for how to initiate a wire transfer to a specific sub account. */
  sendWireTransferInstructionsEmail: SendWireTransferInstructionsEmailMutationPayload;
  /** Emails instructions to the user for how to initiate a wire transfer to a specific sub account. */
  sendWireTransferInstructionsEmailV2: SendWireTransferInstructionsEmailV2MutationPayload;
  /**
   * Submits adhoc document verification results to Socure for processing;
   * submitted in response to a document verification request by Ops or through an
   * automated process outside of the kyc flow
   */
  submitAdhocDocumentVerification: SubmitAdhocDocumentVerificationMutationPayload;
  /** Submits document verification results to Socure for processing */
  submitDocumentVerification: SubmitDocumentVerificationMutationPayload;
  /** Submit user feedback to Zendesk */
  submitFeedback: SubmitFeedbackMutationPayload;
  /** Updates the name on an envelope account. */
  updateAccountName: UpdateAccountNameMutationPayload;
  /** Updates the status of a user's Betterment Advisor Network intent. */
  updateAdvisorNetworkIntent: UpdateAdvisorNetworkIntentMutationPayload;
  /** Updates the beneficiary information on a checking account. */
  updateCheckingBeneficiary: UpdateCheckingBeneficiaryMutationPayload;
  /** Updates the order positions for envelopes. */
  updateEnvelopeOrders: UpdateEnvelopeOrdersMutationPayload;
  /** Updates the visibility of a single ExternalAccount. */
  updateExternalAccountVisibility: UpdateExternalAccountVisibilityMutationPayload;
  /** Updates the retirement assumptions within the user's financial profile. */
  updateFinancialProfileRetirementAssumptions: UpdateFinancialProfileRetirementAssumptionsMutationPayload;
  /** Updates the given account with the provided beneficiary information. */
  updateLegalAccountBeneficiaries: UpdateLegalAccountBeneficiariesMutationPayload;
  /** Updates the security lending enrollment setting for the current user. */
  updateSecuritiesLendingEnrollment: UpdateSecuritiesLendingEnrollmentMutationPayload;
  /**
   * Updates a users student loan payment attestation. This is invoked by clients
   * to update a users attestation when they go through the student loan payment
   * attestation flow. Using this the user can attest to the amount they paid in
   * student loans for a given year. An attestation is made up a of a list of
   * entries, so this mutation takes a series of entry ids and amounts, and then
   * persists the amounts on the corresponding entry
   */
  updateStudentLoanPaymentBenefitAttestation: UpdateStudentLoanPaymentBenefitAttestationMutationPayload;
  /**
   * Updates a users student loan payment estimate. This is invoked by clients to
   * update a users estimate when they go through the student loan payment
   * estimation flow. Using this the user can esimate either by providing an
   * estimated monthly payment, or an annual payment amount.
   */
  updateStudentLoanPaymentBenefitEstimate: UpdateStudentLoanPaymentBenefitEstimateMutationPayload;
  /** Creates or updates a trusted contact for the current user. */
  updateTrustedContact: UpdateTrustedContactMutationPayload;
  /** Updates the investing experience level for the current user. */
  updateUserInvestingExperience: UpdateUserInvestingExperienceMutationPayload;
  /** Updates the postal address details for the current user. */
  updateUserPostalAddress: UpdateUserPostalAddressMutationPayload;
  /** Updates the user profile details for the current user. */
  updateUserProfile: UpdateUserProfileMutationPayload;
  /** Upload address change document */
  uploadAddressChangeDocument: UploadAddressChangeDocumentMutationPayload;
  /** Validates secondary user details for a direct trading joint account. */
  validateDirectTradingJointAccountSecondaryUser: ValidateDirectTradingJointAccountSecondaryUserMutationPayload;
  /** Validates the given trust details. */
  validateDirectTradingTrustDetails: ValidateDirectTradingTrustDetailsMutationPayload;
  /** Validates the given order request. */
  validateFinancialSecurityOrderRequest: ValidateFinancialSecurityOrderRequestMutationPayload;
  /** Validates the given account beneficiary information. */
  validateLegalAccountBeneficiary: ValidateLegalAccountBeneficiaryMutationPayload;
};


/** The entrypoint for all retail schema mutations */
export type MutationAcceptAdvisoryRelationshipApprovalRequestArgs = {
  input: AcceptAdvisoryRelationshipApprovalRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationAddEnvelopeExternalAccountsArgs = {
  input: AddEnvelopeExternalAccountsMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCancelTransactionRequestArgs = {
  input: CancelTransactionRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCapturePackageSignatureArgs = {
  input: CapturePackageSignatureMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCompleteDraftPurposeFlowArgs = {
  input: CompleteDraftPurposeFlowMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCompleteSolo401kClientEnvelopeFlowArgs = {
  input: SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCompleteTaxCoordinatedAccountCreationFlowMutationArgs = {
  input: CompleteTaxCoordinatedAccountCreationFlowMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationConfirmIdentityVerificationChallengeArgs = {
  input: ConfirmIdentityVerificationChallengeMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateAccountRecommendationExplanationArgs = {
  input: CreateAccountRecommendationExplanationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateDirectTradingAccountArgs = {
  input: CreateDirectTradingAccountMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateEmployeeContributionConfigurationChangeRequestArgs = {
  input: CreateEmployeeContributionConfigurationChangeRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateFinancialSecurityOrderRequestArgs = {
  input: CreateFinancialSecurityOrderRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreatePersonalReferralInvitationArgs = {
  input: CreatePersonalReferralInvitationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateRecurringTransactionConfigArgs = {
  input: CreateRecurringTransactionConfigMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateSolo401kInterestSubmissionsArgs = {
  input: CreateSolo401kInterestSubmissionsMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateTransactionMemoArgs = {
  input: CreateTransactionMemoMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateTransactionRequestArgs = {
  input: CreateTransactionRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationCreateUserActivityCsvExportArgs = {
  input: CreateUserActivityCsvExportMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationDeletePurposeArgs = {
  input: DeletePurposeMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationDeleteRecurringTransactionConfigArgs = {
  input: DeleteRecurringTransactionConfigMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationDismissUserActivityCsvExportBannerArgs = {
  input: DismissUserActivityCsvExportBannerMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationProcessCapitalizeWindowEventArgs = {
  input: ProcessCapitalizeWindowEventMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationRemoveTheirExternalAccountEnvelopeArgs = {
  input: RemoveTheirExternalAccountEnvelopeMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationResendPersonalReferralInvitationArgs = {
  input: ResendPersonalReferralInvitationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationRevokeMobileTokenArgs = {
  input: RevokeMobileTokenMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationSendWireTransferInstructionsEmailArgs = {
  input: SendWireTransferInstructionsEmailMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationSendWireTransferInstructionsEmailV2Args = {
  input: SendWireTransferInstructionsEmailV2MutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationSubmitAdhocDocumentVerificationArgs = {
  input: SubmitAdhocDocumentVerificationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationSubmitDocumentVerificationArgs = {
  input: SubmitDocumentVerificationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationSubmitFeedbackArgs = {
  input: SubmitFeedbackMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateAccountNameArgs = {
  input: UpdateAccountNameMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateAdvisorNetworkIntentArgs = {
  input: UpdateAdvisorNetworkIntentMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateCheckingBeneficiaryArgs = {
  input: UpdateCheckingBeneficiaryMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateEnvelopeOrdersArgs = {
  input: UpdateEnvelopeOrdersMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateExternalAccountVisibilityArgs = {
  input: UpdateExternalAccountVisibilityMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateFinancialProfileRetirementAssumptionsArgs = {
  input: UpdateFinancialProfileRetirementAssumptionsMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateLegalAccountBeneficiariesArgs = {
  input: UpdateLegalAccountBeneficiariesMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateSecuritiesLendingEnrollmentArgs = {
  input: UpdateSecuritiesLendingEnrollmentMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateStudentLoanPaymentBenefitAttestationArgs = {
  input: UpdateStudentLoanPaymentBenefitAttestationMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateStudentLoanPaymentBenefitEstimateArgs = {
  input: UpdateStudentLoanPaymentBenefitEstimateMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateTrustedContactArgs = {
  input: UpdateTrustedContactMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateUserInvestingExperienceArgs = {
  input: UpdateUserInvestingExperienceMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateUserPostalAddressArgs = {
  input: UpdateUserPostalAddressMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationUploadAddressChangeDocumentArgs = {
  input: UploadAddressChangeDocumentMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationValidateDirectTradingJointAccountSecondaryUserArgs = {
  input: ValidateDirectTradingJointAccountSecondaryUserMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationValidateDirectTradingTrustDetailsArgs = {
  input: ValidateDirectTradingTrustDetailsMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationValidateFinancialSecurityOrderRequestArgs = {
  input: ValidateFinancialSecurityOrderRequestMutationInput;
};


/** The entrypoint for all retail schema mutations */
export type MutationValidateLegalAccountBeneficiaryArgs = {
  input: ValidateLegalAccountBeneficiaryMutationInput;
};

/** Breakdown of net worth of the current User's Betterment Accounts */
export type NetWorth = {
  __typename: 'NetWorth';
  /** The total balance of the user's net worth */
  balance: Scalars['Cents']['output'];
  /** The subtotal of the user's assets that are managed outside of Betterment. */
  externalSubtotal: NetWorthSubtotal;
  /** The subtotal of the user's assets that are managed by Betterment, including checking accounts. */
  internalSubtotal: NetWorthSubtotal;
};

/** A net worth breakdown of a specific set the user's assets and liabilities */
export type NetWorthSubtotal = {
  __typename: 'NetWorthSubtotal';
  /** The total subtotal balance */
  balance: Scalars['Cents']['output'];
  /** A further breakdown of line items of the subtotal balance */
  items: Array<NetWorthSubtotalItem>;
  /** The name of the subtotal balance (e.g., 'Betterment', 'Managed', Connected') */
  name: Scalars['String']['output'];
};

/** A line item balance for a net worth subtotal. */
export type NetWorthSubtotalItem = {
  __typename: 'NetWorthSubtotalItem';
  /** The balance of the subtotal item. */
  balance: Scalars['Cents']['output'];
  /** The title of the subtotal item. */
  title: Scalars['String']['output'];
};

/** A Retail User that is not the Current User. Used for providing minimal information about other users. */
export type OtherUser = {
  __typename: 'OtherUser';
  /** The First Name of the User. */
  firstName: Scalars['String']['output'];
  /** The Last Name of the User. */
  lastName: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A configuration of a employee deferral from the user's paycheck into one of their accounts. */
export type PayrollContributionConfig = {
  __typename: 'PayrollContributionConfig';
  /** The destination account for the config. */
  account: Five29Account | ManagedSubAccount;
  /** The value of the deferral applied to bonus pay periods, as either a currency amount or a percentage. */
  bonusValue?: Maybe<PayrollContributionConfigValue>;
  /** The destination name for the config. */
  destinationName: Scalars['String']['output'];
  /** The employer associated with the deferral config. */
  employer: Employer;
  /** The id of the config. */
  id: Scalars['ID']['output'];
  /** Whether the participant is currently allowed to edit their deferral settings. */
  isEditable: Scalars['Boolean']['output'];
  /** The ID of the config, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** The reason the participant cannot edit their deferral settings, or null if editing is allowed. */
  notEditableReason?: Maybe<Scalars['String']['output']>;
  /** The value of the deferral, as either a currency amount or a percentage. */
  value: PayrollContributionConfigValue;
};

/** An account used as a destination for payroll contribution configs. */
export type PayrollContributionConfigAccount = {
  /** The id of the account. */
  id: Scalars['ID']['output'];
};

/** The connection type for PayrollContributionConfig. */
export type PayrollContributionConfigConnection = {
  __typename: 'PayrollContributionConfigConnection';
  /** A list of edges. */
  edges: Array<PayrollContributionConfigEdge>;
  /** A list of nodes. */
  nodes: Array<PayrollContributionConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PayrollContributionConfigEdge = {
  __typename: 'PayrollContributionConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PayrollContributionConfig;
};

/** The amount for a payroll contribution config, as either a currency amount or a percentage. */
export type PayrollContributionConfigValue = PayrollContributionConfigValueAmount | PayrollContributionConfigValuePercent;

/** The amount value for a payroll contribution config. */
export type PayrollContributionConfigValueAmount = {
  __typename: 'PayrollContributionConfigValueAmount';
  /** The value as an amount. */
  amount: Scalars['Cents']['output'];
};

/** The percent value for a payroll contribution config. */
export type PayrollContributionConfigValuePercent = {
  __typename: 'PayrollContributionConfigValuePercent';
  /** The value as a percent. */
  percent: Scalars['Percent']['output'];
};

/** Input structure for an Payroll Contribution Configuration Where query. */
export type PayrollContributionConfigsWhereInput = {
  /** A boolean representing if a configuration amount is positive. */
  contributionIsPositive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the employer, which the accounts of the payroll contribution configs belong to. */
  employerId?: InputMaybe<Scalars['ID']['input']>;
  /** A boolean representing whether the payrolls returned are only for 401k accounts */
  is401k?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The most recent pending upload document verification request */
export type PendingDocumentVerificationRequest = {
  __typename: 'PendingDocumentVerificationRequest';
  /** The ID for the document verification request */
  id: Scalars['ID']['output'];
};

/** Aggregated performance data: related accounts. */
export type Performance = {
  __typename: 'Performance';
  /** Accounts included in this performance context. */
  accounts: Array<CashAccount | DirectTradingAccount | ManagedAccount>;
  /** Standard benchmarks to compare performance */
  benchmarks: Array<PerformanceBenchmark>;
  /** Performance history metrics for this performance context. */
  history: PerformanceHistory;
  /**
   * The simple rate of return value for the given accounts over the given time
   * period. This field will ALWAYS return null for accounts using legacy
   * performance calculations (e.g., managed accounts and cash accounts). It will
   * be deprecated and replaced with a time-weightedreturn value, to use for all
   * types of performance-eligible accounts.
   * @deprecated Use time-weighted or money-weighted rate of return instead.
   */
  simpleRateOfReturn?: Maybe<Scalars['Percent']['output']>;
  /** Historic time-weighted returns for this performance context. */
  timeWeightedReturns: PerformanceTimeWeightedReturns;
  /** Performance totals metrics for this performance context. */
  totals: PerformanceTotals;
};


/** Aggregated performance data: related accounts. */
export type PerformanceBenchmarksArgs = {
  performanceBenchmarkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An account participating in performance aggregation. */
export type PerformanceAccount = {
  /** The icon used to represent the account. */
  icon: ThemedAsset;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
  /** The performance of the account. */
  performance: Performance;
};


/** An account participating in performance aggregation. */
export type PerformanceAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** A performance benchmark. */
export type PerformanceBenchmark = {
  __typename: 'PerformanceBenchmark';
  /** The performance benchmark's group. */
  group: PerformanceBenchmarkGroup;
  /** The performance benchmark's unique identifier. */
  id: Scalars['String']['output'];
  /** The performance benchmark's name. */
  name: Scalars['String']['output'];
  /** A time series of the benchmark's time-weighted return. */
  timeWeightedReturns: PerformanceBenchmarkTimeWeightedReturns;
};

/** A performance benchmark group. */
export type PerformanceBenchmarkGroup = {
  __typename: 'PerformanceBenchmarkGroup';
  /** The performance benchmark group's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The performance benchmark group's unique identifier. */
  id: Scalars['String']['output'];
  /** The performance benchmark group's name. */
  name: Scalars['String']['output'];
};

/** The time-weighted returns for a performance benchmark */
export type PerformanceBenchmarkTimeWeightedReturns = {
  __typename: 'PerformanceBenchmarkTimeWeightedReturns';
  /** The time-weighted return time series. */
  timeSeries: Array<PerformanceHistoryTimeWeightedReturnItem>;
};

/** A history of account balances/performance over time. */
export type PerformanceHistory = {
  __typename: 'PerformanceHistory';
  /** A description of how recent the data is. */
  recencyDescription: Scalars['String']['output'];
  /** The time series data for the history. */
  timeSeries: Array<PerformanceHistoryItem>;
};

/** A single data point in the time series of a performance history. */
export type PerformanceHistoryItem = {
  __typename: 'PerformanceHistoryItem';
  /** The balance on the given date. */
  balance: Scalars['Cents']['output'];
  /** The date for the performance history item. */
  date: Scalars['Date']['output'];
  /** The amount earned for the given date */
  earned: Scalars['Cents']['output'];
  /** The amount invested for the given date. */
  invested: Scalars['Cents']['output'];
};

/** A single data point in a time-weighted return time series. */
export type PerformanceHistoryTimeWeightedReturnItem = {
  __typename: 'PerformanceHistoryTimeWeightedReturnItem';
  /** The cumulative time-weighted rate of return on the given date. */
  cumulativeReturn?: Maybe<Scalars['Percent']['output']>;
  /** The date for the time series item. */
  date: Scalars['Date']['output'];
};

/** Provides performance summary of any interest-bearing instrument(s). */
export type PerformanceInterest = {
  __typename: 'PerformanceInterest';
  /** Total amount of accrued but unpaid interest. */
  accrued: Scalars['Cents']['output'];
  /** Detailed explanation of the accrual and payment strategy used by the underlying interest-bearing instrument(s) */
  accruedExplanation: Scalars['String']['output'];
  /** Total amount of interest that has been fully paid out to date. */
  paid: Scalars['Cents']['output'];
};

/** Provides summary of the financial portfolio(s) performance. */
export type PerformanceInvesting = {
  __typename: 'PerformanceInvesting';
  /**
   * The adjustments amount made on the portfolio(s) balance to help determine
   * actual return on assets (ROA). These adjustments may include taxes, fees, or
   * money movements costs incurred on the portfolio(s).
   */
  adjustments: Scalars['Cents']['output'];
  /**
   * The all-time estimated tax savings from Tax-Loss Harvesting. Note that this
   * value cannot be calculated for specific date ranges.
   */
  allTimeTlhEstimatedTaxSavings?: Maybe<Scalars['Cents']['output']>;
  /** Provides dividend totals issued on Goals over the given date range. */
  dividends?: Maybe<PerformanceTotalsDividends>;
  /** The total return on investment (ROI) at point in time. */
  earned: Scalars['Cents']['output'];
  /** The total performance amount contributed solely by each asset class's market volatility. */
  marketChanges: Scalars['Cents']['output'];
  /**
   * The total amount of taxable income reduced by the Tax-Loss Harvesting
   * strategy. Returns null if the user does not have Tax-Loss Harvesting enabled
   * on any of the given accounts.
   */
  taxLossesHarvested?: Maybe<Scalars['Cents']['output']>;
  /** The description of estimated tax savings from Tax-Loss Harvesting. */
  tlhEstimatedTaxSavingsDescription?: Maybe<Scalars['HTML']['output']>;
};

/** The time-weighted returns for an investment or set of investments */
export type PerformanceTimeWeightedReturns = {
  __typename: 'PerformanceTimeWeightedReturns';
  /** The time-weighted return time series. */
  timeSeries: Array<PerformanceHistoryTimeWeightedReturnItem>;
};

/** Provides performance data for a collection of accounts. */
export type PerformanceTotals = {
  __typename: 'PerformanceTotals';
  /**
   * The total earned by the accounts over the given date range. This value
   * includes market changes, dividends (including pending), interest paid, and total fees.
   */
  earned: Scalars['Cents']['output'];
  /** The balance at the end of the period (i.e., at the end of the last day), including pending dividends. */
  endingBalance: Scalars['Cents']['output'];
  /** Provides fee totals charged on Goals over the given date range */
  fees: PerformanceTotalsFees;
  /** Provides performance summary of any interest-bearing instrument(s). */
  interest?: Maybe<PerformanceInterest>;
  /** The total invested in the accounts over the given date range. */
  invested: Scalars['Cents']['output'];
  /** Provides summary of the financial portfolio(s) performance. */
  investing?: Maybe<PerformanceInvesting>;
  /** The money-weighted (also known as the 'internal') rate of return for an investment or set of investments */
  moneyWeightedRateOfReturn: MoneyWeightedRateOfReturn;
  /** The balance at the start of the period (i.e., at the beginning of the first day). */
  startingBalance: Scalars['Cents']['output'];
  /** The time-weighted rate of return for an investment or set of investments */
  timeWeightedRateOfReturn: TimeWeightedRateOfReturn;
  /** Provides details on money movements (deposits, withdrawals and transfers) for goals over the given date range. */
  userTransactions: PerformanceTotalsUserTransactions;
};

/** Provides dividend totals issued on Goals over the given date range. */
export type PerformanceTotalsDividends = {
  __typename: 'PerformanceTotalsDividends';
  /** The total pending dividends (not yet reinvested or withdrawable) of the Goals over the given date range. */
  pending: Scalars['Cents']['output'];
  /** The total of dividends (excluding pending dividends) that have been reinvested into the Goals over the given date range. */
  reinvested: Scalars['Cents']['output'];
  /** The total dividends issued, including pending dividends on the Goals over the given date range. */
  total: Scalars['Cents']['output'];
};

/** Provides fee totals charged on Goals over the given date range */
export type PerformanceTotalsFees = {
  __typename: 'PerformanceTotalsFees';
  /** The total management fees of the Goals over the given date range. */
  management: Scalars['Cents']['output'];
  /** The total fees inclusive of management and trading fees charged on the Goals over the given date range */
  total: Scalars['Cents']['output'];
  /** The total trading fees of the Goals over the given date range. */
  trading: Scalars['Cents']['output'];
};

/** Provides details on money movements (deposits, withdrawals and transfers) for goals over the given date range. */
export type PerformanceTotalsUserTransactions = {
  __typename: 'PerformanceTotalsUserTransactions';
  /** The total deposits (including transfers in) of the Goals over the given date range. */
  deposits: Scalars['Cents']['output'];
  /** The total net deposits (deposits - withdrawals) of the or Goals over the given date range. */
  netDeposits: Scalars['Cents']['output'];
  /** Provides details on pending money movements (deposits, withdrawals and transfers) for goals over the given date range. */
  pending: PerformanceTotalsUserTransactionsPending;
  /** The total withdrawals (including transfers out) of the Goals over the given date range. */
  withdrawals: Scalars['Cents']['output'];
};

/** Provides details on pending money movements (deposits, withdrawals and transfers) for goals over the given date range. */
export type PerformanceTotalsUserTransactionsPending = {
  __typename: 'PerformanceTotalsUserTransactionsPending';
  /** The total pending deposits and transfers in of the Goals over the given date range. */
  depositsAndTransfersIn: Scalars['Cents']['output'];
  /** The total pending withdrawals and transfers out of the Goals over the given date range. */
  withdrawalsAndTransfersOut: Scalars['Cents']['output'];
};

/** Portfolio details for a given goal */
export type Portfolio = {
  /** The strategy for the goal's portfolio */
  strategy: PortfolioStrategy;
};

/** The details for the strategy for a goal's portfolio */
export type PortfolioStrategy = {
  __typename: 'PortfolioStrategy';
  /**
   * The portfolio strategy's description (including HTML links) provides
   * information about the type of investments in the portfolio. For example, the
   * Core portfolio is described as a 'globally diverse portfolio with broad market exposure'.
   */
  descriptionHtml?: Maybe<Scalars['HTML']['output']>;
  /**
   * The themed asset used to represent this portfolio strategy. This icon is
   * strategy-specific, e.g. tree icon for SRI climate impact, dollar bill for cash reserve, etc.
   */
  icon?: Maybe<ThemedAsset>;
  /**
   * The portfolio strategy's name. For advisor custom portfolios, this is provided
   * by the advisor. For Betterment portfolios, this is the customer-facing
   * portfolio name (e.g. Innovative Technology, Core, Socially Responsible
   * Investing, etc.).
   */
  name: Scalars['String']['output'];
};


/** The details for the strategy for a goal's portfolio */
export type PortfolioStrategyDescriptionHtmlArgs = {
  includeLegacyDisclosureLink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Entity representing a valid mailing address. */
export type PostalAddress = {
  __typename: 'PostalAddress';
  /** City/municipality of a postal address. */
  city: Scalars['String']['output'];
  /** First locale line of a postal address. */
  line1: Scalars['String']['output'];
  /** Second locale line of a postal address. */
  line2?: Maybe<Scalars['String']['output']>;
  /** Postal Code (ZIP) of a postal address. */
  postalCode: Scalars['String']['output'];
  /** State/province/territory of a postal address. */
  state: AddressState;
};

/** Input object representing a valid postal address. */
export type PostalAddressInput = {
  /** City/municipality of a postal address. */
  city: Scalars['String']['input'];
  /** First locale line of a postal address. */
  line1: Scalars['String']['input'];
  /** Second locale line of a postal address. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Postal Code (ZIP) of a postal address. */
  postalCode: Scalars['String']['input'];
  /** State/province/territory Code of a postal address. */
  stateCode: Scalars['String']['input'];
};

/** The advisor for a given user with a premium account. This advisor is within Betterment. */
export type PremiumAdvisor = Advisor & {
  __typename: 'PremiumAdvisor';
  /** The calendar link of the advisor */
  calendarLink?: Maybe<Scalars['URL']['output']>;
  /** The email address of the advisor */
  email: Scalars['String']['output'];
  /** The full name of the advisor */
  fullName: Scalars['String']['output'];
  /** A unique identifier of the advisor. */
  id: Scalars['ID']['output'];
  /** The logo of the advisor's firm */
  logo?: Maybe<ThemedAsset>;
};

/** The ability for a user to go through the premium advice flow. */
export type PremiumOnboardingOption = ProductOnboardingOption & {
  __typename: 'PremiumOnboardingOption';
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The premium management fee percentage. */
  fee: Scalars['Percent']['output'];
  /**
   * The disclosure explaining the requirements and implications of the premium
   * management fee (e.g., minimumbalance for account types, and which accounts the
   * fee applies to).
   */
  feeDisclosure: Scalars['HTML']['output'];
  /** If a user has scheduled a consultation meeting */
  hasScheduledMeeting: Scalars['Boolean']['output'];
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** The ability for a user to go through the premium advice flow. */
export type PremiumOnboardingOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/** Description and pricing information for an account group */
export type PriceGroup = {
  __typename: 'PriceGroup';
  /** A description of the group of accounts */
  accountsDescription: Scalars['String']['output'];
  /** A unique identifier of the account group */
  id: Scalars['ID']['output'];
  /** Minimum fee for the account group */
  minFee?: Maybe<PriceGroupMinFee>;
  /** Premium pricing for the account group */
  premiumPricing?: Maybe<PriceGroupPremiumPricing>;
  /** A description of the pricing for a group of accounts */
  priceDescription: Scalars['String']['output'];
  /** Link to read more pricing information for the account group */
  pricingCta?: Maybe<PriceGroupPricingCta>;
  /** Price group tiers for the account group */
  pricingTier?: Maybe<PriceGroupPricingTier>;
};

/** Description for the minimum fee of an account group */
export type PriceGroupMinFee = {
  __typename: 'PriceGroupMinFee';
  /** The description of the minimal fee */
  description: Scalars['String']['output'];
  /** The url of the pricing link */
  name: Scalars['String']['output'];
};

/** Description and premium pricing information for an account group */
export type PriceGroupPremiumPricing = {
  __typename: 'PriceGroupPremiumPricing';
  /** Breakdown of the premium pricing information */
  breakdowns: Array<PriceGroupPricingTierBreakdown>;
  /** Name of the account group premium pricing information */
  name: Scalars['String']['output'];
};

/** Description and pricing link for an account group */
export type PriceGroupPricingCta = {
  __typename: 'PriceGroupPricingCta';
  /** The display name of the pricing link */
  name: Scalars['String']['output'];
  /** The url of the pricing link */
  url: Scalars['String']['output'];
};

/** Description and pricing information for an account group */
export type PriceGroupPricingTier = {
  __typename: 'PriceGroupPricingTier';
  /** Price group tier breakdown for the account group */
  breakdowns: Array<PriceGroupPricingTierBreakdown>;
  /** Nullable explainer around how the breakdown works */
  description?: Maybe<Scalars['HTML']['output']>;
  /** Name of the account group tier */
  name: Scalars['String']['output'];
};

/** Description and individual breakdown information for an account group tier */
export type PriceGroupPricingTierBreakdown = {
  __typename: 'PriceGroupPricingTierBreakdown';
  /** Price group tier breakdown fee amount description */
  description: Scalars['String']['output'];
  /** Price group tier breakdown fee description */
  fee: Scalars['String']['output'];
};

/** A range of prices */
export type PriceRange = {
  __typename: 'PriceRange';
  /** Highest price recorded */
  highPrice: Scalars['Cents']['output'];
  /** Lowest price recorded */
  lowPrice: Scalars['Cents']['output'];
};

/** Autogenerated input type of ProcessCapitalizeWindowEventMutation */
export type ProcessCapitalizeWindowEventMutationInput = {
  /** The payload of the Capitalize window event. */
  eventPayload: Scalars['JSON']['input'];
};

/** Autogenerated return type of ProcessCapitalizeWindowEventMutation. */
export type ProcessCapitalizeWindowEventMutationPayload = {
  __typename: 'ProcessCapitalizeWindowEventMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ProcessCapitalizeWindowEventMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ProcessCapitalizeWindowEventMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** A bundle of multiple products offered together during onboarding */
export type ProductBundle = {
  __typename: 'ProductBundle';
  /** Unique identifier for the bundle */
  id: Scalars['ID']['output'];
  /** The bundle icon to display */
  image: ThemedAsset;
  /** Whether user has started the bundle onboarding */
  isInProgress: Scalars['Boolean']['output'];
  /** Detailed description of the bundle */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** The individual product onboarding options included in this bundle */
  productOnboardingOptions: Array<CheckingAccountCreationOption | FinancialCoachingOnboardingOption | FiveTwoNineGoalCreationOption | GoalCreationOption | PremiumOnboardingOption | Solo401kOnboardingOption>;
  /** Brief description of the bundle */
  shortDescription: Scalars['String']['output'];
  /** URL-friendly identifier for the bundle (e.g., 'investing-savings') */
  slug: Scalars['String']['output'];
  /** Combined onboarding steps for the bundle */
  steps: Array<ProductOnboardingStep>;
  /** Display title for the bundle */
  title: Scalars['String']['output'];
};

/** The product category of a product onboarding option */
export enum ProductCategory {
  /** Advice */
  Advice = 'ADVICE',
  /** Bond investing */
  BondInvesting = 'BOND_INVESTING',
  /** Cash */
  Cash = 'CASH',
  /** Checking */
  Checking = 'CHECKING',
  /** Crypto investing */
  CryptoInvesting = 'CRYPTO_INVESTING',
  /** Direct trading */
  DirectTrading = 'DIRECT_TRADING',
  /** Financial coaching */
  FinancialCoaching = 'FINANCIAL_COACHING',
  /** Five two nine */
  FiveTwoNine = 'FIVE_TWO_NINE',
  /** Investing */
  Investing = 'INVESTING',
  /** Retirement */
  Retirement = 'RETIREMENT',
  /** Solo 401k */
  Solo_401K = 'SOLO_401K'
}

/** The order in which to return product categories. */
export enum ProductCategoryOptionsOrder {
  /** Cross_sell */
  CrossSell = 'CROSS_SELL',
  /** Default */
  Default = 'DEFAULT'
}

/** Represent data concerns of a user onboarding onto a product or service */
export type ProductOnboardingOption = {
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various variants (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** Represent data concerns of a user onboarding onto a product or service */
export type ProductOnboardingOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/** The variant of product onboarding option image to display */
export enum ProductOnboardingOptionImageVariant {
  /** Hero image for account recommendation */
  AccountRecommendation = 'ACCOUNT_RECOMMENDATION',
  /** The main product icon (small, square) */
  Icon = 'ICON'
}

/** A step in any onboarding process that the user has or can initiate */
export type ProductOnboardingStep = {
  __typename: 'ProductOnboardingStep';
  /** The identifier used in uniquely identifying the step */
  id: Scalars['ID']['output'];
  /** A short description of the step */
  shortDescription: Scalars['String']['output'];
  /** The state of the onboarding step */
  state: ProductOnboardingStepState;
};

/** The state of the onboarding step */
export enum ProductOnboardingStepState {
  /** The onboarding step has been started or can be started by the user */
  Active = 'ACTIVE',
  /** The onboarding step has been completed by the user */
  Finished = 'FINISHED',
  /** The onboarding step has not been started by the user */
  Inactive = 'INACTIVE'
}

/** A product that is currently unavailable */
export type ProductUnavailability = {
  __typename: 'ProductUnavailability';
  /** The body content of the product unavailability message */
  body: Scalars['HTML']['output'];
  /** The identifier used in uniquely identifying the product unavailability state */
  id: Scalars['ID']['output'];
  /** The title of the product unavailability message */
  title?: Maybe<Scalars['String']['output']>;
};

/** The user's profession information including employment status and occupation. */
export type Profession = {
  __typename: 'Profession';
  /** The user's employment status (e.g., employed, unemployed, retired, student). */
  employmentStatus: Scalars['String']['output'];
  /** The user's occupation or role. */
  occupation?: Maybe<Scalars['String']['output']>;
};

/** A checklist to display to the user regarding their progress. */
export type ProgressChecklist = {
  __typename: 'ProgressChecklist';
  /** Detailed information about the checklist item, if available. */
  body?: Maybe<Scalars['String']['output']>;
  /** The CTA of the checklist item. */
  cta?: Maybe<MessageCtaLink | MessageCtaModal>;
  /** An identifier for the checklist item. */
  id: Scalars['ID']['output'];
  /** Short form description of the checklist item. */
  shortDescription: Scalars['String']['output'];
  /** The statuses of what a checklist item could be in. */
  status: ProgressChecklistStatus;
  /** The tracking name for the checklist item. */
  trackingName: Scalars['String']['output'];
};

/** The statuses of what a checklist item could be in. */
export enum ProgressChecklistStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

/**
 * The reason an envelope exists. It may be just to organize some of the user's
 * finances, or it may be to make progress towards a specific financial goal.
 */
export type Purpose = {
  /** The user-facing name of the advice type of the chosen purpose (e.g., 'Retirement', 'Emergency fund'). */
  adviceTypeName?: Maybe<Scalars['String']['output']>;
  /** The envelope holding this purpose. */
  envelope: Envelope;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** The image used to represent the envelope and its purpose. */
  image: ThemedAsset;
  /** The boolean to determine whether a user has the ability to delete the purpose */
  isDeletionEligible: Scalars['Boolean']['output'];
  /**
   * The goal ID to use to edit the purpose in legacy application code.
   * @deprecated Migrate existing application code to modify the purpose directly.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /**
   * The target specified for measuring progress to the envelope's purpose.
   * @deprecated Replaced by moving the relevant polymorphism into Purpose. Use data on each implementation of Purpose instead.
   */
  target?: Maybe<TargetAmountAndDate | TargetMonthlyExpenses | TargetRetirementSavings | TargetRetirementSpending>;
};

/** Both representation and domain model assets for a given purpose */
export type PurposeAsset = {
  __typename: 'PurposeAsset';
  /** Themed asset for the purpose icon */
  icon: ThemedAsset;
  /** A unique identifier of the purpose asset. */
  id: Scalars['ID']['output'];
  /**
   * This is human readable image key for the purpose icon
   * @deprecated This should only be used to handle goal images for legacy add/edit goal flow
   */
  legacyImageKey: Scalars['String']['output'];
};

/** The intent for creating a new purpose */
export enum PurposeCreationIntent {
  /** Emergency fund */
  EmergencyFund = 'EMERGENCY_FUND',
  /** Major purchase */
  MajorPurchase = 'MAJOR_PURCHASE',
  /** Retirement */
  Retirement = 'RETIREMENT'
}

/** An option for creating a new purpose */
export type PurposeCreationOptionInterface = {
  /** The default name for this purpose */
  defaultName: Scalars['String']['output'];
  /** A description of the purpose creation option */
  description?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the purpose creation option */
  id: Scalars['ID']['output'];
  /** The legacy advice type identifier */
  legacyAdviceTypeId: Scalars['String']['output'];
  /** The display name of the purpose creation option */
  name: Scalars['String']['output'];
  /** The image icon and image key representing this purpose option */
  purposeAsset: PurposeAsset;
};

/** A purpose tracking the user's savings of a specific amount of money to cover expenses for a certain number of months. */
export type PurposeEmergencyFund = Purpose & {
  __typename: 'PurposeEmergencyFund';
  /** The user-facing name of the advice type of the chosen purpose (e.g., 'Retirement', 'Emergency fund'). */
  adviceTypeName?: Maybe<Scalars['String']['output']>;
  /** The envelope holding this purpose. */
  envelope: Envelope;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** The image used to represent the envelope and its purpose. */
  image: ThemedAsset;
  /** The boolean to determine whether a user has the ability to delete the purpose */
  isDeletionEligible: Scalars['Boolean']['output'];
  /**
   * The goal ID to use to edit the purpose in legacy application code.
   * @deprecated Migrate existing application code to modify the purpose directly.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The user's specified amount of monthly expenses. Used to calculate the total target amount. */
  monthlyExpensesAmount: Scalars['Cents']['output'];
  /** The number of months of user's expenses currently covered by the envelope's balance. */
  monthsExpensesCovered: Scalars['Float']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** A projection of the outcome and expected progress for the emergency fund purpose. */
  projection: PurposeEmergencyFundProjection;
  /**
   * The target specified for measuring progress to the envelope's purpose.
   * @deprecated Replaced by moving the relevant polymorphism into Purpose. Use data on each implementation of Purpose instead.
   */
  target?: Maybe<TargetAmountAndDate | TargetMonthlyExpenses | TargetRetirementSavings | TargetRetirementSpending>;
  /**
   * User-defined target information for their emergency savings purpose, made up
   * of an optional date and amount of money to save by the given date.
   */
  target2?: Maybe<PurposeEmergencyFundTarget>;
};


/** A purpose tracking the user's savings of a specific amount of money to cover expenses for a certain number of months. */
export type PurposeEmergencyFundProjectionArgs = {
  input?: InputMaybe<PurposeEmergencyFundProjectionInput>;
};

/**
 * A projected future for an emergency fund purpose. Emergency fund projections do
 * not express with a percent confidence in completion, as they track against a
 * target amount on a rolling basis (with no specific target date).
 */
export type PurposeEmergencyFundProjection = {
  __typename: 'PurposeEmergencyFundProjection';
  /** A time-series of the expected balances for the envelope. */
  balanceTimeSeries: Array<BalanceProjectionItem>;
  /** The expected number of months of expenses covered by the projected balance. */
  monthsExpensesCovered: Scalars['Float']['output'];
  /** The recommended monthly inflows amount for the user, given their current target and ad-hoc deposit amount. */
  recommendedMonthlyInflows?: Maybe<Scalars['Cents']['output']>;
};

/** Input values for a customized projection for an emergency fund purpose. */
export type PurposeEmergencyFundProjectionInput = {
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of a one-time contribution to the envelope made by the user today.
   */
  adHocInflow: Scalars['Cents']['input'];
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of monthly recurring contributions to the envelope.
   */
  monthlyRecurringInflows: Scalars['Cents']['input'];
};

/**
 * A user-defined target for an emergency fund purpose. The user can configure a
 * custom number of months of expenses to save for, and a custom amount of extra
 * buffer in spending, and we will calculate the total amount of money they need to save.
 */
export type PurposeEmergencyFundTarget = {
  __typename: 'PurposeEmergencyFundTarget';
  /**
   * The total target amount to save, either specified directly by the user as a
   * custom amount, or calculated based on other values provided
   * (months_expenses_covered * monthly_expenses_amount * buffer_percent).
   */
  amount: Scalars['Cents']['output'];
  /** An additional buffer amount to save, on top of the months of monthly expenses to cover. */
  buffer: Scalars['Percent']['output'];
  /** The desired number of months of expenses to have covered in emergency savings. */
  monthsExpensesCovered: Scalars['Float']['output'];
};

/** A purpose oriented towards saving a specific amount by a specific date (i.e., for some specific expense). */
export type PurposeMajorPurchase = Purpose & {
  __typename: 'PurposeMajorPurchase';
  /** The user-facing name of the advice type of the chosen purpose (e.g., 'Retirement', 'Emergency fund'). */
  adviceTypeName?: Maybe<Scalars['String']['output']>;
  /** The envelope holding this purpose. */
  envelope: Envelope;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** The image used to represent the envelope and its purpose. */
  image: ThemedAsset;
  /** The boolean to determine whether a user has the ability to delete the purpose */
  isDeletionEligible: Scalars['Boolean']['output'];
  /**
   * The goal ID to use to edit the purpose in legacy application code.
   * @deprecated Migrate existing application code to modify the purpose directly.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** A projection of the outcome and expected progress for the major purchase purpose. */
  projection?: Maybe<PurposeMajorPurchaseProjection>;
  /**
   * The target specified for measuring progress to the envelope's purpose.
   * @deprecated Replaced by moving the relevant polymorphism into Purpose. Use data on each implementation of Purpose instead.
   */
  target?: Maybe<TargetAmountAndDate | TargetMonthlyExpenses | TargetRetirementSavings | TargetRetirementSpending>;
  /**
   * User-defined target information for their major purchase purpose, made up of
   * an optional date and amount of money to save by the given date.
   */
  target2: PurposeMajorPurchaseTarget;
};


/** A purpose oriented towards saving a specific amount by a specific date (i.e., for some specific expense). */
export type PurposeMajorPurchaseProjectionArgs = {
  input?: InputMaybe<PurposeMajorPurchaseProjectionInput>;
};

/**
 * A projected future for a growth purpose, including a total balance amount, time
 * series, and information about under what conditions the purpose will be on track.
 */
export type PurposeMajorPurchaseProjection = {
  __typename: 'PurposeMajorPurchaseProjection';
  /** A time-series of the expected balances for the envelope. */
  balanceTimeSeries: Array<BalanceProjectionItem>;
  /** Information about the likelihood of the user reaching their goal. */
  completion?: Maybe<PurposeMajorPurchaseProjectionCompletion>;
};

/** Information about the conditions under which the purpose is on track. */
export type PurposeMajorPurchaseProjectionCompletion = {
  __typename: 'PurposeMajorPurchaseProjectionCompletion';
  /** The likelihood that the user will meet their target spending amount by their retirement age. */
  confidencePercent: Scalars['Percent']['output'];
  /** Whether the user is considered on track to meet their retirement spending goal. */
  isOnTrack: Scalars['Boolean']['output'];
  /** A brief description about the user's current progress towards their target. */
  progressDescription: Scalars['String']['output'];
  /** The recommended amount of monthly contributions for the user to reach their target. */
  recommendedMonthlyInflows?: Maybe<Scalars['Cents']['output']>;
  /** The recommended amount of one-time contributions for the user to reach their target. */
  recommendedOneTimeInflow?: Maybe<Scalars['Cents']['output']>;
};

/** Input values for a customized projection for a major purchase purpose. */
export type PurposeMajorPurchaseProjectionInput = {
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of a one-time contribution to the envelope made by the user today.
   */
  adHocInflow: Scalars['Cents']['input'];
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of monthly recurring contributions to the envelope.
   */
  monthlyRecurringInflows: Scalars['Cents']['input'];
};

/** The target for a purpose tracking growth towards a certain amount by a certain date. */
export type PurposeMajorPurchaseTarget = {
  __typename: 'PurposeMajorPurchaseTarget';
  /** The target balance amount set for the envelope's purpose. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The target date by which the purpose should be achieved. */
  date?: Maybe<Scalars['Date']['output']>;
};

/**
 * A purpose tracking the user's progress in saving for retirement. The user can
 * specify a variety of retirement assumptions held as part of their financial
 * profile, and a desired spending amount after retirement. The date for the target
 * is defined by their expected retirement age. When the user has not yet specified
 * various parts of their retirement target, they are null.
 */
export type PurposeRetirementGrowth = Purpose & {
  __typename: 'PurposeRetirementGrowth';
  /** The user-facing name of the advice type of the chosen purpose (e.g., 'Retirement', 'Emergency fund'). */
  adviceTypeName?: Maybe<Scalars['String']['output']>;
  /** The envelope holding this purpose. */
  envelope: Envelope;
  /**
   * The financial profile of the current user, provided on this type to provide
   * access to the user's retirement assumptions on the financial profile, only
   * when an envelope has a retirement savings target.
   */
  financialProfile: FinancialProfile;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** The image used to represent the envelope and its purpose. */
  image: ThemedAsset;
  /** The boolean to determine whether a user has the ability to delete the purpose */
  isDeletionEligible: Scalars['Boolean']['output'];
  /**
   * The goal ID to use to edit the purpose in legacy application code.
   * @deprecated Migrate existing application code to modify the purpose directly.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** A projection of the outcome and expected progress for the retirement growth purpose. */
  projection?: Maybe<PurposeRetirementGrowthProjection>;
  /**
   * The target specified for measuring progress to the envelope's purpose.
   * @deprecated Replaced by moving the relevant polymorphism into Purpose. Use data on each implementation of Purpose instead.
   */
  target?: Maybe<TargetAmountAndDate | TargetMonthlyExpenses | TargetRetirementSavings | TargetRetirementSpending>;
  /**
   * The user-defined target for their retirement growth purpose.
   * @deprecated Use targetMonthlySpendingAmount and projection#targetTotalSpendingAmount instead.
   */
  target2?: Maybe<PurposeRetirementGrowthTarget>;
  /** The amount the user has specified that they would like to have available to spend monthly after retiring. */
  targetMonthlySpendingAmount?: Maybe<Scalars['Cents']['output']>;
};


/**
 * A purpose tracking the user's progress in saving for retirement. The user can
 * specify a variety of retirement assumptions held as part of their financial
 * profile, and a desired spending amount after retirement. The date for the target
 * is defined by their expected retirement age. When the user has not yet specified
 * various parts of their retirement target, they are null.
 */
export type PurposeRetirementGrowthProjectionArgs = {
  input?: InputMaybe<PurposeRetirementGrowthProjectionInput>;
};

/**
 * A projected future for a retirement growth purpose, including a total balance
 * amount, time series, and information about under what conditions the purpose
 * will be on track.
 */
export type PurposeRetirementGrowthProjection = {
  __typename: 'PurposeRetirementGrowthProjection';
  /** A time-series of the expected balances for the envelope. */
  balanceTimeSeries: Array<BalanceProjectionItem>;
  /** Information related to the user's likelihood of meeting their target, including confidence and recommended values. */
  completion: PurposeRetirementGrowthProjectionCompletion;
  /** The amount that we project the user will have available to spend monthly after retiring. */
  monthlySpendingAmount: Scalars['Cents']['output'];
  /** A savings plan for the current tax year, including recommended retirement contributions. */
  savingsPlan: SavingsPlan;
};

/** Information about the conditions under which the purpose is on track. */
export type PurposeRetirementGrowthProjectionCompletion = {
  __typename: 'PurposeRetirementGrowthProjectionCompletion';
  /** The likelihood that the user will meet their target spending amount by their retirement age. */
  confidencePercent: Scalars['Percent']['output'];
  /** Whether the user is considered on track to meet their retirement spending goal. */
  isOnTrack: Scalars['Boolean']['output'];
  /** A brief description about the user's current progress towards their target. */
  progressDescription: Scalars['String']['output'];
  /**
   * The amount that we recommend the user save annually to meet their retirement
   * target, based on the projection's input values.
   */
  recommendedTotalAnnualContributions: Scalars['Cents']['output'];
  /**
   * The calculated, pre-tax, total amount that the user is aiming to have
   * available at retirement. This is considered a projection value because it is
   * sensitive to various changes to projection inputs. This is a pre-tax value.
   */
  targetTotalSpendingAmount: Scalars['Cents']['output'];
};

/** Input values for a customized projection for a retirement growth purpose. */
export type PurposeRetirementGrowthProjectionInput = {
  /** An assumption given to the projection calculations, for a hypothetical amount of planned contributions to the envelope. */
  annualRecurringInflows: Scalars['Cents']['input'];
  /** An assumption given to the projection calculations, for the user's expected retirement age. */
  retirementAge: Scalars['Int']['input'];
  /** An assumption given to the projection calculations, for the user's zip code during retirement. */
  retirementZip: Scalars['String']['input'];
  /**
   * An assumption given to the projection calculations, for the user's desired
   * monthly spending power, expressed in today's dollars.
   */
  targetMonthlySpendingAmount: Scalars['Cents']['input'];
};

/** The user-defined target for their Retirement Growth purpose. */
export type PurposeRetirementGrowthTarget = {
  __typename: 'PurposeRetirementGrowthTarget';
  /**
   * The amount the user has specified that they would like to have available to spend monthly after retiring.
   * @deprecated Use RetirementGrowthPurpose#targetMonthlySpendingAmount instead.
   */
  monthlySpendingAmount: Scalars['Cents']['output'];
  /**
   * Information related to the user's likelihood of meeting their target, including confidence and recommended values.
   * @deprecated Use RetirementGrowthPurpose#projection#targetTotalSpendingAmount instead.
   */
  spendingAmount: Scalars['Cents']['output'];
};

/** A purpose tracking the user's progress in spending their retirement savings. */
export type PurposeRetirementIncome = Purpose & {
  __typename: 'PurposeRetirementIncome';
  /** The user-facing name of the advice type of the chosen purpose (e.g., 'Retirement', 'Emergency fund'). */
  adviceTypeName?: Maybe<Scalars['String']['output']>;
  /** The envelope holding this purpose. */
  envelope: Envelope;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** The image used to represent the envelope and its purpose. */
  image: ThemedAsset;
  /** The boolean to determine whether a user has the ability to delete the purpose */
  isDeletionEligible: Scalars['Boolean']['output'];
  /**
   * The goal ID to use to edit the purpose in legacy application code.
   * @deprecated Migrate existing application code to modify the purpose directly.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The age at which the user expects to no longer need retirement spending. */
  lifeExpectancyAge: Scalars['Int']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** A projection of the outcome and expected progress for the retirement income purpose. */
  projection: PurposeRetirementIncomeProjection;
  /**
   * The target specified for measuring progress to the envelope's purpose.
   * @deprecated Replaced by moving the relevant polymorphism into Purpose. Use data on each implementation of Purpose instead.
   */
  target?: Maybe<TargetAmountAndDate | TargetMonthlyExpenses | TargetRetirementSavings | TargetRetirementSpending>;
  /**
   * The number of years remaining between the user's current age and their life
   * expectancy age, representing how many more years the user's retirement savings needs to last.
   */
  yearsRemaining: Scalars['Int']['output'];
};


/** A purpose tracking the user's progress in spending their retirement savings. */
export type PurposeRetirementIncomeProjectionArgs = {
  input?: InputMaybe<PurposeRetirementIncomeProjectionInput>;
};

/**
 * A projected future for a retirement income purpose. Retirement income
 * projections express the rate at which the user will draw down their retirement
 * savings, and how long it will take to deplete their current balance.
 */
export type PurposeRetirementIncomeProjection = {
  __typename: 'PurposeRetirementIncomeProjection';
  /** A time-series of the expected balances for the envelope. */
  balanceTimeSeries: Array<BalanceProjectionItem>;
  /** The recommended monthly withdrawal amount for the user, given their current life expectancy and ad-hoc deposit amount. */
  recommendedMonthlyOutflows?: Maybe<Scalars['Cents']['output']>;
  /** The number of years projected for the user to take to spend their retirement savings. */
  yearsOfSpending: Scalars['Float']['output'];
};

/** Input values for a customized projection for a retirement income purpose. */
export type PurposeRetirementIncomeProjectionInput = {
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of a one-time contribution to the envelope made by the user today.
   */
  adHocInflow: Scalars['Cents']['input'];
  /**
   * An assumption given to the projection calculations, for a hypothetical amount
   * of monthly recurring withdrawals to the envelope.
   */
  monthlyRecurringOutflows: Scalars['Cents']['input'];
};

/** The entrypoint for all retail schema queries */
export type Query = {
  __typename: 'Query';
  /** The user's ability to receive an account recommendation with AI-generated explanations. */
  accountRecommendationOption?: Maybe<AccountRecommendationOption>;
  /** User Rewards in their active period. */
  activeRewards: Array<ActiveReward>;
  /**
   * Returns the active identity verification challenge, if any. Used by mobile
   * apps to poll for pending verification challenges.
   */
  activeVerificationChallenge?: Maybe<IdentityVerificationChallenge>;
  /** The user's financial activity. */
  activityConnection: ActivityItemConnection;
  /** The options for filtering a users transactional activity by date range. */
  activityDateRangeOptions: Array<ActivityDateRangeOption>;
  /** The options for filtering a users transactional activity by item type. */
  activityItemTypeOptions: Array<ActivityItemTypeFilterOption>;
  /** The options for filtering a users transactional activity by item type. */
  activityItemTypeOptionsV2: Array<ActivityItemTypeFilterOptionV2>;
  /** Activity items for a specific Id. */
  activityItemsForId: Array<ActivityItemAllocationChange | ActivityItemDeposit | ActivityItemDividendGroup | ActivityItemFee | ActivityItemOrder | ActivityItemOther | ActivityItemRollover | ActivityItemTradeGroup | ActivityItemTransferGroup | ActivityItemWithdrawal>;
  /** US States and Territories where Betterment services are available. */
  addressStateOptions: Array<AddressState>;
  /** Invitation details for an advised solo 401(k) plan. */
  advisedSoloFourOhOneKClientInvite?: Maybe<AdvisedSoloFourOhOneKClientInvite>;
  /** The advisor for the current user. */
  advisor?: Maybe<InstitutionalAdvisor | PremiumAdvisor>;
  /** A single article, by ID. */
  article: Article;
  /** A collection of articles for education and advice for the user. */
  articles: Array<Article>;
  /** A single CheckingAccount by ID. */
  checkingAccount: CheckingAccount;
  /** All checking accounts for the user */
  checkingAccounts: Array<CheckingAccount>;
  /** The Checking Customer profile for the current User. */
  checkingCustomer: CheckingCustomerResult;
  /** Invitations received by the current User to become a Joint Account Holder on a Checking Account. */
  checkingReceivedInvitations: Array<JointAccountInvitation>;
  /** Approval request for existing user to accept advisor relationship */
  clientEnvelopeApprovalRequest: ClientEnvelopeApprovalRequest;
  /** Auditing all messages to journal and filter messages based on location and goal id */
  currentMarketingMessage?: Maybe<MarketingMessage>;
  /** A deferral setting for the user. */
  deferralSetting: DeferralSetting;
  /** All deferral settings for the user. */
  deferralSettings: Array<DeferralSetting>;
  /** The option to edit deferral settings. */
  deferralSettingsEditOption: DeferralSettingsEditOption;
  /** Provides investment account that is used for direct trading */
  directTradingAccount: DirectTradingAccount;
  disclosures: Disclosures;
  /** Retrieves the data for an individual document */
  document: DocumentFile;
  /** A list of available document categories or category groups for the current user */
  documentCategories: Array<DocumentCategoryOrCategoryGroup>;
  /** Retrieves the data for an individual document category */
  documentCategory: DocumentCategory;
  /** Retrieves a list of documents in a particular category between the provided start and end dates */
  documents: DocumentsResult;
  /**
   * A single education article
   * @deprecated Use article instead.
   */
  educationArticle: Article;
  /**
   * Provides a collection of articles with investing and planning education/advice
   * @deprecated Use articles instead.
   */
  educationArticles: Array<Article>;
  /** The employee user associated with the current user, if there is one. */
  employee: Employee;
  /** Provides data for the user's employer 401(k) contributions, if there are any. */
  employerFourOhOneKContributions?: Maybe<EmployerFourOhOneKContributionsResult>;
  /** Provides data for the user's employers, if there are any. */
  employers: Array<Employer>;
  /** A single envelope by ID */
  envelope: Envelope;
  /** A single account within an envelope. */
  envelopeAccount: CashAccount | CheckingAccount | DirectTradingAccount | ExternalAccountEnvelopeAssociation | Five29Account | ManagedAccount;
  /** All of the user's envelopes. */
  envelopes: Array<Envelope>;
  /** Provides a collection of ExternalAccounts for the current Investor */
  externalAccounts: Array<ExternalAccount>;
  /** The financial profile of the current user. */
  financialProfile?: Maybe<FinancialProfile>;
  /** The financial service options available to the current user. */
  financialServiceOptions: Array<BettermentAdvisorNetworkOption | BettermentPremiumOption>;
  /** A single Five29Account by ID. */
  five29Account: Five29Account;
  /** The ability for a user to onboard into a Betterment 529 Plan. */
  fiveTwoNineOnboardingOption?: Maybe<FiveTwoNineGoalCreationOption>;
  /** Provides data for the user's 401(k) contributions, if there are any. */
  fourOhOneKContributions?: Maybe<FourOhOneKContributionsResult>;
  /**
   * Provides an entry point for all data related to the 401k student loan payment
   * match feature of our 401k product. Will be nil if the user has never eligible
   * for the feature, because they are not a b4b user, or their employer does not
   * offer the feature. However if they have any historical data related to the
   * feature, this field will not be nil, even if they are no longer eligible.
   */
  fourOhOneKStudentLoanMatchBenefit?: Maybe<FourOhOneKStudentLoanMatchBenefit>;
  /** Provides a goal given a goal id */
  goal: Goal;
  /** Provides a collection of available Goal Creation Intent records for the current User. */
  goalCreationIntents: Array<GoalCreationIntent>;
  /** Provides a goal creation option given an id */
  goalCreationOption: GoalCreationOption;
  /** A collection of goals for a given category */
  goals: Array<Goal>;
  /** Provides data for the user's IRA contribution match grants, if there are any. */
  iraContributionMatchGrants: Array<IraContributionMatchGrant>;
  /** Provides data for the user's IRA contributions, if there are any. */
  iraContributions?: Maybe<IraContributionsResult>;
  /** Whether the user is eligible to view earned rewards. */
  isEarnedRewardsEligible: Scalars['Boolean']['output'];
  /** Whether the user is eligible to view eligible rewards. */
  isEligibleRewardsEligible: Scalars['Boolean']['output'];
  /** Whether the user is eligible to make referrals. */
  isReferralEligible: Scalars['Boolean']['output'];
  /** The legal account of the current user for the given legal_account id */
  legalAccount: LegalAccount;
  /** All legal accounts for the current user */
  legalAccounts: Array<LegalAccount>;
  /** All sub accounts for the current user. */
  legalSubAccounts: Array<CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount>;
  /** A single managed account. */
  managedAccount: ManagedAccount;
  /** Retrieve information about the given market schedule */
  marketSchedule: MarketSchedule;
  /** The option to create a transaction memo */
  memoCreationOption: MemoCreationOption;
  /** A set of messages for the user. */
  messages: Array<Message>;
  /** A breakdown of the user's net worth */
  netWorth?: Maybe<NetWorth>;
  /** All payroll contribution configs for the user. */
  payrollContributionConfigs: Array<PayrollContributionConfig>;
  /** The latest document verification request with a pending upload status */
  pendingDocumentVerificationRequest?: Maybe<PendingDocumentVerificationRequest>;
  /** Aggregated performance data including history, totals, and accounts. */
  performance: Performance;
  /**
   * Rollup of the performance totals of the given Goals over the given date range.
   * @deprecated Use performance#totals instead.
   */
  performanceTotals: PerformanceTotals;
  /** Provides a single Portfolio Strategy Option based on the provided Goal properties and Portfolio Strategy slug */
  portfolioStrategyOption?: Maybe<LegacyPortfolioStrategyOption>;
  /** Provides a collection of Portfolio Strategy Options based on the provided Goal properties */
  portfolioStrategyOptions: Array<LegacyPortfolioStrategyOption>;
  /** The ability for a user to onboard into Betterment Premium. */
  premiumOnboardingOption?: Maybe<PremiumOnboardingOption>;
  /** Pricing information for the logged in user's accounts */
  priceGroups: Array<PriceGroup>;
  /** Available product bundles for the current user */
  productBundles: Array<ProductBundle>;
  /** Provides the product onboarding options for the current user */
  productOnboardingOptions: Array<CheckingAccountCreationOption | FinancialCoachingOnboardingOption | FiveTwoNineGoalCreationOption | GoalCreationOption | PremiumOnboardingOption | Solo401kOnboardingOption>;
  /** An envelope's purpose, by ID. */
  purpose: PurposeEmergencyFund | PurposeMajorPurchase | PurposeRetirementGrowth | PurposeRetirementIncome;
  /** All icons the user can use to as the icon for one of their purposes (excluding user-uploaded custom icons.) */
  purposeAssets: Array<PurposeAsset>;
  /** A single purpose creation option filtered by intent and purpose type. */
  purposeCreationOption: EmergencyFundPurposeCreationOption | MajorPurchasePurposeCreationOption | RetirementGrowthPurposeCreationOption | RetirementIncomePurposeCreationOption;
  /** A list of purpose creation options filtered by intent. */
  purposeCreationOptions: Array<EmergencyFundPurposeCreationOption | MajorPurchasePurposeCreationOption | RetirementGrowthPurposeCreationOption | RetirementIncomePurposeCreationOption>;
  /** All of the user's envelope purposes with option to filter by purpose intent. */
  purposes: Array<PurposeEmergencyFund | PurposeMajorPurchase | PurposeRetirementGrowth | PurposeRetirementIncome>;
  /** A recurring transaction config involving the user's accounts. */
  recurringTransactionConfig: RecurringTransactionConfig;
  /** The recurring transaction configs involving the user's accounts. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** Preview a recurring transaction schedule by computing upcoming transaction dates for a given frequency. */
  recurringTransactionSchedule: RecurringTransactionSchedule;
  /** The referral program for the current user. */
  referralProgram?: Maybe<ReferralProgram>;
  /** The global list of all possible calendly scheduled events. */
  scheduledEventConfiguration: ScheduledEventConfiguration;
  /**
   * A SomebodysExternalAccount accessible by the current user, either because it
   * was connected by the current user, or because it was connected by someone else
   * and associated with one of the current user's envelopes.
   */
  somebodysExternalAccount: ExternalAccount | TheirExternalAccount;
  /** The sub account of the current user for the given sub_account id */
  subAccount: SubAccount;
  /** A list of tax coordination eligible accounts. */
  taxCoordinationAccountOptions: Array<TaxCoordinationAccountOption>;
  /** All available terms and agreements for selected products or features */
  termsAndAgreements: Array<TermsAndAgreements>;
  /** The options to initiate a transaction */
  transactionOptions: Array<CharitableDonationOption | DeferralSettingsEditOption | ExternalTransferOption | ManageRecurringTransactionsOption | RolloverOption | RothIraConversionOption | TransferOption | WireTransferOption>;
  /** A single account that can be the source or destination of a transfer. */
  transferableAccount: BankAccount | CashAccount | CheckingAccount | CheckingExternalAccount | DirectTradingAccount | Five29Account | ManagedSubAccount | TheirLegalSubAccount;
  /** The current logged in User */
  user: User;
  /** The latest non-cancelled activity CSV export for the current user. */
  userActivityCsvExport?: Maybe<CsvExport>;
  /** All user level settings for the current user. */
  userLevelSettings: UserLevelSettings;
  /** A specific wire transfer option presented to a user. */
  wireTransferOption: WireTransferOption;
};


/** The entrypoint for all retail schema queries */
export type QueryActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The entrypoint for all retail schema queries */
export type QueryActivityItemsForIdArgs = {
  id: ActivityItemIdInput;
};


/** The entrypoint for all retail schema queries */
export type QueryAdvisedSoloFourOhOneKClientInviteArgs = {
  token: Scalars['String']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryArticlesArgs = {
  scope?: InputMaybe<ArticlesScope>;
};


/** The entrypoint for all retail schema queries */
export type QueryCheckingAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryClientEnvelopeApprovalRequestArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryCurrentMarketingMessageArgs = {
  input: MarketingMessagesInput;
};


/** The entrypoint for all retail schema queries */
export type QueryDeferralSettingArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryDeferralSettingsEditOptionArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryDirectTradingAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
  type: DocumentFileType;
};


/** The entrypoint for all retail schema queries */
export type QueryDocumentCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryDocumentsArgs = {
  categoryId: Scalars['ID']['input'];
  endDateInclusive?: InputMaybe<Scalars['Date']['input']>;
  startDateInclusive?: InputMaybe<Scalars['Date']['input']>;
};


/** The entrypoint for all retail schema queries */
export type QueryEducationArticleArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryEducationArticlesArgs = {
  category?: InputMaybe<EducationArticleCategoryType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The entrypoint for all retail schema queries */
export type QueryEmployeeArgs = {
  employerId: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryEnvelopeArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryEnvelopeAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryExternalAccountsArgs = {
  where?: InputMaybe<ExternalAccountsWhereInput>;
};


/** The entrypoint for all retail schema queries */
export type QueryFive29AccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryGoalCreationOptionArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryGoalsArgs = {
  category?: InputMaybe<GoalsCategory>;
};


/** The entrypoint for all retail schema queries */
export type QueryIraContributionMatchGrantsArgs = {
  where?: InputMaybe<IraContributionMatchGrantsWhereInput>;
};


/** The entrypoint for all retail schema queries */
export type QueryLegalAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryLegalSubAccountsArgs = {
  input?: InputMaybe<LegalSubAccountInput>;
};


/** The entrypoint for all retail schema queries */
export type QueryManagedAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryMarketScheduleArgs = {
  time?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The entrypoint for all retail schema queries */
export type QueryMemoCreationOptionArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryPayrollContributionConfigsArgs = {
  where?: InputMaybe<PayrollContributionConfigsWhereInput>;
};


/** The entrypoint for all retail schema queries */
export type QueryPerformanceArgs = {
  accountIds?: Array<Scalars['ID']['input']>;
  customDateRange?: InputMaybe<DateRangeInput>;
  dateRangeOption?: DateRangeOption;
};


/** The entrypoint for all retail schema queries */
export type QueryPerformanceTotalsArgs = {
  dateRangeOption?: DateRangeOption;
};


/** The entrypoint for all retail schema queries */
export type QueryPortfolioStrategyOptionArgs = {
  adviceTypeId?: InputMaybe<Scalars['String']['input']>;
  limitedAdviceEligible: Scalars['Boolean']['input'];
  targetDate: Scalars['Date']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryPortfolioStrategyOptionsArgs = {
  adviceTypeId?: InputMaybe<Scalars['String']['input']>;
  limitedAdviceEligible: Scalars['Boolean']['input'];
  productCategory?: InputMaybe<Scalars['String']['input']>;
  targetDate: Scalars['Date']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryProductOnboardingOptionsArgs = {
  order?: InputMaybe<ProductCategoryOptionsOrder>;
};


/** The entrypoint for all retail schema queries */
export type QueryPurposeArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryPurposeCreationOptionArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryPurposeCreationOptionsArgs = {
  intent: PurposeCreationIntent;
};


/** The entrypoint for all retail schema queries */
export type QueryPurposesArgs = {
  intent?: InputMaybe<PurposeCreationIntent>;
};


/** The entrypoint for all retail schema queries */
export type QueryRecurringTransactionConfigArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryRecurringTransactionScheduleArgs = {
  frequency: RecurringTransactionFrequencyInput;
  startingFromDate?: InputMaybe<Scalars['Date']['input']>;
};


/** The entrypoint for all retail schema queries */
export type QueryScheduledEventConfigurationArgs = {
  scheduleEvent: Scalars['String']['input'];
};


/** The entrypoint for all retail schema queries */
export type QuerySomebodysExternalAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QuerySubAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryTermsAndAgreementsArgs = {
  filter: TermsAndAgreementsFilterInput;
};


/** The entrypoint for all retail schema queries */
export type QueryTransferableAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all retail schema queries */
export type QueryWireTransferOptionArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Information about the rebalancing features as relevant to the given portfolio.
 * Rebalancing is a feature of our portfolio management system, where Betterment
 * will automatically buy and sell assets as the market changes to keep the user's
 * portfolio close to its target allocation (aka, reducing the 'drift' between the
 * portfolio and its target allocation).
 */
export type Rebalance = {
  __typename: 'Rebalance';
  /**
   * An explanation of our rebalancing features, and in particular, how it enables
   * automatic trading to bring the portfolio's allocation closer to its target.
   */
  explanation: Scalars['String']['output'];
  /** Rebalancing setting status. */
  isEnabled: Scalars['Boolean']['output'];
};

/** A Result Type representing the absence of a record/object for the Query conditions. */
export type RecordNotFoundResult = {
  __typename: 'RecordNotFoundResult';
  /** Dummy field for an otherwise empty type. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** A Result Type representing a non-error state for a query result if a field/object cannot be resolved. */
export type RecordUnavailableResult = {
  __typename: 'RecordUnavailableResult';
  /** Dummy field for an otherwise empty type. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** A reason-to-believe used to motivate the user to initiate a recurring deposit */
export type RecurringDepositMotivation = {
  __typename: 'RecurringDepositMotivation';
  /** The text intended to users into creating a recurring deposit. */
  description: Scalars['String']['output'];
  /** A longer disclosure further qualifying the description in full. */
  longDisclosure: Scalars['HTML']['output'];
  /** A brief disclosure qualifying the description. */
  shortDisclosure: Scalars['HTML']['output'];
};

/**
 * A configuration for a user-defined recurring transaction between accounts.
 * Source and destination accounts can be internal betterment accounts or external
 * bank accounts, so this type encompasses all of what have been historically known
 * as 'auto-deposits', 'recurring transfers', and 'auto-withdrawals' (use the
 * `legacyTransferType` field to disambiguate between those three concepts). For
 * employer 401k deferral configurations, see `DeferralSetting`.
 */
export type RecurringTransactionConfig = {
  __typename: 'RecurringTransactionConfig';
  /** The amount of the transaction. */
  amount: Scalars['Cents']['output'];
  /**
   * The amount of the transaction planned per month. For example, a config with a
   * $12,000 annual amount, will have an amount per month of $1,000.
   */
  amountPerMonth: Scalars['Cents']['output'];
  /** The destination account for the config. */
  destination: BankAccount | CashAccount | CheckingAccount | CheckingExternalAccount | DirectTradingAccount | Five29Account | ManagedSubAccount | TheirLegalSubAccount;
  /**
   * The name of the destination account for the config.
   * @deprecated Use a name from destination instead
   */
  destinationName: Scalars['String']['output'];
  /** The datetime when the config was most recently disabled. */
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The frequency at which the transaction occurs. */
  frequency: RecurringTransactionFrequency;
  /** A human-readable description of the transaction frequency. */
  frequencyDescription: Scalars['String']['output'];
  /**
   * The icon for the goal related to the config.
   * @deprecated Use an account icon from the source or destination.
   */
  icon: ThemedAsset;
  /** The ID for the config. */
  id: Scalars['ID']['output'];
  /** Whether the config is editable by the current user. */
  isEditable: Scalars['Boolean']['output'];
  /** The ID for the config, as recognized by our legacy REST APIs. */
  legacyId?: Maybe<Scalars['LegacyID']['output']>;
  /**
   * The type of OmniTransfer transaction type presented to a user. Marked as
   * legacy to indicate that future development in the OmniTransfer flow should be
   * done in a way that's agnostic to differences between transfer types.
   */
  legacyTransferType: LegacyTransferType;
  /** The ID for the config, as recognized by our legacy REST APIs. */
  legacyUuid?: Maybe<Scalars['LegacyUUID']['output']>;
  /** A set of messages for the user. */
  messages: Array<Message>;
  /** The date for following transaction to occur. */
  nextTransactionDate: Scalars['Date']['output'];
  /** The source account for the config. */
  source: BankAccount | CashAccount | CheckingAccount | CheckingExternalAccount | DirectTradingAccount | Five29Account | ManagedSubAccount | TheirLegalSubAccount;
  /**
   * The name of the source account for the config.
   * @deprecated Use a name from source instead
   */
  sourceName: Scalars['String']['output'];
  /** The lifecycle status of the config. */
  status: RecurringTransactionConfigLifecycleStatus;
  /** A collection of statuses associated with the configuration. */
  statuses: Array<RecurringTransactionConfigStatus>;
};


/**
 * A configuration for a user-defined recurring transaction between accounts.
 * Source and destination accounts can be internal betterment accounts or external
 * bank accounts, so this type encompasses all of what have been historically known
 * as 'auto-deposits', 'recurring transfers', and 'auto-withdrawals' (use the
 * `legacyTransferType` field to disambiguate between those three concepts). For
 * employer 401k deferral configurations, see `DeferralSetting`.
 */
export type RecurringTransactionConfigMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** The lifecycle status of a RecurringTransactionConfig. */
export enum RecurringTransactionConfigLifecycleStatus {
  /** The config is active and will process transactions. */
  Active = 'ACTIVE',
  /** The config has been disabled and will not process transactions. */
  Archived = 'ARCHIVED',
  /** The config is temporarily paused and will not process transactions. */
  Paused = 'PAUSED'
}

/** A collection of statuses associated with a recurring transaction configuration. */
export type RecurringTransactionConfigStatus = {
  __typename: 'RecurringTransactionConfigStatus';
  /** The description of the status. */
  description: Scalars['String']['output'];
  /** The name of the status. */
  name: Scalars['String']['output'];
  /** The style of a RecurringTransactionConfigStatus. It can be used to determine the visual formatting. */
  style: RecurringTransactionConfigStatusStyle;
  /** The title of the status. */
  title: Scalars['String']['output'];
};

/** The style of a RecurringTransactionConfigStatus. */
export enum RecurringTransactionConfigStatusStyle {
  /** Warning or dangerous status */
  Danger = 'DANGER',
  /** Informational status */
  Info = 'INFO',
  /** Nowise status */
  None = 'NONE',
  /** Successful status */
  Success = 'SUCCESS'
}

/**
 * Possible configurations of a recurring transaction's frequency. Acceptable day
 * of week values are 1-5 (Monday-Friday), and acceptable day of month values are 1-28.
 */
export type RecurringTransactionFrequency = RecurringTransactionFrequencyAnnually | RecurringTransactionFrequencyEveryOtherWeek | RecurringTransactionFrequencyMonthly | RecurringTransactionFrequencyTwiceAMonth | RecurringTransactionFrequencyWeekly;

/** Frequency for transactions executing once a year. */
export type RecurringTransactionFrequencyAnnually = {
  __typename: 'RecurringTransactionFrequencyAnnually';
  /** The day of the month. */
  day: Scalars['Int']['output'];
  /** The month. */
  month: Scalars['Int']['output'];
};

/** Frequency for transactions executing every other week. */
export type RecurringTransactionFrequencyEveryOtherWeek = {
  __typename: 'RecurringTransactionFrequencyEveryOtherWeek';
  /** The day of week. */
  day: Scalars['Int']['output'];
};

/** Input object representing a recurring transaction frequency */
export type RecurringTransactionFrequencyInput =
  /** Frequency for once a year. Represented by an integer array [month, day]. For example, [1, 15] represents January 15th. */
  { annual: Array<Scalars['Int']['input']>; everyOtherWeek?: never; monthly?: never; twiceAMonth?: never; weekly?: never; }
  |  /**
   * Frequency for every other week. Represented by an integer value from 1-5. For
   * example, 1 represents a transaction every other Monday.
   */
  { annual?: never; everyOtherWeek: Scalars['Int']['input']; monthly?: never; twiceAMonth?: never; weekly?: never; }
  |  /**
   * Frequency for once a month. Represented by an integer value from 1-28. For
   * example, 15 represents the 15th day of the month.
   */
  { annual?: never; everyOtherWeek?: never; monthly: Scalars['Int']['input']; twiceAMonth?: never; weekly?: never; }
  |  /**
   * Frequency for twice a month. Represented by an integer array [day1, day2]. For
   * example, [1, 15] represents transactions on the 1st and 15th of the month.
   */
  { annual?: never; everyOtherWeek?: never; monthly?: never; twiceAMonth: Array<Scalars['Int']['input']>; weekly?: never; }
  |  /** Frequency for once a week. Represented by an integer value from 1-5. For example, 1 represents a transaction every Monday. */
  { annual?: never; everyOtherWeek?: never; monthly?: never; twiceAMonth?: never; weekly: Scalars['Int']['input']; };

/** Frequency for transactions executing once a month. */
export type RecurringTransactionFrequencyMonthly = {
  __typename: 'RecurringTransactionFrequencyMonthly';
  /** The day of month. */
  day: Scalars['Int']['output'];
};

/** Frequency for transactions executing twice a month. */
export type RecurringTransactionFrequencyTwiceAMonth = {
  __typename: 'RecurringTransactionFrequencyTwiceAMonth';
  /** The first day of month. */
  firstDay: Scalars['Int']['output'];
  /** The second day of month. */
  secondDay: Scalars['Int']['output'];
};

/** Frequency for transactions executing once a week. */
export type RecurringTransactionFrequencyWeekly = {
  __typename: 'RecurringTransactionFrequencyWeekly';
  /** The day of week. */
  day: Scalars['Int']['output'];
};

/** A computed preview of a recurring transaction schedule. */
export type RecurringTransactionSchedule = {
  __typename: 'RecurringTransactionSchedule';
  /**
   * The soonest possible processing date for the given frequency that is after or
   * equal to the given schedule start date, or if none is given, after today.
   */
  nextTransactionDate: Scalars['Date']['output'];
  /** The possible processing dates for the given frequency over the next four months. */
  upcomingTransactableDates: Array<Scalars['Date']['output']>;
};

/** An invitation for a referral. */
export type ReferralInvitation = {
  __typename: 'ReferralInvitation';
  /** Email address of the referred user. */
  emailAddress: Scalars['String']['output'];
  /** The identifier for this invitation. */
  id: Scalars['ID']['output'];
  /** The date and time the invitation was last sent. */
  lastSentAt: Scalars['DateTime']['output'];
  /** Status of the invitation. */
  status: ReferralInvitationStatus;
};

/** Referral invitation states. */
export enum ReferralInvitationStatus {
  /** User has funded */
  Funded = 'FUNDED',
  /** User has been prompted to sign up */
  Prompt = 'PROMPT',
  /** Invitation has been sent to user */
  Sent = 'SENT',
  /** User has signed up */
  SignedUp = 'SIGNED_UP'
}

/** A referral program. */
export type ReferralProgram = {
  __typename: 'ReferralProgram';
  /** Legal disclosure copy. */
  disclosureDescription: Scalars['HTML']['output'];
  /** The featured image for the referral program. */
  featuredImage: ThemedAsset;
  /** Indicates if user has reached the maximum number of referral rewards. */
  hasReachedMaxReferralRewards: Scalars['Boolean']['output'];
  /** Long description of the referral program. */
  longDescription: Scalars['String']['output'];
  /** Maximum number of rewards a user can earn. */
  maxReferralRewards: Scalars['Int']['output'];
  /** Name of the referral program. */
  name: Scalars['String']['output'];
  /** Referral invitations for a user. */
  referralInvitations?: Maybe<Array<ReferralInvitation>>;
  /** Key used to associate referrals to sending user. */
  referralKey: Scalars['String']['output'];
  /** Rewards a user earned for referrals. */
  referralRewards?: Maybe<Array<ReferralReward>>;
  /** Number of rewards a user has earned. */
  referralRewardsCount: Scalars['Int']['output'];
  /** Content for the referral invitation from the user. */
  referrerInvitationContent: ReferrerInvitationContent;
  /** Short description of the referral program. */
  shortDescription: Scalars['String']['output'];
  /** Link to full page of terms, conditions, and other relevant public info. */
  termsUrl: Scalars['String']['output'];
};

/** A reward for a referral. */
export type ReferralReward = {
  __typename: 'ReferralReward';
  /** Active period of the reward. */
  activePeriod: DateRange;
  /** The identifier for this reward. */
  id: Scalars['ID']['output'];
  /** Name of the referral offer. */
  offerName: Scalars['String']['output'];
  /** Description of the reward. */
  rewardDescription: Scalars['String']['output'];
  /** Type of referral reward. */
  rewardType: ReferralRewardType;
  /** Status of the reward. */
  status: ReferralRewardStatus;
};

/** Referral reward states. */
export enum ReferralRewardStatus {
  /** Reward is active */
  Active = 'ACTIVE',
  /** Reward is expired */
  Expired = 'EXPIRED',
  /** Reward is pending */
  Pending = 'PENDING',
  /** Reward is upcoming */
  Upcoming = 'UPCOMING'
}

/** Referral reward types. */
export enum ReferralRewardType {
  /** Capped amount of free dollars that accumulate */
  CumulativeFreeDollarsCapped = 'CUMULATIVE_FREE_DOLLARS_CAPPED',
  /** Capped amount of free dollars */
  FreeDollarsCapped = 'FREE_DOLLARS_CAPPED',
  /** Fixed amount of free dollars */
  FreeDollarsFixed = 'FREE_DOLLARS_FIXED',
  /** Savings rate boost */
  SavingsRateBoost = 'SAVINGS_RATE_BOOST'
}

/** Content for a referrer invitation. */
export type ReferrerInvitationContent = {
  __typename: 'ReferrerInvitationContent';
  /** Body of the invitation. */
  body: Scalars['String']['output'];
  /** Legal disclosure copy for sending invitation. */
  disclosureDescription: Scalars['HTML']['output'];
  /** Subject of the invitation. */
  subject: Scalars['String']['output'];
  /** URL for the referral link in the invitation. */
  url: Scalars['URL']['output'];
};

/** Relative risk details for a given investing goal */
export type RelativeRisk = {
  __typename: 'RelativeRisk';
  /** The explanation of the relative risk */
  explanation: Scalars['String']['output'];
  /** The name of the relative risk */
  name: Scalars['String']['output'];
};

/** The remote data for a checking account. */
export type RemoteCheckingAccount = {
  __typename: 'RemoteCheckingAccount';
  /** The Account Number for the given Checking Account. */
  accountNumber: Scalars['String']['output'];
  /** The current Available Balance for the given Checking Account. */
  availableBalance: Scalars['Cents']['output'];
  /** The checking customer holding the account. */
  customer: CheckingCustomer;
  /** Record identifier for the given Checking Account. */
  id: Scalars['ID']['output'];
  /** Flag indicating that the given Checking Account has been Locked. */
  isLocked: Scalars['Boolean']['output'];
  /** Flag to indicate that the the given Checking Account is the only account for the current User. */
  isOnlyAccount: Scalars['Boolean']['output'];
  /** Flag to indicate that the given Checking Account is a Spending Account. */
  isSpendingAccount: Scalars['Boolean']['output'];
  /** The Joint Account Holder users for the given Checking Account. */
  jointAccountHolders: Array<OtherUser>;
  /** The legacy system identifier for the given Checking Account. */
  legacyId: Scalars['LegacyID']['output'];
  /** The human-readable Name for the given Checking Account. */
  name: Scalars['String']['output'];
  /** The Routing Number for the given Checking Account. */
  routingNumber: Scalars['String']['output'];
  /** Collection of Joint Account Invitations for the given Checking Account. */
  sentInvitations: Array<JointAccountInvitation>;
};

/** Autogenerated input type of RemoveTheirExternalAccountEnvelopeMutation */
export type RemoveTheirExternalAccountEnvelopeMutationInput = {
  /** The ID of the TheirExternalAccount to remove from its currently assigned envelope */
  theirExternalAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTheirExternalAccountEnvelopeMutation. */
export type RemoveTheirExternalAccountEnvelopeMutationPayload = {
  __typename: 'RemoveTheirExternalAccountEnvelopeMutationPayload';
  /** The user-displayable errors produced while attempting to resolve RemoveTheirExternalAccountEnvelopeMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the RemoveTheirExternalAccountEnvelopeMutation execution as type Envelope. */
  result?: Maybe<Envelope>;
};

/** Autogenerated input type of ResendPersonalReferralInvitationMutation */
export type ResendPersonalReferralInvitationMutationInput = {
  /** The ID of the referral invitation to resend */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendPersonalReferralInvitationMutation. */
export type ResendPersonalReferralInvitationMutationPayload = {
  __typename: 'ResendPersonalReferralInvitationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ResendPersonalReferralInvitationMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ResendPersonalReferralInvitationMutation execution as type ReferralInvitation. */
  result?: Maybe<ReferralInvitation>;
};

/**
 * Represents a recommendation for a retirement contribution, including visual and
 * textual information, eligibility details, and a call-to-action.
 */
export type RetirementContributionRecommendation = {
  __typename: 'RetirementContributionRecommendation';
  /** The HTML body content describing the recommendation. */
  body: Scalars['String']['output'];
  /** The call-to-action for this recommendation. */
  cta?: Maybe<MessageCtaLink>;
  /** The eligibility amount for this contribution type. */
  eligibilityAmount?: Maybe<Scalars['Cents']['output']>;
  /** The themed asset for the account icon. */
  icon: ThemedAsset;
  /** The title of the contribution recommendation. */
  title: Scalars['String']['output'];
};

/** A retirement growth purpose creation option */
export type RetirementGrowthPurposeCreationOption = PurposeCreationOptionInterface & {
  __typename: 'RetirementGrowthPurposeCreationOption';
  /** The default name for this purpose */
  defaultName: Scalars['String']['output'];
  /** The default retirement age */
  defaultRetirementAge: Scalars['Int']['output'];
  /** The default retirement monthly spending amount */
  defaultRetirementMonthlySpending: Scalars['Cents']['output'];
  /** A description of the purpose creation option */
  description?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the purpose creation option */
  id: Scalars['ID']['output'];
  /** The legacy advice type identifier */
  legacyAdviceTypeId: Scalars['String']['output'];
  /** The display name of the purpose creation option */
  name: Scalars['String']['output'];
  /** The image icon and image key representing this purpose option */
  purposeAsset: PurposeAsset;
  /** The recommendation message for retirement monthly spending amount */
  recommendedMonthlySpending: Message;
};

/** Input object for updating a retirement growth purpose */
export type RetirementGrowthUpdateInput = {
  /** The age at which the user plans to retire */
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  /** The ZIP code where the user plans to retire, used for cost of living adjustments */
  retirementZip?: InputMaybe<Scalars['String']['input']>;
  /** The target amount of monthly spending */
  targetMonthlySpendingAmount?: InputMaybe<Scalars['Cents']['input']>;
};

/** A retirement income purpose creation option */
export type RetirementIncomePurposeCreationOption = PurposeCreationOptionInterface & {
  __typename: 'RetirementIncomePurposeCreationOption';
  /** The default name for this purpose */
  defaultName: Scalars['String']['output'];
  /** A description of the purpose creation option */
  description?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the purpose creation option */
  id: Scalars['ID']['output'];
  /** The legacy advice type identifier */
  legacyAdviceTypeId: Scalars['String']['output'];
  /** The display name of the purpose creation option */
  name: Scalars['String']['output'];
  /** The image icon and image key representing this purpose option */
  purposeAsset: PurposeAsset;
};

/** Input object for updating a retirement income purpose */
export type RetirementIncomeUpdateInput = {
  /** Indicates whether the user is retired */
  isRetired?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of RevokeMobileTokenMutation */
export type RevokeMobileTokenMutationInput = {
  /** List of mobile token IDs to revoke (must belong to the authenticated user) */
  mobileTokenIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RevokeMobileTokenMutation. */
export type RevokeMobileTokenMutationPayload = {
  __typename: 'RevokeMobileTokenMutationPayload';
  /** The user-displayable errors produced while attempting to resolve RevokeMobileTokenMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the RevokeMobileTokenMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** Reward progress state descriptions and values. */
export type RewardProgressStatus = {
  __typename: 'RewardProgressStatus';
  /** Brief description of the progress status on the reward, e.g. 'Current net deposits' */
  briefDescription: Scalars['String']['output'];
  /**
   * Description of the progress status on the reward, e.g. 'Current net deposits'
   * @deprecated Replaced with 'brief_description', for better clarity
   */
  description: Scalars['String']['output'];
  /** Trailing supporting text of the brief_description */
  detailedDescription?: Maybe<Scalars['String']['output']>;
  /** The identifier for this reward. */
  id: Scalars['ID']['output'];
  /** Value of the progress status on the reward, e.g. '$10,000' or '2 referrals' */
  value: Scalars['String']['output'];
};

/** A tier of an active reward and its relevant information. */
export type RewardTier = {
  __typename: 'RewardTier';
  /** Describes the requirements of fulfilling the tier, e.g. '3 referrals' */
  conditionDescription: Scalars['String']['output'];
  /** Indicates if a tier currently the currently active one. */
  currentTier: Scalars['Boolean']['output'];
  /** Indicator of the status of fulfillment of a tier */
  fulfillmentStatus?: Maybe<RewardTierFulfillmentStatus>;
  /** The identifier for this reward tier. */
  id: Scalars['ID']['output'];
  /** Describes the value of the reward */
  rewardDescription: Scalars['String']['output'];
};

/** Reward tier fulfillment states. */
export enum RewardTierFulfillmentStatus {
  /** Reward is fulfilled */
  Fulfilled = 'FULFILLED',
  /** Reward is projected to be fulfilled */
  ProjectedFulfilled = 'PROJECTED_FULFILLED',
  /** Reward is unfulfilled */
  Unfulfilled = 'UNFULFILLED'
}

/** The asset allocation for a risk based model portfolio option */
export type RiskBasedAssetAllocation = AssetAllocation & {
  __typename: 'RiskBasedAssetAllocation';
  /** The breakdown of asset type weights for the asset allocation */
  assetTypeWeights: Array<AssetTypeWeight>;
  /**
   * The auto adjust options for the risk based allocation. Determined based on
   * purpose id. Empty if the purpose or model portfolio does not support auto-adjust.
   */
  autoAdjustOptions: Array<AutoAdjustOption>;
  /** The diversification of the asset allocation */
  diversification: AssetAllocationDiversification;
  /** The id of the asset allocation. Maps to the model_portfolio_risk_level ID */
  id: Scalars['ID']['output'];
  /** The risk of the asset allocation */
  risk: AssetAllocationRisk;
  /** The set of all security groups holdings/allocations for this asset allocation. */
  securityGroups: Array<SecurityGroup>;
  /**
   * The weighted securities contained in the asset allocation
   * @deprecated Use securityGroupHoldings instead.
   */
  securityWeights: Array<LegacyWeightedSecurity>;
};

/**
 * A portfolio's risk level. When the user creates a portfolio, they can choose
 * between a collection of securities and weights of those securities, each of
 * which represents a different amount of investing risk. For example: -
 * Stock/bonds allocation: Many portfolios have 101 risk levels, each representing
 * a different percentage of bonds/stocks in a portfolio (such that 90/10
 * stocks/bonds is the 'default risk level' in many contexts). - Bonds-only
 * portfolios: The Goldman Sachs Tax Smart Bonds portfolio risk level is chosen for
 * the user based on our understanding of their tax bracket. The Blackrock Target
 * Income portfolio also has risk levels that balance target income with risk.-
 * Flexible and Advised401(k) portfolios have a single risk level, created by the
 * user.- It's possible for the risk level to not be configurable (e.g. crypto ETF
 * portfolio only has a single risk level, the Goldman Sachs Tax Smart Bonds
 * assigned risk level is not user-configurable).- Risk level are unique to a tax
 * treatment (taxable, tax deferred, tax coordinated).
 */
export type RiskLevel = {
  __typename: 'RiskLevel';
  /**
   * The bond yield values associated with this risk level. A 'bond yield'
   * generally represents the return an investor can expect to earn on a bond investment.
   */
  bondYields?: Maybe<BondPortfolioYields>;
  /**
   * The aggregate dividend yield for the risk level. A 'dividend yield' generally
   * represents the ratio of how much a company pays out in dividends each year
   * relative to its stock price. This value represents a calculated dividend yield
   * for all the stocks in the portfolio, weighted by their allocation in the
   * portfolio. The dividend yield is calculated as the sum of the dividend yields
   * of all the stocks in the portfolio, divided by the total value of the
   * portfolio. This value is expressed as a percentage and is used to assess the
   * income-generating potential of the portfolio.
   */
  dividendYield: Scalars['Percent']['output'];
  /** An explanation of dividend yield and the impact it has on your investment. */
  dividendYieldExplanation: Scalars['String']['output'];
  /** The portfolio risk level id. */
  id: Scalars['ID']['output'];
  /**
   * The portfolio risk level name:
   * - For portfolios with 101 risk levels, the name will be a description of the
   * stock/bonds allocation (e.g., '80% stocks, 20% bonds').
   * - For portfolios with fewer than 101 risk levels (aka 'sparse portfolios'),
   * the name will be the risk level name (e.g., Conservative, Moderate, Aggressive).
   */
  name: Scalars['String']['output'];
  /** The security groups associated with this risk level. This collection represents the target allocation of the risk level. */
  securityGroups: Array<SecurityGroup>;
  /**
   * This value is expressed as a percentage and represents the proportion of the
   * portfolio that is allocated to stocks. This value is used to assess the risk
   * level of the portfolio, with higher percentages indicating a higher level of
   * risk. It is only available for portfolios with 101 risk levels. For portfolios
   * with fewer than 101 risk levels (aka 'sparse portfolios'), the stock
   * allocation percentage is not available and the field will return null.
   */
  stockAllocationPercent?: Maybe<Scalars['Percent']['output']>;
};

/**
 * A portfolio that is made up of a collection of 2 or more risk levels. Each risk
 * level is a collection of security groups that are designed to achieve a specific
 * risk/return profile. The autoglide feature, when available, automatically
 * adjusts the portfolio's risk level over time in order to decrease risk as the
 * user approaches retirement. Some portfolios have 101 risk levels, each
 * representing a stock (vs. bond) allocation percentage from 0% to 100%. Other
 * portfolios have fewer than 101 risk levels (aka 'sparse portfolios'), which are
 * named risk levels (e.g., Conservative, Moderate, Aggressive). A risk level is
 * unique to a tax treatment (taxable, tax deferred, tax coordinated).
 */
export type RiskLevelBasedPortfolio = ManagedPortfolio & {
  __typename: 'RiskLevelBasedPortfolio';
  /**
   * A description of the configuration of the portfolio, typically including
   * details like the portfolio strategy name, and details about the risk level
   * (e.g., "Core portfolio (90% stocks)").
   */
  configurationDescription: Scalars['String']['output'];
  /**
   * The portfolio strategy's legal disclosure contains information about the
   * portfolio strategy, including the investment strategy, risks, features, and
   * construction methodology. This is a link to the legal disclosure for the
   * portfolio strategy.
   */
  disclosureUrl?: Maybe<Scalars['URL']['output']>;
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** Contains the portfolio's expense ratio details. */
  expenseRatio: ExpenseRatio;
  /** Indicates if there is a pending portfolio change request for this portfolio. */
  hasPendingPortfolioChangeRequest: Scalars['Boolean']['output'];
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the user can edit the target allocation of the portfolio. */
  isAllocationEditable: Scalars['Boolean']['output'];
  /** Whether this portfolio uses the Crypto ETF strategy. */
  isCryptoPortfolio: Scalars['Boolean']['output'];
  /** Whether the user is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
  /** The current portfolio risk level. */
  riskLevel: RiskLevel;
  /** Contains portfolio strategy details. */
  strategy: PortfolioStrategy;
};

/** The option to rollover an account. */
export type RolloverOption = TransactionOption & {
  __typename: 'RolloverOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** Whether the rollover is partially acatsable. */
  isPartiallyAcatsable: Scalars['Boolean']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** The option to convert an Roth IRA. */
export type RothIraConversionOption = TransactionOption & {
  __typename: 'RothIraConversionOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** Represents a savings plan for a specific tax year, including recommended retirement contributions. */
export type SavingsPlan = {
  __typename: 'SavingsPlan';
  /** List of recommended retirement contributions for this tax year. */
  contributionRecommendations: Array<RetirementContributionRecommendation>;
  /** A brief summary of your annual savings goal based on your current savings and retirement target. */
  subtitle: Scalars['String']['output'];
};

/** Scheduled event configuration details for embedding scheduling links and HTML source. */
export type ScheduledEventConfiguration = {
  __typename: 'ScheduledEventConfiguration';
  /** The event scheduling URL. */
  calendarLink: Scalars['URL']['output'];
  /** The HTML source code for embedding the scheduling widget on mobile only. */
  embedSource: Scalars['HTML']['output'];
};

/** IDs for an existing secondary user and their associated search record */
export type SecondaryUserExistingInput = {
  /** ID of stored secondary user found in search attempt */
  userId: Scalars['ID']['input'];
  /** ID of stored user search record */
  userSearchId: Scalars['ID']['input'];
};

/** Input for an existing or new secondary user */
export type SecondaryUserInput =
  /** IDs for existing user and user search record */
  { existing: SecondaryUserExistingInput; newUser?: never; }
  |  /** User details for new secondary user account */
  { existing?: never; newUser: SecondaryUserNewInput; };

/** Non-id attributes for a new secondary user */
export type SecondaryUserNewInput = {
  /** Address for secondary user */
  address: PostalAddressInput;
  /** Date of birth for secondary user */
  dateOfBirth: Scalars['Date']['input'];
  /** Email for secondary user */
  email: Scalars['String']['input'];
  /** First name for secondary user */
  firstName: Scalars['String']['input'];
  /** Last name for secondary user */
  lastName: Scalars['String']['input'];
  /** Optional middle initial for secondary user */
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for secondary user */
  phoneNumber: Scalars['String']['input'];
  /** SSN for secondary user */
  ssn: Scalars['TIN']['input'];
  /** ID of stored secondary user search attempt */
  userSearchId: Scalars['ID']['input'];
};

/** Securities lending settings and status for the user */
export type SecuritiesLending = {
  __typename: 'SecuritiesLending';
  /** Whether the user can self-update their securities lending settings (false for advised clients) */
  canUserSelfUpdate: Scalars['Boolean']['output'];
  /** Disclosures related to securities lending */
  disclosures: Scalars['HTML']['output'];
  /** Expected arrival date for securities lending */
  expectedArrival: Scalars['String']['output'];
  /** An explanation of how securities lending works */
  explanation: Scalars['HTML']['output'];
  /** A detailed description of securities lending */
  longDescription: Scalars['String']['output'];
  /** A brief description of securities lending */
  shortDescription: Scalars['String']['output'];
  /** The enrollment status of securities lending for the user */
  status: SecuritiesLendingStatus;
};

/** The status of securities lending enrollment for a user */
export enum SecuritiesLendingStatus {
  /** User is currently enrolled in securities lending */
  Enrolled = 'ENROLLED',
  /** User is not eligible for securities lending */
  Ineligible = 'INELIGIBLE',
  /** User needs to complete legal account setup to enroll */
  LegalAccountRequired = 'LEGAL_ACCOUNT_REQUIRED',
  /** User has never enrolled in securities lending */
  NeverEnrolled = 'NEVER_ENROLLED',
  /** User was enrolled but has since unenrolled */
  Unenrolled = 'UNENROLLED',
  /** Status is unknown (handles mobile edge cases for new states) */
  Unknown = 'UNKNOWN'
}

/** A security (stock, ETF, mutual fund, bond, etc.) that can be held in a portfolio. */
export type Security = {
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
};

/**
 * An instance of SecurityInterface for an exchange traded fund (ETF). ETFs are is
 * an investment funds that hold multiple underlying assets and can be bought and
 * sold on an exchange, much like an individual stock.
 */
export type SecurityFund = Security & {
  __typename: 'SecurityFund';
  /**
   * The expense ratio is the total annual fund operating expenses divided by the
   * average dollar value of the fund's assets under management (AUM). Essentially,
   * it is the fund's annual fee, measured as a percent of the investment in the fund.
   */
  expenseRatio: ExpenseRatio;
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** The name of the fund. */
  name: Scalars['String']['output'];
  /**
   * A prospectus is a written document used in finance to inform the public of the
   * relevant details about an offering of securities, such as stocks, bonds, and
   * mutual funds. The prospectus is part of a company's registration statement,
   * which is filed with the SEC. Betterment does not host the prospectus; this is
   * a link to the fund's prospectus on the fund company's website.
   */
  prospectusUrl: Scalars['URL']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
  /**
   * Tax-loss harvesting helps investors reduce taxes by offsetting the amount they
   * have to claim as capital gains or income. The TLH priority is the order in
   * which Betterment will sell securities to harvest tax losses, in the following
   * order: 1: This is the preferred ticker in its respective security group. If
   * possible, this ticker will be purchased.2: This is the second-priority ticker.
   * If the preferred ticker needs to be sold to harvest tax losses, this ticker
   * will be purchased.0: This ticker is holdable but cannot be purchased. It can
   * be sold to harvest tax losses.
   */
  tlhPriority?: Maybe<Scalars['Int']['output']>;
};

/**
 * A group of securities that are defined by a common theme, such as asset class,
 * industry, or issuer. The securities in the group may be held interchangeably
 * (based on their TLH priority) in order to enable tax loss harvesting. A security
 * group also defines a target allocation, which respresents the defined total
 * percentage of a portfolio that should be held by the group.
 */
export type SecurityGroup = {
  __typename: 'SecurityGroup';
  /**
   * The description for the security group provides information such as what types
   * securities are defined in the group, who the securities are issued by, what
   * industry exposure is provided, and the purpose of the group in the portfolio.
   */
  description?: Maybe<Scalars['HTML']['output']>;
  /** A unique identifier for the security group. */
  id: Scalars['ID']['output'];
  /**
   * The name of the security group, which indicates the asset class of securities
   * defined in the group (e.g. U.S. Large Cap Stocks).
   */
  name: Scalars['String']['output'];
  /**
   * The securities within this security group.
   * @deprecated does not work for TCP goals
   */
  securities: Array<SecurityFund | SecurityStock>;
  /**
   * The target weight of the security group in the portfolio definition for the
   * risk level that this security group belongs to. The value is expressed as the
   * percentage of the portfolio that is allocated to this group. For example, a
   * target weight of 0.1 means that 10% of the portfolio is allocated to this
   * security group.
   */
  targetWeight: Scalars['Percent']['output'];
};

/** A position for a single security group. */
export type SecurityGroupPosition = {
  __typename: 'SecurityGroupPosition';
  /** The amount held by the position in cents. */
  amount: Scalars['Cents']['output'];
  /** The average expense ratio, expressed as a percent, of all of the securities in the position. */
  averageExpenseRatioPercent: Scalars['Percent']['output'];
  /** The stock percent of the position. */
  currentWeight: Scalars['Percent']['output'];
  /** The drift of the position from the defined weight. */
  drift: Scalars['Percent']['output'];
  /** The total fees for all securities in the position in cents. */
  fundFees: Scalars['Cents']['output'];
  /** The unique ID for the given security group. */
  id: Scalars['ID']['output'];
  /** The security group of the position. */
  securityGroup: SecurityGroup;
  /** The actual security positions held. */
  securityPositions: Array<SecurityPosition>;
  /** The distinct security positions held across all sub accounts */
  securityPositionsBySecurity: Array<SecurityPositionsBySecurity>;
};

/** The held position of a given security in a portfolio. */
export type SecurityPosition = {
  __typename: 'SecurityPosition';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount?: Maybe<Scalars['Cents']['output']>;
  /** The market representation of the security. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** The security being held. */
  security: SecurityFund | SecurityStock;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
};

/** The distinct held position of a given security in a portfolio across sub accounts. */
export type SecurityPositionsBySecurity = {
  __typename: 'SecurityPositionsBySecurity';
  /** The amount held by the distinct ticker position in cents. */
  amount: Scalars['Cents']['output'];
  /** The average stock percent of the positions. */
  currentWeight: Scalars['Percent']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount?: Maybe<Scalars['Cents']['output']>;
  /** The market representation of the security. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** The unique ID for the given distinct security positions. */
  id: Scalars['ID']['output'];
  /** The sub account positions for the specific security */
  securityPositionsBySubAccount: Array<SecurityPositionsBySubAccount>;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** The symbol */
  symbol: Scalars['String']['output'];
};

/** The sub account within a specific security. */
export type SecurityPositionsBySubAccount = {
  __typename: 'SecurityPositionsBySubAccount';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount?: Maybe<Scalars['Cents']['output']>;
  /** The unique ID for the given account positions. */
  id: Scalars['ID']['output'];
  /** The actual security positions held. */
  securityPositions: Array<SecurityPosition>;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** The sub account */
  subAccount: CashAccount | DirectTradingAccount | Five29Account | ManagedSubAccount;
};

/** A stock instance of SecurityInterface. */
export type SecurityStock = Security & {
  __typename: 'SecurityStock';
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** name of company for security */
  name: Scalars['String']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
};

/**
 * A self-directed portfolio is not modeled using risk levels, but is instead a
 * simple collection of security groups. There are different types of self-directed
 * portfolios: Flexible portfolio: This is Betterment's 'build your own portfolio'
 * feature. It allows users to select their own security groups and assign weights
 * to them. Advised 401(k): This is a self-directed portfolio that is created by an
 * advisor. The advisor selects the available security groups and assigns targets
 * weights to them, but the user can change the weights.
 */
export type SelfDirectedPortfolio = ManagedPortfolio & {
  __typename: 'SelfDirectedPortfolio';
  /**
   * A description of the configuration of the portfolio, typically including
   * details like the portfolio strategy name, and details about the risk level
   * (e.g., "Core portfolio (90% stocks)").
   */
  configurationDescription: Scalars['String']['output'];
  /**
   * The portfolio strategy's legal disclosure contains information about the
   * portfolio strategy, including the investment strategy, risks, features, and
   * construction methodology. This is a link to the legal disclosure for the
   * portfolio strategy.
   */
  disclosureUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The diversification score describes how well diversified a user-defined
   * portfolio is. It is calculated in real time based on the selected security
   * groups. The value ranges from 0 to 1. If the score is equal to 0, the
   * portfolio has no diversification. If the diversification score is equal to 1,
   * the portfolio has maximum diversification.
   */
  diversificationScore?: Maybe<Scalars['Float']['output']>;
  /**
   * The aggregate dividend yield for the risk level. A 'dividend yield' generally
   * represents the ratio of how much a company pays out in dividends each year
   * relative to its stock price. This value represents a calculated dividend yield
   * for all the stocks in the portfolio, weighted by their allocation in the
   * portfolio. The dividend yield is calculated as the sum of the dividend yields
   * of all the stocks in the portfolio, divided by the total value of the
   * portfolio. This value is expressed as a percentage and is used to assess the
   * income-generating potential of the portfolio.
   */
  dividendYield: Scalars['Percent']['output'];
  /** An explanation of dividend yield and the impact it has on your investment. */
  dividendYieldExplanation: Scalars['String']['output'];
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** Contains the portfolio's expense ratio details. */
  expenseRatio: ExpenseRatio;
  /** Indicates if there is a pending portfolio change request for this portfolio. */
  hasPendingPortfolioChangeRequest: Scalars['Boolean']['output'];
  /**
   * The themed asset used to represent this portfolio strategy. It is specific to
   * the type of portfolio (i.e. flexible, advised 401(k)).
   */
  icon?: Maybe<ThemedAsset>;
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the user can edit the target allocation of the portfolio. */
  isAllocationEditable: Scalars['Boolean']['output'];
  /** Whether this portfolio uses the Crypto ETF strategy. */
  isCryptoPortfolio: Scalars['Boolean']['output'];
  /**
   * Whether the portfolio is an advised 401k, advised by an external plan advisor.
   * In the future, when adding more granular detail about advised 401ks, replace
   * this field with a field representing the externally advised plan.
   */
  isExternallyAdvised: Scalars['Boolean']['output'];
  /** Whether the user is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Describes the type of portfolio. For instance, 'Flexible Portfolio' or 'Advised 401(k)'. */
  name: Scalars['String']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
  /**
   * While security groups weights are user-assignable in a self-directed
   * portfolio, the portfolios all have a target allocation. For Betterment
   * portfolios, this is defined in the portfolio definition. For Advised 401(k)
   * portfolios, this is defined by the advisor. The target allocation is a
   * collection of security groups, which define the securities and the group's
   * target weight. The target allocation represents what Betterment believes to be
   * an ideal asset allocation, resulting in a high diversification score.
   */
  targetAllocation: Array<SecurityGroup>;
  /**
   * A readable description of the target allocation of the portfolio:
   * - For a flexpo portfolio, this value describes the percentage of stocks/bonds
   * represented by the current target allocation (e.g., '80% stocks, 20% bonds').
   * - For an advised 401k, for a portfolio targeting just one ticker/fund, this
   * value will describe that one ticker/fund (e.g., 'VLXVX | Vanguard Target
   * Retirement 2065 Fund'), or for a portfolio targeting multiple tickers, 'Custom'.
   */
  targetAllocationDescription: Scalars['String']['output'];
};

/** Autogenerated return type of SendEmailVerificationEmailMutation. */
export type SendEmailVerificationEmailMutationPayload = {
  __typename: 'SendEmailVerificationEmailMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SendEmailVerificationEmailMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the SendEmailVerificationEmailMutation execution as type EmailDispatch. */
  result?: Maybe<EmailDispatch>;
};

/** Autogenerated input type of SendWireTransferInstructionsEmailMutation */
export type SendWireTransferInstructionsEmailMutationInput = {
  /** The ID of the sub account the user intends to wire transfer into */
  subAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendWireTransferInstructionsEmailMutation. */
export type SendWireTransferInstructionsEmailMutationPayload = {
  __typename: 'SendWireTransferInstructionsEmailMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SendWireTransferInstructionsEmailMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the SendWireTransferInstructionsEmailMutation execution as type SubAccount. */
  result?: Maybe<SubAccount>;
};

/** Autogenerated input type of SendWireTransferInstructionsEmailV2Mutation */
export type SendWireTransferInstructionsEmailV2MutationInput = {
  /** The ID of the transferable account that the user intends to wire transfer into. */
  destinationAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendWireTransferInstructionsEmailV2Mutation. */
export type SendWireTransferInstructionsEmailV2MutationPayload = {
  __typename: 'SendWireTransferInstructionsEmailV2MutationPayload';
  /** The user-displayable errors produced while attempting to resolve SendWireTransferInstructionsEmailV2Mutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the SendWireTransferInstructionsEmailV2Mutation execution as type SubAccount. */
  result?: Maybe<SubAccount>;
};

/** A package of documents that need to be signed via DocuSign */
export type SignablePackage = {
  __typename: 'SignablePackage';
  /** DocuSign signing details, null if already signed */
  docusignSignature?: Maybe<DocusignSignature>;
  /** Unique identifier for this signable package */
  id: Scalars['ID']['output'];
  /** Whether the documents have been signed */
  signed: Scalars['Boolean']['output'];
  /** Type of documents (e.g., 'solo_401k_plan_documents') */
  type: Scalars['String']['output'];
};

/** The type of contribution for solo 401k accounts */
export enum Solo401kContributionType {
  /** The contributor is making a employee_contribution contribution */
  EmployeeContribution = 'EMPLOYEE_CONTRIBUTION',
  /** The contributor is making a employer_profit_sharing contribution */
  EmployerProfitSharing = 'EMPLOYER_PROFIT_SHARING',
  /** The contributor is making a rollover contribution */
  Rollover = 'ROLLOVER'
}

/** The business type for a Solo 401k Interest Submission */
export enum Solo401kInterestBusinessType {
  CCorp = 'C_CORP',
  Individual = 'INDIVIDUAL',
  Llc = 'LLC',
  Llp = 'LLP',
  NonProfit = 'NON_PROFIT',
  Partnership = 'PARTNERSHIP',
  SCorp = 'S_CORP'
}

/** The associated plan details for a Solo 401k Interest Submission */
export type Solo401kInterestPlanDetails = {
  /** The business full address */
  businessFullAddress: PostalAddressInput;
  /** Business phone number */
  businessPhoneNumber: Scalars['String']['input'];
  /** Type of business */
  businessType?: InputMaybe<Solo401kInterestBusinessType>;
  /** Employer Identification Number */
  ein: Scalars['TIN']['input'];
  /** The legal business name */
  legalBusinessName: Scalars['String']['input'];
  /** The plan's effective date */
  planEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  /** The plan name */
  planName: Scalars['String']['input'];
  /** The plan owner's name */
  planOwnerName: Scalars['String']['input'];
  /** Type of plan participants */
  planParticipants: Solo401kInterestPlanParticipantsType;
  /** The plan spouse's name */
  planSpouseName?: InputMaybe<Scalars['String']['input']>;
};

/** The plan participants type for a Solo 401k Interest Submission */
export enum Solo401kInterestPlanParticipantsType {
  OwnerAndSpouse = 'OWNER_AND_SPOUSE',
  OwnerOnly = 'OWNER_ONLY'
}

/** The plan type for a Solo 401k Interest Submission */
export enum Solo401kInterestPlanType {
  Conversion = 'CONVERSION',
  New = 'NEW'
}

/** Payload for Solo401kInterestSubmissionsMutationPayload mutation */
export type Solo401kInterestRequest = {
  __typename: 'Solo401kInterestRequest';
  /** ID for newly created record */
  id: Scalars['ID']['output'];
};

/** The ability for a user to go through the solo 401k onboarding flow. */
export type Solo401kOnboardingOption = ProductOnboardingOption & {
  __typename: 'Solo401kOnboardingOption';
  /** Disclosure html for the given product */
  disclosure?: Maybe<Scalars['HTML']['output']>;
  /** If a user has scheduled a consultation meeting */
  hasScheduledMeeting: Scalars['Boolean']['output'];
  /** The main product icon (small, themed SVG) */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** Image for the product in various contexts (icon, account recommendation, etc.) */
  image: ThemedAsset;
  /** Boolean indicating if the product onboarding has been started by the user */
  isInProgress: Scalars['Boolean']['output'];
  /** Boolean indicating if the product is a company benefit */
  isPlanBenefit: Scalars['Boolean']['output'];
  /**
   * Product category string used in legacy navigation code
   * @deprecated Avoid using this in favor of concrete type or fields based approach
   */
  legacyProductCategory: Scalars['String']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The product category of this onboarding option */
  productCategory: ProductCategory;
  /** Promotional points for why the user may be interested in the product. */
  reasonsToBelieve: Array<Scalars['HTML']['output']>;
  /** A short description of the option */
  shortDescription: Scalars['String']['output'];
  /** Steps to fully complete onboarding onto this product */
  steps?: Maybe<Array<ProductOnboardingStep>>;
  /** A short description with yield percent of the product */
  yieldDescription?: Maybe<Scalars['String']['output']>;
};


/** The ability for a user to go through the solo 401k onboarding flow. */
export type Solo401kOnboardingOptionImageArgs = {
  variant?: InputMaybe<ProductOnboardingOptionImageVariant>;
};

/** Autogenerated input type of SoloFourOhOneKClientEnvelopeFlowCompletionMutation */
export type SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput = {
  /** Whether the user has accepted the advisory agreement (required when applicable) */
  advisoryAgreementAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the client envelope invite to complete */
  inviteId: Scalars['ID']['input'];
  /** Whether the user has accepted the terms and conditions */
  termsAndConditionsAccepted: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SoloFourOhOneKClientEnvelopeFlowCompletionMutation. */
export type SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload = {
  __typename: 'SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SoloFourOhOneKClientEnvelopeFlowCompletionMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * SoloFourOhOneKClientEnvelopeFlowCompletionMutation execution as type
   * AdvisedSoloFourOhOneKClientInvite.
   */
  result?: Maybe<AdvisedSoloFourOhOneKClientInvite>;
};

/** The Participant in a solo 401(k) plan. */
export type SoloFourOhOneKParticipant = {
  __typename: 'SoloFourOhOneKParticipant';
  /** The balance of the solo 401(k) plan participant. */
  balance: Scalars['Cents']['output'];
  /** A unique identifier for a solo 401(k) plan participant. */
  id: Scalars['ID']['output'];
  /** A boolean representing if the participant is the owner of the solo 401(k) plan. */
  isPlanOwner: Scalars['Boolean']['output'];
  /** The user associated with the solo 401(k) plan participant. */
  user: OtherUser;
};

/** A solo 401(k) plan. This plan allows self-employed individuals to set up a 401(k) retirement plan  */
export type SoloFourOhOneKPlan = {
  __typename: 'SoloFourOhOneKPlan';
  /** The auto enrollment status for this solo 401(k) plan. */
  autoEnrollment?: Maybe<Scalars['Boolean']['output']>;
  /** The B4B plan ID of the solo 401(k) plan. */
  b4bPlanId: Scalars['ID']['output'];
  /** The distribution allowance for this solo 401(k) plan. */
  distributionsAllowance: Array<Scalars['String']['output']>;
  /** The eligibility description for this solo 401(k) plan. */
  eligibilityDescription: Scalars['String']['output'];
  /** A unique identifier for a solo 401(k) plan. */
  id: Scalars['ID']['output'];
  /** The maximum number of loans allowed under this solo 401(k) plan. */
  loansAllowed: Scalars['Int']['output'];
  /** The name of the solo 401(k) plan. */
  name: Scalars['String']['output'];
  /** The date on which this solo 401(k) plan was originally effective if available. */
  originallyEffectiveOn?: Maybe<Scalars['Date']['output']>;
  /** The participants in this solo 401(k) plan. */
  participants: Array<SoloFourOhOneKParticipant>;
  /** The betterment start date of the solo 401(k) plan, if available. */
  startOn: Scalars['Date']['output'];
  /** The vesting description for this solo 401(k) plan. */
  vestingDescription: Scalars['String']['output'];
};

/**
 * An external account. When the external account has been connected by the current
 * user, it will be an ExternalAccount. When connected by someone else, it will be
 * a TheirExternalAccount.
 */
export type SomebodysExternalAccount = {
  /** The redacted account number for the given External Account. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** The account type display name for the given External Account. */
  accountType: Scalars['String']['output'];
  /** A description for the account, including account type and redacted account number. */
  accountTypeAndRedactedAccountNumber: Scalars['String']['output'];
  /** The current account balance for this External Account. */
  balance: Scalars['Cents']['output'];
  /** The envelope that this external account is associated with. */
  envelope?: Maybe<Envelope>;
  /** The goal that this external account is associated with. */
  goal?: Maybe<Goal>;
  /** Indicates that a rollover process has started for funds transfer into a Betterment account. */
  hasPendingRollover: Scalars['Boolean']['output'];
  /** The icon for the account. */
  icon: ThemedAsset;
  /** The unique id for the external account. */
  id: Scalars['ID']['output'];
  /** The name of the institution that holds the account. */
  institutionName: Scalars['String']['output'];
  /**
   * The overarching investment type that best describes the account. Can be
   * `diversified` to represent complex accounts with multiple or complex financial instruments.
   */
  investmentType?: Maybe<Scalars['String']['output']>;
  /** Is this External Account manually synchronized? */
  isManual: Scalars['Boolean']['output'];
  /** Whether the account is visible in aggregation views and data. */
  isVisible: Scalars['Boolean']['output'];
  /** A description of when the account was last updated. */
  lastUpdatedAtDisplay?: Maybe<Scalars['String']['output']>;
  /** Non-dismissable information displayed to users. */
  messages: Array<Message>;
  /** The name for the account that comes from plaid or entered by the user during manual connection. */
  name: Scalars['String']['output'];
  /** The owner of the account. This is not always the same as the connector of the account. */
  ownerName: Scalars['String']['output'];
  /**
   * The subtype of the external account that encapsulates more specific financial
   * data that varies depending on the type of account.
   */
  subtype: ExternalAccountSubtypeBasic | ExternalAccountSubtypeEmployerSponsored | ExternalAccountSubtypeIra;
};


/**
 * An external account. When the external account has been connected by the current
 * user, it will be an ExternalAccount. When connected by someone else, it will be
 * a TheirExternalAccount.
 */
export type SomebodysExternalAccountMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** Information about the user's spouse, typically as it relates to their taxes and finances. */
export type Spouse = {
  __typename: 'Spouse';
  /** The spouse's annual pretax income, as specified by the user. */
  annualPretaxIncome?: Maybe<Scalars['Cents']['output']>;
  /** The spouse's date of birth, as specified by the user. */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the spouse. */
  id: Scalars['ID']['output'];
  /** The spouse's name, as specified by the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** Assumptions about the spouse's plans for retirement, as specified by the user. */
  retirementUserAssumptions?: Maybe<FinancialProfileRetirementUserAssumptions>;
};

/** Input object for spouse information. */
export type SpouseInput = {
  /** The spouse's annual pretax income. */
  annualPretaxIncome: Scalars['Cents']['input'];
  /** The spouse's date of birth. */
  dateOfBirth: Scalars['Date']['input'];
  /** The spouse's employment status (e.g., 'employed', 'self_employed', 'student', 'retired', 'unemployed'). */
  employmentStatus: Scalars['String']['input'];
  /** The spouse's full name. */
  name: Scalars['String']['input'];
};

/** The status of the account option. */
export enum Status {
  /** The account is available for transfers. */
  Available = 'AVAILABLE',
  /** The external service the checking account is connected to is unavailable. */
  CheckingUnavailable = 'CHECKING_UNAVAILABLE',
  /** The account is locked and cannot be used for transfers. */
  Locked = 'LOCKED',
  /** The account is unavailable for transfers. */
  Unavailable = 'UNAVAILABLE',
  /** The account is not yet verified and cannot be used for transfers. */
  VerificationRequired = 'VERIFICATION_REQUIRED'
}

/**
 * An attestation provided by a user confirming how much they made in student loan
 * payments for a given year. An attestation consists of multiple entries, each of
 * which represents an eligibility period for a given employer. Eligibility is
 * determined by 401k eligibility, based off of the users employment oand other
 * plan rules. Employees may have multiple entries for different employers, or even
 * multiple entries for the same employer as a result of complex employment
 * situations. (i.e. leave a company for a few months, then return) An attestation
 * is generated in an incomplete state, where the system defines the collections of
 * entries and all other details, but each entry has a null value for the dollar
 * amount. The user must then 'fill in' the blank amount values to complete the attestation
 */
export type StudentLoanPaymentAttestation = {
  __typename: 'StudentLoanPaymentAttestation';
  /**
   * The date and time at which the user attested to the amount they had made in
   * student loan payments during the given plan year. This will be null if the
   * user has not yet complated the attestation process.
   */
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of entries that make up the attestation. The user will have one entry for each eligibility period they have. */
  entries: Array<StudentLoanPaymentAttestationEntry>;
  /**
   * The unique identifier for the attestation, a uuid from the database table
   * employment_employee_student_loan_payment_attestations
   */
  id: Scalars['ID']['output'];
  /**
   * Whether the user is eligible to update the attestation. Attestations can be
   * updated during a window from Dec 1st - Jan 15th of the following year.
   */
  isUpdateEligible: Scalars['Boolean']['output'];
  /**
   * The year for which the user is providing an attestation. So if it is 2025,
   * then the user is attesting how much money thet paid towards their student loans in 2025.
   */
  planYear: Scalars['Int']['output'];
  /**
   * The window during which the user is eligible to update the attestation. This
   * is from Dec 1st - Jan 15th of the following year.
   */
  updateEligibilityWindow: DateRange;
};

/**
 * An entry in a student loan payment attestation. Each entry represents a period
 * of time in a year that the user was eligible to recive 401k match for their
 * student loan payments. Each entry consists of the employer that the user was
 * employed by during the period, the start and end dates of their eligibility with
 * that employer, and the amount of money they made in student loan payments during that period.
 */
export type StudentLoanPaymentAttestationEntry = {
  __typename: 'StudentLoanPaymentAttestationEntry';
  /**
   * The amount of money the user made in student loan payments during the period
   * of this entry. If the user has not yet completed the attestation, this may be nil
   */
  amount?: Maybe<Scalars['Cents']['output']>;
  /**
   * The period of time during which the user was eligible for 401k match for their
   * student loan payments. This is the period of time that the user was employed
   * by the employer and also eligible for 401k match.
   */
  eligibilityPeriod: DateRange;
  /** The employer that the user was employed by during the period of this entry. */
  employer: Employer;
  /**
   * The unique identifier for the entry, a uuid from the database table
   * employment_employee_student_loan_payment_attestation_entries
   */
  id: Scalars['ID']['output'];
};

/**
 * Input object representing how much money a user paid in student loan payments
 * during a given type period.This input object consists of an entry id, and a
 * corresponding amount. The entry id points to a database record in the table
 * employment_employee_student_loan_payment_attestation_entries. This table stores
 * the date range for which the amount applies
 */
export type StudentLoanPaymentBenefitAttestationEntryInput = {
  /** The amount of money the user paid in student loan payments during the period this entry covers. */
  amountCents: Scalars['Int']['input'];
  /** The database id of the entry */
  entryId: Scalars['ID']['input'];
};

/**
 * An estimate provided by the user for how much many they expect to pay towards
 * their student loans. The estimate is either on an annual basis, or a monthly
 * basis. Each user has a single estimate record, which is updated in-place as
 * their estimate changes.
 */
export type StudentLoanPaymentEstimate = {
  __typename: 'StudentLoanPaymentEstimate';
  /** The amount of their estimate for the given period */
  amount: Scalars['Cents']['output'];
  /**
   * The amount that we expect the user will pay over the course of the year. If
   * they selected an annual period, this will be the same as amount. If they
   * selected monthly, it will be the amount * 12.
   */
  computedAnnualAmount: Scalars['Cents']['output'];
  /**
   * The unique identifier for the estimate, a uuid from the database table
   * employment_employee_estimated_student_loan_payment_configs
   */
  id: Scalars['ID']['output'];
  /** The period of time over which the user is estimating their student loan payments, can be either annual or monthly. */
  period: StudentLoanPaymentEstimationPeriod;
};

/** The period of time over which the user is estimating their student loan payments, can be either annual or monthly. */
export enum StudentLoanPaymentEstimationPeriod {
  /** The esimtae is based on a monthly period */
  Monthly = 'MONTHLY',
  /** The estimate is based on an annual time period */
  Yearly = 'YEARLY'
}

/** An account within a Goal */
export type SubAccount = {
  __typename: 'SubAccount';
  /** The total anticipated balance for the given Sub Account. */
  anticipatedBalance: Scalars['Cents']['output'];
  /** A type of contribution specific to a tax year */
  contributionTypeSelectionOption?: Maybe<ContributionTypeSelectionOption>;
  /** The display name for the given Sub Account. */
  displayName: Scalars['String']['output'];
  /** The Goal associated with the given Sub Account. */
  goal: Goal;
  /** The unique ID for the given Sub Account. */
  id: Scalars['ID']['output'];
  /** The ID for the sub account, as recognized by our legacy REST APIs. */
  legacyId: Scalars['LegacyID']['output'];
  /** The Legal Account associated with the given Sub Account. */
  legalAccount: LegalAccount;
  /** A list of recurring transactions into the sub account. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
};


/** An account within a Goal */
export type SubAccountRecurringTransactionConfigsArgs = {
  where?: InputMaybe<SubAccountRecurringTransactionConfigsWhereInput>;
};

/** Input object representing a filter for recurring transactions. */
export type SubAccountRecurringTransactionConfigsWhereInput = {
  /** A boolean indicating whether the transactions are inflows */
  isInflow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of SubmitAdhocDocumentVerificationMutation */
export type SubmitAdhocDocumentVerificationMutationInput = {
  /** Transaction token from Socure */
  docvTransactionToken: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitAdhocDocumentVerificationMutation. */
export type SubmitAdhocDocumentVerificationMutationPayload = {
  __typename: 'SubmitAdhocDocumentVerificationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SubmitAdhocDocumentVerificationMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the SubmitAdhocDocumentVerificationMutation
   * execution as type SubmitAdhocDocumentVerificationMutationResult.
   */
  result?: Maybe<SubmitAdhocDocumentVerificationMutationResult>;
};

/** Adhoc document verification submission result */
export type SubmitAdhocDocumentVerificationMutationResult = {
  __typename: 'SubmitAdhocDocumentVerificationMutationResult';
  /** The status of the document verification request after submission */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SubmitDocumentVerificationMutation */
export type SubmitDocumentVerificationMutationInput = {
  /** Transaction token from Socure */
  docvTransactionToken: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitDocumentVerificationMutation. */
export type SubmitDocumentVerificationMutationPayload = {
  __typename: 'SubmitDocumentVerificationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SubmitDocumentVerificationMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the SubmitDocumentVerificationMutation execution as
   * type SubmitDocumentVerificationMutationResult.
   */
  result?: Maybe<SubmitDocumentVerificationMutationResult>;
};

/** Document verification submission result */
export type SubmitDocumentVerificationMutationResult = {
  __typename: 'SubmitDocumentVerificationMutationResult';
  /** The verification decision */
  status: DocumentVerificationStatus;
};

/** Autogenerated input type of SubmitFeedbackMutation */
export type SubmitFeedbackMutationInput = {
  /** The type of feedback being submitted */
  feedbackType: FeedbackType;
  /** The feedback message from the user */
  message: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitFeedbackMutation. */
export type SubmitFeedbackMutationPayload = {
  __typename: 'SubmitFeedbackMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SubmitFeedbackMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the SubmitFeedbackMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** A specific target to use for measuring the user's progress for a specific envelope's purpose. */
export type Target = {
  /** The ID for the target. */
  id: Scalars['ID']['output'];
};

/** A target for a purpose oriented towards saving a specific amount by a specific date. */
export type TargetAmountAndDate = Target & {
  __typename: 'TargetAmountAndDate';
  /** The target balance amount set for the envelope's purpose. */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** The target date by which the purpose should be achieved. */
  date?: Maybe<Scalars['Date']['output']>;
  /** The ID for the target. */
  id: Scalars['ID']['output'];
};

/** Account Purposes that use the target amount and date for target settings */
export type TargetBasedPurposeOption = AccountPurposeOption & {
  __typename: 'TargetBasedPurposeOption';
  /** The default name of the account purpose option */
  defaultName: Scalars['String']['output'];
  /** The Default Target Date */
  defaultTargetDate: Scalars['Date']['output'];
  /** An explanation of the default target date */
  defaultTargetDateExplanation: Scalars['HTML']['output'];
  /** The themed asset set for the icon used to represent this account purpose option. */
  icon: ThemedAsset;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the concrete account purpose option type */
  name: Scalars['String']['output'];
};

/** The target specified by a user for saving a specific amount of money to cover expenses for a certain number of months. */
export type TargetMonthlyExpenses = Target & {
  __typename: 'TargetMonthlyExpenses';
  /**
   * The total target amount to save, either specified directly by the user as a
   * custom amount, or calculated based on other values provided (months_coverage *
   * monthly_expenses_amount * buffer_percent).
   */
  amount?: Maybe<Scalars['Cents']['output']>;
  /** An additional buffer amount to save, on top of the months of monthly expenses to cover. */
  bufferPercent: Scalars['Percent']['output'];
  /** The ID for the target. */
  id: Scalars['ID']['output'];
  /** The user's specified amount of monthly expenses. Used to calculate the total target amount. */
  monthlyExpensesAmount: Scalars['Cents']['output'];
};

/**
 * A target measuring the user's progress in saving for retirement. The user can
 * specify a variety of retirement assumptions held as part of their financial
 * profile, and a desired spending amount after retirement. The date for the target
 * is defined by their expected retirement age. When the user has not yet specified
 * various parts of their retirement target, they are null.
 */
export type TargetRetirementSavings = Target & {
  __typename: 'TargetRetirementSavings';
  /**
   * The financial profile of the current user, provided on this type to provide
   * access to the user's retirement assumptions on the financial profile, only
   * when an envelope has a retirement savings target.
   */
  financialProfile: FinancialProfile;
  /** The ID for the target. */
  id: Scalars['ID']['output'];
  /** The amount the user has specified that they would like to have available to spend annually after retiring. */
  monthlySpendingAmount?: Maybe<Scalars['Cents']['output']>;
};

/** A target measuring the user's progress in drawing down their retirement savings. */
export type TargetRetirementSpending = Target & {
  __typename: 'TargetRetirementSpending';
  /** The ID for the target. */
  id: Scalars['ID']['output'];
  /** The age at which the user expects to no longer need retirement spending. */
  lifeExpectancyAge: Scalars['Int']['output'];
  /**
   * The number of years remaining between the user's current age and their life
   * expectancy age, representinghow many more years the user's retirement savings needs to last.
   */
  yearsRemaining: Scalars['Int']['output'];
};

/** Input for creating a new account to associate with a Tax Coordinated Portfolio. */
export type TaxCoordinatedAccountCreationInput = {
  /** The legal account type (taxation or ownership) for the new account. */
  accountType: LegalAccountTypeInput;
};

/** An account option for tax-coordination setup */
export type TaxCoordinationAccountOption = {
  __typename: 'TaxCoordinationAccountOption';
  /** The underlying envelope account */
  envelopeAccount: CashAccount | CheckingAccount | DirectTradingAccount | ExternalAccountEnvelopeAssociation | Five29Account | ManagedAccount;
  /** The id of the tax coordination account option */
  id: Scalars['ID']['output'];
  /** Whether the account has a long-term investment horizon */
  isLongTermHorizon: Scalars['Boolean']['output'];
  /** Portfolio details for REST endpoints. Returns nil for Flexpo (self-directed) portfolios. */
  legacyPortfolioDetails?: Maybe<LegacyPortfolioDetails>;
};

/**
 * The user's tax filing status. See documentation by the IRS for more information:
 * https://apps.irs.gov/app/understandingTaxes/teacher/hows_mod05.jsp
 */
export enum TaxFilingStatus {
  /** Head of household */
  HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
  /** Married filing jointly */
  MarriedFilingJointly = 'MARRIED_FILING_JOINTLY',
  /** Married filing separately */
  MarriedFilingSeparately = 'MARRIED_FILING_SEPARATELY',
  /** Married filing separately living apart */
  MarriedFilingSeparatelyLivingApart = 'MARRIED_FILING_SEPARATELY_LIVING_APART',
  /** Qualifying surviving spouse */
  QualifyingSurvivingSpouse = 'QUALIFYING_SURVIVING_SPOUSE',
  /** Single */
  Single = 'SINGLE'
}

/** Estimated tax impact for a trade */
export type TaxImpact = {
  __typename: 'TaxImpact';
  /** Server driven copy for a Tax Impact preview */
  copy: TaxImpactCopy;
  /** Whether accounts have tax lots with unknown or missing basis */
  hasNonCoveredTaxLots: Scalars['Boolean']['output'];
  /** Whether there is a transaction pending */
  hasTransactionPending: Scalars['Boolean']['output'];
  /** Whether there is a gain (the net gain is greater than 0) */
  isGain: Scalars['Boolean']['output'];
  /** Whether the transaction would result in a net loss and washed amount */
  isLossWithWashed: Scalars['Boolean']['output'];
  /** Long term gain amount */
  longTermGain: Scalars['Cents']['output'];
  /** Long term loss amount */
  longTermLoss: Scalars['Cents']['output'];
  /** Long term permanently washed amount */
  longTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Long term washed amount */
  longTermWashed: Scalars['Cents']['output'];
  /** Whether the transaction might impact the taxpayers gains allowance */
  mayImpactGainsAllowance: Scalars['Boolean']['output'];
  /** Net estimated taxes from transaction */
  netEstimatedTaxes: Scalars['Cents']['output'];
  /** Net gain amount */
  netGain: Scalars['Cents']['output'];
  /** Net gain before wash sale rules */
  netGainBeforeWash: Scalars['Cents']['output'];
  /** Net long term amount */
  netLongTerm: Scalars['Cents']['output'];
  /** Net long term amount before wash sale rules */
  netLongTermBeforeWash: Scalars['Cents']['output'];
  /** Net short term amount */
  netShortTerm: Scalars['Cents']['output'];
  /** Net short term amount before wash sale rules */
  netShortTermBeforeWash: Scalars['Cents']['output'];
  /** Net losses from wash sale rules */
  netWashedLosses: Scalars['Cents']['output'];
  /** Short term gain amount */
  shortTermGain: Scalars['Cents']['output'];
  /** Short term loss amount */
  shortTermLoss: Scalars['Cents']['output'];
  /** Short term loss amount */
  shortTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Short term loss amount */
  shortTermWashed: Scalars['Cents']['output'];
};

/** Server driven copy for tax impact */
export type TaxImpactCopy = {
  __typename: 'TaxImpactCopy';
  /** Explanation regarding taxes from buy only trades due to wash sale rules */
  buyOnlyWashSaleExplanation: Scalars['HTML']['output'];
  /** Estimated tax impact banner copy */
  estimatedTaxImpactBanner: Scalars['String']['output'];
  /** Text for link on estimated tax impact banner to open details */
  estimatedTaxImpactBannerLinkText: Scalars['String']['output'];
  /** Disclosure text for estimated tax impact banner */
  estimatedTaxImpactDisclosure: Scalars['String']['output'];
  /** HTML description of tax impact estimation */
  estimatedTaxImpactInfoHtml: Scalars['HTML']['output'];
  /** General description of how we estimate tax impact */
  howWeEstimateTaxImpact: Scalars['String']['output'];
  /** Explanation of long term gains */
  longTermGainEstimation: Scalars['String']['output'];
  /** Explanation of how pending transactions impacted tax impact calculation */
  pendingExplanation: Scalars['String']['output'];
  /** Explanation of short term gains */
  shortTermGainEstimation: Scalars['String']['output'];
  /** Explanation of tax-minimization algorithm */
  taxMinExplanation: Scalars['String']['output'];
  /** Explanation of wash sale rules */
  washSaleExplanation: Scalars['String']['output'];
};

/** A tax year. */
export type TaxYear = {
  __typename: 'TaxYear';
  /** Tax year end date. */
  endsAt: Scalars['Date']['output'];
  /** 401(k) contribution limit for the tax year. */
  fourOhOneKContributionLimit: Scalars['Cents']['output'];
  /** A unique identifier for the tax year. */
  id: Scalars['ID']['output'];
  /** IRA contribution limit for the tax year. */
  iraContributionLimit: Scalars['Cents']['output'];
  /** Indicate if 401(k) contributions can be made for the tax year. */
  isEligibleFor401kContributions: Scalars['Boolean']['output'];
  /** Indicate if employer contributions can be made for the tax year. */
  isEligibleForEmployerContributions: Scalars['Boolean']['output'];
  /** 401(k) contribution catch up eligbility for the tax year. */
  isEligibleForFourOhOneKContributionCatchUp: Scalars['Boolean']['output'];
  /** IRA contribution catch up eligbility for the tax year. */
  isEligibleForIraContributionCatchUp: Scalars['Boolean']['output'];
  /** Indicate if IRA contributions can be made for the tax year. */
  isEligibleForIraContributions: Scalars['Boolean']['output'];
  /** Tax year start date. */
  startsAt: Scalars['Date']['output'];
  /** The tax year. */
  year: Scalars['Int']['output'];
};

/** Eligibility status for a contribution */
export enum TaxYearContributionTypeEligibilityStatus {
  /** The contribution is eligible */
  Eligible = 'ELIGIBLE',
  /** The contributor has high income */
  HighIncome = 'HIGH_INCOME',
  /** The contributor has maxed out their contributions */
  MaxedOut = 'MAXED_OUT',
  /** Other eligibility status */
  Other = 'OTHER',
  /** The contributor has zero income */
  ZeroIncome = 'ZERO_INCOME'
}

/** The type of tax identification number (SSN or EIN) */
export enum TaxpayerIdentificationNumberType {
  /** Employer Identification Number */
  Ein = 'EIN',
  /** Social Security Number */
  Ssn = 'SSN'
}

/** The required terms and agreements needed for a user to open an account */
export type TermsAndAgreements = {
  __typename: 'TermsAndAgreements';
  /** The body provided terms for that legal account. */
  terms: Scalars['HTML']['output'];
  /** Title of the Terms and Agreements */
  title: Scalars['String']['output'];
};

/** The inputs used to filter transactional activity. */
export type TermsAndAgreementsFilterInput = {
  /** The terms and agreements types to filter by. */
  termsAndAgreementsOptions: Array<TermsAndAgreementsOption>;
};

/** The type of terms and agreements available */
export enum TermsAndAgreementsOption {
  /** Direct trading */
  DirectTrading = 'DIRECT_TRADING',
  /** Securities lending */
  SecuritiesLending = 'SECURITIES_LENDING'
}

/** An external account connected by someone other than the current user. */
export type TheirExternalAccount = SomebodysExternalAccount & {
  __typename: 'TheirExternalAccount';
  /** The redacted account number for the given External Account. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** The account type display name for the given External Account. */
  accountType: Scalars['String']['output'];
  /** A description for the account, including account type and redacted account number. */
  accountTypeAndRedactedAccountNumber: Scalars['String']['output'];
  /** The current account balance for this External Account. */
  balance: Scalars['Cents']['output'];
  /** The envelope that this external account is associated with. */
  envelope?: Maybe<Envelope>;
  /** The goal that this external account is associated with. */
  goal?: Maybe<Goal>;
  /** Indicates that a rollover process has started for funds transfer into a Betterment account. */
  hasPendingRollover: Scalars['Boolean']['output'];
  /** The icon for the account. */
  icon: ThemedAsset;
  /** The unique ID for the TheirExternalAccount. */
  id: Scalars['ID']['output'];
  /** The name of the institution that holds the account. */
  institutionName: Scalars['String']['output'];
  /**
   * The overarching investment type that best describes the account. Can be
   * `diversified` to represent complex accounts with multiple or complex financial instruments.
   */
  investmentType?: Maybe<Scalars['String']['output']>;
  /** Is this External Account manually synchronized? */
  isManual: Scalars['Boolean']['output'];
  /** Whether the account is visible in aggregation views and data. */
  isVisible: Scalars['Boolean']['output'];
  /** A description of when the account was last updated. */
  lastUpdatedAtDisplay?: Maybe<Scalars['String']['output']>;
  /** Non-dismissable information displayed to users. */
  messages: Array<Message>;
  /** The name for the account that comes from plaid or entered by the user during manual connection. */
  name: Scalars['String']['output'];
  /** The owner of the account. This is not always the same as the connector of the account. */
  ownerName: Scalars['String']['output'];
  /**
   * The subtype of the external account that encapsulates more specific financial
   * data that varies depending on the type of account.
   */
  subtype: ExternalAccountSubtypeBasic | ExternalAccountSubtypeEmployerSponsored | ExternalAccountSubtypeIra;
};


/** An external account connected by someone other than the current user. */
export type TheirExternalAccountMessagesArgs = {
  location: Scalars['MessageLocation']['input'];
};

/** A sub account belonging to a user other than the current user. */
export type TheirLegalSubAccount = TransferableAccount & {
  __typename: 'TheirLegalSubAccount';
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** A unique ID for the given sub account. */
  id: Scalars['ID']['output'];
  /** The name of the sub account. */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** A set of assets for each supported theme. */
export type ThemedAsset = {
  __typename: 'ThemedAsset';
  /** A url for an asset to be displayed in dark mode. */
  dark: Scalars['URL']['output'];
  /** An id used to identify the asset. */
  id: Scalars['ID']['output'];
  /** A url for an asset to be displayed in light mode. */
  light: Scalars['URL']['output'];
};

/** The identifier assigned to a listed security, also known as a 'stock symbol' */
export type Ticker = {
  __typename: 'Ticker';
  expenseRatio: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The symbol of the ticker */
  symbol: Scalars['String']['output'];
  tlhPriority: TlhPriority;
  url: Scalars['String']['output'];
};

/** The method for applying tiered rates */
export enum TieredFeeCalculationMethod {
  /** Tiered billing plan rates will be applied at the current applicable tier, without regard to lower tiers */
  Cliff = 'CLIFF',
  /** Tiered billing plan rates will be applied progressively across tiers */
  Progressive = 'PROGRESSIVE'
}

/** The time-weighted rate of return for an investment or set of investments */
export type TimeWeightedRateOfReturn = {
  __typename: 'TimeWeightedRateOfReturn';
  /** The annualized rate of return */
  annualized?: Maybe<Scalars['Percent']['output']>;
  /** The rate of return for the whole period */
  cumulative?: Maybe<Scalars['Percent']['output']>;
};

/** TLH Priority for ticker */
export enum TlhPriority {
  /** Primary Priority */
  Primary = 'PRIMARY',
  /** Secondary Priority */
  Secondary = 'SECONDARY',
  /** Tertiary Priority */
  Tertiary = 'TERTIARY'
}

/** An option to initiate a transaction. */
export type TransactionOption = {
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** The result of creating a deposit, withdrawal, or transfer request. */
export type TransactionRequest = {
  __typename: 'TransactionRequest';
  /** The estimated completion date of a transaction. */
  estimatedCompletionOn?: Maybe<Scalars['Date']['output']>;
  /** Metadata for the option to create a transaction memo. */
  memoCreationOption?: Maybe<MemoCreationOption>;
  /**
   * Guidance for IRA or taxable investing or IRA accounts that do not have a
   * recurring deposit configured.This field will return null if the guidance is
   * not applicable to a user based on their account configuration
   */
  transactionSuccessGuidance?: Maybe<TransactionSuccessGuidance>;
};

/** Input object representing the amount for a transaction */
export type TransactionRequestAmountInput =
  /** The amount, in cents, of the transaction */
  { amount: Scalars['Int']['input']; fullTransfer?: never; }
  |  /** A boolean representing whether the transaction is a full transfer */
  { amount?: never; fullTransfer: Scalars['Boolean']['input']; };

/** Guidance for IRA or taxable investing accounts that do not have a recurring deposit configured. */
export type TransactionSuccessGuidance = {
  __typename: 'TransactionSuccessGuidance';
  /** A detailed description of the transaction success guidance. */
  detailedDescription: Scalars['String']['output'];
  /** An HTML snippet containing the full disclosure details. */
  fullDisclosureDetailsHtml: Scalars['String']['output'];
  /** The headline for the full disclosure details. */
  fullDisclosureHeadline: Scalars['String']['output'];
  /** A checklist of items to track progress in the transaction. */
  progressChecklist: Array<ProgressChecklist>;
  /** A short description of the progress made in the transaction. */
  progressShortDescription: Scalars['String']['output'];
  /** A short description of the transaction success guidance. */
  shortDescription: Scalars['String']['output'];
  /** A short HTML snippet providing disclosure information. */
  shortDisclosureHtml: Scalars['String']['output'];
  /** An HTML snippet providing additional supporting disclosure information. */
  supportingDisclosureHtml: Scalars['String']['output'];
};

/** The option to transfer between accounts. */
export type TransferOption = TransactionOption & {
  __typename: 'TransferOption';
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /**
   * The type of OmniTransfer transaction option presented to a user. Marked as
   * legacy to indicate that future development in the `TransferOption` type and
   * the OmniTransfer flow should be done in a way that's agnostic to differences
   * between transfer types.
   */
  legacyTransferType: LegacyTransferType;
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};

/** An account compatible for use for our main money movement transactions. */
export type TransferableAccount = {
  /** The name describing the account. */
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique id for the account. */
  id: Scalars['ID']['output'];
  /** The displayable name of the account. */
  name: Scalars['String']['output'];
  /** The name the user inputted describing the type of account. */
  nameOverride?: Maybe<Scalars['String']['output']>;
  /** The source account options for transfers into this account. */
  transferSourceAccountOptions: Array<TransferableAccountOption>;
  /** Instructions for initiating a wire transfer into this account. */
  wireTransferInstructions?: Maybe<WireTransferInstructions>;
};

/** An account that can be used as a source or destination for a transfer. */
export type TransferableAccountOption = {
  __typename: 'TransferableAccountOption';
  /** The account that can be used for the transfer. */
  account: BankAccount | CashAccount | CheckingAccount | CheckingExternalAccount | DirectTradingAccount | Five29Account | ManagedSubAccount | TheirLegalSubAccount;
  /** Message with additional details about the option. */
  detail?: Maybe<Message>;
  /** The status of the account option. */
  status: Status;
};

/** A trust */
export type Trust = {
  __typename: 'Trust';
  /** The id of the legal account holding the trust */
  id: Scalars['ID']['output'];
  /** The name of the trust */
  name: Scalars['String']['output'];
};

/** Non-id attributes for trust details */
export type TrustDetailsInput = {
  /** Address for new trust */
  address: PostalAddressInput;
  /** Date of establishment for new trust */
  dateOfEstablishment: Scalars['Date']['input'];
  /** EIN or SSN for new trust */
  einOrSsn: Scalars['TIN']['input'];
  /** Legal name for new trust */
  legalName: Scalars['String']['input'];
  /** Nickname for new trust */
  nickname: Scalars['String']['input'];
  /** State of organization for new trust */
  stateOfOrganization: Scalars['String']['input'];
  /** Taxpayer identification number type of trust */
  taxpayerIdentificationNumberType: TaxpayerIdentificationNumberType;
};

/** Input for an existing or new trust */
export type TrustInput =
  /** ID for existing trust account */
  { existingTrustId: Scalars['ID']['input']; newTrustDetails?: never; }
  |  /** Trust details for new trust account */
  { existingTrustId?: never; newTrustDetails: TrustDetailsInput; };

/** A trust account ownership option */
export type TrustOwnershipOption = AccountOwnershipOption & {
  __typename: 'TrustOwnershipOption';
  /** The description of the option */
  description: Scalars['String']['output'];
  /** All trusts the current user has opened */
  existingTrusts: Array<Trust>;
  /** The id of the option */
  id: Scalars['ID']['output'];
  /** The name of the option */
  name: Scalars['String']['output'];
  /** The ownership type of the option */
  ownershipType: LegalAccountOwnershipType;
};

/** A type intended to describe a trusted contact for a user */
export type TrustedContact = {
  __typename: 'TrustedContact';
  /** The email of the trusted contact. */
  email: Scalars['String']['output'];
  /** The first name of the trusted contact. */
  firstName: Scalars['String']['output'];
  /** The last name of the trusted contact. */
  lastName: Scalars['String']['output'];
  /** The phone number of the trusted contact. */
  phoneNumber: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateAccountNameMutation */
export type UpdateAccountNameMutationInput = {
  /** The ID of the account to update */
  accountId: Scalars['ID']['input'];
  /**
   * The custom name for the account. Helps users differentiate between multiple accounts.
   * Set to null or empty string to clear the custom name and use the default account name.
   */
  nameOverride?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAccountNameMutation. */
export type UpdateAccountNameMutationPayload = {
  __typename: 'UpdateAccountNameMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateAccountNameMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateAccountNameMutation execution as type EnvelopeAccount. */
  result?: Maybe<CashAccount | CheckingAccount | DirectTradingAccount | ExternalAccountEnvelopeAssociation | Five29Account | ManagedAccount>;
};

/** Autogenerated input type of UpdateAdvisorNetworkIntentMutation */
export type UpdateAdvisorNetworkIntentMutationInput = {
  /** The status to update the advisor network intent to */
  status: AdvisorNetworkIntentStatus;
};

/** Autogenerated return type of UpdateAdvisorNetworkIntentMutation. */
export type UpdateAdvisorNetworkIntentMutationPayload = {
  __typename: 'UpdateAdvisorNetworkIntentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateAdvisorNetworkIntentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateAdvisorNetworkIntentMutation execution as type AdvisorNetworkIntent. */
  result?: Maybe<AdvisorNetworkIntent>;
};

/** Autogenerated input type of UpdateCheckingBeneficiaryMutation */
export type UpdateCheckingBeneficiaryMutationInput = {
  /** The new beneficiary for the checking customer */
  beneficiary: CheckingBeneficiaryInput;
};

/** Autogenerated return type of UpdateCheckingBeneficiaryMutation. */
export type UpdateCheckingBeneficiaryMutationPayload = {
  __typename: 'UpdateCheckingBeneficiaryMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateCheckingBeneficiaryMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateCheckingBeneficiaryMutation execution as type CheckingCustomerResult. */
  result?: Maybe<CheckingCustomerResult>;
};

/** Autogenerated input type of UpdateEnvelopeOrdersMutation */
export type UpdateEnvelopeOrdersMutationInput = {
  /** Array of envelope IDs and their corresponding order positions */
  envelopes: Array<EnvelopeOrderInput>;
};

/** Autogenerated return type of UpdateEnvelopeOrdersMutation. */
export type UpdateEnvelopeOrdersMutationPayload = {
  __typename: 'UpdateEnvelopeOrdersMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateEnvelopeOrdersMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateEnvelopeOrdersMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** Autogenerated input type of UpdateExternalAccountVisibilityMutation */
export type UpdateExternalAccountVisibilityMutationInput = {
  /** The ExternalAccount to update. */
  id: Scalars['ID']['input'];
  /** Whether the account should be visible */
  isVisible: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateExternalAccountVisibilityMutation. */
export type UpdateExternalAccountVisibilityMutationPayload = {
  __typename: 'UpdateExternalAccountVisibilityMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateExternalAccountVisibilityMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateExternalAccountVisibilityMutation execution as type ExternalAccount. */
  result?: Maybe<ExternalAccount>;
};

/** Autogenerated input type of UpdateFinancialProfileRetirementAssumptionsMutation */
export type UpdateFinancialProfileRetirementAssumptionsMutationInput = {
  /** The user's expected above-the-line deductions on their income before retiring. */
  aboveTheLineDeductions: Scalars['Cents']['input'];
  /** The user's adjusted gross income. */
  adjustedGrossIncome: Scalars['Cents']['input'];
  /** The expected annual growth rate of the user's salary after inflation. */
  expectedAnnualSalaryGrowthPercent: Scalars['Percent']['input'];
  /** The user's expected rate of inflation. */
  expectedInflationPercent: Scalars['Percent']['input'];
  /** The user's expected payout percentage for social security. */
  expectedSocialSecurityPercent: Scalars['Percent']['input'];
  /** The user's expected itemized deductions. */
  itemizedDeductions: Scalars['Cents']['input'];
  /** The user's expected life expectancy. */
  lifeExpectancyAge: Scalars['Int']['input'];
  /** The user's number of dependents. */
  numberOfDependents: Scalars['Int']['input'];
  /** The user's expected amount of other retirement income. */
  otherRetirementIncome: Scalars['Cents']['input'];
  /** The user's expected social security start age. */
  socialSecurityStartAge: Scalars['Int']['input'];
  /** The user's expected social security yearly benefit. */
  socialSecurityYearlyBenefit: Scalars['Cents']['input'];
  /** The user's expected spouse's life expectancy. */
  spouseLifeExpectancyAge?: InputMaybe<Scalars['Int']['input']>;
  /** The user's expected spouse's social security start age. */
  spouseSocialSecurityStartAge?: InputMaybe<Scalars['Int']['input']>;
  /** The user's expected spouse's social security yearly benefit. */
  spouseSocialSecurityYearlyBenefit?: InputMaybe<Scalars['Cents']['input']>;
};

/** Autogenerated return type of UpdateFinancialProfileRetirementAssumptionsMutation. */
export type UpdateFinancialProfileRetirementAssumptionsMutationPayload = {
  __typename: 'UpdateFinancialProfileRetirementAssumptionsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateFinancialProfileRetirementAssumptionsMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateFinancialProfileRetirementAssumptionsMutation execution as type FinancialProfile. */
  result?: Maybe<FinancialProfile>;
};

/** Autogenerated input type of UpdateLegalAccountBeneficiariesMutation */
export type UpdateLegalAccountBeneficiariesMutationInput = {
  /** The new contingent beneficiaries for the account. */
  contingentBeneficiaries: Array<UpdateLegalAccountBeneficiaryInput>;
  /** The id of the legal account to update. */
  legalAccountId: Scalars['ID']['input'];
  /** The new primary beneficiaries for the account. */
  primaryBeneficiaries: Array<UpdateLegalAccountBeneficiaryInput>;
};

/** Autogenerated return type of UpdateLegalAccountBeneficiariesMutation. */
export type UpdateLegalAccountBeneficiariesMutationPayload = {
  __typename: 'UpdateLegalAccountBeneficiariesMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateLegalAccountBeneficiariesMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateLegalAccountBeneficiariesMutation execution as type LegalAccount. */
  result?: Maybe<LegalAccount>;
};

/** Input structure to set a Beneficiary on a Legal Account. */
export type UpdateLegalAccountBeneficiaryInput = {
  /** Beneficiary to set on a Legal Account. */
  beneficiary: LegalAccountBeneficiaryInput;
  /** Percentage of the account to be distributed to the beneficiary. */
  distributionShare: Scalars['Percent']['input'];
};

/** Input object for updating a draft purpose. Only one purpose type can be provided. */
export type UpdatePurposeInput =
  /** Update data for an emergency fund purpose */
  { emergencyFund: EmergencyFundUpdateInput; majorPurchase?: never; retirementGrowth?: never; retirementIncome?: never; }
  |  /** Update data for a major purchase purpose */
  { emergencyFund?: never; majorPurchase: MajorPurchaseUpdateInput; retirementGrowth?: never; retirementIncome?: never; }
  |  /** Update data for a retirement growth purpose */
  { emergencyFund?: never; majorPurchase?: never; retirementGrowth: RetirementGrowthUpdateInput; retirementIncome?: never; }
  |  /** Update data for a retirement income purpose */
  { emergencyFund?: never; majorPurchase?: never; retirementGrowth?: never; retirementIncome: RetirementIncomeUpdateInput; };

/** Autogenerated input type of UpdateSecuritiesLendingEnrollmentMutation */
export type UpdateSecuritiesLendingEnrollmentMutationInput = {
  /** The securities lending enrollment status to change to. */
  isEnrolled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateSecuritiesLendingEnrollmentMutation. */
export type UpdateSecuritiesLendingEnrollmentMutationPayload = {
  __typename: 'UpdateSecuritiesLendingEnrollmentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateSecuritiesLendingEnrollmentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateSecuritiesLendingEnrollmentMutation execution as type UserLevelSettings. */
  result?: Maybe<UserLevelSettings>;
};

/** Autogenerated input type of UpdateStudentLoanPaymentBenefitAttestationMutation */
export type UpdateStudentLoanPaymentBenefitAttestationMutationInput = {
  /**
   * The unique identifier for the attestation, a uuid from the database table
   * employment_employee_student_loan_payment_attestations
   */
  attestationId: Scalars['ID']['input'];
  /** The list of monetary amounts and entries ids that make up the users update */
  entries: Array<StudentLoanPaymentBenefitAttestationEntryInput>;
  /**
   * Optional input for updating the users estimated student loan payment config
   * along side the attestation mutation. We support this because the UI flow
   * encourages the user confirm their estimate will remain the same for next year,
   * and prompts them to change if it will not.
   */
  newEstimate?: InputMaybe<UpdateStudentLoanPaymentBenefitEstimateMutationInput>;
};

/** Autogenerated return type of UpdateStudentLoanPaymentBenefitAttestationMutation. */
export type UpdateStudentLoanPaymentBenefitAttestationMutationPayload = {
  __typename: 'UpdateStudentLoanPaymentBenefitAttestationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateStudentLoanPaymentBenefitAttestationMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * UpdateStudentLoanPaymentBenefitAttestationMutation execution as type
   * FourOhOneKStudentLoanMatchBenefit.
   */
  result?: Maybe<FourOhOneKStudentLoanMatchBenefit>;
};

/** Autogenerated input type of UpdateStudentLoanPaymentBenefitEstimateMutation */
export type UpdateStudentLoanPaymentBenefitEstimateMutationInput = {
  /** Amount the user estimates they'll pay in student loans over a given period. */
  amountCents: Scalars['Int']['input'];
  /** The period over which the user is estimating, either monthly or yearly. */
  period: StudentLoanPaymentEstimationPeriod;
};

/** Autogenerated return type of UpdateStudentLoanPaymentBenefitEstimateMutation. */
export type UpdateStudentLoanPaymentBenefitEstimateMutationPayload = {
  __typename: 'UpdateStudentLoanPaymentBenefitEstimateMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateStudentLoanPaymentBenefitEstimateMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the UpdateStudentLoanPaymentBenefitEstimateMutation
   * execution as type FourOhOneKStudentLoanMatchBenefit.
   */
  result?: Maybe<FourOhOneKStudentLoanMatchBenefit>;
};

/** Autogenerated input type of UpdateTrustedContactMutation */
export type UpdateTrustedContactMutationInput = {
  /** The email address of the trusted contact. */
  email: Scalars['String']['input'];
  /** The first name of the trusted contact. */
  firstName: Scalars['String']['input'];
  /** The last name of the trusted contact. */
  lastName: Scalars['String']['input'];
  /** The phone number of the trusted contact. */
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTrustedContactMutation. */
export type UpdateTrustedContactMutationPayload = {
  __typename: 'UpdateTrustedContactMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateTrustedContactMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateTrustedContactMutation execution as type User. */
  result?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserInvestingExperienceMutation */
export type UpdateUserInvestingExperienceMutationInput = {
  /** Selected Investing Experience Level */
  investingExperienceLevel: InvestingExperienceLevel;
};

/** Autogenerated return type of UpdateUserInvestingExperienceMutation. */
export type UpdateUserInvestingExperienceMutationPayload = {
  __typename: 'UpdateUserInvestingExperienceMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateUserInvestingExperienceMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateUserInvestingExperienceMutation execution as type FinancialProfile. */
  result?: Maybe<FinancialProfile>;
};

/** Autogenerated input type of UpdateUserPostalAddressMutation */
export type UpdateUserPostalAddressMutationInput = {
  /** Input values for updating the User's Mailing Address. Only required when the User is a Checking Customer. */
  mailingAddress?: InputMaybe<PostalAddressInput>;
  /** Input values for updating the User's Residential Address. */
  residentialAddress: PostalAddressInput;
};

/** Autogenerated return type of UpdateUserPostalAddressMutation. */
export type UpdateUserPostalAddressMutationPayload = {
  __typename: 'UpdateUserPostalAddressMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateUserPostalAddressMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateUserPostalAddressMutation execution as type User. */
  result?: Maybe<User>;
};

/** Autogenerated input type of UpdateUserProfileMutation */
export type UpdateUserProfileMutationInput = {
  /** The user's annual pretax income. */
  annualPretaxIncome?: InputMaybe<Scalars['Cents']['input']>;
  /** The user's spouse information. */
  spouse?: InputMaybe<SpouseInput>;
  /** The user's tax filing status. */
  taxFilingStatus?: InputMaybe<TaxFilingStatus>;
};

/** Autogenerated return type of UpdateUserProfileMutation. */
export type UpdateUserProfileMutationPayload = {
  __typename: 'UpdateUserProfileMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateUserProfileMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateUserProfileMutation execution as type FinancialProfile. */
  result?: Maybe<FinancialProfile>;
};

/** Autogenerated input type of UploadAddressChangeDocumentMutation */
export type UploadAddressChangeDocumentMutationInput = {
  /** document content */
  documentContent: Scalars['String']['input'];
  /** document name. */
  documentName: Scalars['String']['input'];
};

/** Autogenerated return type of UploadAddressChangeDocumentMutation. */
export type UploadAddressChangeDocumentMutationPayload = {
  __typename: 'UploadAddressChangeDocumentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UploadAddressChangeDocumentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UploadAddressChangeDocumentMutation execution as type Query. */
  result?: Maybe<Query>;
};

/** A type intended to describe the currently-logged-in user */
export type User = {
  __typename: 'User';
  /** The user's current Advisor Network intent */
  advisorNetworkIntent?: Maybe<AdvisorNetworkIntent>;
  /** The first name used to address this user. */
  commonFirstName: Scalars['String']['output'];
  /** The user's current age, derived from their date of birth. */
  currentAge: Scalars['Int']['output'];
  /** The user's email address. */
  email: Scalars['String']['output'];
  /** Does the customer have a bond-only product? */
  hasBondsOnlyProduct: Scalars['Boolean']['output'];
  /** Whether this user has exactly one deposit eligible goal. */
  hasOneDepositEligibleAccount: Scalars['Boolean']['output'];
  /** A unique identifier for the User. */
  id: Scalars['ID']['output'];
  /** Whether this user can be prompted for mobile app reviews. */
  isAppReviewPromptEligible: Scalars['Boolean']['output'];
  /** Whether this user is currently a checking user. */
  isCheckingCustomer: Scalars['Boolean']['output'];
  /**
   * Whether this user is required to go through doc verification.
   * @deprecated Use CheckingAccountCreationOption.requiresDocumentVerification instead
   */
  isCheckingDocumentVerificationRequired: Scalars['Boolean']['output'];
  /** Whether this user has a sub account eligible for deposit. */
  isDepositEligible: Scalars['Boolean']['output'];
  /** Whether this user needs to verify their email. */
  isEmailVerificationEligible: Scalars['Boolean']['output'];
  /** Whether this user is eligible to adopt their first product. */
  isFirstProductAdoptionEligible: Scalars['Boolean']['output'];
  /** Flag to signal that the mailing address is the same as the residential address. */
  isMailingSameAsResidentialAddress: Scalars['Boolean']['output'];
  /** Whether this user is required to complete profile setup. */
  isProfileSetupRequired: Scalars['Boolean']['output'];
  /** Whether this user is suspended. */
  isSuspended: Scalars['Boolean']['output'];
  /** The last name for this user. */
  lastName: Scalars['String']['output'];
  /** The ID for the user, as recognized by our legacy REST APIs. */
  legacyId: Scalars['ID']['output'];
  /** The user's legal first name. */
  legalFirstName: Scalars['String']['output'];
  /** Generic attributes for third-party tools to identify the segments the user belongs to. */
  logTags: Scalars['JSON']['output'];
  /** The identifier used in our logging systems to identify this user. */
  loggingIdentifier: Scalars['ID']['output'];
  /** The mailing postal address for this user, if one exists. */
  mailingAddress?: Maybe<PostalAddress>;
  /** The user's phone number. */
  phoneNumber: Scalars['String']['output'];
  /** Flag that indicates the given User is allowed to change Goal allocations. */
  portfolioStrategySelectionAvailable: Scalars['Boolean']['output'];
  /**
   * The ability for a user to onboard into Betterment Premium.
   * @deprecated Use Query#premiumOnboardingOption instead.
   */
  premiumOnboardingOption?: Maybe<PremiumOnboardingOption>;
  /** The residential postal address for this user. */
  residentialAddress?: Maybe<PostalAddress>;
  /** The identifier used in TestTrack to identify this user. */
  testTrackIdentifier: Scalars['ID']['output'];
  /** The User's Trusted Contact. */
  trustedContact?: Maybe<TrustedContact>;
};


/** A type intended to describe the currently-logged-in user */
export type UserPhoneNumberArgs = {
  isRedacted: Scalars['Boolean']['input'];
};

/** User level settings for the current user */
export type UserLevelSettings = {
  __typename: 'UserLevelSettings';
  /** Whether the User has an account eligible for tax-loss harvesting. */
  isTaxLossHarvestingEligible: Scalars['Boolean']['output'];
  /** Securities lending settings for the user */
  securityLending: SecuritiesLending;
};

/** Autogenerated input type of ValidateDirectTradingJointAccountSecondaryUserMutation */
export type ValidateDirectTradingJointAccountSecondaryUserMutationInput = {
  /** The secondary user details to validate. */
  secondaryUser: DirectTradingJointAccountSecondaryUserValidationInput;
};

/** Autogenerated return type of ValidateDirectTradingJointAccountSecondaryUserMutation. */
export type ValidateDirectTradingJointAccountSecondaryUserMutationPayload = {
  __typename: 'ValidateDirectTradingJointAccountSecondaryUserMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateDirectTradingJointAccountSecondaryUserMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateDirectTradingJointAccountSecondaryUserMutation execution as type Boolean. */
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ValidateDirectTradingTrustDetailsMutation */
export type ValidateDirectTradingTrustDetailsMutationInput = {
  /** The trust details to validate. */
  trustDetails: DirectTradingTrustDetailsValidationInput;
};

/** Autogenerated return type of ValidateDirectTradingTrustDetailsMutation. */
export type ValidateDirectTradingTrustDetailsMutationPayload = {
  __typename: 'ValidateDirectTradingTrustDetailsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateDirectTradingTrustDetailsMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateDirectTradingTrustDetailsMutation execution as type Boolean. */
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** The result of validating a custody single security order request */
export type ValidateFinancialSecurityOrderRequest = {
  __typename: 'ValidateFinancialSecurityOrderRequest';
  /** Estimated timing when the trade request will complete */
  estimatedTradeTiming: EstimatedTradeTiming;
  /** Whether there is a window for the order to be canceled or not */
  orderWillBeCancelable: Scalars['Boolean']['output'];
  /** Whether the order is a sale over 90% of the position in the account */
  saleOver90Percent: Scalars['Boolean']['output'];
  /** Estimated tax impact from the trade */
  taxImpactPreview?: Maybe<TaxImpact>;
};

/** Autogenerated input type of ValidateFinancialSecurityOrderRequestMutation */
export type ValidateFinancialSecurityOrderRequestMutationInput = {
  /** The account within which to perform the trade */
  accountId: FinancialSecurityOrderRequestAccountIdInput;
  /** Determines if the order is a buy or sell */
  direction: FinancialSecurityOrderRequestDirection;
  /** Custody's security id for the security to buy or sell */
  financialSecurityId: Scalars['ID']['input'];
  /** Indicates the customer intended to sell all of their existing shares of the chosen security */
  sellAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provides a dollar amount or share value for the order based on customer inputs */
  value: FinancialSecurityOrderRequestValueInput;
};

/** Autogenerated return type of ValidateFinancialSecurityOrderRequestMutation. */
export type ValidateFinancialSecurityOrderRequestMutationPayload = {
  __typename: 'ValidateFinancialSecurityOrderRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateFinancialSecurityOrderRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the ValidateFinancialSecurityOrderRequestMutation
   * execution as type ValidateFinancialSecurityOrderRequest.
   */
  result?: Maybe<ValidateFinancialSecurityOrderRequest>;
};

/** Autogenerated input type of ValidateLegalAccountBeneficiaryMutation */
export type ValidateLegalAccountBeneficiaryMutationInput = {
  /** The legal account beneficiary to validate. */
  beneficiary: LegalAccountBeneficiaryInput;
  /** The id of the legal account to validate its beneficiary. */
  legalAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of ValidateLegalAccountBeneficiaryMutation. */
export type ValidateLegalAccountBeneficiaryMutationPayload = {
  __typename: 'ValidateLegalAccountBeneficiaryMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateLegalAccountBeneficiaryMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateLegalAccountBeneficiaryMutation execution as type Boolean. */
  result?: Maybe<Scalars['Boolean']['output']>;
};

/** Instructions for initiating a wire transfer. */
export type WireTransferInstructions = {
  __typename: 'WireTransferInstructions';
  /** The address for the wire transfer */
  address: PostalAddress;
  /** The id for the wire transfer instructions. */
  id: Scalars['ID']['output'];
  /** The line items for the instructions */
  items: Array<WireTransferInstructionsItem>;
};

/** A line item for the transfer instructions */
export type WireTransferInstructionsItem = {
  __typename: 'WireTransferInstructionsItem';
  /** The label for the line item */
  label: Scalars['String']['output'];
  /** The value for the line item */
  value: Scalars['String']['output'];
};

/** The option to receive wire transfer instructions for an account. */
export type WireTransferOption = TransactionOption & {
  __typename: 'WireTransferOption';
  /** The accounts eligible for wire transfers. */
  accountOptions: Array<SubAccount>;
  /** Unique identifier for the given option. */
  id: Scalars['ID']['output'];
  /** The instructions for how to complete a wire transfer into an account. */
  instructions: WireTransferInstructions;
  /** If present, reason for why the option is unavailable at the moment. */
  transactionUnavailableMessage?: Maybe<Message>;
};


/** The option to receive wire transfer instructions for an account. */
export type WireTransferOptionInstructionsArgs = {
  accountId: Scalars['ID']['input'];
};

/** The asset allocation for a yield based model portfolio option */
export type YieldBasedAssetAllocation = AssetAllocation & {
  __typename: 'YieldBasedAssetAllocation';
  /** The after tax yield percent for the asset allocation */
  afterTaxYield: Scalars['Percent']['output'];
  /** The breakdown of asset type weights for the asset allocation */
  assetTypeWeights: Array<AssetTypeWeight>;
  /** The diversification of the asset allocation */
  diversification: AssetAllocationDiversification;
  /** The id of the asset allocation. Maps to the model_portfolio_risk_level ID */
  id: Scalars['ID']['output'];
  /** The name of the yield asset allocation */
  name: Scalars['String']['output'];
  /** The risk of the asset allocation */
  risk: AssetAllocationRisk;
  /** The set of all security groups holdings/allocations for this asset allocation. */
  securityGroups: Array<SecurityGroup>;
  /**
   * The weighted securities contained in the asset allocation
   * @deprecated Use securityGroupHoldings instead.
   */
  securityWeights: Array<LegacyWeightedSecurity>;
  /** The yield percent for the asset allocation */
  yield: Scalars['Percent']['output'];
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountOwnershipOption": [
      "IndividualOwnershipOption",
      "JointOwnershipOption",
      "TrustOwnershipOption"
    ],
    "AccountPurposeOption": [
      "ExpensesBasedPurposeOption",
      "GeneralPurposeOption",
      "TargetBasedPurposeOption"
    ],
    "ActivityItem": [
      "ActivityItemAllocationChange",
      "ActivityItemDeposit",
      "ActivityItemDividendGroup",
      "ActivityItemFee",
      "ActivityItemOrder",
      "ActivityItemOther",
      "ActivityItemRollover",
      "ActivityItemTradeGroup",
      "ActivityItemTransferGroup",
      "ActivityItemWithdrawal"
    ],
    "Advice": [
      "CryptoAdvice"
    ],
    "Advisor": [
      "InstitutionalAdvisor",
      "PremiumAdvisor"
    ],
    "AssetAllocation": [
      "CustomizableAssetAllocation",
      "RiskBasedAssetAllocation",
      "YieldBasedAssetAllocation"
    ],
    "CheckingCustomerResult": [
      "CheckingCustomer",
      "RecordNotFoundResult",
      "RecordUnavailableResult"
    ],
    "ClientEnvelopeApprovalAdvisorFee": [
      "ClientEnvelopeApprovalRateBasedFee",
      "ClientEnvelopeApprovalTieredFee"
    ],
    "DocumentCategoryOrCategoryGroup": [
      "DocumentCategory",
      "DocumentCategoryGroup"
    ],
    "EditableEnvelope": [
      "DraftEnvelope"
    ],
    "EditablePurpose": [
      "DraftPurposeEmergencyFund",
      "DraftPurposeMajorPurchase",
      "DraftPurposeRetirementGrowth",
      "DraftPurposeRetirementIncome"
    ],
    "EditablePurposeEmergencyFund": [
      "DraftPurposeEmergencyFund"
    ],
    "EditablePurposeMajorPurchase": [
      "DraftPurposeMajorPurchase"
    ],
    "EditablePurposeRetirementGrowth": [
      "DraftPurposeRetirementGrowth"
    ],
    "EditablePurposeRetirementIncome": [
      "DraftPurposeRetirementIncome"
    ],
    "EnvelopeAccount": [
      "CashAccount",
      "CheckingAccount",
      "DirectTradingAccount",
      "ExternalAccountEnvelopeAssociation",
      "Five29Account",
      "ManagedAccount"
    ],
    "EstimatedTradeTiming": [
      "EstimatedTradeDate",
      "EstimatedTradeTimeRange"
    ],
    "ExternalAccountSubtype": [
      "ExternalAccountSubtypeBasic",
      "ExternalAccountSubtypeEmployerSponsored",
      "ExternalAccountSubtypeIra"
    ],
    "FinancialSecurity": [
      "FinancialSecurityFund",
      "FinancialSecurityStock"
    ],
    "FinancialSecurityFundamentals": [
      "FinancialSecurityFundamentalsFund",
      "FinancialSecurityFundamentalsStock"
    ],
    "FinancialServiceOption": [
      "BettermentAdvisorNetworkOption",
      "BettermentPremiumOption"
    ],
    "Grant": [
      "IraContributionMatchGrant"
    ],
    "LegalSubAccount": [
      "CashAccount",
      "DirectTradingAccount",
      "Five29Account",
      "ManagedSubAccount"
    ],
    "ManagedPortfolio": [
      "RiskLevelBasedPortfolio",
      "SelfDirectedPortfolio"
    ],
    "MessageCta": [
      "MessageCtaLink",
      "MessageCtaModal"
    ],
    "PayrollContributionConfigAccount": [
      "Five29Account",
      "ManagedSubAccount"
    ],
    "PayrollContributionConfigValue": [
      "PayrollContributionConfigValueAmount",
      "PayrollContributionConfigValuePercent"
    ],
    "PerformanceAccount": [
      "CashAccount",
      "DirectTradingAccount",
      "ManagedAccount"
    ],
    "Portfolio": [
      "CryptoPortfolio",
      "ExternallyAdvisedPlanPortfolio",
      "InvestmentPortfolio"
    ],
    "ProductOnboardingOption": [
      "CheckingAccountCreationOption",
      "FinancialCoachingOnboardingOption",
      "FiveTwoNineGoalCreationOption",
      "GoalCreationOption",
      "PremiumOnboardingOption",
      "Solo401kOnboardingOption"
    ],
    "Purpose": [
      "PurposeEmergencyFund",
      "PurposeMajorPurchase",
      "PurposeRetirementGrowth",
      "PurposeRetirementIncome"
    ],
    "PurposeCreationOptionInterface": [
      "EmergencyFundPurposeCreationOption",
      "MajorPurchasePurposeCreationOption",
      "RetirementGrowthPurposeCreationOption",
      "RetirementIncomePurposeCreationOption"
    ],
    "RecurringTransactionFrequency": [
      "RecurringTransactionFrequencyAnnually",
      "RecurringTransactionFrequencyEveryOtherWeek",
      "RecurringTransactionFrequencyMonthly",
      "RecurringTransactionFrequencyTwiceAMonth",
      "RecurringTransactionFrequencyWeekly"
    ],
    "Security": [
      "SecurityFund",
      "SecurityStock"
    ],
    "SomebodysExternalAccount": [
      "ExternalAccount",
      "TheirExternalAccount"
    ],
    "Target": [
      "TargetAmountAndDate",
      "TargetMonthlyExpenses",
      "TargetRetirementSavings",
      "TargetRetirementSpending"
    ],
    "TransactionOption": [
      "CharitableDonationOption",
      "DeferralSettingsEditOption",
      "ExternalTransferOption",
      "ManageRecurringTransactionsOption",
      "RolloverOption",
      "RothIraConversionOption",
      "TransferOption",
      "WireTransferOption"
    ],
    "TransferableAccount": [
      "BankAccount",
      "CashAccount",
      "CheckingAccount",
      "CheckingExternalAccount",
      "DirectTradingAccount",
      "Five29Account",
      "ManagedSubAccount",
      "TheirLegalSubAccount"
    ]
  }
};
      export default result;
    


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  CheckingCustomerResult:
    | ( CheckingCustomer )
    | ( RecordNotFoundResult )
    | ( RecordUnavailableResult )
  ;
  ClientEnvelopeApprovalAdvisorFee:
    | ( ClientEnvelopeApprovalRateBasedFee )
    | ( ClientEnvelopeApprovalTieredFee )
  ;
  DocumentCategoryOrCategoryGroup:
    | ( DocumentCategory )
    | ( DocumentCategoryGroup )
  ;
  EstimatedTradeTiming:
    | ( EstimatedTradeDate )
    | ( EstimatedTradeTimeRange )
  ;
  PayrollContributionConfigValue:
    | ( PayrollContributionConfigValueAmount )
    | ( PayrollContributionConfigValuePercent )
  ;
  RecurringTransactionFrequency:
    | ( RecurringTransactionFrequencyAnnually )
    | ( RecurringTransactionFrequencyEveryOtherWeek )
    | ( RecurringTransactionFrequencyMonthly )
    | ( RecurringTransactionFrequencyTwiceAMonth )
    | ( RecurringTransactionFrequencyWeekly )
  ;
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  AccountOwnershipOption:
    | ( IndividualOwnershipOption )
    | ( JointOwnershipOption )
    | ( TrustOwnershipOption )
  ;
  AccountPurposeOption:
    | ( Omit<ExpensesBasedPurposeOption, 'icon' | 'recommendation'> & { icon: _RefType['ThemedAsset'], recommendation: _RefType['Message'] } )
    | ( Omit<GeneralPurposeOption, 'icon'> & { icon: _RefType['ThemedAsset'] } )
    | ( Omit<TargetBasedPurposeOption, 'icon'> & { icon: _RefType['ThemedAsset'] } )
  ;
  ActivityItem:
    | ( Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemDeposit, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount: _RefType['LegalSubAccount'], sourceAccount?: Maybe<_RefType['BankAccount']>, subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemDividendGroup, 'dividends' | 'subAccount'> & { dividends: Array<_RefType['ActivityItemDividend']>, subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemFee, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: _RefType['Security'], subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemOther, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemRollover, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<_RefType['ActivityItemTrade']>, sales: Array<_RefType['ActivityItemTrade']>, subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<_RefType['LegalSubAccount']>, sourceAccount?: Maybe<_RefType['LegalSubAccount']>, subAccount: _RefType['LegalSubAccount'], transferItems: Array<_RefType['ActivityItemTransfer']> } )
    | ( Omit<ActivityItemWithdrawal, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount?: Maybe<_RefType['BankAccount']>, sourceAccount: _RefType['LegalSubAccount'], subAccount: _RefType['LegalSubAccount'] } )
  ;
  Advice: ( CryptoAdvice );
  Advisor:
    | ( Omit<InstitutionalAdvisor, 'logo'> & { logo?: Maybe<_RefType['ThemedAsset']> } )
    | ( Omit<PremiumAdvisor, 'logo'> & { logo?: Maybe<_RefType['ThemedAsset']> } )
  ;
  AssetAllocation:
    | ( Omit<CustomizableAssetAllocation, 'securityGroups'> & { securityGroups: Array<_RefType['SecurityGroup']> } )
    | ( Omit<RiskBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<_RefType['SecurityGroup']> } )
    | ( Omit<YieldBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<_RefType['SecurityGroup']> } )
  ;
  EditableEnvelope: ( Omit<DraftEnvelope, 'editablePurpose'> & { editablePurpose?: Maybe<_RefType['EditablePurpose']> } );
  EditablePurpose:
    | ( DraftPurposeEmergencyFund )
    | ( DraftPurposeMajorPurchase )
    | ( DraftPurposeRetirementGrowth )
    | ( DraftPurposeRetirementIncome )
  ;
  EditablePurposeEmergencyFund: ( DraftPurposeEmergencyFund );
  EditablePurposeMajorPurchase: ( DraftPurposeMajorPurchase );
  EditablePurposeRetirementGrowth: ( DraftPurposeRetirementGrowth );
  EditablePurposeRetirementIncome: ( DraftPurposeRetirementIncome );
  EnvelopeAccount:
    | ( Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], performance: _RefType['Performance'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<CheckingAccount, 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], financialSecuritiesSearch: Array<_RefType['FinancialSecurity']>, financialSecurity: _RefType['FinancialSecurity'], icon: _RefType['ThemedAsset'], pendingOrders: Array<_RefType['ActivityItemOrder']>, performance: _RefType['Performance'], securityPosition?: Maybe<_RefType['DirectTradingSecurityPosition']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ExternalAccountEnvelopeAssociation, 'account' | 'envelope' | 'icon'> & { account: _RefType['SomebodysExternalAccount'], envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'] } )
    | ( Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<_RefType['Five29AccountConnection']>, activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ManagedAccount, 'activityConnection' | 'assetAllocation' | 'envelope' | 'icon' | 'messages' | 'minFeeWarning' | 'payrollContributionConfigs' | 'performance' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccounts' | 'transactionOptions'> & { activityConnection: _RefType['ActivityItemConnection'], assetAllocation: _RefType['AssetAllocation'], envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], messages: Array<_RefType['Message']>, minFeeWarning?: Maybe<_RefType['Message']>, payrollContributionConfigs: Array<_RefType['PayrollContributionConfig']>, performance: _RefType['Performance'], portfolio: _RefType['ManagedPortfolio'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, securityGroupPositions: Array<_RefType['SecurityGroupPosition']>, subAccounts: Array<_RefType['ManagedSubAccount']>, transactionOptions: Array<_RefType['TransactionOption']> } )
  ;
  ExternalAccountSubtype:
    | ( ExternalAccountSubtypeBasic )
    | ( ExternalAccountSubtypeEmployerSponsored )
    | ( ExternalAccountSubtypeIra )
  ;
  FinancialSecurity:
    | ( Omit<FinancialSecurityFund, 'fundamentals' | 'portfolio'> & { fundamentals: _RefType['FinancialSecurityFundamentals'], portfolio: _RefType['FinancialSecurityFundPortfolio'] } )
    | ( Omit<FinancialSecurityStock, 'companyProfile' | 'fundamentals'> & { companyProfile: _RefType['FinancialSecurityCompanyProfile'], fundamentals: _RefType['FinancialSecurityFundamentals'] } )
  ;
  FinancialSecurityFundamentals:
    | ( FinancialSecurityFundamentalsFund )
    | ( FinancialSecurityFundamentalsStock )
  ;
  FinancialServiceOption:
    | ( Omit<BettermentAdvisorNetworkOption, 'image'> & { image: _RefType['ThemedAsset'] } )
    | ( Omit<BettermentPremiumOption, 'image'> & { image: _RefType['ThemedAsset'] } )
  ;
  Grant: ( IraContributionMatchGrant );
  LegalSubAccount:
    | ( Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], performance: _RefType['Performance'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], financialSecuritiesSearch: Array<_RefType['FinancialSecurity']>, financialSecurity: _RefType['FinancialSecurity'], icon: _RefType['ThemedAsset'], pendingOrders: Array<_RefType['ActivityItemOrder']>, performance: _RefType['Performance'], securityPosition?: Maybe<_RefType['DirectTradingSecurityPosition']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<_RefType['Five29AccountConnection']>, activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ManagedSubAccount, 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'managedAccount' | 'transferSourceAccountOptions'> & { bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], managedAccount: _RefType['ManagedAccount'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
  ;
  ManagedPortfolio:
    | ( Omit<RiskLevelBasedPortfolio, 'riskLevel' | 'strategy'> & { riskLevel: _RefType['RiskLevel'], strategy: _RefType['PortfolioStrategy'] } )
    | ( Omit<SelfDirectedPortfolio, 'icon' | 'targetAllocation'> & { icon?: Maybe<_RefType['ThemedAsset']>, targetAllocation: Array<_RefType['SecurityGroup']> } )
  ;
  MessageCta:
    | ( MessageCtaLink )
    | ( MessageCtaModal )
  ;
  PayrollContributionConfigAccount:
    | ( Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<_RefType['Five29AccountConnection']>, activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ManagedSubAccount, 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'managedAccount' | 'transferSourceAccountOptions'> & { bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], managedAccount: _RefType['ManagedAccount'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
  ;
  PerformanceAccount:
    | ( Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], performance: _RefType['Performance'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], financialSecuritiesSearch: Array<_RefType['FinancialSecurity']>, financialSecurity: _RefType['FinancialSecurity'], icon: _RefType['ThemedAsset'], pendingOrders: Array<_RefType['ActivityItemOrder']>, performance: _RefType['Performance'], securityPosition?: Maybe<_RefType['DirectTradingSecurityPosition']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ManagedAccount, 'activityConnection' | 'assetAllocation' | 'envelope' | 'icon' | 'messages' | 'minFeeWarning' | 'payrollContributionConfigs' | 'performance' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccounts' | 'transactionOptions'> & { activityConnection: _RefType['ActivityItemConnection'], assetAllocation: _RefType['AssetAllocation'], envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], messages: Array<_RefType['Message']>, minFeeWarning?: Maybe<_RefType['Message']>, payrollContributionConfigs: Array<_RefType['PayrollContributionConfig']>, performance: _RefType['Performance'], portfolio: _RefType['ManagedPortfolio'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, securityGroupPositions: Array<_RefType['SecurityGroupPosition']>, subAccounts: Array<_RefType['ManagedSubAccount']>, transactionOptions: Array<_RefType['TransactionOption']> } )
  ;
  Portfolio:
    | ( Omit<CryptoPortfolio, 'strategy' | 'tokenIcons'> & { strategy: _RefType['PortfolioStrategy'], tokenIcons: Array<_RefType['ThemedAsset']> } )
    | ( Omit<ExternallyAdvisedPlanPortfolio, 'strategy'> & { strategy: _RefType['PortfolioStrategy'] } )
    | ( Omit<InvestmentPortfolio, 'icon' | 'strategy'> & { icon?: Maybe<_RefType['ThemedAsset']>, strategy: _RefType['PortfolioStrategy'] } )
  ;
  ProductOnboardingOption:
    | ( Omit<CheckingAccountCreationOption, 'icon' | 'image'> & { icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'] } )
    | ( Omit<FinancialCoachingOnboardingOption, 'icon' | 'image'> & { icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'] } )
    | ( Omit<FiveTwoNineGoalCreationOption, 'icon' | 'image'> & { icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'] } )
    | ( Omit<GoalCreationOption, 'accountOwnershipOption' | 'accountOwnershipOptions' | 'accountPurposeOption' | 'accountPurposeOptions' | 'draftEnvelopeAccount' | 'emergencyFundCoverage' | 'icon' | 'image' | 'modelPortfolioOption' | 'modelPortfolioOptions' | 'termsAndAgreements'> & { accountOwnershipOption: _RefType['AccountOwnershipOption'], accountOwnershipOptions: Array<_RefType['AccountOwnershipOption']>, accountPurposeOption: _RefType['AccountPurposeOption'], accountPurposeOptions: Array<_RefType['AccountPurposeOption']>, draftEnvelopeAccount?: Maybe<_RefType['DraftEnvelopeAccount']>, emergencyFundCoverage?: Maybe<_RefType['EmergencyFundCoverage']>, icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'], modelPortfolioOption: _RefType['ModelPortfolioOption'], modelPortfolioOptions: Array<_RefType['ModelPortfolioOption']>, termsAndAgreements: Array<_RefType['LegacyTermsAndAgreements']> } )
    | ( Omit<PremiumOnboardingOption, 'icon' | 'image'> & { icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'] } )
    | ( Omit<Solo401kOnboardingOption, 'icon' | 'image'> & { icon: _RefType['ThemedAsset'], image: _RefType['ThemedAsset'] } )
  ;
  Purpose:
    | ( Omit<PurposeEmergencyFund, 'envelope' | 'image' | 'target'> & { envelope: _RefType['Envelope'], image: _RefType['ThemedAsset'], target?: Maybe<_RefType['Target']> } )
    | ( Omit<PurposeMajorPurchase, 'envelope' | 'image' | 'target'> & { envelope: _RefType['Envelope'], image: _RefType['ThemedAsset'], target?: Maybe<_RefType['Target']> } )
    | ( Omit<PurposeRetirementGrowth, 'envelope' | 'image' | 'projection' | 'target'> & { envelope: _RefType['Envelope'], image: _RefType['ThemedAsset'], projection?: Maybe<_RefType['PurposeRetirementGrowthProjection']>, target?: Maybe<_RefType['Target']> } )
    | ( Omit<PurposeRetirementIncome, 'envelope' | 'image' | 'target'> & { envelope: _RefType['Envelope'], image: _RefType['ThemedAsset'], target?: Maybe<_RefType['Target']> } )
  ;
  PurposeCreationOptionInterface:
    | ( Omit<EmergencyFundPurposeCreationOption, 'emergencyFundCoverage' | 'purposeAsset' | 'recommendation'> & { emergencyFundCoverage: _RefType['EmergencyFundCoverage'], purposeAsset: _RefType['PurposeAsset'], recommendation: _RefType['Message'] } )
    | ( Omit<MajorPurchasePurposeCreationOption, 'purposeAsset'> & { purposeAsset: _RefType['PurposeAsset'] } )
    | ( Omit<RetirementGrowthPurposeCreationOption, 'purposeAsset' | 'recommendedMonthlySpending'> & { purposeAsset: _RefType['PurposeAsset'], recommendedMonthlySpending: _RefType['Message'] } )
    | ( Omit<RetirementIncomePurposeCreationOption, 'purposeAsset'> & { purposeAsset: _RefType['PurposeAsset'] } )
  ;
  Security:
    | ( SecurityFund )
    | ( SecurityStock )
  ;
  SomebodysExternalAccount:
    | ( Omit<ExternalAccount, 'envelope' | 'envelopeOptions' | 'goal' | 'icon' | 'messages' | 'subtype' | 'transactionOption'> & { envelope?: Maybe<_RefType['Envelope']>, envelopeOptions: Array<_RefType['Envelope']>, goal?: Maybe<_RefType['Goal']>, icon: _RefType['ThemedAsset'], messages: Array<_RefType['Message']>, subtype: _RefType['ExternalAccountSubtype'], transactionOption?: Maybe<_RefType['TransactionOption']> } )
    | ( Omit<TheirExternalAccount, 'envelope' | 'goal' | 'icon' | 'messages' | 'subtype'> & { envelope?: Maybe<_RefType['Envelope']>, goal?: Maybe<_RefType['Goal']>, icon: _RefType['ThemedAsset'], messages: Array<_RefType['Message']>, subtype: _RefType['ExternalAccountSubtype'] } )
  ;
  Target:
    | ( TargetAmountAndDate )
    | ( TargetMonthlyExpenses )
    | ( TargetRetirementSavings )
    | ( TargetRetirementSpending )
  ;
  TransactionOption:
    | ( Omit<CharitableDonationOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<DeferralSettingsEditOption, 'deferralSettings' | 'transactionUnavailableMessage'> & { deferralSettings: Array<_RefType['DeferralSetting']>, transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<ExternalTransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<ManageRecurringTransactionsOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<RolloverOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<RothIraConversionOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<TransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
    | ( Omit<WireTransferOption, 'accountOptions' | 'transactionUnavailableMessage'> & { accountOptions: Array<_RefType['SubAccount']>, transactionUnavailableMessage?: Maybe<_RefType['Message']> } )
  ;
  TransferableAccount:
    | ( Omit<BankAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], performance: _RefType['Performance'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<CheckingAccount, 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<CheckingExternalAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], financialSecuritiesSearch: Array<_RefType['FinancialSecurity']>, financialSecurity: _RefType['FinancialSecurity'], icon: _RefType['ThemedAsset'], pendingOrders: Array<_RefType['ActivityItemOrder']>, performance: _RefType['Performance'], securityPosition?: Maybe<_RefType['DirectTradingSecurityPosition']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, transactionOptions: Array<_RefType['TransactionOption']>, transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<_RefType['Five29AccountConnection']>, activityConnection: _RefType['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<ManagedSubAccount, 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'managedAccount' | 'transferSourceAccountOptions'> & { bankAccountEligibleCheckingAccounts: Array<_RefType['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<_RefType['ExternalAccount']>, envelope: _RefType['Envelope'], icon: _RefType['ThemedAsset'], managedAccount: _RefType['ManagedAccount'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
    | ( Omit<TheirLegalSubAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: _RefType['ThemedAsset'], transferSourceAccountOptions: Array<_RefType['TransferableAccountOption']> } )
  ;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptAdvisoryRelationshipApprovalRequestMutationInput: AcceptAdvisoryRelationshipApprovalRequestMutationInput;
  AcceptAdvisoryRelationshipApprovalRequestMutationPayload: ResolverTypeWrapper<AcceptAdvisoryRelationshipApprovalRequestMutationPayload>;
  AcceptAdvisoryRelationshipApprovalRequestMutationResult: ResolverTypeWrapper<AcceptAdvisoryRelationshipApprovalRequestMutationResult>;
  AccountOwnershipOption: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AccountOwnershipOption']>;
  AccountPurposeOption: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AccountPurposeOption']>;
  AccountRecommendation: ResolverTypeWrapper<Omit<AccountRecommendation, 'productOnboardingOption'> & { productOnboardingOption: ResolversTypes['ProductOnboardingOption'] }>;
  AccountRecommendationOption: ResolverTypeWrapper<Omit<AccountRecommendationOption, 'recommendation'> & { recommendation: ResolversTypes['AccountRecommendation'] }>;
  AccountTaxationOption: ResolverTypeWrapper<AccountTaxationOption>;
  ActiveReward: ResolverTypeWrapper<Omit<ActiveReward, 'message'> & { message?: Maybe<ResolversTypes['Message']> }>;
  ActivityDateRangeOption: ResolverTypeWrapper<ActivityDateRangeOption>;
  ActivityFilterInput: ActivityFilterInput;
  ActivityItem: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ActivityItem']>;
  ActivityItemAllocationChange: ResolverTypeWrapper<Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemConnection: ResolverTypeWrapper<Omit<ActivityItemConnection, 'edges' | 'nodes'> & { edges: Array<ResolversTypes['ActivityItemEdge']>, nodes: Array<ResolversTypes['ActivityItem']> }>;
  ActivityItemDeposit: ResolverTypeWrapper<Omit<ActivityItemDeposit, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount: ResolversTypes['LegalSubAccount'], sourceAccount?: Maybe<ResolversTypes['BankAccount']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemDividend: ResolverTypeWrapper<Omit<ActivityItemDividend, 'security'> & { security: ResolversTypes['Security'] }>;
  ActivityItemDividendGroup: ResolverTypeWrapper<Omit<ActivityItemDividendGroup, 'dividends' | 'subAccount'> & { dividends: Array<ResolversTypes['ActivityItemDividend']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemEdge: ResolverTypeWrapper<Omit<ActivityItemEdge, 'node'> & { node: ResolversTypes['ActivityItem'] }>;
  ActivityItemFee: ResolverTypeWrapper<Omit<ActivityItemFee, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemIdInput: ActivityItemIdInput;
  ActivityItemOrder: ResolverTypeWrapper<Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: ResolversTypes['Security'], subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemOther: ResolverTypeWrapper<Omit<ActivityItemOther, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemRollover: ResolverTypeWrapper<Omit<ActivityItemRollover, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemStage: ActivityItemStage;
  ActivityItemStatus: ResolverTypeWrapper<ActivityItemStatus>;
  ActivityItemTrade: ResolverTypeWrapper<Omit<ActivityItemTrade, 'security'> & { security: ResolversTypes['Security'] }>;
  ActivityItemTradeAttribution: ActivityItemTradeAttribution;
  ActivityItemTradeGroup: ResolverTypeWrapper<Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<ResolversTypes['ActivityItemTrade']>, sales: Array<ResolversTypes['ActivityItemTrade']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemTradeSide: ActivityItemTradeSide;
  ActivityItemTransfer: ResolverTypeWrapper<Omit<ActivityItemTransfer, 'destinationAccount' | 'security' | 'sourceAccount'> & { destinationAccount?: Maybe<ResolversTypes['LegalSubAccount']>, security?: Maybe<ResolversTypes['Security']>, sourceAccount?: Maybe<ResolversTypes['LegalSubAccount']> }>;
  ActivityItemTransferAssetType: ActivityItemTransferAssetType;
  ActivityItemTransferGroup: ResolverTypeWrapper<Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<ResolversTypes['LegalSubAccount']>, sourceAccount?: Maybe<ResolversTypes['LegalSubAccount']>, subAccount: ResolversTypes['LegalSubAccount'], transferItems: Array<ResolversTypes['ActivityItemTransfer']> }>;
  ActivityItemTypeFilterOption: ActivityItemTypeFilterOption;
  ActivityItemTypeFilterOptionV2: ActivityItemTypeFilterOptionV2;
  ActivityItemWithdrawal: ResolverTypeWrapper<Omit<ActivityItemWithdrawal, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount?: Maybe<ResolversTypes['BankAccount']>, sourceAccount: ResolversTypes['LegalSubAccount'], subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityTransactionMemo: ResolverTypeWrapper<ActivityTransactionMemo>;
  AddEnvelopeExternalAccountsMutationInput: AddEnvelopeExternalAccountsMutationInput;
  AddEnvelopeExternalAccountsMutationPayload: ResolverTypeWrapper<Omit<AddEnvelopeExternalAccountsMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Envelope']> }>;
  AddressState: ResolverTypeWrapper<AddressState>;
  Advice: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Advice']>;
  AdvisedSoloFourOhOneKClientInvite: ResolverTypeWrapper<Omit<AdvisedSoloFourOhOneKClientInvite, 'advisor'> & { advisor: ResolversTypes['Advisor'] }>;
  AdvisedSoloFourOhOneKClientInviteStatus: AdvisedSoloFourOhOneKClientInviteStatus;
  Advisor: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Advisor']>;
  AdvisorNetworkIntent: ResolverTypeWrapper<AdvisorNetworkIntent>;
  AdvisorNetworkIntentStatus: AdvisorNetworkIntentStatus;
  Agreement: ResolverTypeWrapper<Agreement>;
  AllocationBreakdown: ResolverTypeWrapper<AllocationBreakdown>;
  AllocationType: AllocationType;
  AnnualFourOhOneKContributions: ResolverTypeWrapper<Omit<AnnualFourOhOneKContributions, 'result'> & { result: ResolversTypes['FourOhOneKContributions'] }>;
  AnnualIraContributions: ResolverTypeWrapper<Omit<AnnualIraContributions, 'result'> & { result: ResolversTypes['IraContributions'] }>;
  Article: ResolverTypeWrapper<Article>;
  ArticleAuthor: ResolverTypeWrapper<ArticleAuthor>;
  ArticleCta: ResolverTypeWrapper<ArticleCta>;
  ArticleDisclosures: ResolverTypeWrapper<ArticleDisclosures>;
  ArticlesScope: ArticlesScope;
  AssetAllocation: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AssetAllocation']>;
  AssetAllocationDiversification: ResolverTypeWrapper<AssetAllocationDiversification>;
  AssetAllocationRisk: ResolverTypeWrapper<AssetAllocationRisk>;
  AssetTypeWeight: ResolverTypeWrapper<AssetTypeWeight>;
  AutoAdjustOption: ResolverTypeWrapper<AutoAdjustOption>;
  Autoglide: ResolverTypeWrapper<Autoglide>;
  BalanceProjection: ResolverTypeWrapper<BalanceProjection>;
  BalanceProjectionItem: ResolverTypeWrapper<BalanceProjectionItem>;
  BankAccount: ResolverTypeWrapper<Omit<BankAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  Base64: ResolverTypeWrapper<Scalars['Base64']['output']>;
  BeneficiaryRelationship: BeneficiaryRelationship;
  BeneficiaryUpdateInstructions: ResolverTypeWrapper<BeneficiaryUpdateInstructions>;
  BettermentAdvisorNetworkOption: ResolverTypeWrapper<Omit<BettermentAdvisorNetworkOption, 'image'> & { image: ResolversTypes['ThemedAsset'] }>;
  BettermentPremiumOption: ResolverTypeWrapper<Omit<BettermentPremiumOption, 'image'> & { image: ResolversTypes['ThemedAsset'] }>;
  BondPortfolioYields: ResolverTypeWrapper<BondPortfolioYields>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CancelTransactionRequestMutationInput: CancelTransactionRequestMutationInput;
  CancelTransactionRequestMutationPayload: ResolverTypeWrapper<Omit<CancelTransactionRequestMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: ResolverTypeWrapper<CapturePackageSignatureMutationPayload>;
  CashAccount: ResolverTypeWrapper<Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: ResolversTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversTypes['ExternalAccount']>, envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'], performance: ResolversTypes['Performance'], recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']>, transactionOptions: Array<ResolversTypes['TransactionOption']>, transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  CashApy: ResolverTypeWrapper<CashApy>;
  CashFdicInsurance: ResolverTypeWrapper<CashFdicInsurance>;
  Cents: ResolverTypeWrapper<Scalars['Cents']['output']>;
  CharitableDonationOption: ResolverTypeWrapper<Omit<CharitableDonationOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  CheckingAccount: ResolverTypeWrapper<Omit<CheckingAccount, 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  CheckingAccountCreationOption: ResolverTypeWrapper<Omit<CheckingAccountCreationOption, 'icon' | 'image'> & { icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'] }>;
  CheckingBeneficiary: ResolverTypeWrapper<CheckingBeneficiary>;
  CheckingBeneficiaryInput: CheckingBeneficiaryInput;
  CheckingCustomer: ResolverTypeWrapper<CheckingCustomer>;
  CheckingCustomerResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CheckingCustomerResult']>;
  CheckingExternalAccount: ResolverTypeWrapper<Omit<CheckingExternalAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  ClientEnvelopeApprovalAdvisorFee: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ClientEnvelopeApprovalAdvisorFee']>;
  ClientEnvelopeApprovalAgreement: ResolverTypeWrapper<ClientEnvelopeApprovalAgreement>;
  ClientEnvelopeApprovalAgreements: ResolverTypeWrapper<ClientEnvelopeApprovalAgreements>;
  ClientEnvelopeApprovalFeeTier: ResolverTypeWrapper<ClientEnvelopeApprovalFeeTier>;
  ClientEnvelopeApprovalFirm: ResolverTypeWrapper<ClientEnvelopeApprovalFirm>;
  ClientEnvelopeApprovalRateBasedFee: ResolverTypeWrapper<ClientEnvelopeApprovalRateBasedFee>;
  ClientEnvelopeApprovalRequest: ResolverTypeWrapper<Omit<ClientEnvelopeApprovalRequest, 'advisorFee'> & { advisorFee?: Maybe<ResolversTypes['ClientEnvelopeApprovalAdvisorFee']> }>;
  ClientEnvelopeApprovalRequestSource: ClientEnvelopeApprovalRequestSource;
  ClientEnvelopeApprovalTieredFee: ResolverTypeWrapper<ClientEnvelopeApprovalTieredFee>;
  CompleteDraftPurposeFlowMutationInput: CompleteDraftPurposeFlowMutationInput;
  CompleteDraftPurposeFlowMutationPayload: ResolverTypeWrapper<Omit<CompleteDraftPurposeFlowMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['DraftEnvelope']> }>;
  CompleteTaxCoordinatedAccountCreationFlowMutationInput: CompleteTaxCoordinatedAccountCreationFlowMutationInput;
  CompleteTaxCoordinatedAccountCreationFlowMutationPayload: ResolverTypeWrapper<Omit<CompleteTaxCoordinatedAccountCreationFlowMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Envelope']> }>;
  ConfirmIdentityVerificationChallengeMutationInput: ConfirmIdentityVerificationChallengeMutationInput;
  ConfirmIdentityVerificationChallengeMutationPayload: ResolverTypeWrapper<ConfirmIdentityVerificationChallengeMutationPayload>;
  ContributionType: ContributionType;
  ContributionTypeOption: ResolverTypeWrapper<ContributionTypeOption>;
  ContributionTypeSelectionOption: ResolverTypeWrapper<ContributionTypeSelectionOption>;
  CreateAccountRecommendationExplanationMutationInput: CreateAccountRecommendationExplanationMutationInput;
  CreateAccountRecommendationExplanationMutationPayload: ResolverTypeWrapper<CreateAccountRecommendationExplanationMutationPayload>;
  CreateDirectTradingAccountMutationInput: CreateDirectTradingAccountMutationInput;
  CreateDirectTradingAccountMutationPayload: ResolverTypeWrapper<Omit<CreateDirectTradingAccountMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['DirectTradingAccount']> }>;
  CreateDocumentVerificationTokenMutationPayload: ResolverTypeWrapper<CreateDocumentVerificationTokenMutationPayload>;
  CreateEmployeeContributionConfigurationChangeRequestMutationInput: CreateEmployeeContributionConfigurationChangeRequestMutationInput;
  CreateEmployeeContributionConfigurationChangeRequestMutationPayload: ResolverTypeWrapper<Omit<CreateEmployeeContributionConfigurationChangeRequestMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['PayrollContributionConfigConnection']> }>;
  CreateFinancialSecurityOrderRequestMutationInput: CreateFinancialSecurityOrderRequestMutationInput;
  CreateFinancialSecurityOrderRequestMutationPayload: ResolverTypeWrapper<CreateFinancialSecurityOrderRequestMutationPayload>;
  CreatePersonalReferralInvitationMutationInput: CreatePersonalReferralInvitationMutationInput;
  CreatePersonalReferralInvitationMutationPayload: ResolverTypeWrapper<CreatePersonalReferralInvitationMutationPayload>;
  CreateRecurringTransactionConfigMutationInput: CreateRecurringTransactionConfigMutationInput;
  CreateRecurringTransactionConfigMutationPayload: ResolverTypeWrapper<Omit<CreateRecurringTransactionConfigMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['RecurringTransactionConfig']> }>;
  CreateSolo401kInterestSubmissionsMutationInput: CreateSolo401kInterestSubmissionsMutationInput;
  CreateSolo401kInterestSubmissionsMutationPayload: ResolverTypeWrapper<CreateSolo401kInterestSubmissionsMutationPayload>;
  CreateTransactionMemoMutationInput: CreateTransactionMemoMutationInput;
  CreateTransactionMemoMutationPayload: ResolverTypeWrapper<Omit<CreateTransactionMemoMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['User']> }>;
  CreateTransactionRequestMutationInput: CreateTransactionRequestMutationInput;
  CreateTransactionRequestMutationPayload: ResolverTypeWrapper<Omit<CreateTransactionRequestMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['TransactionRequest']> }>;
  CreateUserActivityCsvExportMutationInput: CreateUserActivityCsvExportMutationInput;
  CreateUserActivityCsvExportMutationPayload: ResolverTypeWrapper<CreateUserActivityCsvExportMutationPayload>;
  CryptoAdvice: ResolverTypeWrapper<CryptoAdvice>;
  CryptoPortfolio: ResolverTypeWrapper<Omit<CryptoPortfolio, 'strategy' | 'tokenIcons'> & { strategy: ResolversTypes['PortfolioStrategy'], tokenIcons: Array<ResolversTypes['ThemedAsset']> }>;
  CsvExport: ResolverTypeWrapper<CsvExport>;
  CsvExportStatus: CsvExportStatus;
  CustomizableAssetAllocation: ResolverTypeWrapper<Omit<CustomizableAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversTypes['SecurityGroup']> }>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateRange: ResolverTypeWrapper<DateRange>;
  DateRangeInput: DateRangeInput;
  DateRangeOption: DateRangeOption;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DebitCard: ResolverTypeWrapper<DebitCard>;
  DebitCardLockTypeCode: DebitCardLockTypeCode;
  DebitCardStatus: DebitCardStatus;
  DeferralSetting: ResolverTypeWrapper<Omit<DeferralSetting, 'account' | 'value'> & { account: ResolversTypes['SubAccount'], value: ResolversTypes['PayrollContributionConfigValue'] }>;
  DeferralSettingsEditOption: ResolverTypeWrapper<Omit<DeferralSettingsEditOption, 'deferralSettings' | 'transactionUnavailableMessage'> & { deferralSettings: Array<ResolversTypes['DeferralSetting']>, transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  DeleteCheckingBeneficiaryMutationPayload: ResolverTypeWrapper<Omit<DeleteCheckingBeneficiaryMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['CheckingCustomerResult']> }>;
  DeletePurposeMutationInput: DeletePurposeMutationInput;
  DeletePurposeMutationPayload: ResolverTypeWrapper<Omit<DeletePurposeMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  DeleteRecurringTransactionConfigMutationInput: DeleteRecurringTransactionConfigMutationInput;
  DeleteRecurringTransactionConfigMutationPayload: ResolverTypeWrapper<Omit<DeleteRecurringTransactionConfigMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  DeleteTrustedContactMutationPayload: ResolverTypeWrapper<Omit<DeleteTrustedContactMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['User']> }>;
  DirectTradingAccount: ResolverTypeWrapper<Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: ResolversTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversTypes['ExternalAccount']>, envelope: ResolversTypes['Envelope'], financialSecuritiesSearch: Array<ResolversTypes['FinancialSecurity']>, financialSecurity: ResolversTypes['FinancialSecurity'], icon: ResolversTypes['ThemedAsset'], pendingOrders: Array<ResolversTypes['ActivityItemOrder']>, performance: ResolversTypes['Performance'], securityPosition?: Maybe<ResolversTypes['DirectTradingSecurityPosition']>, securityPositions: Array<ResolversTypes['DirectTradingSecurityPosition']>, transactionOptions: Array<ResolversTypes['TransactionOption']>, transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  DirectTradingCashBalances: ResolverTypeWrapper<DirectTradingCashBalances>;
  DirectTradingInvestableAssetsAdvice: ResolverTypeWrapper<DirectTradingInvestableAssetsAdvice>;
  DirectTradingJointAccountSecondaryUserValidationInput: DirectTradingJointAccountSecondaryUserValidationInput;
  DirectTradingSecurityPosition: ResolverTypeWrapper<Omit<DirectTradingSecurityPosition, 'financialSecurity' | 'pendingOrders'> & { financialSecurity: ResolversTypes['FinancialSecurity'], pendingOrders: Array<ResolversTypes['ActivityItemOrder']> }>;
  DirectTradingSecurityPositionReturn: ResolverTypeWrapper<DirectTradingSecurityPositionReturn>;
  DirectTradingTrustDetailsValidationInput: DirectTradingTrustDetailsValidationInput;
  Disclosures: ResolverTypeWrapper<Disclosures>;
  DismissUserActivityCsvExportBannerMutationInput: DismissUserActivityCsvExportBannerMutationInput;
  DismissUserActivityCsvExportBannerMutationPayload: ResolverTypeWrapper<DismissUserActivityCsvExportBannerMutationPayload>;
  DisplayableError: ResolverTypeWrapper<DisplayableError>;
  Document: ResolverTypeWrapper<Document>;
  DocumentCategory: ResolverTypeWrapper<DocumentCategory>;
  DocumentCategoryDisclosure: ResolverTypeWrapper<DocumentCategoryDisclosure>;
  DocumentCategoryGroup: ResolverTypeWrapper<DocumentCategoryGroup>;
  DocumentCategoryOrCategoryGroup: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DocumentCategoryOrCategoryGroup']>;
  DocumentFile: ResolverTypeWrapper<DocumentFile>;
  DocumentFileType: DocumentFileType;
  DocumentFilter: ResolverTypeWrapper<DocumentFilter>;
  DocumentFilterOption: ResolverTypeWrapper<DocumentFilterOption>;
  DocumentVerificationStatus: DocumentVerificationStatus;
  DocumentsResult: ResolverTypeWrapper<DocumentsResult>;
  DocusignSignature: ResolverTypeWrapper<DocusignSignature>;
  DraftEnvelope: ResolverTypeWrapper<Omit<DraftEnvelope, 'editablePurpose'> & { editablePurpose?: Maybe<ResolversTypes['EditablePurpose']> }>;
  DraftEnvelopeAccount: ResolverTypeWrapper<Omit<DraftEnvelopeAccount, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  DraftPurposeEmergencyFund: ResolverTypeWrapper<DraftPurposeEmergencyFund>;
  DraftPurposeMajorPurchase: ResolverTypeWrapper<DraftPurposeMajorPurchase>;
  DraftPurposeRetirementGrowth: ResolverTypeWrapper<DraftPurposeRetirementGrowth>;
  DraftPurposeRetirementIncome: ResolverTypeWrapper<DraftPurposeRetirementIncome>;
  Drift: ResolverTypeWrapper<Drift>;
  EditableEnvelope: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditableEnvelope']>;
  EditablePurpose: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditablePurpose']>;
  EditablePurposeEmergencyFund: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditablePurposeEmergencyFund']>;
  EditablePurposeMajorPurchase: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditablePurposeMajorPurchase']>;
  EditablePurposeRetirementGrowth: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditablePurposeRetirementGrowth']>;
  EditablePurposeRetirementIncome: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EditablePurposeRetirementIncome']>;
  EducationArticleCategoryType: EducationArticleCategoryType;
  EmailDispatch: ResolverTypeWrapper<Omit<EmailDispatch, 'user'> & { user: ResolversTypes['User'] }>;
  EmergencyFundCoverage: ResolverTypeWrapper<Omit<EmergencyFundCoverage, 'messages'> & { messages: Array<ResolversTypes['Message']> }>;
  EmergencyFundCoverageOption: ResolverTypeWrapper<EmergencyFundCoverageOption>;
  EmergencyFundCoverageVariant: EmergencyFundCoverageVariant;
  EmergencyFundPurposeCreationOption: ResolverTypeWrapper<Omit<EmergencyFundPurposeCreationOption, 'emergencyFundCoverage' | 'purposeAsset' | 'recommendation'> & { emergencyFundCoverage: ResolversTypes['EmergencyFundCoverage'], purposeAsset: ResolversTypes['PurposeAsset'], recommendation: ResolversTypes['Message'] }>;
  EmergencyFundUpdateInput: EmergencyFundUpdateInput;
  Employee: ResolverTypeWrapper<Employee>;
  EmployeeContributionConfigurationChangeInput: EmployeeContributionConfigurationChangeInput;
  EmployeeContributionRateType: EmployeeContributionRateType;
  Employer: ResolverTypeWrapper<Employer>;
  EmployerFourOhOneKContributionConfig: ResolverTypeWrapper<EmployerFourOhOneKContributionConfig>;
  EmployerFourOhOneKContributionFrequency: EmployerFourOhOneKContributionFrequency;
  EmployerFourOhOneKContributions: ResolverTypeWrapper<EmployerFourOhOneKContributions>;
  EmployerFourOhOneKContributionsProjection: ResolverTypeWrapper<EmployerFourOhOneKContributionsProjection>;
  EmployerFourOhOneKContributionsResult: ResolverTypeWrapper<EmployerFourOhOneKContributionsResult>;
  EmployerFourOhOneKContributionsVested: ResolverTypeWrapper<EmployerFourOhOneKContributionsVested>;
  Envelope: ResolverTypeWrapper<Omit<Envelope, 'accounts' | 'activityConnection' | 'icon' | 'legalSubAccounts' | 'messages' | 'payrollContributionConfigs' | 'purpose' | 'recurringTransactionConfigs' | 'transactionOptions'> & { accounts: Array<ResolversTypes['EnvelopeAccount']>, activityConnection: ResolversTypes['ActivityItemConnection'], icon: ResolversTypes['ThemedAsset'], legalSubAccounts: Array<ResolversTypes['LegalSubAccount']>, messages: Array<ResolversTypes['Message']>, payrollContributionConfigs: Array<ResolversTypes['PayrollContributionConfig']>, purpose?: Maybe<ResolversTypes['Purpose']>, recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']>, transactionOptions: Array<ResolversTypes['TransactionOption']> }>;
  EnvelopeAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EnvelopeAccount']>;
  EnvelopeOrderInput: EnvelopeOrderInput;
  EnvelopeStatus: ResolverTypeWrapper<EnvelopeStatus>;
  EnvelopeStatusStyle: EnvelopeStatusStyle;
  EstimatedTradeDate: ResolverTypeWrapper<EstimatedTradeDate>;
  EstimatedTradeTimeRange: ResolverTypeWrapper<EstimatedTradeTimeRange>;
  EstimatedTradeTiming: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['EstimatedTradeTiming']>;
  ExpenseRatio: ResolverTypeWrapper<ExpenseRatio>;
  ExpensesBasedPurposeOption: ResolverTypeWrapper<Omit<ExpensesBasedPurposeOption, 'icon' | 'recommendation'> & { icon: ResolversTypes['ThemedAsset'], recommendation: ResolversTypes['Message'] }>;
  ExternalAccount: ResolverTypeWrapper<Omit<ExternalAccount, 'envelope' | 'envelopeOptions' | 'goal' | 'icon' | 'messages' | 'subtype' | 'transactionOption'> & { envelope?: Maybe<ResolversTypes['Envelope']>, envelopeOptions: Array<ResolversTypes['Envelope']>, goal?: Maybe<ResolversTypes['Goal']>, icon: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']>, subtype: ResolversTypes['ExternalAccountSubtype'], transactionOption?: Maybe<ResolversTypes['TransactionOption']> }>;
  ExternalAccountEmployerMatch: ResolverTypeWrapper<ExternalAccountEmployerMatch>;
  ExternalAccountEnvelopeAssociation: ResolverTypeWrapper<Omit<ExternalAccountEnvelopeAssociation, 'account' | 'envelope' | 'icon'> & { account: ResolversTypes['SomebodysExternalAccount'], envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'] }>;
  ExternalAccountPlanContributions: ResolverTypeWrapper<ExternalAccountPlanContributions>;
  ExternalAccountSubtype: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ExternalAccountSubtype']>;
  ExternalAccountSubtypeBasic: ResolverTypeWrapper<ExternalAccountSubtypeBasic>;
  ExternalAccountSubtypeEmployerSponsored: ResolverTypeWrapper<ExternalAccountSubtypeEmployerSponsored>;
  ExternalAccountSubtypeIra: ResolverTypeWrapper<ExternalAccountSubtypeIra>;
  ExternalAccountsWhereInput: ExternalAccountsWhereInput;
  ExternalTransferOption: ResolverTypeWrapper<Omit<ExternalTransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  ExternallyAdvisedPlanPortfolio: ResolverTypeWrapper<Omit<ExternallyAdvisedPlanPortfolio, 'strategy'> & { strategy: ResolversTypes['PortfolioStrategy'] }>;
  FeedbackType: FeedbackType;
  FinancialCoachingOnboardingOption: ResolverTypeWrapper<Omit<FinancialCoachingOnboardingOption, 'icon' | 'image'> & { icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'] }>;
  FinancialProfile: ResolverTypeWrapper<FinancialProfile>;
  FinancialProfileRetirementAssumptions: ResolverTypeWrapper<FinancialProfileRetirementAssumptions>;
  FinancialProfileRetirementUserAssumptions: ResolverTypeWrapper<FinancialProfileRetirementUserAssumptions>;
  FinancialSecurity: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FinancialSecurity']>;
  FinancialSecurityCompanyProfile: ResolverTypeWrapper<Omit<FinancialSecurityCompanyProfile, 'logo'> & { logo?: Maybe<ResolversTypes['ThemedAsset']> }>;
  FinancialSecurityFund: ResolverTypeWrapper<Omit<FinancialSecurityFund, 'fundamentals' | 'portfolio'> & { fundamentals: ResolversTypes['FinancialSecurityFundamentals'], portfolio: ResolversTypes['FinancialSecurityFundPortfolio'] }>;
  FinancialSecurityFundPortfolio: ResolverTypeWrapper<Omit<FinancialSecurityFundPortfolio, 'holdings'> & { holdings: Array<ResolversTypes['FinancialSecurityFundPortfolioHolding']> }>;
  FinancialSecurityFundPortfolioHolding: ResolverTypeWrapper<Omit<FinancialSecurityFundPortfolioHolding, 'security'> & { security?: Maybe<ResolversTypes['FinancialSecurity']> }>;
  FinancialSecurityFundamentals: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FinancialSecurityFundamentals']>;
  FinancialSecurityFundamentalsDividendYield: ResolverTypeWrapper<FinancialSecurityFundamentalsDividendYield>;
  FinancialSecurityFundamentalsDividendsAmount: ResolverTypeWrapper<FinancialSecurityFundamentalsDividendsAmount>;
  FinancialSecurityFundamentalsEarningsPerShare: ResolverTypeWrapper<FinancialSecurityFundamentalsEarningsPerShare>;
  FinancialSecurityFundamentalsEbitda: ResolverTypeWrapper<FinancialSecurityFundamentalsEbitda>;
  FinancialSecurityFundamentalsExpenseRatio: ResolverTypeWrapper<FinancialSecurityFundamentalsExpenseRatio>;
  FinancialSecurityFundamentalsFund: ResolverTypeWrapper<FinancialSecurityFundamentalsFund>;
  FinancialSecurityFundamentalsFundAnnual: ResolverTypeWrapper<FinancialSecurityFundamentalsFundAnnual>;
  FinancialSecurityFundamentalsFundTrailingTwelveMonths: ResolverTypeWrapper<FinancialSecurityFundamentalsFundTrailingTwelveMonths>;
  FinancialSecurityFundamentalsMarketCap: ResolverTypeWrapper<FinancialSecurityFundamentalsMarketCap>;
  FinancialSecurityFundamentalsPriceToEarningsRatio: ResolverTypeWrapper<FinancialSecurityFundamentalsPriceToEarningsRatio>;
  FinancialSecurityFundamentalsRevenue: ResolverTypeWrapper<FinancialSecurityFundamentalsRevenue>;
  FinancialSecurityFundamentalsSharesOutstanding: ResolverTypeWrapper<FinancialSecurityFundamentalsSharesOutstanding>;
  FinancialSecurityFundamentalsStock: ResolverTypeWrapper<FinancialSecurityFundamentalsStock>;
  FinancialSecurityFundamentalsStockAnnual: ResolverTypeWrapper<FinancialSecurityFundamentalsStockAnnual>;
  FinancialSecurityFundamentalsStockTrailingTwelveMonths: ResolverTypeWrapper<FinancialSecurityFundamentalsStockTrailingTwelveMonths>;
  FinancialSecurityOrderRequest: ResolverTypeWrapper<FinancialSecurityOrderRequest>;
  FinancialSecurityOrderRequestAccountIdInput: FinancialSecurityOrderRequestAccountIdInput;
  FinancialSecurityOrderRequestDirection: FinancialSecurityOrderRequestDirection;
  FinancialSecurityOrderRequestValueInput: FinancialSecurityOrderRequestValueInput;
  FinancialSecurityPriceHistory: ResolverTypeWrapper<FinancialSecurityPriceHistory>;
  FinancialSecurityPricePerformance: ResolverTypeWrapper<FinancialSecurityPricePerformance>;
  FinancialSecurityPricePerformancePricePoint: ResolverTypeWrapper<FinancialSecurityPricePerformancePricePoint>;
  FinancialSecurityPricePoint: ResolverTypeWrapper<FinancialSecurityPricePoint>;
  FinancialSecurityPriceReturns: ResolverTypeWrapper<FinancialSecurityPriceReturns>;
  FinancialSecuritySecurityType: FinancialSecuritySecurityType;
  FinancialSecurityStatistics: ResolverTypeWrapper<FinancialSecurityStatistics>;
  FinancialSecurityStatisticsComponentDays: ResolverTypeWrapper<FinancialSecurityStatisticsComponentDays>;
  FinancialSecurityStatisticsComponentIntraDay: ResolverTypeWrapper<FinancialSecurityStatisticsComponentIntraDay>;
  FinancialSecurityStatisticsLatestPrice: ResolverTypeWrapper<FinancialSecurityStatisticsLatestPrice>;
  FinancialSecurityStock: ResolverTypeWrapper<Omit<FinancialSecurityStock, 'companyProfile' | 'fundamentals'> & { companyProfile: ResolversTypes['FinancialSecurityCompanyProfile'], fundamentals: ResolversTypes['FinancialSecurityFundamentals'] }>;
  FinancialServiceOption: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FinancialServiceOption']>;
  Firm: ResolverTypeWrapper<Firm>;
  Five29Account: ResolverTypeWrapper<Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<ResolversTypes['Five29AccountConnection']>, activityConnection: ResolversTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversTypes['ExternalAccount']>, envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  Five29AccountConnection: ResolverTypeWrapper<Omit<Five29AccountConnection, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  FiveTwoNineGoalCreationOption: ResolverTypeWrapper<Omit<FiveTwoNineGoalCreationOption, 'icon' | 'image'> & { icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'] }>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FourOhOneKContributions: ResolverTypeWrapper<Omit<FourOhOneKContributions, 'projection'> & { projection?: Maybe<ResolversTypes['FourOhOneKContributionsProjection']> }>;
  FourOhOneKContributionsLineItem: ResolverTypeWrapper<FourOhOneKContributionsLineItem>;
  FourOhOneKContributionsProjection: ResolverTypeWrapper<Omit<FourOhOneKContributionsProjection, 'deferralSettingsEditOption' | 'deferralSettingsEditOptionV2' | 'messages' | 'recurringInflows'> & { deferralSettingsEditOption: ResolversTypes['DeferralSettingsEditOption'], deferralSettingsEditOptionV2?: Maybe<ResolversTypes['DeferralSettingsEditOption']>, messages: Array<ResolversTypes['Message']>, recurringInflows: Array<ResolversTypes['RecurringTransactionConfig']> }>;
  FourOhOneKContributionsResult: ResolverTypeWrapper<Omit<FourOhOneKContributionsResult, 'allTime' | 'thisYear'> & { allTime: ResolversTypes['FourOhOneKContributions'], thisYear: ResolversTypes['AnnualFourOhOneKContributions'] }>;
  FourOhOneKStudentLoanMatchBenefit: ResolverTypeWrapper<Omit<FourOhOneKStudentLoanMatchBenefit, 'currentLoanPaymentEstimate' | 'messages'> & { currentLoanPaymentEstimate?: Maybe<ResolversTypes['StudentLoanPaymentEstimate']>, messages: Array<ResolversTypes['Message']> }>;
  GeneralPurposeOption: ResolverTypeWrapper<Omit<GeneralPurposeOption, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  Goal: ResolverTypeWrapper<Omit<Goal, 'advice' | 'envelope' | 'externalAccounts' | 'icon' | 'image' | 'messages' | 'portfolio' | 'subAccounts'> & { advice?: Maybe<ResolversTypes['Advice']>, envelope: ResolversTypes['Envelope'], externalAccounts: Array<ResolversTypes['ExternalAccount']>, icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']>, portfolio?: Maybe<ResolversTypes['Portfolio']>, subAccounts: Array<ResolversTypes['SubAccount']> }>;
  GoalBalances: ResolverTypeWrapper<GoalBalances>;
  GoalCreationIntent: ResolverTypeWrapper<Omit<GoalCreationIntent, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  GoalCreationOption: ResolverTypeWrapper<Omit<GoalCreationOption, 'accountOwnershipOption' | 'accountOwnershipOptions' | 'accountPurposeOption' | 'accountPurposeOptions' | 'draftEnvelopeAccount' | 'emergencyFundCoverage' | 'icon' | 'image' | 'modelPortfolioOption' | 'modelPortfolioOptions' | 'termsAndAgreements'> & { accountOwnershipOption: ResolversTypes['AccountOwnershipOption'], accountOwnershipOptions: Array<ResolversTypes['AccountOwnershipOption']>, accountPurposeOption: ResolversTypes['AccountPurposeOption'], accountPurposeOptions: Array<ResolversTypes['AccountPurposeOption']>, draftEnvelopeAccount?: Maybe<ResolversTypes['DraftEnvelopeAccount']>, emergencyFundCoverage?: Maybe<ResolversTypes['EmergencyFundCoverage']>, icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'], modelPortfolioOption: ResolversTypes['ModelPortfolioOption'], modelPortfolioOptions: Array<ResolversTypes['ModelPortfolioOption']>, termsAndAgreements: Array<ResolversTypes['LegacyTermsAndAgreements']> }>;
  GoalStatusStyle: GoalStatusStyle;
  GoalStatusSummary: ResolverTypeWrapper<GoalStatusSummary>;
  GoalsCategory: GoalsCategory;
  Grant: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Grant']>;
  HTML: ResolverTypeWrapper<Scalars['HTML']['output']>;
  HistoricalPerformance: ResolverTypeWrapper<HistoricalPerformance>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IdentityVerificationChallenge: ResolverTypeWrapper<IdentityVerificationChallenge>;
  IdentityVerificationChallengeResponse: IdentityVerificationChallengeResponse;
  IdentityVerificationChallengeStatus: IdentityVerificationChallengeStatus;
  IndividualOwnershipOption: ResolverTypeWrapper<IndividualOwnershipOption>;
  InitiateStudentLoanPaymentBenefitAttestationMutationPayload: ResolverTypeWrapper<Omit<InitiateStudentLoanPaymentBenefitAttestationMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']> }>;
  InstitutionalAdvisor: ResolverTypeWrapper<Omit<InstitutionalAdvisor, 'logo'> & { logo?: Maybe<ResolversTypes['ThemedAsset']> }>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvestingExperienceLevel: InvestingExperienceLevel;
  InvestmentPortfolio: ResolverTypeWrapper<Omit<InvestmentPortfolio, 'icon' | 'strategy'> & { icon?: Maybe<ResolversTypes['ThemedAsset']>, strategy: ResolversTypes['PortfolioStrategy'] }>;
  IraContributionMatchGrant: ResolverTypeWrapper<IraContributionMatchGrant>;
  IraContributionMatchGrantStatus: IraContributionMatchGrantStatus;
  IraContributionMatchGrantsWhereInput: IraContributionMatchGrantsWhereInput;
  IraContributions: ResolverTypeWrapper<Omit<IraContributions, 'lineItems' | 'projection'> & { lineItems: Array<ResolversTypes['IraContributionsLineItem']>, projection?: Maybe<ResolversTypes['IraContributionsProjection']> }>;
  IraContributionsByYearWhere: IraContributionsByYearWhere;
  IraContributionsLineItem: ResolverTypeWrapper<IraContributionsLineItem>;
  IraContributionsProjection: ResolverTypeWrapper<Omit<IraContributionsProjection, 'messages' | 'recurringInflows'> & { messages: Array<ResolversTypes['Message']>, recurringInflows: Array<ResolversTypes['RecurringTransactionConfig']> }>;
  IraContributionsResult: ResolverTypeWrapper<Omit<IraContributionsResult, 'allTime' | 'byYear'> & { allTime: ResolversTypes['IraContributions'], byYear: Array<ResolversTypes['AnnualIraContributions']> }>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JointAccountInvitation: ResolverTypeWrapper<JointAccountInvitation>;
  JointAccountInvitationStatus: JointAccountInvitationStatus;
  JointOwnershipOption: ResolverTypeWrapper<JointOwnershipOption>;
  LegacyAllocationAssets: ResolverTypeWrapper<LegacyAllocationAssets>;
  LegacyAssetClass: ResolverTypeWrapper<LegacyAssetClass>;
  LegacyHoldingsPageInfo: ResolverTypeWrapper<LegacyHoldingsPageInfo>;
  LegacyID: ResolverTypeWrapper<Scalars['LegacyID']['output']>;
  LegacyNamedOptions: ResolverTypeWrapper<LegacyNamedOptions>;
  LegacyPortfolioDetails: ResolverTypeWrapper<LegacyPortfolioDetails>;
  LegacyPortfolioInfoRow: ResolverTypeWrapper<LegacyPortfolioInfoRow>;
  LegacyPortfolioStrategyOption: ResolverTypeWrapper<Omit<LegacyPortfolioStrategyOption, 'icon' | 'messages'> & { icon: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']> }>;
  LegacySecurity: ResolverTypeWrapper<LegacySecurity>;
  LegacySecurityGroupDetails: ResolverTypeWrapper<LegacySecurityGroupDetails>;
  LegacySuperAssetClass: ResolverTypeWrapper<LegacySuperAssetClass>;
  LegacyTermsAndAgreements: ResolverTypeWrapper<Omit<LegacyTermsAndAgreements, 'agreements' | 'image'> & { agreements: Array<ResolversTypes['Agreement']>, image?: Maybe<ResolversTypes['ThemedAsset']> }>;
  LegacyTransferType: LegacyTransferType;
  LegacyUUID: ResolverTypeWrapper<Scalars['LegacyUUID']['output']>;
  LegacyWeightedSecurity: ResolverTypeWrapper<LegacyWeightedSecurity>;
  LegalAccount: ResolverTypeWrapper<LegalAccount>;
  LegalAccountBeneficiary: ResolverTypeWrapper<LegalAccountBeneficiary>;
  LegalAccountBeneficiaryInput: LegalAccountBeneficiaryInput;
  LegalAccountOwnershipType: LegalAccountOwnershipType;
  LegalAccountTaxationType: LegalAccountTaxationType;
  LegalAccountTypeInput: LegalAccountTypeInput;
  LegalSubAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LegalSubAccount']>;
  LegalSubAccountInput: LegalSubAccountInput;
  MajorPurchasePurposeCreationOption: ResolverTypeWrapper<Omit<MajorPurchasePurposeCreationOption, 'purposeAsset'> & { purposeAsset: ResolversTypes['PurposeAsset'] }>;
  MajorPurchaseUpdateInput: MajorPurchaseUpdateInput;
  ManageRecurringTransactionsOption: ResolverTypeWrapper<Omit<ManageRecurringTransactionsOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  ManagedAccount: ResolverTypeWrapper<Omit<ManagedAccount, 'activityConnection' | 'assetAllocation' | 'envelope' | 'icon' | 'messages' | 'minFeeWarning' | 'payrollContributionConfigs' | 'performance' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccounts' | 'transactionOptions'> & { activityConnection: ResolversTypes['ActivityItemConnection'], assetAllocation: ResolversTypes['AssetAllocation'], envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']>, minFeeWarning?: Maybe<ResolversTypes['Message']>, payrollContributionConfigs: Array<ResolversTypes['PayrollContributionConfig']>, performance: ResolversTypes['Performance'], portfolio: ResolversTypes['ManagedPortfolio'], recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']>, securityGroupPositions: Array<ResolversTypes['SecurityGroupPosition']>, subAccounts: Array<ResolversTypes['ManagedSubAccount']>, transactionOptions: Array<ResolversTypes['TransactionOption']> }>;
  ManagedAccountProjection: ResolverTypeWrapper<ManagedAccountProjection>;
  ManagedAccountProjectionInput: ManagedAccountProjectionInput;
  ManagedPortfolio: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ManagedPortfolio']>;
  ManagedSubAccount: ResolverTypeWrapper<Omit<ManagedSubAccount, 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'managedAccount' | 'transferSourceAccountOptions'> & { bankAccountEligibleCheckingAccounts: Array<ResolversTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversTypes['ExternalAccount']>, envelope: ResolversTypes['Envelope'], icon: ResolversTypes['ThemedAsset'], managedAccount: ResolversTypes['ManagedAccount'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  MarketSchedule: ResolverTypeWrapper<MarketSchedule>;
  MarketingMessage: ResolverTypeWrapper<MarketingMessage>;
  MarketingMessageExtras: ResolverTypeWrapper<MarketingMessageExtras>;
  MarketingMessageExtrasInput: MarketingMessageExtrasInput;
  MarketingMessageInput: MarketingMessageInput;
  MarketingMessagesInput: MarketingMessagesInput;
  MemoCreationOption: ResolverTypeWrapper<MemoCreationOption>;
  MemoReasonOption: ResolverTypeWrapper<MemoReasonOption>;
  Message: ResolverTypeWrapper<Omit<Message, 'cta'> & { cta?: Maybe<ResolversTypes['MessageCta']> }>;
  MessageCta: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['MessageCta']>;
  MessageCtaLink: ResolverTypeWrapper<MessageCtaLink>;
  MessageCtaModal: ResolverTypeWrapper<MessageCtaModal>;
  MessageLocation: ResolverTypeWrapper<Scalars['MessageLocation']['output']>;
  MessageStyle: MessageStyle;
  ModelPortfolioOption: ResolverTypeWrapper<Omit<ModelPortfolioOption, 'assetAllocations' | 'icon' | 'recommendedAllocation'> & { assetAllocations: Array<ResolversTypes['AssetAllocation']>, icon: ResolversTypes['ThemedAsset'], recommendedAllocation: ResolversTypes['AssetAllocation'] }>;
  MoneyWeightedRateOfReturn: ResolverTypeWrapper<MoneyWeightedRateOfReturn>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NetWorth: ResolverTypeWrapper<NetWorth>;
  NetWorthSubtotal: ResolverTypeWrapper<NetWorthSubtotal>;
  NetWorthSubtotalItem: ResolverTypeWrapper<NetWorthSubtotalItem>;
  OtherUser: ResolverTypeWrapper<OtherUser>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PayrollContributionConfig: ResolverTypeWrapper<Omit<PayrollContributionConfig, 'account' | 'bonusValue' | 'value'> & { account: ResolversTypes['PayrollContributionConfigAccount'], bonusValue?: Maybe<ResolversTypes['PayrollContributionConfigValue']>, value: ResolversTypes['PayrollContributionConfigValue'] }>;
  PayrollContributionConfigAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PayrollContributionConfigAccount']>;
  PayrollContributionConfigConnection: ResolverTypeWrapper<Omit<PayrollContributionConfigConnection, 'edges' | 'nodes'> & { edges: Array<ResolversTypes['PayrollContributionConfigEdge']>, nodes: Array<ResolversTypes['PayrollContributionConfig']> }>;
  PayrollContributionConfigEdge: ResolverTypeWrapper<Omit<PayrollContributionConfigEdge, 'node'> & { node: ResolversTypes['PayrollContributionConfig'] }>;
  PayrollContributionConfigValue: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PayrollContributionConfigValue']>;
  PayrollContributionConfigValueAmount: ResolverTypeWrapper<PayrollContributionConfigValueAmount>;
  PayrollContributionConfigValuePercent: ResolverTypeWrapper<PayrollContributionConfigValuePercent>;
  PayrollContributionConfigsWhereInput: PayrollContributionConfigsWhereInput;
  PendingDocumentVerificationRequest: ResolverTypeWrapper<PendingDocumentVerificationRequest>;
  Percent: ResolverTypeWrapper<Scalars['Percent']['output']>;
  Performance: ResolverTypeWrapper<Omit<Performance, 'accounts'> & { accounts: Array<ResolversTypes['PerformanceAccount']> }>;
  PerformanceAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PerformanceAccount']>;
  PerformanceBenchmark: ResolverTypeWrapper<PerformanceBenchmark>;
  PerformanceBenchmarkGroup: ResolverTypeWrapper<PerformanceBenchmarkGroup>;
  PerformanceBenchmarkTimeWeightedReturns: ResolverTypeWrapper<PerformanceBenchmarkTimeWeightedReturns>;
  PerformanceHistory: ResolverTypeWrapper<PerformanceHistory>;
  PerformanceHistoryItem: ResolverTypeWrapper<PerformanceHistoryItem>;
  PerformanceHistoryTimeWeightedReturnItem: ResolverTypeWrapper<PerformanceHistoryTimeWeightedReturnItem>;
  PerformanceInterest: ResolverTypeWrapper<PerformanceInterest>;
  PerformanceInvesting: ResolverTypeWrapper<PerformanceInvesting>;
  PerformanceTimeWeightedReturns: ResolverTypeWrapper<PerformanceTimeWeightedReturns>;
  PerformanceTotals: ResolverTypeWrapper<PerformanceTotals>;
  PerformanceTotalsDividends: ResolverTypeWrapper<PerformanceTotalsDividends>;
  PerformanceTotalsFees: ResolverTypeWrapper<PerformanceTotalsFees>;
  PerformanceTotalsUserTransactions: ResolverTypeWrapper<PerformanceTotalsUserTransactions>;
  PerformanceTotalsUserTransactionsPending: ResolverTypeWrapper<PerformanceTotalsUserTransactionsPending>;
  Portfolio: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Portfolio']>;
  PortfolioStrategy: ResolverTypeWrapper<Omit<PortfolioStrategy, 'icon'> & { icon?: Maybe<ResolversTypes['ThemedAsset']> }>;
  PostalAddress: ResolverTypeWrapper<PostalAddress>;
  PostalAddressInput: PostalAddressInput;
  PremiumAdvisor: ResolverTypeWrapper<Omit<PremiumAdvisor, 'logo'> & { logo?: Maybe<ResolversTypes['ThemedAsset']> }>;
  PremiumOnboardingOption: ResolverTypeWrapper<Omit<PremiumOnboardingOption, 'icon' | 'image'> & { icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'] }>;
  PriceGroup: ResolverTypeWrapper<PriceGroup>;
  PriceGroupMinFee: ResolverTypeWrapper<PriceGroupMinFee>;
  PriceGroupPremiumPricing: ResolverTypeWrapper<PriceGroupPremiumPricing>;
  PriceGroupPricingCta: ResolverTypeWrapper<PriceGroupPricingCta>;
  PriceGroupPricingTier: ResolverTypeWrapper<PriceGroupPricingTier>;
  PriceGroupPricingTierBreakdown: ResolverTypeWrapper<PriceGroupPricingTierBreakdown>;
  PriceRange: ResolverTypeWrapper<PriceRange>;
  ProcessCapitalizeWindowEventMutationInput: ProcessCapitalizeWindowEventMutationInput;
  ProcessCapitalizeWindowEventMutationPayload: ResolverTypeWrapper<Omit<ProcessCapitalizeWindowEventMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  ProductBundle: ResolverTypeWrapper<Omit<ProductBundle, 'image' | 'productOnboardingOptions'> & { image: ResolversTypes['ThemedAsset'], productOnboardingOptions: Array<ResolversTypes['ProductOnboardingOption']> }>;
  ProductCategory: ProductCategory;
  ProductCategoryOptionsOrder: ProductCategoryOptionsOrder;
  ProductOnboardingOption: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ProductOnboardingOption']>;
  ProductOnboardingOptionImageVariant: ProductOnboardingOptionImageVariant;
  ProductOnboardingStep: ResolverTypeWrapper<ProductOnboardingStep>;
  ProductOnboardingStepState: ProductOnboardingStepState;
  ProductUnavailability: ResolverTypeWrapper<ProductUnavailability>;
  Profession: ResolverTypeWrapper<Profession>;
  ProgressChecklist: ResolverTypeWrapper<Omit<ProgressChecklist, 'cta'> & { cta?: Maybe<ResolversTypes['MessageCta']> }>;
  ProgressChecklistStatus: ProgressChecklistStatus;
  Purpose: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Purpose']>;
  PurposeAsset: ResolverTypeWrapper<Omit<PurposeAsset, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  PurposeCreationIntent: PurposeCreationIntent;
  PurposeCreationOptionInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PurposeCreationOptionInterface']>;
  PurposeEmergencyFund: ResolverTypeWrapper<Omit<PurposeEmergencyFund, 'envelope' | 'image' | 'target'> & { envelope: ResolversTypes['Envelope'], image: ResolversTypes['ThemedAsset'], target?: Maybe<ResolversTypes['Target']> }>;
  PurposeEmergencyFundProjection: ResolverTypeWrapper<PurposeEmergencyFundProjection>;
  PurposeEmergencyFundProjectionInput: PurposeEmergencyFundProjectionInput;
  PurposeEmergencyFundTarget: ResolverTypeWrapper<PurposeEmergencyFundTarget>;
  PurposeMajorPurchase: ResolverTypeWrapper<Omit<PurposeMajorPurchase, 'envelope' | 'image' | 'target'> & { envelope: ResolversTypes['Envelope'], image: ResolversTypes['ThemedAsset'], target?: Maybe<ResolversTypes['Target']> }>;
  PurposeMajorPurchaseProjection: ResolverTypeWrapper<PurposeMajorPurchaseProjection>;
  PurposeMajorPurchaseProjectionCompletion: ResolverTypeWrapper<PurposeMajorPurchaseProjectionCompletion>;
  PurposeMajorPurchaseProjectionInput: PurposeMajorPurchaseProjectionInput;
  PurposeMajorPurchaseTarget: ResolverTypeWrapper<PurposeMajorPurchaseTarget>;
  PurposeRetirementGrowth: ResolverTypeWrapper<Omit<PurposeRetirementGrowth, 'envelope' | 'image' | 'projection' | 'target'> & { envelope: ResolversTypes['Envelope'], image: ResolversTypes['ThemedAsset'], projection?: Maybe<ResolversTypes['PurposeRetirementGrowthProjection']>, target?: Maybe<ResolversTypes['Target']> }>;
  PurposeRetirementGrowthProjection: ResolverTypeWrapper<Omit<PurposeRetirementGrowthProjection, 'completion' | 'savingsPlan'> & { completion: ResolversTypes['PurposeRetirementGrowthProjectionCompletion'], savingsPlan: ResolversTypes['SavingsPlan'] }>;
  PurposeRetirementGrowthProjectionCompletion: ResolverTypeWrapper<PurposeRetirementGrowthProjectionCompletion>;
  PurposeRetirementGrowthProjectionInput: PurposeRetirementGrowthProjectionInput;
  PurposeRetirementGrowthTarget: ResolverTypeWrapper<PurposeRetirementGrowthTarget>;
  PurposeRetirementIncome: ResolverTypeWrapper<Omit<PurposeRetirementIncome, 'envelope' | 'image' | 'target'> & { envelope: ResolversTypes['Envelope'], image: ResolversTypes['ThemedAsset'], target?: Maybe<ResolversTypes['Target']> }>;
  PurposeRetirementIncomeProjection: ResolverTypeWrapper<PurposeRetirementIncomeProjection>;
  PurposeRetirementIncomeProjectionInput: PurposeRetirementIncomeProjectionInput;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Rebalance: ResolverTypeWrapper<Rebalance>;
  RecordNotFoundResult: ResolverTypeWrapper<RecordNotFoundResult>;
  RecordUnavailableResult: ResolverTypeWrapper<RecordUnavailableResult>;
  RecurringDepositMotivation: ResolverTypeWrapper<RecurringDepositMotivation>;
  RecurringTransactionConfig: ResolverTypeWrapper<Omit<RecurringTransactionConfig, 'destination' | 'frequency' | 'icon' | 'messages' | 'source'> & { destination: ResolversTypes['TransferableAccount'], frequency: ResolversTypes['RecurringTransactionFrequency'], icon: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']>, source: ResolversTypes['TransferableAccount'] }>;
  RecurringTransactionConfigLifecycleStatus: RecurringTransactionConfigLifecycleStatus;
  RecurringTransactionConfigStatus: ResolverTypeWrapper<RecurringTransactionConfigStatus>;
  RecurringTransactionConfigStatusStyle: RecurringTransactionConfigStatusStyle;
  RecurringTransactionFrequency: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RecurringTransactionFrequency']>;
  RecurringTransactionFrequencyAnnually: ResolverTypeWrapper<RecurringTransactionFrequencyAnnually>;
  RecurringTransactionFrequencyEveryOtherWeek: ResolverTypeWrapper<RecurringTransactionFrequencyEveryOtherWeek>;
  RecurringTransactionFrequencyInput: RecurringTransactionFrequencyInput;
  RecurringTransactionFrequencyMonthly: ResolverTypeWrapper<RecurringTransactionFrequencyMonthly>;
  RecurringTransactionFrequencyTwiceAMonth: ResolverTypeWrapper<RecurringTransactionFrequencyTwiceAMonth>;
  RecurringTransactionFrequencyWeekly: ResolverTypeWrapper<RecurringTransactionFrequencyWeekly>;
  RecurringTransactionSchedule: ResolverTypeWrapper<RecurringTransactionSchedule>;
  ReferralInvitation: ResolverTypeWrapper<ReferralInvitation>;
  ReferralInvitationStatus: ReferralInvitationStatus;
  ReferralProgram: ResolverTypeWrapper<Omit<ReferralProgram, 'featuredImage'> & { featuredImage: ResolversTypes['ThemedAsset'] }>;
  ReferralReward: ResolverTypeWrapper<ReferralReward>;
  ReferralRewardStatus: ReferralRewardStatus;
  ReferralRewardType: ReferralRewardType;
  ReferrerInvitationContent: ResolverTypeWrapper<ReferrerInvitationContent>;
  RelativeRisk: ResolverTypeWrapper<RelativeRisk>;
  RemoteCheckingAccount: ResolverTypeWrapper<RemoteCheckingAccount>;
  RemoveTheirExternalAccountEnvelopeMutationInput: RemoveTheirExternalAccountEnvelopeMutationInput;
  RemoveTheirExternalAccountEnvelopeMutationPayload: ResolverTypeWrapper<Omit<RemoveTheirExternalAccountEnvelopeMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Envelope']> }>;
  ResendPersonalReferralInvitationMutationInput: ResendPersonalReferralInvitationMutationInput;
  ResendPersonalReferralInvitationMutationPayload: ResolverTypeWrapper<ResendPersonalReferralInvitationMutationPayload>;
  RetirementContributionRecommendation: ResolverTypeWrapper<Omit<RetirementContributionRecommendation, 'cta' | 'icon'> & { cta?: Maybe<ResolversTypes['MessageCtaLink']>, icon: ResolversTypes['ThemedAsset'] }>;
  RetirementGrowthPurposeCreationOption: ResolverTypeWrapper<Omit<RetirementGrowthPurposeCreationOption, 'purposeAsset' | 'recommendedMonthlySpending'> & { purposeAsset: ResolversTypes['PurposeAsset'], recommendedMonthlySpending: ResolversTypes['Message'] }>;
  RetirementGrowthUpdateInput: RetirementGrowthUpdateInput;
  RetirementIncomePurposeCreationOption: ResolverTypeWrapper<Omit<RetirementIncomePurposeCreationOption, 'purposeAsset'> & { purposeAsset: ResolversTypes['PurposeAsset'] }>;
  RetirementIncomeUpdateInput: RetirementIncomeUpdateInput;
  RevokeMobileTokenMutationInput: RevokeMobileTokenMutationInput;
  RevokeMobileTokenMutationPayload: ResolverTypeWrapper<Omit<RevokeMobileTokenMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  RewardProgressStatus: ResolverTypeWrapper<RewardProgressStatus>;
  RewardTier: ResolverTypeWrapper<RewardTier>;
  RewardTierFulfillmentStatus: RewardTierFulfillmentStatus;
  RiskBasedAssetAllocation: ResolverTypeWrapper<Omit<RiskBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversTypes['SecurityGroup']> }>;
  RiskLevel: ResolverTypeWrapper<Omit<RiskLevel, 'securityGroups'> & { securityGroups: Array<ResolversTypes['SecurityGroup']> }>;
  RiskLevelBasedPortfolio: ResolverTypeWrapper<Omit<RiskLevelBasedPortfolio, 'riskLevel' | 'strategy'> & { riskLevel: ResolversTypes['RiskLevel'], strategy: ResolversTypes['PortfolioStrategy'] }>;
  RolloverOption: ResolverTypeWrapper<Omit<RolloverOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  RothIraConversionOption: ResolverTypeWrapper<Omit<RothIraConversionOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  SavingsPlan: ResolverTypeWrapper<Omit<SavingsPlan, 'contributionRecommendations'> & { contributionRecommendations: Array<ResolversTypes['RetirementContributionRecommendation']> }>;
  ScheduledEventConfiguration: ResolverTypeWrapper<ScheduledEventConfiguration>;
  SecondaryUserExistingInput: SecondaryUserExistingInput;
  SecondaryUserInput: SecondaryUserInput;
  SecondaryUserNewInput: SecondaryUserNewInput;
  SecuritiesLending: ResolverTypeWrapper<SecuritiesLending>;
  SecuritiesLendingStatus: SecuritiesLendingStatus;
  Security: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Security']>;
  SecurityFund: ResolverTypeWrapper<SecurityFund>;
  SecurityGroup: ResolverTypeWrapper<Omit<SecurityGroup, 'securities'> & { securities: Array<ResolversTypes['Security']> }>;
  SecurityGroupPosition: ResolverTypeWrapper<Omit<SecurityGroupPosition, 'securityGroup' | 'securityPositions' | 'securityPositionsBySecurity'> & { securityGroup: ResolversTypes['SecurityGroup'], securityPositions: Array<ResolversTypes['SecurityPosition']>, securityPositionsBySecurity: Array<ResolversTypes['SecurityPositionsBySecurity']> }>;
  SecurityPosition: ResolverTypeWrapper<Omit<SecurityPosition, 'financialSecurity' | 'security'> & { financialSecurity: ResolversTypes['FinancialSecurity'], security: ResolversTypes['Security'] }>;
  SecurityPositionsBySecurity: ResolverTypeWrapper<Omit<SecurityPositionsBySecurity, 'financialSecurity' | 'securityPositionsBySubAccount'> & { financialSecurity: ResolversTypes['FinancialSecurity'], securityPositionsBySubAccount: Array<ResolversTypes['SecurityPositionsBySubAccount']> }>;
  SecurityPositionsBySubAccount: ResolverTypeWrapper<Omit<SecurityPositionsBySubAccount, 'securityPositions' | 'subAccount'> & { securityPositions: Array<ResolversTypes['SecurityPosition']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  SecurityStock: ResolverTypeWrapper<SecurityStock>;
  SelfDirectedPortfolio: ResolverTypeWrapper<Omit<SelfDirectedPortfolio, 'icon' | 'targetAllocation'> & { icon?: Maybe<ResolversTypes['ThemedAsset']>, targetAllocation: Array<ResolversTypes['SecurityGroup']> }>;
  SendEmailVerificationEmailMutationPayload: ResolverTypeWrapper<Omit<SendEmailVerificationEmailMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['EmailDispatch']> }>;
  SendWireTransferInstructionsEmailMutationInput: SendWireTransferInstructionsEmailMutationInput;
  SendWireTransferInstructionsEmailMutationPayload: ResolverTypeWrapper<Omit<SendWireTransferInstructionsEmailMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['SubAccount']> }>;
  SendWireTransferInstructionsEmailV2MutationInput: SendWireTransferInstructionsEmailV2MutationInput;
  SendWireTransferInstructionsEmailV2MutationPayload: ResolverTypeWrapper<Omit<SendWireTransferInstructionsEmailV2MutationPayload, 'result'> & { result?: Maybe<ResolversTypes['SubAccount']> }>;
  SignablePackage: ResolverTypeWrapper<SignablePackage>;
  Solo401kContributionType: Solo401kContributionType;
  Solo401kInterestBusinessType: Solo401kInterestBusinessType;
  Solo401kInterestPlanDetails: Solo401kInterestPlanDetails;
  Solo401kInterestPlanParticipantsType: Solo401kInterestPlanParticipantsType;
  Solo401kInterestPlanType: Solo401kInterestPlanType;
  Solo401kInterestRequest: ResolverTypeWrapper<Solo401kInterestRequest>;
  Solo401kOnboardingOption: ResolverTypeWrapper<Omit<Solo401kOnboardingOption, 'icon' | 'image'> & { icon: ResolversTypes['ThemedAsset'], image: ResolversTypes['ThemedAsset'] }>;
  SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput: SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput;
  SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload: ResolverTypeWrapper<Omit<SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['AdvisedSoloFourOhOneKClientInvite']> }>;
  SoloFourOhOneKParticipant: ResolverTypeWrapper<SoloFourOhOneKParticipant>;
  SoloFourOhOneKPlan: ResolverTypeWrapper<SoloFourOhOneKPlan>;
  SomebodysExternalAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SomebodysExternalAccount']>;
  Spouse: ResolverTypeWrapper<Spouse>;
  SpouseInput: SpouseInput;
  Status: Status;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StudentLoanPaymentAttestation: ResolverTypeWrapper<StudentLoanPaymentAttestation>;
  StudentLoanPaymentAttestationEntry: ResolverTypeWrapper<StudentLoanPaymentAttestationEntry>;
  StudentLoanPaymentBenefitAttestationEntryInput: StudentLoanPaymentBenefitAttestationEntryInput;
  StudentLoanPaymentEstimate: ResolverTypeWrapper<StudentLoanPaymentEstimate>;
  StudentLoanPaymentEstimationPeriod: StudentLoanPaymentEstimationPeriod;
  SubAccount: ResolverTypeWrapper<Omit<SubAccount, 'goal' | 'recurringTransactionConfigs'> & { goal: ResolversTypes['Goal'], recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']> }>;
  SubAccountRecurringTransactionConfigsWhereInput: SubAccountRecurringTransactionConfigsWhereInput;
  SubmitAdhocDocumentVerificationMutationInput: SubmitAdhocDocumentVerificationMutationInput;
  SubmitAdhocDocumentVerificationMutationPayload: ResolverTypeWrapper<SubmitAdhocDocumentVerificationMutationPayload>;
  SubmitAdhocDocumentVerificationMutationResult: ResolverTypeWrapper<SubmitAdhocDocumentVerificationMutationResult>;
  SubmitDocumentVerificationMutationInput: SubmitDocumentVerificationMutationInput;
  SubmitDocumentVerificationMutationPayload: ResolverTypeWrapper<SubmitDocumentVerificationMutationPayload>;
  SubmitDocumentVerificationMutationResult: ResolverTypeWrapper<SubmitDocumentVerificationMutationResult>;
  SubmitFeedbackMutationInput: SubmitFeedbackMutationInput;
  SubmitFeedbackMutationPayload: ResolverTypeWrapper<Omit<SubmitFeedbackMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  TIN: ResolverTypeWrapper<Scalars['TIN']['output']>;
  Target: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Target']>;
  TargetAmountAndDate: ResolverTypeWrapper<TargetAmountAndDate>;
  TargetBasedPurposeOption: ResolverTypeWrapper<Omit<TargetBasedPurposeOption, 'icon'> & { icon: ResolversTypes['ThemedAsset'] }>;
  TargetMonthlyExpenses: ResolverTypeWrapper<TargetMonthlyExpenses>;
  TargetRetirementSavings: ResolverTypeWrapper<TargetRetirementSavings>;
  TargetRetirementSpending: ResolverTypeWrapper<TargetRetirementSpending>;
  TaxCoordinatedAccountCreationInput: TaxCoordinatedAccountCreationInput;
  TaxCoordinationAccountOption: ResolverTypeWrapper<Omit<TaxCoordinationAccountOption, 'envelopeAccount'> & { envelopeAccount: ResolversTypes['EnvelopeAccount'] }>;
  TaxFilingStatus: TaxFilingStatus;
  TaxImpact: ResolverTypeWrapper<TaxImpact>;
  TaxImpactCopy: ResolverTypeWrapper<TaxImpactCopy>;
  TaxYear: ResolverTypeWrapper<TaxYear>;
  TaxYearContributionTypeEligibilityStatus: TaxYearContributionTypeEligibilityStatus;
  TaxpayerIdentificationNumberType: TaxpayerIdentificationNumberType;
  TermsAndAgreements: ResolverTypeWrapper<TermsAndAgreements>;
  TermsAndAgreementsFilterInput: TermsAndAgreementsFilterInput;
  TermsAndAgreementsOption: TermsAndAgreementsOption;
  TheirExternalAccount: ResolverTypeWrapper<Omit<TheirExternalAccount, 'envelope' | 'goal' | 'icon' | 'messages' | 'subtype'> & { envelope?: Maybe<ResolversTypes['Envelope']>, goal?: Maybe<ResolversTypes['Goal']>, icon: ResolversTypes['ThemedAsset'], messages: Array<ResolversTypes['Message']>, subtype: ResolversTypes['ExternalAccountSubtype'] }>;
  TheirLegalSubAccount: ResolverTypeWrapper<Omit<TheirLegalSubAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversTypes['TransferableAccountOption']> }>;
  ThemedAsset: ResolverTypeWrapper<ThemedAsset>;
  Ticker: ResolverTypeWrapper<Ticker>;
  TieredFeeCalculationMethod: TieredFeeCalculationMethod;
  TimeWeightedRateOfReturn: ResolverTypeWrapper<TimeWeightedRateOfReturn>;
  TlhPriority: TlhPriority;
  TransactionOption: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['TransactionOption']>;
  TransactionRequest: ResolverTypeWrapper<Omit<TransactionRequest, 'transactionSuccessGuidance'> & { transactionSuccessGuidance?: Maybe<ResolversTypes['TransactionSuccessGuidance']> }>;
  TransactionRequestAmountInput: TransactionRequestAmountInput;
  TransactionSuccessGuidance: ResolverTypeWrapper<Omit<TransactionSuccessGuidance, 'progressChecklist'> & { progressChecklist: Array<ResolversTypes['ProgressChecklist']> }>;
  TransferOption: ResolverTypeWrapper<Omit<TransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  TransferableAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['TransferableAccount']>;
  TransferableAccountOption: ResolverTypeWrapper<Omit<TransferableAccountOption, 'account' | 'detail'> & { account: ResolversTypes['TransferableAccount'], detail?: Maybe<ResolversTypes['Message']> }>;
  Trust: ResolverTypeWrapper<Trust>;
  TrustDetailsInput: TrustDetailsInput;
  TrustInput: TrustInput;
  TrustOwnershipOption: ResolverTypeWrapper<TrustOwnershipOption>;
  TrustedContact: ResolverTypeWrapper<TrustedContact>;
  URL: ResolverTypeWrapper<Scalars['URL']['output']>;
  UpdateAccountNameMutationInput: UpdateAccountNameMutationInput;
  UpdateAccountNameMutationPayload: ResolverTypeWrapper<Omit<UpdateAccountNameMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['EnvelopeAccount']> }>;
  UpdateAdvisorNetworkIntentMutationInput: UpdateAdvisorNetworkIntentMutationInput;
  UpdateAdvisorNetworkIntentMutationPayload: ResolverTypeWrapper<Omit<UpdateAdvisorNetworkIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['AdvisorNetworkIntent']> }>;
  UpdateCheckingBeneficiaryMutationInput: UpdateCheckingBeneficiaryMutationInput;
  UpdateCheckingBeneficiaryMutationPayload: ResolverTypeWrapper<Omit<UpdateCheckingBeneficiaryMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['CheckingCustomerResult']> }>;
  UpdateEnvelopeOrdersMutationInput: UpdateEnvelopeOrdersMutationInput;
  UpdateEnvelopeOrdersMutationPayload: ResolverTypeWrapper<Omit<UpdateEnvelopeOrdersMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  UpdateExternalAccountVisibilityMutationInput: UpdateExternalAccountVisibilityMutationInput;
  UpdateExternalAccountVisibilityMutationPayload: ResolverTypeWrapper<Omit<UpdateExternalAccountVisibilityMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['ExternalAccount']> }>;
  UpdateFinancialProfileRetirementAssumptionsMutationInput: UpdateFinancialProfileRetirementAssumptionsMutationInput;
  UpdateFinancialProfileRetirementAssumptionsMutationPayload: ResolverTypeWrapper<UpdateFinancialProfileRetirementAssumptionsMutationPayload>;
  UpdateLegalAccountBeneficiariesMutationInput: UpdateLegalAccountBeneficiariesMutationInput;
  UpdateLegalAccountBeneficiariesMutationPayload: ResolverTypeWrapper<UpdateLegalAccountBeneficiariesMutationPayload>;
  UpdateLegalAccountBeneficiaryInput: UpdateLegalAccountBeneficiaryInput;
  UpdatePurposeInput: UpdatePurposeInput;
  UpdateSecuritiesLendingEnrollmentMutationInput: UpdateSecuritiesLendingEnrollmentMutationInput;
  UpdateSecuritiesLendingEnrollmentMutationPayload: ResolverTypeWrapper<UpdateSecuritiesLendingEnrollmentMutationPayload>;
  UpdateStudentLoanPaymentBenefitAttestationMutationInput: UpdateStudentLoanPaymentBenefitAttestationMutationInput;
  UpdateStudentLoanPaymentBenefitAttestationMutationPayload: ResolverTypeWrapper<Omit<UpdateStudentLoanPaymentBenefitAttestationMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']> }>;
  UpdateStudentLoanPaymentBenefitEstimateMutationInput: UpdateStudentLoanPaymentBenefitEstimateMutationInput;
  UpdateStudentLoanPaymentBenefitEstimateMutationPayload: ResolverTypeWrapper<Omit<UpdateStudentLoanPaymentBenefitEstimateMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']> }>;
  UpdateTrustedContactMutationInput: UpdateTrustedContactMutationInput;
  UpdateTrustedContactMutationPayload: ResolverTypeWrapper<Omit<UpdateTrustedContactMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['User']> }>;
  UpdateUserInvestingExperienceMutationInput: UpdateUserInvestingExperienceMutationInput;
  UpdateUserInvestingExperienceMutationPayload: ResolverTypeWrapper<UpdateUserInvestingExperienceMutationPayload>;
  UpdateUserPostalAddressMutationInput: UpdateUserPostalAddressMutationInput;
  UpdateUserPostalAddressMutationPayload: ResolverTypeWrapper<Omit<UpdateUserPostalAddressMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['User']> }>;
  UpdateUserProfileMutationInput: UpdateUserProfileMutationInput;
  UpdateUserProfileMutationPayload: ResolverTypeWrapper<UpdateUserProfileMutationPayload>;
  UploadAddressChangeDocumentMutationInput: UploadAddressChangeDocumentMutationInput;
  UploadAddressChangeDocumentMutationPayload: ResolverTypeWrapper<Omit<UploadAddressChangeDocumentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Query']> }>;
  User: ResolverTypeWrapper<Omit<User, 'advisorNetworkIntent' | 'premiumOnboardingOption'> & { advisorNetworkIntent?: Maybe<ResolversTypes['AdvisorNetworkIntent']>, premiumOnboardingOption?: Maybe<ResolversTypes['PremiumOnboardingOption']> }>;
  UserLevelSettings: ResolverTypeWrapper<UserLevelSettings>;
  ValidateDirectTradingJointAccountSecondaryUserMutationInput: ValidateDirectTradingJointAccountSecondaryUserMutationInput;
  ValidateDirectTradingJointAccountSecondaryUserMutationPayload: ResolverTypeWrapper<ValidateDirectTradingJointAccountSecondaryUserMutationPayload>;
  ValidateDirectTradingTrustDetailsMutationInput: ValidateDirectTradingTrustDetailsMutationInput;
  ValidateDirectTradingTrustDetailsMutationPayload: ResolverTypeWrapper<ValidateDirectTradingTrustDetailsMutationPayload>;
  ValidateFinancialSecurityOrderRequest: ResolverTypeWrapper<Omit<ValidateFinancialSecurityOrderRequest, 'estimatedTradeTiming'> & { estimatedTradeTiming: ResolversTypes['EstimatedTradeTiming'] }>;
  ValidateFinancialSecurityOrderRequestMutationInput: ValidateFinancialSecurityOrderRequestMutationInput;
  ValidateFinancialSecurityOrderRequestMutationPayload: ResolverTypeWrapper<Omit<ValidateFinancialSecurityOrderRequestMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['ValidateFinancialSecurityOrderRequest']> }>;
  ValidateLegalAccountBeneficiaryMutationInput: ValidateLegalAccountBeneficiaryMutationInput;
  ValidateLegalAccountBeneficiaryMutationPayload: ResolverTypeWrapper<ValidateLegalAccountBeneficiaryMutationPayload>;
  WireTransferInstructions: ResolverTypeWrapper<WireTransferInstructions>;
  WireTransferInstructionsItem: ResolverTypeWrapper<WireTransferInstructionsItem>;
  WireTransferOption: ResolverTypeWrapper<Omit<WireTransferOption, 'accountOptions' | 'transactionUnavailableMessage'> & { accountOptions: Array<ResolversTypes['SubAccount']>, transactionUnavailableMessage?: Maybe<ResolversTypes['Message']> }>;
  YieldBasedAssetAllocation: ResolverTypeWrapper<Omit<YieldBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversTypes['SecurityGroup']> }>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptAdvisoryRelationshipApprovalRequestMutationInput: AcceptAdvisoryRelationshipApprovalRequestMutationInput;
  AcceptAdvisoryRelationshipApprovalRequestMutationPayload: AcceptAdvisoryRelationshipApprovalRequestMutationPayload;
  AcceptAdvisoryRelationshipApprovalRequestMutationResult: AcceptAdvisoryRelationshipApprovalRequestMutationResult;
  AccountOwnershipOption: ResolversInterfaceTypes<ResolversParentTypes>['AccountOwnershipOption'];
  AccountPurposeOption: ResolversInterfaceTypes<ResolversParentTypes>['AccountPurposeOption'];
  AccountRecommendation: Omit<AccountRecommendation, 'productOnboardingOption'> & { productOnboardingOption: ResolversParentTypes['ProductOnboardingOption'] };
  AccountRecommendationOption: Omit<AccountRecommendationOption, 'recommendation'> & { recommendation: ResolversParentTypes['AccountRecommendation'] };
  AccountTaxationOption: AccountTaxationOption;
  ActiveReward: Omit<ActiveReward, 'message'> & { message?: Maybe<ResolversParentTypes['Message']> };
  ActivityDateRangeOption: ActivityDateRangeOption;
  ActivityFilterInput: ActivityFilterInput;
  ActivityItem: ResolversInterfaceTypes<ResolversParentTypes>['ActivityItem'];
  ActivityItemAllocationChange: Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemConnection: Omit<ActivityItemConnection, 'edges' | 'nodes'> & { edges: Array<ResolversParentTypes['ActivityItemEdge']>, nodes: Array<ResolversParentTypes['ActivityItem']> };
  ActivityItemDeposit: Omit<ActivityItemDeposit, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount: ResolversParentTypes['LegalSubAccount'], sourceAccount?: Maybe<ResolversParentTypes['BankAccount']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemDividend: Omit<ActivityItemDividend, 'security'> & { security: ResolversParentTypes['Security'] };
  ActivityItemDividendGroup: Omit<ActivityItemDividendGroup, 'dividends' | 'subAccount'> & { dividends: Array<ResolversParentTypes['ActivityItemDividend']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemEdge: Omit<ActivityItemEdge, 'node'> & { node: ResolversParentTypes['ActivityItem'] };
  ActivityItemFee: Omit<ActivityItemFee, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemIdInput: ActivityItemIdInput;
  ActivityItemOrder: Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: ResolversParentTypes['Security'], subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemOther: Omit<ActivityItemOther, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemRollover: Omit<ActivityItemRollover, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemStatus: ActivityItemStatus;
  ActivityItemTrade: Omit<ActivityItemTrade, 'security'> & { security: ResolversParentTypes['Security'] };
  ActivityItemTradeGroup: Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<ResolversParentTypes['ActivityItemTrade']>, sales: Array<ResolversParentTypes['ActivityItemTrade']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemTransfer: Omit<ActivityItemTransfer, 'destinationAccount' | 'security' | 'sourceAccount'> & { destinationAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, security?: Maybe<ResolversParentTypes['Security']>, sourceAccount?: Maybe<ResolversParentTypes['LegalSubAccount']> };
  ActivityItemTransferGroup: Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, sourceAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, subAccount: ResolversParentTypes['LegalSubAccount'], transferItems: Array<ResolversParentTypes['ActivityItemTransfer']> };
  ActivityItemWithdrawal: Omit<ActivityItemWithdrawal, 'destinationAccount' | 'sourceAccount' | 'subAccount'> & { destinationAccount?: Maybe<ResolversParentTypes['BankAccount']>, sourceAccount: ResolversParentTypes['LegalSubAccount'], subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityTransactionMemo: ActivityTransactionMemo;
  AddEnvelopeExternalAccountsMutationInput: AddEnvelopeExternalAccountsMutationInput;
  AddEnvelopeExternalAccountsMutationPayload: Omit<AddEnvelopeExternalAccountsMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Envelope']> };
  AddressState: AddressState;
  Advice: ResolversInterfaceTypes<ResolversParentTypes>['Advice'];
  AdvisedSoloFourOhOneKClientInvite: Omit<AdvisedSoloFourOhOneKClientInvite, 'advisor'> & { advisor: ResolversParentTypes['Advisor'] };
  Advisor: ResolversInterfaceTypes<ResolversParentTypes>['Advisor'];
  AdvisorNetworkIntent: AdvisorNetworkIntent;
  Agreement: Agreement;
  AllocationBreakdown: AllocationBreakdown;
  AnnualFourOhOneKContributions: Omit<AnnualFourOhOneKContributions, 'result'> & { result: ResolversParentTypes['FourOhOneKContributions'] };
  AnnualIraContributions: Omit<AnnualIraContributions, 'result'> & { result: ResolversParentTypes['IraContributions'] };
  Article: Article;
  ArticleAuthor: ArticleAuthor;
  ArticleCta: ArticleCta;
  ArticleDisclosures: ArticleDisclosures;
  AssetAllocation: ResolversInterfaceTypes<ResolversParentTypes>['AssetAllocation'];
  AssetAllocationDiversification: AssetAllocationDiversification;
  AssetAllocationRisk: AssetAllocationRisk;
  AssetTypeWeight: AssetTypeWeight;
  AutoAdjustOption: AutoAdjustOption;
  Autoglide: Autoglide;
  BalanceProjection: BalanceProjection;
  BalanceProjectionItem: BalanceProjectionItem;
  BankAccount: Omit<BankAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversParentTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  Base64: Scalars['Base64']['output'];
  BeneficiaryUpdateInstructions: BeneficiaryUpdateInstructions;
  BettermentAdvisorNetworkOption: Omit<BettermentAdvisorNetworkOption, 'image'> & { image: ResolversParentTypes['ThemedAsset'] };
  BettermentPremiumOption: Omit<BettermentPremiumOption, 'image'> & { image: ResolversParentTypes['ThemedAsset'] };
  BondPortfolioYields: BondPortfolioYields;
  Boolean: Scalars['Boolean']['output'];
  CancelTransactionRequestMutationInput: CancelTransactionRequestMutationInput;
  CancelTransactionRequestMutationPayload: Omit<CancelTransactionRequestMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: CapturePackageSignatureMutationPayload;
  CashAccount: Omit<CashAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'performance' | 'recurringTransactionConfigs' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: ResolversParentTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversParentTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversParentTypes['ExternalAccount']>, envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'], performance: ResolversParentTypes['Performance'], recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']>, transactionOptions: Array<ResolversParentTypes['TransactionOption']>, transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  CashApy: CashApy;
  CashFdicInsurance: CashFdicInsurance;
  Cents: Scalars['Cents']['output'];
  CharitableDonationOption: Omit<CharitableDonationOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  CheckingAccount: Omit<CheckingAccount, 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  CheckingAccountCreationOption: Omit<CheckingAccountCreationOption, 'icon' | 'image'> & { icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'] };
  CheckingBeneficiary: CheckingBeneficiary;
  CheckingBeneficiaryInput: CheckingBeneficiaryInput;
  CheckingCustomer: CheckingCustomer;
  CheckingCustomerResult: ResolversUnionTypes<ResolversParentTypes>['CheckingCustomerResult'];
  CheckingExternalAccount: Omit<CheckingExternalAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversParentTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  ClientEnvelopeApprovalAdvisorFee: ResolversUnionTypes<ResolversParentTypes>['ClientEnvelopeApprovalAdvisorFee'];
  ClientEnvelopeApprovalAgreement: ClientEnvelopeApprovalAgreement;
  ClientEnvelopeApprovalAgreements: ClientEnvelopeApprovalAgreements;
  ClientEnvelopeApprovalFeeTier: ClientEnvelopeApprovalFeeTier;
  ClientEnvelopeApprovalFirm: ClientEnvelopeApprovalFirm;
  ClientEnvelopeApprovalRateBasedFee: ClientEnvelopeApprovalRateBasedFee;
  ClientEnvelopeApprovalRequest: Omit<ClientEnvelopeApprovalRequest, 'advisorFee'> & { advisorFee?: Maybe<ResolversParentTypes['ClientEnvelopeApprovalAdvisorFee']> };
  ClientEnvelopeApprovalTieredFee: ClientEnvelopeApprovalTieredFee;
  CompleteDraftPurposeFlowMutationInput: CompleteDraftPurposeFlowMutationInput;
  CompleteDraftPurposeFlowMutationPayload: Omit<CompleteDraftPurposeFlowMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['DraftEnvelope']> };
  CompleteTaxCoordinatedAccountCreationFlowMutationInput: CompleteTaxCoordinatedAccountCreationFlowMutationInput;
  CompleteTaxCoordinatedAccountCreationFlowMutationPayload: Omit<CompleteTaxCoordinatedAccountCreationFlowMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Envelope']> };
  ConfirmIdentityVerificationChallengeMutationInput: ConfirmIdentityVerificationChallengeMutationInput;
  ConfirmIdentityVerificationChallengeMutationPayload: ConfirmIdentityVerificationChallengeMutationPayload;
  ContributionTypeOption: ContributionTypeOption;
  ContributionTypeSelectionOption: ContributionTypeSelectionOption;
  CreateAccountRecommendationExplanationMutationInput: CreateAccountRecommendationExplanationMutationInput;
  CreateAccountRecommendationExplanationMutationPayload: CreateAccountRecommendationExplanationMutationPayload;
  CreateDirectTradingAccountMutationInput: CreateDirectTradingAccountMutationInput;
  CreateDirectTradingAccountMutationPayload: Omit<CreateDirectTradingAccountMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['DirectTradingAccount']> };
  CreateDocumentVerificationTokenMutationPayload: CreateDocumentVerificationTokenMutationPayload;
  CreateEmployeeContributionConfigurationChangeRequestMutationInput: CreateEmployeeContributionConfigurationChangeRequestMutationInput;
  CreateEmployeeContributionConfigurationChangeRequestMutationPayload: Omit<CreateEmployeeContributionConfigurationChangeRequestMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['PayrollContributionConfigConnection']> };
  CreateFinancialSecurityOrderRequestMutationInput: CreateFinancialSecurityOrderRequestMutationInput;
  CreateFinancialSecurityOrderRequestMutationPayload: CreateFinancialSecurityOrderRequestMutationPayload;
  CreatePersonalReferralInvitationMutationInput: CreatePersonalReferralInvitationMutationInput;
  CreatePersonalReferralInvitationMutationPayload: CreatePersonalReferralInvitationMutationPayload;
  CreateRecurringTransactionConfigMutationInput: CreateRecurringTransactionConfigMutationInput;
  CreateRecurringTransactionConfigMutationPayload: Omit<CreateRecurringTransactionConfigMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['RecurringTransactionConfig']> };
  CreateSolo401kInterestSubmissionsMutationInput: CreateSolo401kInterestSubmissionsMutationInput;
  CreateSolo401kInterestSubmissionsMutationPayload: CreateSolo401kInterestSubmissionsMutationPayload;
  CreateTransactionMemoMutationInput: CreateTransactionMemoMutationInput;
  CreateTransactionMemoMutationPayload: Omit<CreateTransactionMemoMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['User']> };
  CreateTransactionRequestMutationInput: CreateTransactionRequestMutationInput;
  CreateTransactionRequestMutationPayload: Omit<CreateTransactionRequestMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['TransactionRequest']> };
  CreateUserActivityCsvExportMutationInput: CreateUserActivityCsvExportMutationInput;
  CreateUserActivityCsvExportMutationPayload: CreateUserActivityCsvExportMutationPayload;
  CryptoAdvice: CryptoAdvice;
  CryptoPortfolio: Omit<CryptoPortfolio, 'strategy' | 'tokenIcons'> & { strategy: ResolversParentTypes['PortfolioStrategy'], tokenIcons: Array<ResolversParentTypes['ThemedAsset']> };
  CsvExport: CsvExport;
  CustomizableAssetAllocation: Omit<CustomizableAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversParentTypes['SecurityGroup']> };
  Date: Scalars['Date']['output'];
  DateRange: DateRange;
  DateRangeInput: DateRangeInput;
  DateTime: Scalars['DateTime']['output'];
  DebitCard: DebitCard;
  DeferralSetting: Omit<DeferralSetting, 'account' | 'value'> & { account: ResolversParentTypes['SubAccount'], value: ResolversParentTypes['PayrollContributionConfigValue'] };
  DeferralSettingsEditOption: Omit<DeferralSettingsEditOption, 'deferralSettings' | 'transactionUnavailableMessage'> & { deferralSettings: Array<ResolversParentTypes['DeferralSetting']>, transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  DeleteCheckingBeneficiaryMutationPayload: Omit<DeleteCheckingBeneficiaryMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['CheckingCustomerResult']> };
  DeletePurposeMutationInput: DeletePurposeMutationInput;
  DeletePurposeMutationPayload: Omit<DeletePurposeMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  DeleteRecurringTransactionConfigMutationInput: DeleteRecurringTransactionConfigMutationInput;
  DeleteRecurringTransactionConfigMutationPayload: Omit<DeleteRecurringTransactionConfigMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  DeleteTrustedContactMutationPayload: Omit<DeleteTrustedContactMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['User']> };
  DirectTradingAccount: Omit<DirectTradingAccount, 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'financialSecuritiesSearch' | 'financialSecurity' | 'icon' | 'pendingOrders' | 'performance' | 'securityPosition' | 'securityPositions' | 'transactionOptions' | 'transferSourceAccountOptions'> & { activityConnection: ResolversParentTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversParentTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversParentTypes['ExternalAccount']>, envelope: ResolversParentTypes['Envelope'], financialSecuritiesSearch: Array<ResolversParentTypes['FinancialSecurity']>, financialSecurity: ResolversParentTypes['FinancialSecurity'], icon: ResolversParentTypes['ThemedAsset'], pendingOrders: Array<ResolversParentTypes['ActivityItemOrder']>, performance: ResolversParentTypes['Performance'], securityPosition?: Maybe<ResolversParentTypes['DirectTradingSecurityPosition']>, securityPositions: Array<ResolversParentTypes['DirectTradingSecurityPosition']>, transactionOptions: Array<ResolversParentTypes['TransactionOption']>, transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  DirectTradingCashBalances: DirectTradingCashBalances;
  DirectTradingInvestableAssetsAdvice: DirectTradingInvestableAssetsAdvice;
  DirectTradingJointAccountSecondaryUserValidationInput: DirectTradingJointAccountSecondaryUserValidationInput;
  DirectTradingSecurityPosition: Omit<DirectTradingSecurityPosition, 'financialSecurity' | 'pendingOrders'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'], pendingOrders: Array<ResolversParentTypes['ActivityItemOrder']> };
  DirectTradingSecurityPositionReturn: DirectTradingSecurityPositionReturn;
  DirectTradingTrustDetailsValidationInput: DirectTradingTrustDetailsValidationInput;
  Disclosures: Disclosures;
  DismissUserActivityCsvExportBannerMutationInput: DismissUserActivityCsvExportBannerMutationInput;
  DismissUserActivityCsvExportBannerMutationPayload: DismissUserActivityCsvExportBannerMutationPayload;
  DisplayableError: DisplayableError;
  Document: Document;
  DocumentCategory: DocumentCategory;
  DocumentCategoryDisclosure: DocumentCategoryDisclosure;
  DocumentCategoryGroup: DocumentCategoryGroup;
  DocumentCategoryOrCategoryGroup: ResolversUnionTypes<ResolversParentTypes>['DocumentCategoryOrCategoryGroup'];
  DocumentFile: DocumentFile;
  DocumentFilter: DocumentFilter;
  DocumentFilterOption: DocumentFilterOption;
  DocumentsResult: DocumentsResult;
  DocusignSignature: DocusignSignature;
  DraftEnvelope: Omit<DraftEnvelope, 'editablePurpose'> & { editablePurpose?: Maybe<ResolversParentTypes['EditablePurpose']> };
  DraftEnvelopeAccount: Omit<DraftEnvelopeAccount, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  DraftPurposeEmergencyFund: DraftPurposeEmergencyFund;
  DraftPurposeMajorPurchase: DraftPurposeMajorPurchase;
  DraftPurposeRetirementGrowth: DraftPurposeRetirementGrowth;
  DraftPurposeRetirementIncome: DraftPurposeRetirementIncome;
  Drift: Drift;
  EditableEnvelope: ResolversInterfaceTypes<ResolversParentTypes>['EditableEnvelope'];
  EditablePurpose: ResolversInterfaceTypes<ResolversParentTypes>['EditablePurpose'];
  EditablePurposeEmergencyFund: ResolversInterfaceTypes<ResolversParentTypes>['EditablePurposeEmergencyFund'];
  EditablePurposeMajorPurchase: ResolversInterfaceTypes<ResolversParentTypes>['EditablePurposeMajorPurchase'];
  EditablePurposeRetirementGrowth: ResolversInterfaceTypes<ResolversParentTypes>['EditablePurposeRetirementGrowth'];
  EditablePurposeRetirementIncome: ResolversInterfaceTypes<ResolversParentTypes>['EditablePurposeRetirementIncome'];
  EmailDispatch: Omit<EmailDispatch, 'user'> & { user: ResolversParentTypes['User'] };
  EmergencyFundCoverage: Omit<EmergencyFundCoverage, 'messages'> & { messages: Array<ResolversParentTypes['Message']> };
  EmergencyFundCoverageOption: EmergencyFundCoverageOption;
  EmergencyFundPurposeCreationOption: Omit<EmergencyFundPurposeCreationOption, 'emergencyFundCoverage' | 'purposeAsset' | 'recommendation'> & { emergencyFundCoverage: ResolversParentTypes['EmergencyFundCoverage'], purposeAsset: ResolversParentTypes['PurposeAsset'], recommendation: ResolversParentTypes['Message'] };
  EmergencyFundUpdateInput: EmergencyFundUpdateInput;
  Employee: Employee;
  EmployeeContributionConfigurationChangeInput: EmployeeContributionConfigurationChangeInput;
  Employer: Employer;
  EmployerFourOhOneKContributionConfig: EmployerFourOhOneKContributionConfig;
  EmployerFourOhOneKContributions: EmployerFourOhOneKContributions;
  EmployerFourOhOneKContributionsProjection: EmployerFourOhOneKContributionsProjection;
  EmployerFourOhOneKContributionsResult: EmployerFourOhOneKContributionsResult;
  EmployerFourOhOneKContributionsVested: EmployerFourOhOneKContributionsVested;
  Envelope: Omit<Envelope, 'accounts' | 'activityConnection' | 'icon' | 'legalSubAccounts' | 'messages' | 'payrollContributionConfigs' | 'purpose' | 'recurringTransactionConfigs' | 'transactionOptions'> & { accounts: Array<ResolversParentTypes['EnvelopeAccount']>, activityConnection: ResolversParentTypes['ActivityItemConnection'], icon: ResolversParentTypes['ThemedAsset'], legalSubAccounts: Array<ResolversParentTypes['LegalSubAccount']>, messages: Array<ResolversParentTypes['Message']>, payrollContributionConfigs: Array<ResolversParentTypes['PayrollContributionConfig']>, purpose?: Maybe<ResolversParentTypes['Purpose']>, recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']>, transactionOptions: Array<ResolversParentTypes['TransactionOption']> };
  EnvelopeAccount: ResolversInterfaceTypes<ResolversParentTypes>['EnvelopeAccount'];
  EnvelopeOrderInput: EnvelopeOrderInput;
  EnvelopeStatus: EnvelopeStatus;
  EstimatedTradeDate: EstimatedTradeDate;
  EstimatedTradeTimeRange: EstimatedTradeTimeRange;
  EstimatedTradeTiming: ResolversUnionTypes<ResolversParentTypes>['EstimatedTradeTiming'];
  ExpenseRatio: ExpenseRatio;
  ExpensesBasedPurposeOption: Omit<ExpensesBasedPurposeOption, 'icon' | 'recommendation'> & { icon: ResolversParentTypes['ThemedAsset'], recommendation: ResolversParentTypes['Message'] };
  ExternalAccount: Omit<ExternalAccount, 'envelope' | 'envelopeOptions' | 'goal' | 'icon' | 'messages' | 'subtype' | 'transactionOption'> & { envelope?: Maybe<ResolversParentTypes['Envelope']>, envelopeOptions: Array<ResolversParentTypes['Envelope']>, goal?: Maybe<ResolversParentTypes['Goal']>, icon: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']>, subtype: ResolversParentTypes['ExternalAccountSubtype'], transactionOption?: Maybe<ResolversParentTypes['TransactionOption']> };
  ExternalAccountEmployerMatch: ExternalAccountEmployerMatch;
  ExternalAccountEnvelopeAssociation: Omit<ExternalAccountEnvelopeAssociation, 'account' | 'envelope' | 'icon'> & { account: ResolversParentTypes['SomebodysExternalAccount'], envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'] };
  ExternalAccountPlanContributions: ExternalAccountPlanContributions;
  ExternalAccountSubtype: ResolversInterfaceTypes<ResolversParentTypes>['ExternalAccountSubtype'];
  ExternalAccountSubtypeBasic: ExternalAccountSubtypeBasic;
  ExternalAccountSubtypeEmployerSponsored: ExternalAccountSubtypeEmployerSponsored;
  ExternalAccountSubtypeIra: ExternalAccountSubtypeIra;
  ExternalAccountsWhereInput: ExternalAccountsWhereInput;
  ExternalTransferOption: Omit<ExternalTransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  ExternallyAdvisedPlanPortfolio: Omit<ExternallyAdvisedPlanPortfolio, 'strategy'> & { strategy: ResolversParentTypes['PortfolioStrategy'] };
  FinancialCoachingOnboardingOption: Omit<FinancialCoachingOnboardingOption, 'icon' | 'image'> & { icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'] };
  FinancialProfile: FinancialProfile;
  FinancialProfileRetirementAssumptions: FinancialProfileRetirementAssumptions;
  FinancialProfileRetirementUserAssumptions: FinancialProfileRetirementUserAssumptions;
  FinancialSecurity: ResolversInterfaceTypes<ResolversParentTypes>['FinancialSecurity'];
  FinancialSecurityCompanyProfile: Omit<FinancialSecurityCompanyProfile, 'logo'> & { logo?: Maybe<ResolversParentTypes['ThemedAsset']> };
  FinancialSecurityFund: Omit<FinancialSecurityFund, 'fundamentals' | 'portfolio'> & { fundamentals: ResolversParentTypes['FinancialSecurityFundamentals'], portfolio: ResolversParentTypes['FinancialSecurityFundPortfolio'] };
  FinancialSecurityFundPortfolio: Omit<FinancialSecurityFundPortfolio, 'holdings'> & { holdings: Array<ResolversParentTypes['FinancialSecurityFundPortfolioHolding']> };
  FinancialSecurityFundPortfolioHolding: Omit<FinancialSecurityFundPortfolioHolding, 'security'> & { security?: Maybe<ResolversParentTypes['FinancialSecurity']> };
  FinancialSecurityFundamentals: ResolversInterfaceTypes<ResolversParentTypes>['FinancialSecurityFundamentals'];
  FinancialSecurityFundamentalsDividendYield: FinancialSecurityFundamentalsDividendYield;
  FinancialSecurityFundamentalsDividendsAmount: FinancialSecurityFundamentalsDividendsAmount;
  FinancialSecurityFundamentalsEarningsPerShare: FinancialSecurityFundamentalsEarningsPerShare;
  FinancialSecurityFundamentalsEbitda: FinancialSecurityFundamentalsEbitda;
  FinancialSecurityFundamentalsExpenseRatio: FinancialSecurityFundamentalsExpenseRatio;
  FinancialSecurityFundamentalsFund: FinancialSecurityFundamentalsFund;
  FinancialSecurityFundamentalsFundAnnual: FinancialSecurityFundamentalsFundAnnual;
  FinancialSecurityFundamentalsFundTrailingTwelveMonths: FinancialSecurityFundamentalsFundTrailingTwelveMonths;
  FinancialSecurityFundamentalsMarketCap: FinancialSecurityFundamentalsMarketCap;
  FinancialSecurityFundamentalsPriceToEarningsRatio: FinancialSecurityFundamentalsPriceToEarningsRatio;
  FinancialSecurityFundamentalsRevenue: FinancialSecurityFundamentalsRevenue;
  FinancialSecurityFundamentalsSharesOutstanding: FinancialSecurityFundamentalsSharesOutstanding;
  FinancialSecurityFundamentalsStock: FinancialSecurityFundamentalsStock;
  FinancialSecurityFundamentalsStockAnnual: FinancialSecurityFundamentalsStockAnnual;
  FinancialSecurityFundamentalsStockTrailingTwelveMonths: FinancialSecurityFundamentalsStockTrailingTwelveMonths;
  FinancialSecurityOrderRequest: FinancialSecurityOrderRequest;
  FinancialSecurityOrderRequestAccountIdInput: FinancialSecurityOrderRequestAccountIdInput;
  FinancialSecurityOrderRequestValueInput: FinancialSecurityOrderRequestValueInput;
  FinancialSecurityPriceHistory: FinancialSecurityPriceHistory;
  FinancialSecurityPricePerformance: FinancialSecurityPricePerformance;
  FinancialSecurityPricePerformancePricePoint: FinancialSecurityPricePerformancePricePoint;
  FinancialSecurityPricePoint: FinancialSecurityPricePoint;
  FinancialSecurityPriceReturns: FinancialSecurityPriceReturns;
  FinancialSecurityStatistics: FinancialSecurityStatistics;
  FinancialSecurityStatisticsComponentDays: FinancialSecurityStatisticsComponentDays;
  FinancialSecurityStatisticsComponentIntraDay: FinancialSecurityStatisticsComponentIntraDay;
  FinancialSecurityStatisticsLatestPrice: FinancialSecurityStatisticsLatestPrice;
  FinancialSecurityStock: Omit<FinancialSecurityStock, 'companyProfile' | 'fundamentals'> & { companyProfile: ResolversParentTypes['FinancialSecurityCompanyProfile'], fundamentals: ResolversParentTypes['FinancialSecurityFundamentals'] };
  FinancialServiceOption: ResolversInterfaceTypes<ResolversParentTypes>['FinancialServiceOption'];
  Firm: Firm;
  Five29Account: Omit<Five29Account, 'accountConnection' | 'activityConnection' | 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'transferSourceAccountOptions'> & { accountConnection?: Maybe<ResolversParentTypes['Five29AccountConnection']>, activityConnection: ResolversParentTypes['ActivityItemConnection'], bankAccountEligibleCheckingAccounts: Array<ResolversParentTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversParentTypes['ExternalAccount']>, envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  Five29AccountConnection: Omit<Five29AccountConnection, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  FiveTwoNineGoalCreationOption: Omit<FiveTwoNineGoalCreationOption, 'icon' | 'image'> & { icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'] };
  Float: Scalars['Float']['output'];
  FourOhOneKContributions: Omit<FourOhOneKContributions, 'projection'> & { projection?: Maybe<ResolversParentTypes['FourOhOneKContributionsProjection']> };
  FourOhOneKContributionsLineItem: FourOhOneKContributionsLineItem;
  FourOhOneKContributionsProjection: Omit<FourOhOneKContributionsProjection, 'deferralSettingsEditOption' | 'deferralSettingsEditOptionV2' | 'messages' | 'recurringInflows'> & { deferralSettingsEditOption: ResolversParentTypes['DeferralSettingsEditOption'], deferralSettingsEditOptionV2?: Maybe<ResolversParentTypes['DeferralSettingsEditOption']>, messages: Array<ResolversParentTypes['Message']>, recurringInflows: Array<ResolversParentTypes['RecurringTransactionConfig']> };
  FourOhOneKContributionsResult: Omit<FourOhOneKContributionsResult, 'allTime' | 'thisYear'> & { allTime: ResolversParentTypes['FourOhOneKContributions'], thisYear: ResolversParentTypes['AnnualFourOhOneKContributions'] };
  FourOhOneKStudentLoanMatchBenefit: Omit<FourOhOneKStudentLoanMatchBenefit, 'currentLoanPaymentEstimate' | 'messages'> & { currentLoanPaymentEstimate?: Maybe<ResolversParentTypes['StudentLoanPaymentEstimate']>, messages: Array<ResolversParentTypes['Message']> };
  GeneralPurposeOption: Omit<GeneralPurposeOption, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  Goal: Omit<Goal, 'advice' | 'envelope' | 'externalAccounts' | 'icon' | 'image' | 'messages' | 'portfolio' | 'subAccounts'> & { advice?: Maybe<ResolversParentTypes['Advice']>, envelope: ResolversParentTypes['Envelope'], externalAccounts: Array<ResolversParentTypes['ExternalAccount']>, icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']>, portfolio?: Maybe<ResolversParentTypes['Portfolio']>, subAccounts: Array<ResolversParentTypes['SubAccount']> };
  GoalBalances: GoalBalances;
  GoalCreationIntent: Omit<GoalCreationIntent, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  GoalCreationOption: Omit<GoalCreationOption, 'accountOwnershipOption' | 'accountOwnershipOptions' | 'accountPurposeOption' | 'accountPurposeOptions' | 'draftEnvelopeAccount' | 'emergencyFundCoverage' | 'icon' | 'image' | 'modelPortfolioOption' | 'modelPortfolioOptions' | 'termsAndAgreements'> & { accountOwnershipOption: ResolversParentTypes['AccountOwnershipOption'], accountOwnershipOptions: Array<ResolversParentTypes['AccountOwnershipOption']>, accountPurposeOption: ResolversParentTypes['AccountPurposeOption'], accountPurposeOptions: Array<ResolversParentTypes['AccountPurposeOption']>, draftEnvelopeAccount?: Maybe<ResolversParentTypes['DraftEnvelopeAccount']>, emergencyFundCoverage?: Maybe<ResolversParentTypes['EmergencyFundCoverage']>, icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'], modelPortfolioOption: ResolversParentTypes['ModelPortfolioOption'], modelPortfolioOptions: Array<ResolversParentTypes['ModelPortfolioOption']>, termsAndAgreements: Array<ResolversParentTypes['LegacyTermsAndAgreements']> };
  GoalStatusSummary: GoalStatusSummary;
  Grant: ResolversInterfaceTypes<ResolversParentTypes>['Grant'];
  HTML: Scalars['HTML']['output'];
  HistoricalPerformance: HistoricalPerformance;
  ID: Scalars['ID']['output'];
  IdentityVerificationChallenge: IdentityVerificationChallenge;
  IndividualOwnershipOption: IndividualOwnershipOption;
  InitiateStudentLoanPaymentBenefitAttestationMutationPayload: Omit<InitiateStudentLoanPaymentBenefitAttestationMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['FourOhOneKStudentLoanMatchBenefit']> };
  InstitutionalAdvisor: Omit<InstitutionalAdvisor, 'logo'> & { logo?: Maybe<ResolversParentTypes['ThemedAsset']> };
  Int: Scalars['Int']['output'];
  InvestmentPortfolio: Omit<InvestmentPortfolio, 'icon' | 'strategy'> & { icon?: Maybe<ResolversParentTypes['ThemedAsset']>, strategy: ResolversParentTypes['PortfolioStrategy'] };
  IraContributionMatchGrant: IraContributionMatchGrant;
  IraContributionMatchGrantsWhereInput: IraContributionMatchGrantsWhereInput;
  IraContributions: Omit<IraContributions, 'lineItems' | 'projection'> & { lineItems: Array<ResolversParentTypes['IraContributionsLineItem']>, projection?: Maybe<ResolversParentTypes['IraContributionsProjection']> };
  IraContributionsByYearWhere: IraContributionsByYearWhere;
  IraContributionsLineItem: IraContributionsLineItem;
  IraContributionsProjection: Omit<IraContributionsProjection, 'messages' | 'recurringInflows'> & { messages: Array<ResolversParentTypes['Message']>, recurringInflows: Array<ResolversParentTypes['RecurringTransactionConfig']> };
  IraContributionsResult: Omit<IraContributionsResult, 'allTime' | 'byYear'> & { allTime: ResolversParentTypes['IraContributions'], byYear: Array<ResolversParentTypes['AnnualIraContributions']> };
  JSON: Scalars['JSON']['output'];
  JointAccountInvitation: JointAccountInvitation;
  JointOwnershipOption: JointOwnershipOption;
  LegacyAllocationAssets: LegacyAllocationAssets;
  LegacyAssetClass: LegacyAssetClass;
  LegacyHoldingsPageInfo: LegacyHoldingsPageInfo;
  LegacyID: Scalars['LegacyID']['output'];
  LegacyNamedOptions: LegacyNamedOptions;
  LegacyPortfolioDetails: LegacyPortfolioDetails;
  LegacyPortfolioInfoRow: LegacyPortfolioInfoRow;
  LegacyPortfolioStrategyOption: Omit<LegacyPortfolioStrategyOption, 'icon' | 'messages'> & { icon: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']> };
  LegacySecurity: LegacySecurity;
  LegacySecurityGroupDetails: LegacySecurityGroupDetails;
  LegacySuperAssetClass: LegacySuperAssetClass;
  LegacyTermsAndAgreements: Omit<LegacyTermsAndAgreements, 'agreements' | 'image'> & { agreements: Array<ResolversParentTypes['Agreement']>, image?: Maybe<ResolversParentTypes['ThemedAsset']> };
  LegacyUUID: Scalars['LegacyUUID']['output'];
  LegacyWeightedSecurity: LegacyWeightedSecurity;
  LegalAccount: LegalAccount;
  LegalAccountBeneficiary: LegalAccountBeneficiary;
  LegalAccountBeneficiaryInput: LegalAccountBeneficiaryInput;
  LegalAccountTypeInput: LegalAccountTypeInput;
  LegalSubAccount: ResolversInterfaceTypes<ResolversParentTypes>['LegalSubAccount'];
  LegalSubAccountInput: LegalSubAccountInput;
  MajorPurchasePurposeCreationOption: Omit<MajorPurchasePurposeCreationOption, 'purposeAsset'> & { purposeAsset: ResolversParentTypes['PurposeAsset'] };
  MajorPurchaseUpdateInput: MajorPurchaseUpdateInput;
  ManageRecurringTransactionsOption: Omit<ManageRecurringTransactionsOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  ManagedAccount: Omit<ManagedAccount, 'activityConnection' | 'assetAllocation' | 'envelope' | 'icon' | 'messages' | 'minFeeWarning' | 'payrollContributionConfigs' | 'performance' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccounts' | 'transactionOptions'> & { activityConnection: ResolversParentTypes['ActivityItemConnection'], assetAllocation: ResolversParentTypes['AssetAllocation'], envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']>, minFeeWarning?: Maybe<ResolversParentTypes['Message']>, payrollContributionConfigs: Array<ResolversParentTypes['PayrollContributionConfig']>, performance: ResolversParentTypes['Performance'], portfolio: ResolversParentTypes['ManagedPortfolio'], recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']>, securityGroupPositions: Array<ResolversParentTypes['SecurityGroupPosition']>, subAccounts: Array<ResolversParentTypes['ManagedSubAccount']>, transactionOptions: Array<ResolversParentTypes['TransactionOption']> };
  ManagedAccountProjection: ManagedAccountProjection;
  ManagedAccountProjectionInput: ManagedAccountProjectionInput;
  ManagedPortfolio: ResolversInterfaceTypes<ResolversParentTypes>['ManagedPortfolio'];
  ManagedSubAccount: Omit<ManagedSubAccount, 'bankAccountEligibleCheckingAccounts' | 'bankAccountEligibleExternalAccounts' | 'envelope' | 'icon' | 'managedAccount' | 'transferSourceAccountOptions'> & { bankAccountEligibleCheckingAccounts: Array<ResolversParentTypes['CheckingAccount']>, bankAccountEligibleExternalAccounts: Array<ResolversParentTypes['ExternalAccount']>, envelope: ResolversParentTypes['Envelope'], icon: ResolversParentTypes['ThemedAsset'], managedAccount: ResolversParentTypes['ManagedAccount'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  MarketSchedule: MarketSchedule;
  MarketingMessage: MarketingMessage;
  MarketingMessageExtras: MarketingMessageExtras;
  MarketingMessageExtrasInput: MarketingMessageExtrasInput;
  MarketingMessageInput: MarketingMessageInput;
  MarketingMessagesInput: MarketingMessagesInput;
  MemoCreationOption: MemoCreationOption;
  MemoReasonOption: MemoReasonOption;
  Message: Omit<Message, 'cta'> & { cta?: Maybe<ResolversParentTypes['MessageCta']> };
  MessageCta: ResolversInterfaceTypes<ResolversParentTypes>['MessageCta'];
  MessageCtaLink: MessageCtaLink;
  MessageCtaModal: MessageCtaModal;
  MessageLocation: Scalars['MessageLocation']['output'];
  ModelPortfolioOption: Omit<ModelPortfolioOption, 'assetAllocations' | 'icon' | 'recommendedAllocation'> & { assetAllocations: Array<ResolversParentTypes['AssetAllocation']>, icon: ResolversParentTypes['ThemedAsset'], recommendedAllocation: ResolversParentTypes['AssetAllocation'] };
  MoneyWeightedRateOfReturn: MoneyWeightedRateOfReturn;
  Mutation: Record<PropertyKey, never>;
  NetWorth: NetWorth;
  NetWorthSubtotal: NetWorthSubtotal;
  NetWorthSubtotalItem: NetWorthSubtotalItem;
  OtherUser: OtherUser;
  PageInfo: PageInfo;
  PayrollContributionConfig: Omit<PayrollContributionConfig, 'account' | 'bonusValue' | 'value'> & { account: ResolversParentTypes['PayrollContributionConfigAccount'], bonusValue?: Maybe<ResolversParentTypes['PayrollContributionConfigValue']>, value: ResolversParentTypes['PayrollContributionConfigValue'] };
  PayrollContributionConfigAccount: ResolversInterfaceTypes<ResolversParentTypes>['PayrollContributionConfigAccount'];
  PayrollContributionConfigConnection: Omit<PayrollContributionConfigConnection, 'edges' | 'nodes'> & { edges: Array<ResolversParentTypes['PayrollContributionConfigEdge']>, nodes: Array<ResolversParentTypes['PayrollContributionConfig']> };
  PayrollContributionConfigEdge: Omit<PayrollContributionConfigEdge, 'node'> & { node: ResolversParentTypes['PayrollContributionConfig'] };
  PayrollContributionConfigValue: ResolversUnionTypes<ResolversParentTypes>['PayrollContributionConfigValue'];
  PayrollContributionConfigValueAmount: PayrollContributionConfigValueAmount;
  PayrollContributionConfigValuePercent: PayrollContributionConfigValuePercent;
  PayrollContributionConfigsWhereInput: PayrollContributionConfigsWhereInput;
  PendingDocumentVerificationRequest: PendingDocumentVerificationRequest;
  Percent: Scalars['Percent']['output'];
  Performance: Omit<Performance, 'accounts'> & { accounts: Array<ResolversParentTypes['PerformanceAccount']> };
  PerformanceAccount: ResolversInterfaceTypes<ResolversParentTypes>['PerformanceAccount'];
  PerformanceBenchmark: PerformanceBenchmark;
  PerformanceBenchmarkGroup: PerformanceBenchmarkGroup;
  PerformanceBenchmarkTimeWeightedReturns: PerformanceBenchmarkTimeWeightedReturns;
  PerformanceHistory: PerformanceHistory;
  PerformanceHistoryItem: PerformanceHistoryItem;
  PerformanceHistoryTimeWeightedReturnItem: PerformanceHistoryTimeWeightedReturnItem;
  PerformanceInterest: PerformanceInterest;
  PerformanceInvesting: PerformanceInvesting;
  PerformanceTimeWeightedReturns: PerformanceTimeWeightedReturns;
  PerformanceTotals: PerformanceTotals;
  PerformanceTotalsDividends: PerformanceTotalsDividends;
  PerformanceTotalsFees: PerformanceTotalsFees;
  PerformanceTotalsUserTransactions: PerformanceTotalsUserTransactions;
  PerformanceTotalsUserTransactionsPending: PerformanceTotalsUserTransactionsPending;
  Portfolio: ResolversInterfaceTypes<ResolversParentTypes>['Portfolio'];
  PortfolioStrategy: Omit<PortfolioStrategy, 'icon'> & { icon?: Maybe<ResolversParentTypes['ThemedAsset']> };
  PostalAddress: PostalAddress;
  PostalAddressInput: PostalAddressInput;
  PremiumAdvisor: Omit<PremiumAdvisor, 'logo'> & { logo?: Maybe<ResolversParentTypes['ThemedAsset']> };
  PremiumOnboardingOption: Omit<PremiumOnboardingOption, 'icon' | 'image'> & { icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'] };
  PriceGroup: PriceGroup;
  PriceGroupMinFee: PriceGroupMinFee;
  PriceGroupPremiumPricing: PriceGroupPremiumPricing;
  PriceGroupPricingCta: PriceGroupPricingCta;
  PriceGroupPricingTier: PriceGroupPricingTier;
  PriceGroupPricingTierBreakdown: PriceGroupPricingTierBreakdown;
  PriceRange: PriceRange;
  ProcessCapitalizeWindowEventMutationInput: ProcessCapitalizeWindowEventMutationInput;
  ProcessCapitalizeWindowEventMutationPayload: Omit<ProcessCapitalizeWindowEventMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  ProductBundle: Omit<ProductBundle, 'image' | 'productOnboardingOptions'> & { image: ResolversParentTypes['ThemedAsset'], productOnboardingOptions: Array<ResolversParentTypes['ProductOnboardingOption']> };
  ProductOnboardingOption: ResolversInterfaceTypes<ResolversParentTypes>['ProductOnboardingOption'];
  ProductOnboardingStep: ProductOnboardingStep;
  ProductUnavailability: ProductUnavailability;
  Profession: Profession;
  ProgressChecklist: Omit<ProgressChecklist, 'cta'> & { cta?: Maybe<ResolversParentTypes['MessageCta']> };
  Purpose: ResolversInterfaceTypes<ResolversParentTypes>['Purpose'];
  PurposeAsset: Omit<PurposeAsset, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  PurposeCreationOptionInterface: ResolversInterfaceTypes<ResolversParentTypes>['PurposeCreationOptionInterface'];
  PurposeEmergencyFund: Omit<PurposeEmergencyFund, 'envelope' | 'image' | 'target'> & { envelope: ResolversParentTypes['Envelope'], image: ResolversParentTypes['ThemedAsset'], target?: Maybe<ResolversParentTypes['Target']> };
  PurposeEmergencyFundProjection: PurposeEmergencyFundProjection;
  PurposeEmergencyFundProjectionInput: PurposeEmergencyFundProjectionInput;
  PurposeEmergencyFundTarget: PurposeEmergencyFundTarget;
  PurposeMajorPurchase: Omit<PurposeMajorPurchase, 'envelope' | 'image' | 'target'> & { envelope: ResolversParentTypes['Envelope'], image: ResolversParentTypes['ThemedAsset'], target?: Maybe<ResolversParentTypes['Target']> };
  PurposeMajorPurchaseProjection: PurposeMajorPurchaseProjection;
  PurposeMajorPurchaseProjectionCompletion: PurposeMajorPurchaseProjectionCompletion;
  PurposeMajorPurchaseProjectionInput: PurposeMajorPurchaseProjectionInput;
  PurposeMajorPurchaseTarget: PurposeMajorPurchaseTarget;
  PurposeRetirementGrowth: Omit<PurposeRetirementGrowth, 'envelope' | 'image' | 'projection' | 'target'> & { envelope: ResolversParentTypes['Envelope'], image: ResolversParentTypes['ThemedAsset'], projection?: Maybe<ResolversParentTypes['PurposeRetirementGrowthProjection']>, target?: Maybe<ResolversParentTypes['Target']> };
  PurposeRetirementGrowthProjection: Omit<PurposeRetirementGrowthProjection, 'completion' | 'savingsPlan'> & { completion: ResolversParentTypes['PurposeRetirementGrowthProjectionCompletion'], savingsPlan: ResolversParentTypes['SavingsPlan'] };
  PurposeRetirementGrowthProjectionCompletion: PurposeRetirementGrowthProjectionCompletion;
  PurposeRetirementGrowthProjectionInput: PurposeRetirementGrowthProjectionInput;
  PurposeRetirementGrowthTarget: PurposeRetirementGrowthTarget;
  PurposeRetirementIncome: Omit<PurposeRetirementIncome, 'envelope' | 'image' | 'target'> & { envelope: ResolversParentTypes['Envelope'], image: ResolversParentTypes['ThemedAsset'], target?: Maybe<ResolversParentTypes['Target']> };
  PurposeRetirementIncomeProjection: PurposeRetirementIncomeProjection;
  PurposeRetirementIncomeProjectionInput: PurposeRetirementIncomeProjectionInput;
  Query: Record<PropertyKey, never>;
  Rebalance: Rebalance;
  RecordNotFoundResult: RecordNotFoundResult;
  RecordUnavailableResult: RecordUnavailableResult;
  RecurringDepositMotivation: RecurringDepositMotivation;
  RecurringTransactionConfig: Omit<RecurringTransactionConfig, 'destination' | 'frequency' | 'icon' | 'messages' | 'source'> & { destination: ResolversParentTypes['TransferableAccount'], frequency: ResolversParentTypes['RecurringTransactionFrequency'], icon: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']>, source: ResolversParentTypes['TransferableAccount'] };
  RecurringTransactionConfigStatus: RecurringTransactionConfigStatus;
  RecurringTransactionFrequency: ResolversUnionTypes<ResolversParentTypes>['RecurringTransactionFrequency'];
  RecurringTransactionFrequencyAnnually: RecurringTransactionFrequencyAnnually;
  RecurringTransactionFrequencyEveryOtherWeek: RecurringTransactionFrequencyEveryOtherWeek;
  RecurringTransactionFrequencyInput: RecurringTransactionFrequencyInput;
  RecurringTransactionFrequencyMonthly: RecurringTransactionFrequencyMonthly;
  RecurringTransactionFrequencyTwiceAMonth: RecurringTransactionFrequencyTwiceAMonth;
  RecurringTransactionFrequencyWeekly: RecurringTransactionFrequencyWeekly;
  RecurringTransactionSchedule: RecurringTransactionSchedule;
  ReferralInvitation: ReferralInvitation;
  ReferralProgram: Omit<ReferralProgram, 'featuredImage'> & { featuredImage: ResolversParentTypes['ThemedAsset'] };
  ReferralReward: ReferralReward;
  ReferrerInvitationContent: ReferrerInvitationContent;
  RelativeRisk: RelativeRisk;
  RemoteCheckingAccount: RemoteCheckingAccount;
  RemoveTheirExternalAccountEnvelopeMutationInput: RemoveTheirExternalAccountEnvelopeMutationInput;
  RemoveTheirExternalAccountEnvelopeMutationPayload: Omit<RemoveTheirExternalAccountEnvelopeMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Envelope']> };
  ResendPersonalReferralInvitationMutationInput: ResendPersonalReferralInvitationMutationInput;
  ResendPersonalReferralInvitationMutationPayload: ResendPersonalReferralInvitationMutationPayload;
  RetirementContributionRecommendation: Omit<RetirementContributionRecommendation, 'cta' | 'icon'> & { cta?: Maybe<ResolversParentTypes['MessageCtaLink']>, icon: ResolversParentTypes['ThemedAsset'] };
  RetirementGrowthPurposeCreationOption: Omit<RetirementGrowthPurposeCreationOption, 'purposeAsset' | 'recommendedMonthlySpending'> & { purposeAsset: ResolversParentTypes['PurposeAsset'], recommendedMonthlySpending: ResolversParentTypes['Message'] };
  RetirementGrowthUpdateInput: RetirementGrowthUpdateInput;
  RetirementIncomePurposeCreationOption: Omit<RetirementIncomePurposeCreationOption, 'purposeAsset'> & { purposeAsset: ResolversParentTypes['PurposeAsset'] };
  RetirementIncomeUpdateInput: RetirementIncomeUpdateInput;
  RevokeMobileTokenMutationInput: RevokeMobileTokenMutationInput;
  RevokeMobileTokenMutationPayload: Omit<RevokeMobileTokenMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  RewardProgressStatus: RewardProgressStatus;
  RewardTier: RewardTier;
  RiskBasedAssetAllocation: Omit<RiskBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversParentTypes['SecurityGroup']> };
  RiskLevel: Omit<RiskLevel, 'securityGroups'> & { securityGroups: Array<ResolversParentTypes['SecurityGroup']> };
  RiskLevelBasedPortfolio: Omit<RiskLevelBasedPortfolio, 'riskLevel' | 'strategy'> & { riskLevel: ResolversParentTypes['RiskLevel'], strategy: ResolversParentTypes['PortfolioStrategy'] };
  RolloverOption: Omit<RolloverOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  RothIraConversionOption: Omit<RothIraConversionOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  SavingsPlan: Omit<SavingsPlan, 'contributionRecommendations'> & { contributionRecommendations: Array<ResolversParentTypes['RetirementContributionRecommendation']> };
  ScheduledEventConfiguration: ScheduledEventConfiguration;
  SecondaryUserExistingInput: SecondaryUserExistingInput;
  SecondaryUserInput: SecondaryUserInput;
  SecondaryUserNewInput: SecondaryUserNewInput;
  SecuritiesLending: SecuritiesLending;
  Security: ResolversInterfaceTypes<ResolversParentTypes>['Security'];
  SecurityFund: SecurityFund;
  SecurityGroup: Omit<SecurityGroup, 'securities'> & { securities: Array<ResolversParentTypes['Security']> };
  SecurityGroupPosition: Omit<SecurityGroupPosition, 'securityGroup' | 'securityPositions' | 'securityPositionsBySecurity'> & { securityGroup: ResolversParentTypes['SecurityGroup'], securityPositions: Array<ResolversParentTypes['SecurityPosition']>, securityPositionsBySecurity: Array<ResolversParentTypes['SecurityPositionsBySecurity']> };
  SecurityPosition: Omit<SecurityPosition, 'financialSecurity' | 'security'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'], security: ResolversParentTypes['Security'] };
  SecurityPositionsBySecurity: Omit<SecurityPositionsBySecurity, 'financialSecurity' | 'securityPositionsBySubAccount'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'], securityPositionsBySubAccount: Array<ResolversParentTypes['SecurityPositionsBySubAccount']> };
  SecurityPositionsBySubAccount: Omit<SecurityPositionsBySubAccount, 'securityPositions' | 'subAccount'> & { securityPositions: Array<ResolversParentTypes['SecurityPosition']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  SecurityStock: SecurityStock;
  SelfDirectedPortfolio: Omit<SelfDirectedPortfolio, 'icon' | 'targetAllocation'> & { icon?: Maybe<ResolversParentTypes['ThemedAsset']>, targetAllocation: Array<ResolversParentTypes['SecurityGroup']> };
  SendEmailVerificationEmailMutationPayload: Omit<SendEmailVerificationEmailMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['EmailDispatch']> };
  SendWireTransferInstructionsEmailMutationInput: SendWireTransferInstructionsEmailMutationInput;
  SendWireTransferInstructionsEmailMutationPayload: Omit<SendWireTransferInstructionsEmailMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['SubAccount']> };
  SendWireTransferInstructionsEmailV2MutationInput: SendWireTransferInstructionsEmailV2MutationInput;
  SendWireTransferInstructionsEmailV2MutationPayload: Omit<SendWireTransferInstructionsEmailV2MutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['SubAccount']> };
  SignablePackage: SignablePackage;
  Solo401kInterestPlanDetails: Solo401kInterestPlanDetails;
  Solo401kInterestRequest: Solo401kInterestRequest;
  Solo401kOnboardingOption: Omit<Solo401kOnboardingOption, 'icon' | 'image'> & { icon: ResolversParentTypes['ThemedAsset'], image: ResolversParentTypes['ThemedAsset'] };
  SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput: SoloFourOhOneKClientEnvelopeFlowCompletionMutationInput;
  SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload: Omit<SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['AdvisedSoloFourOhOneKClientInvite']> };
  SoloFourOhOneKParticipant: SoloFourOhOneKParticipant;
  SoloFourOhOneKPlan: SoloFourOhOneKPlan;
  SomebodysExternalAccount: ResolversInterfaceTypes<ResolversParentTypes>['SomebodysExternalAccount'];
  Spouse: Spouse;
  SpouseInput: SpouseInput;
  String: Scalars['String']['output'];
  StudentLoanPaymentAttestation: StudentLoanPaymentAttestation;
  StudentLoanPaymentAttestationEntry: StudentLoanPaymentAttestationEntry;
  StudentLoanPaymentBenefitAttestationEntryInput: StudentLoanPaymentBenefitAttestationEntryInput;
  StudentLoanPaymentEstimate: StudentLoanPaymentEstimate;
  SubAccount: Omit<SubAccount, 'goal' | 'recurringTransactionConfigs'> & { goal: ResolversParentTypes['Goal'], recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']> };
  SubAccountRecurringTransactionConfigsWhereInput: SubAccountRecurringTransactionConfigsWhereInput;
  SubmitAdhocDocumentVerificationMutationInput: SubmitAdhocDocumentVerificationMutationInput;
  SubmitAdhocDocumentVerificationMutationPayload: SubmitAdhocDocumentVerificationMutationPayload;
  SubmitAdhocDocumentVerificationMutationResult: SubmitAdhocDocumentVerificationMutationResult;
  SubmitDocumentVerificationMutationInput: SubmitDocumentVerificationMutationInput;
  SubmitDocumentVerificationMutationPayload: SubmitDocumentVerificationMutationPayload;
  SubmitDocumentVerificationMutationResult: SubmitDocumentVerificationMutationResult;
  SubmitFeedbackMutationInput: SubmitFeedbackMutationInput;
  SubmitFeedbackMutationPayload: Omit<SubmitFeedbackMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  TIN: Scalars['TIN']['output'];
  Target: ResolversInterfaceTypes<ResolversParentTypes>['Target'];
  TargetAmountAndDate: TargetAmountAndDate;
  TargetBasedPurposeOption: Omit<TargetBasedPurposeOption, 'icon'> & { icon: ResolversParentTypes['ThemedAsset'] };
  TargetMonthlyExpenses: TargetMonthlyExpenses;
  TargetRetirementSavings: TargetRetirementSavings;
  TargetRetirementSpending: TargetRetirementSpending;
  TaxCoordinatedAccountCreationInput: TaxCoordinatedAccountCreationInput;
  TaxCoordinationAccountOption: Omit<TaxCoordinationAccountOption, 'envelopeAccount'> & { envelopeAccount: ResolversParentTypes['EnvelopeAccount'] };
  TaxImpact: TaxImpact;
  TaxImpactCopy: TaxImpactCopy;
  TaxYear: TaxYear;
  TermsAndAgreements: TermsAndAgreements;
  TermsAndAgreementsFilterInput: TermsAndAgreementsFilterInput;
  TheirExternalAccount: Omit<TheirExternalAccount, 'envelope' | 'goal' | 'icon' | 'messages' | 'subtype'> & { envelope?: Maybe<ResolversParentTypes['Envelope']>, goal?: Maybe<ResolversParentTypes['Goal']>, icon: ResolversParentTypes['ThemedAsset'], messages: Array<ResolversParentTypes['Message']>, subtype: ResolversParentTypes['ExternalAccountSubtype'] };
  TheirLegalSubAccount: Omit<TheirLegalSubAccount, 'icon' | 'transferSourceAccountOptions'> & { icon: ResolversParentTypes['ThemedAsset'], transferSourceAccountOptions: Array<ResolversParentTypes['TransferableAccountOption']> };
  ThemedAsset: ThemedAsset;
  Ticker: Ticker;
  TimeWeightedRateOfReturn: TimeWeightedRateOfReturn;
  TransactionOption: ResolversInterfaceTypes<ResolversParentTypes>['TransactionOption'];
  TransactionRequest: Omit<TransactionRequest, 'transactionSuccessGuidance'> & { transactionSuccessGuidance?: Maybe<ResolversParentTypes['TransactionSuccessGuidance']> };
  TransactionRequestAmountInput: TransactionRequestAmountInput;
  TransactionSuccessGuidance: Omit<TransactionSuccessGuidance, 'progressChecklist'> & { progressChecklist: Array<ResolversParentTypes['ProgressChecklist']> };
  TransferOption: Omit<TransferOption, 'transactionUnavailableMessage'> & { transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  TransferableAccount: ResolversInterfaceTypes<ResolversParentTypes>['TransferableAccount'];
  TransferableAccountOption: Omit<TransferableAccountOption, 'account' | 'detail'> & { account: ResolversParentTypes['TransferableAccount'], detail?: Maybe<ResolversParentTypes['Message']> };
  Trust: Trust;
  TrustDetailsInput: TrustDetailsInput;
  TrustInput: TrustInput;
  TrustOwnershipOption: TrustOwnershipOption;
  TrustedContact: TrustedContact;
  URL: Scalars['URL']['output'];
  UpdateAccountNameMutationInput: UpdateAccountNameMutationInput;
  UpdateAccountNameMutationPayload: Omit<UpdateAccountNameMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['EnvelopeAccount']> };
  UpdateAdvisorNetworkIntentMutationInput: UpdateAdvisorNetworkIntentMutationInput;
  UpdateAdvisorNetworkIntentMutationPayload: Omit<UpdateAdvisorNetworkIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['AdvisorNetworkIntent']> };
  UpdateCheckingBeneficiaryMutationInput: UpdateCheckingBeneficiaryMutationInput;
  UpdateCheckingBeneficiaryMutationPayload: Omit<UpdateCheckingBeneficiaryMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['CheckingCustomerResult']> };
  UpdateEnvelopeOrdersMutationInput: UpdateEnvelopeOrdersMutationInput;
  UpdateEnvelopeOrdersMutationPayload: Omit<UpdateEnvelopeOrdersMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  UpdateExternalAccountVisibilityMutationInput: UpdateExternalAccountVisibilityMutationInput;
  UpdateExternalAccountVisibilityMutationPayload: Omit<UpdateExternalAccountVisibilityMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['ExternalAccount']> };
  UpdateFinancialProfileRetirementAssumptionsMutationInput: UpdateFinancialProfileRetirementAssumptionsMutationInput;
  UpdateFinancialProfileRetirementAssumptionsMutationPayload: UpdateFinancialProfileRetirementAssumptionsMutationPayload;
  UpdateLegalAccountBeneficiariesMutationInput: UpdateLegalAccountBeneficiariesMutationInput;
  UpdateLegalAccountBeneficiariesMutationPayload: UpdateLegalAccountBeneficiariesMutationPayload;
  UpdateLegalAccountBeneficiaryInput: UpdateLegalAccountBeneficiaryInput;
  UpdatePurposeInput: UpdatePurposeInput;
  UpdateSecuritiesLendingEnrollmentMutationInput: UpdateSecuritiesLendingEnrollmentMutationInput;
  UpdateSecuritiesLendingEnrollmentMutationPayload: UpdateSecuritiesLendingEnrollmentMutationPayload;
  UpdateStudentLoanPaymentBenefitAttestationMutationInput: UpdateStudentLoanPaymentBenefitAttestationMutationInput;
  UpdateStudentLoanPaymentBenefitAttestationMutationPayload: Omit<UpdateStudentLoanPaymentBenefitAttestationMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['FourOhOneKStudentLoanMatchBenefit']> };
  UpdateStudentLoanPaymentBenefitEstimateMutationInput: UpdateStudentLoanPaymentBenefitEstimateMutationInput;
  UpdateStudentLoanPaymentBenefitEstimateMutationPayload: Omit<UpdateStudentLoanPaymentBenefitEstimateMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['FourOhOneKStudentLoanMatchBenefit']> };
  UpdateTrustedContactMutationInput: UpdateTrustedContactMutationInput;
  UpdateTrustedContactMutationPayload: Omit<UpdateTrustedContactMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['User']> };
  UpdateUserInvestingExperienceMutationInput: UpdateUserInvestingExperienceMutationInput;
  UpdateUserInvestingExperienceMutationPayload: UpdateUserInvestingExperienceMutationPayload;
  UpdateUserPostalAddressMutationInput: UpdateUserPostalAddressMutationInput;
  UpdateUserPostalAddressMutationPayload: Omit<UpdateUserPostalAddressMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['User']> };
  UpdateUserProfileMutationInput: UpdateUserProfileMutationInput;
  UpdateUserProfileMutationPayload: UpdateUserProfileMutationPayload;
  UploadAddressChangeDocumentMutationInput: UploadAddressChangeDocumentMutationInput;
  UploadAddressChangeDocumentMutationPayload: Omit<UploadAddressChangeDocumentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Query']> };
  User: Omit<User, 'advisorNetworkIntent' | 'premiumOnboardingOption'> & { advisorNetworkIntent?: Maybe<ResolversParentTypes['AdvisorNetworkIntent']>, premiumOnboardingOption?: Maybe<ResolversParentTypes['PremiumOnboardingOption']> };
  UserLevelSettings: UserLevelSettings;
  ValidateDirectTradingJointAccountSecondaryUserMutationInput: ValidateDirectTradingJointAccountSecondaryUserMutationInput;
  ValidateDirectTradingJointAccountSecondaryUserMutationPayload: ValidateDirectTradingJointAccountSecondaryUserMutationPayload;
  ValidateDirectTradingTrustDetailsMutationInput: ValidateDirectTradingTrustDetailsMutationInput;
  ValidateDirectTradingTrustDetailsMutationPayload: ValidateDirectTradingTrustDetailsMutationPayload;
  ValidateFinancialSecurityOrderRequest: Omit<ValidateFinancialSecurityOrderRequest, 'estimatedTradeTiming'> & { estimatedTradeTiming: ResolversParentTypes['EstimatedTradeTiming'] };
  ValidateFinancialSecurityOrderRequestMutationInput: ValidateFinancialSecurityOrderRequestMutationInput;
  ValidateFinancialSecurityOrderRequestMutationPayload: Omit<ValidateFinancialSecurityOrderRequestMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['ValidateFinancialSecurityOrderRequest']> };
  ValidateLegalAccountBeneficiaryMutationInput: ValidateLegalAccountBeneficiaryMutationInput;
  ValidateLegalAccountBeneficiaryMutationPayload: ValidateLegalAccountBeneficiaryMutationPayload;
  WireTransferInstructions: WireTransferInstructions;
  WireTransferInstructionsItem: WireTransferInstructionsItem;
  WireTransferOption: Omit<WireTransferOption, 'accountOptions' | 'transactionUnavailableMessage'> & { accountOptions: Array<ResolversParentTypes['SubAccount']>, transactionUnavailableMessage?: Maybe<ResolversParentTypes['Message']> };
  YieldBasedAssetAllocation: Omit<YieldBasedAssetAllocation, 'securityGroups'> & { securityGroups: Array<ResolversParentTypes['SecurityGroup']> };
};

export type MaxSupportedVersionDirectiveArgs = {
  version: Scalars['String']['input'];
};

export type MaxSupportedVersionDirectiveResolver<Result, Parent, ContextType = any, Args = MaxSupportedVersionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type OperationServiceConfigDirectiveArgs = {
  feature: Scalars['String']['input'];
};

export type OperationServiceConfigDirectiveResolver<Result, Parent, ContextType = any, Args = OperationServiceConfigDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type OwnedDirectiveArgs = {
  by: Scalars['String']['input'];
};

export type OwnedDirectiveResolver<Result, Parent, ContextType = any, Args = OwnedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AcceptAdvisoryRelationshipApprovalRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptAdvisoryRelationshipApprovalRequestMutationPayload'] = ResolversParentTypes['AcceptAdvisoryRelationshipApprovalRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['AcceptAdvisoryRelationshipApprovalRequestMutationResult']>, ParentType, ContextType>;
};

export type AcceptAdvisoryRelationshipApprovalRequestMutationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptAdvisoryRelationshipApprovalRequestMutationResult'] = ResolversParentTypes['AcceptAdvisoryRelationshipApprovalRequestMutationResult']> = {
  advisorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  householdEnrolled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AccountOwnershipOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountOwnershipOption'] = ResolversParentTypes['AccountOwnershipOption']> = {
  __resolveType: TypeResolveFn<'IndividualOwnershipOption' | 'JointOwnershipOption' | 'TrustOwnershipOption', ParentType, ContextType>;
};

export type AccountPurposeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountPurposeOption'] = ResolversParentTypes['AccountPurposeOption']> = {
  __resolveType: TypeResolveFn<'ExpensesBasedPurposeOption' | 'GeneralPurposeOption' | 'TargetBasedPurposeOption', ParentType, ContextType>;
};

export type AccountRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountRecommendation'] = ResolversParentTypes['AccountRecommendation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSkipEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  optionDisclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  productOnboardingOption?: Resolver<ResolversTypes['ProductOnboardingOption'], ParentType, ContextType>;
};

export type AccountRecommendationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountRecommendationOption'] = ResolversParentTypes['AccountRecommendationOption']> = {
  postExplanationDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  preExplanationDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  recommendation?: Resolver<ResolversTypes['AccountRecommendation'], ParentType, ContextType, Partial<AccountRecommendationOptionRecommendationArgs>>;
};

export type AccountTaxationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTaxationOption'] = ResolversParentTypes['AccountTaxationOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxationType?: Resolver<ResolversTypes['LegalAccountTaxationType'], ParentType, ContextType>;
};

export type ActiveRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveReward'] = ResolversParentTypes['ActiveReward']> = {
  detailedDescription?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  disclosureDescription?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  fulfillmentConditionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fulfillmentRewardDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  periodEndDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promotionWindow?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  rewardCompositionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardContextDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardProgressStatuses?: Resolver<Array<ResolversTypes['RewardProgressStatus']>, ParentType, ContextType>;
  rewardValueDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  tiers?: Resolver<Array<ResolversTypes['RewardTier']>, ParentType, ContextType>;
};

export type ActivityDateRangeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDateRangeOption'] = ResolversParentTypes['ActivityDateRangeOption']> = {
  endDateInclusive?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDateInclusive?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
};

export type ActivityItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItem'] = ResolversParentTypes['ActivityItem']> = {
  __resolveType: TypeResolveFn<'ActivityItemAllocationChange' | 'ActivityItemDeposit' | 'ActivityItemDividendGroup' | 'ActivityItemFee' | 'ActivityItemOrder' | 'ActivityItemOther' | 'ActivityItemRollover' | 'ActivityItemTradeGroup' | 'ActivityItemTransferGroup' | 'ActivityItemWithdrawal', ParentType, ContextType>;
};

export type ActivityItemAllocationChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemAllocationChange'] = ResolversParentTypes['ActivityItemAllocationChange']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newPortfolioDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemConnection'] = ResolversParentTypes['ActivityItemConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ActivityItemEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityItem']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
};

export type ActivityItemDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemDeposit'] = ResolversParentTypes['ActivityItemDeposit']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  depositRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transactionMemo?: Resolver<Maybe<ResolversTypes['ActivityTransactionMemo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemDividendResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemDividend'] = ResolversParentTypes['ActivityItemDividend']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
};

export type ActivityItemDividendGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemDividendGroup'] = ResolversParentTypes['ActivityItemDividendGroup']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dividends?: Resolver<Array<ResolversTypes['ActivityItemDividend']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemEdge'] = ResolversParentTypes['ActivityItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ActivityItem'], ParentType, ContextType>;
};

export type ActivityItemFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemFee'] = ResolversParentTypes['ActivityItemFee']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemOrder'] = ResolversParentTypes['ActivityItemOrder']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  amountRequested?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  amountTraded?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  financialSecurityOrderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  sharePrice?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  sharesRequested?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharesTraded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ActivityItemStatus'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  tradeSide?: Resolver<ResolversTypes['ActivityItemTradeSide'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemOtherResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemOther'] = ResolversParentTypes['ActivityItemOther']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemRolloverResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemRollover'] = ResolversParentTypes['ActivityItemRollover']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemStatus'] = ResolversParentTypes['ActivityItemStatus']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['ActivityItemStage'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type ActivityItemTradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTrade'] = ResolversParentTypes['ActivityItemTrade']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  sharePrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeAttribution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradeAttributionV2?: Resolver<Maybe<ResolversTypes['ActivityItemTradeAttribution']>, ParentType, ContextType>;
  tradeSide?: Resolver<ResolversTypes['ActivityItemTradeSide'], ParentType, ContextType>;
};

export type ActivityItemTradeGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTradeGroup'] = ResolversParentTypes['ActivityItemTradeGroup']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  purchases?: Resolver<Array<ResolversTypes['ActivityItemTrade']>, ParentType, ContextType>;
  purchasesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  sales?: Resolver<Array<ResolversTypes['ActivityItemTrade']>, ParentType, ContextType>;
  salesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTransfer'] = ResolversParentTypes['ActivityItemTransfer']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  assetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assetTypeV2?: Resolver<ResolversTypes['ActivityItemTransferAssetType'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  requestedDollarTransferAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  security?: Resolver<Maybe<ResolversTypes['Security']>, ParentType, ContextType>;
  sharePrice?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  shares?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  transferRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type ActivityItemTransferGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTransferGroup'] = ResolversParentTypes['ActivityItemTransferGroup']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFullTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transferItems?: Resolver<Array<ResolversTypes['ActivityItemTransfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemWithdrawalResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemWithdrawal'] = ResolversParentTypes['ActivityItemWithdrawal']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFullWithdrawal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transactionMemo?: Resolver<Maybe<ResolversTypes['ActivityTransactionMemo']>, ParentType, ContextType>;
  withdrawalRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTransactionMemoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTransactionMemo'] = ResolversParentTypes['ActivityTransactionMemo']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AddEnvelopeExternalAccountsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddEnvelopeExternalAccountsMutationPayload'] = ResolversParentTypes['AddEnvelopeExternalAccountsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Envelope']>, ParentType, ContextType>;
};

export type AddressStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressState'] = ResolversParentTypes['AddressState']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advice'] = ResolversParentTypes['Advice']> = {
  __resolveType: TypeResolveFn<'CryptoAdvice', ParentType, ContextType>;
};

export type AdvisedSoloFourOhOneKClientInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvisedSoloFourOhOneKClientInvite'] = ResolversParentTypes['AdvisedSoloFourOhOneKClientInvite']> = {
  advisor?: Resolver<ResolversTypes['Advisor'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSoloFourOhOneKPlanOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  signablePackage?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdvisedSoloFourOhOneKClientInviteStatus'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdvisorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advisor'] = ResolversParentTypes['Advisor']> = {
  __resolveType: TypeResolveFn<'InstitutionalAdvisor' | 'PremiumAdvisor', ParentType, ContextType>;
};

export type AdvisorNetworkIntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvisorNetworkIntent'] = ResolversParentTypes['AdvisorNetworkIntent']> = {
  isExpired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdvisorNetworkIntentStatus'], ParentType, ContextType>;
};

export type AgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agreement'] = ResolversParentTypes['Agreement']> = {
  htmlBody?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AllocationBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllocationBreakdown'] = ResolversParentTypes['AllocationBreakdown']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AllocationType'], ParentType, ContextType>;
};

export type AnnualFourOhOneKContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnualFourOhOneKContributions'] = ResolversParentTypes['AnnualFourOhOneKContributions']> = {
  result?: Resolver<ResolversTypes['FourOhOneKContributions'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['TaxYear'], ParentType, ContextType>;
};

export type AnnualIraContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnualIraContributions'] = ResolversParentTypes['AnnualIraContributions']> = {
  result?: Resolver<ResolversTypes['IraContributions'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['TaxYear'], ParentType, ContextType>;
};

export type ArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article'] = ResolversParentTypes['Article']> = {
  author?: Resolver<ResolversTypes['ArticleAuthor'], ParentType, ContextType>;
  bodyHtml?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  cta?: Resolver<ResolversTypes['ArticleCta'], ParentType, ContextType>;
  disclosures?: Resolver<Maybe<ResolversTypes['ArticleDisclosures']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageAltText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type ArticleAuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArticleAuthor'] = ResolversParentTypes['ArticleAuthor']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ArticleCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArticleCta'] = ResolversParentTypes['ArticleCta']> = {
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
};

export type ArticleDisclosuresResolvers<ContextType = any, ParentType extends ResolversParentTypes['ArticleDisclosures'] = ResolversParentTypes['ArticleDisclosures']> = {
  defaultDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oneOffDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optionalDisclosures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type AssetAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetAllocation'] = ResolversParentTypes['AssetAllocation']> = {
  __resolveType: TypeResolveFn<'CustomizableAssetAllocation' | 'RiskBasedAssetAllocation' | 'YieldBasedAssetAllocation', ParentType, ContextType>;
};

export type AssetAllocationDiversificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetAllocationDiversification'] = ResolversParentTypes['AssetAllocationDiversification']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AssetAllocationRiskResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetAllocationRisk'] = ResolversParentTypes['AssetAllocationRisk']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AssetTypeWeightResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetTypeWeight'] = ResolversParentTypes['AssetTypeWeight']> = {
  percentage?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AllocationType'], ParentType, ContextType>;
};

export type AutoAdjustOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoAdjustOption'] = ResolversParentTypes['AutoAdjustOption']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AutoglideResolvers<ContextType = any, ParentType extends ResolversParentTypes['Autoglide'] = ResolversParentTypes['Autoglide']> = {
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type BalanceProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceProjection'] = ResolversParentTypes['BalanceProjection']> = {
  timeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
};

export type BalanceProjectionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceProjectionItem'] = ResolversParentTypes['BalanceProjectionItem']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  expected?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netDeposits?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  optimistic?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  pessimistic?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyObject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Base64ScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Base64'], any> {
  name: 'Base64';
}

export type BeneficiaryUpdateInstructionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BeneficiaryUpdateInstructions'] = ResolversParentTypes['BeneficiaryUpdateInstructions']> = {
  instructions?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BettermentAdvisorNetworkOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BettermentAdvisorNetworkOption'] = ResolversParentTypes['BettermentAdvisorNetworkOption']> = {
  description?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  feeDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  minimumBalanceDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledEventConfiguration?: Resolver<ResolversTypes['ScheduledEventConfiguration'], ParentType, ContextType, RequireFields<BettermentAdvisorNetworkOptionScheduledEventConfigurationArgs, 'scheduleEvent'>>;
  serviceFee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BettermentPremiumOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BettermentPremiumOption'] = ResolversParentTypes['BettermentPremiumOption']> = {
  description?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  feeDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  minimumBalanceDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledEventConfiguration?: Resolver<ResolversTypes['ScheduledEventConfiguration'], ParentType, ContextType, RequireFields<BettermentPremiumOptionScheduledEventConfigurationArgs, 'scheduleEvent'>>;
  serviceFee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BondPortfolioYieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BondPortfolioYields'] = ResolversParentTypes['BondPortfolioYields']> = {
  afterTaxYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  afterTaxYieldExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  blendedSecYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  blendedSecYieldExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type CancelTransactionRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelTransactionRequestMutationPayload'] = ResolversParentTypes['CancelTransactionRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type CapturePackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapturePackageSignatureMutationPayload'] = ResolversParentTypes['CapturePackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
};

export type CashAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashAccount'] = ResolversParentTypes['CashAccount']> = {
  accountDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<CashAccountActivityConnectionArgs, 'filters'>>;
  apy?: Resolver<ResolversTypes['CashApy'], ParentType, ContextType>;
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, Partial<CashAccountArticlesArgs>>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<CashAccountBalanceArgs, 'includePending'>>;
  balanceProjection?: Resolver<Maybe<ResolversTypes['BalanceProjection']>, ParentType, ContextType>;
  bankAccountEligibleCheckingAccounts?: Resolver<Array<ResolversTypes['CheckingAccount']>, ParentType, ContextType>;
  bankAccountEligibleExternalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  fdicInsurance?: Resolver<ResolversTypes['CashFdicInsurance'], ParentType, ContextType>;
  hasReachedOpsBankAccountLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isClosed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurringDepositEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<CashAccountPerformanceArgs, 'dateRangeOption'>>;
  performanceTotals?: Resolver<ResolversTypes['PerformanceTotals'], ParentType, ContextType>;
  recurringDepositMotivation?: Resolver<Maybe<ResolversTypes['RecurringDepositMotivation']>, ParentType, ContextType>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  transactionOptions?: Resolver<Array<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CashApyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashApy'] = ResolversParentTypes['CashApy']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isBoostActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBoostEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CashFdicInsuranceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashFdicInsurance'] = ResolversParentTypes['CashFdicInsurance']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface CentsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cents'], any> {
  name: 'Cents';
}

export type CharitableDonationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CharitableDonationOption'] = ResolversParentTypes['CharitableDonationOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingAccount'] = ResolversParentTypes['CheckingAccount']> = {
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remote?: Resolver<Maybe<ResolversTypes['RemoteCheckingAccount']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckingAccountCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingAccountCreationOption'] = ResolversParentTypes['CheckingAccountCreationOption']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<CheckingAccountCreationOptionImageArgs, 'variant'>>;
  isInManualReview?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInManualReviewWithDocumentsRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  requiresDocumentVerification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckingBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingBeneficiary'] = ResolversParentTypes['CheckingBeneficiary']> = {
  dateOfBirth?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxId?: Resolver<ResolversTypes['TIN'], ParentType, ContextType>;
};

export type CheckingCustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingCustomer'] = ResolversParentTypes['CheckingCustomer']> = {
  account?: Resolver<ResolversTypes['RemoteCheckingAccount'], ParentType, ContextType, RequireFields<CheckingCustomerAccountArgs, 'id'>>;
  accounts?: Resolver<Array<ResolversTypes['RemoteCheckingAccount']>, ParentType, ContextType>;
  beneficiary?: Resolver<Maybe<ResolversTypes['CheckingBeneficiary']>, ParentType, ContextType>;
  beneficiaryUpdateInstructions?: Resolver<ResolversTypes['BeneficiaryUpdateInstructions'], ParentType, ContextType>;
  card?: Resolver<ResolversTypes['DebitCard'], ParentType, ContextType>;
  cardPendingVerification?: Resolver<Maybe<ResolversTypes['DebitCard']>, ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckingCustomerResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingCustomerResult'] = ResolversParentTypes['CheckingCustomerResult']> = {
  __resolveType: TypeResolveFn<'CheckingCustomer' | 'RecordNotFoundResult' | 'RecordUnavailableResult', ParentType, ContextType>;
};

export type CheckingExternalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckingExternalAccount'] = ResolversParentTypes['CheckingExternalAccount']> = {
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientEnvelopeApprovalAdvisorFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalAdvisorFee'] = ResolversParentTypes['ClientEnvelopeApprovalAdvisorFee']> = {
  __resolveType: TypeResolveFn<'ClientEnvelopeApprovalRateBasedFee' | 'ClientEnvelopeApprovalTieredFee', ParentType, ContextType>;
};

export type ClientEnvelopeApprovalAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalAgreement'] = ResolversParentTypes['ClientEnvelopeApprovalAgreement']> = {
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeApprovalAgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalAgreements'] = ResolversParentTypes['ClientEnvelopeApprovalAgreements']> = {
  advPart2bAgreement?: Resolver<Maybe<ResolversTypes['ClientEnvelopeApprovalAgreement']>, ParentType, ContextType>;
  banAgreement?: Resolver<Maybe<ResolversTypes['ClientEnvelopeApprovalAgreement']>, ParentType, ContextType>;
  clientAgreement?: Resolver<Maybe<ResolversTypes['ClientEnvelopeApprovalAgreement']>, ParentType, ContextType>;
};

export type ClientEnvelopeApprovalFeeTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalFeeTier'] = ResolversParentTypes['ClientEnvelopeApprovalFeeTier']> = {
  range?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeApprovalFirmResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalFirm'] = ResolversParentTypes['ClientEnvelopeApprovalFirm']> = {
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeApprovalRateBasedFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalRateBasedFee'] = ResolversParentTypes['ClientEnvelopeApprovalRateBasedFee']> = {
  rate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientEnvelopeApprovalRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalRequest'] = ResolversParentTypes['ClientEnvelopeApprovalRequest']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  advisorFee?: Resolver<Maybe<ResolversTypes['ClientEnvelopeApprovalAdvisorFee']>, ParentType, ContextType>;
  agreements?: Resolver<ResolversTypes['ClientEnvelopeApprovalAgreements'], ParentType, ContextType>;
  clientEnvelopeApprovalRequestSource?: Resolver<ResolversTypes['ClientEnvelopeApprovalRequestSource'], ParentType, ContextType>;
  expiredOrCancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firm?: Resolver<ResolversTypes['ClientEnvelopeApprovalFirm'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  platformFee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeApprovalTieredFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeApprovalTieredFee'] = ResolversParentTypes['ClientEnvelopeApprovalTieredFee']> = {
  calculationMethod?: Resolver<ResolversTypes['TieredFeeCalculationMethod'], ParentType, ContextType>;
  tiers?: Resolver<Array<ResolversTypes['ClientEnvelopeApprovalFeeTier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompleteDraftPurposeFlowMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompleteDraftPurposeFlowMutationPayload'] = ResolversParentTypes['CompleteDraftPurposeFlowMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['DraftEnvelope']>, ParentType, ContextType>;
};

export type CompleteTaxCoordinatedAccountCreationFlowMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompleteTaxCoordinatedAccountCreationFlowMutationPayload'] = ResolversParentTypes['CompleteTaxCoordinatedAccountCreationFlowMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Envelope']>, ParentType, ContextType>;
};

export type ConfirmIdentityVerificationChallengeMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmIdentityVerificationChallengeMutationPayload'] = ResolversParentTypes['ConfirmIdentityVerificationChallengeMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['IdentityVerificationChallenge']>, ParentType, ContextType>;
};

export type ContributionTypeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionTypeOption'] = ResolversParentTypes['ContributionTypeOption']> = {
  contributionLimitAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  contributionType?: Resolver<ResolversTypes['ContributionType'], ParentType, ContextType>;
  currentContributionAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eligibilityStatus?: Resolver<ResolversTypes['TaxYearContributionTypeEligibilityStatus'], ParentType, ContextType>;
  remainingContributionAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  taxYear?: Resolver<Maybe<ResolversTypes['TaxYear']>, ParentType, ContextType>;
};

export type ContributionTypeSelectionOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContributionTypeSelectionOption'] = ResolversParentTypes['ContributionTypeSelectionOption']> = {
  contributionLimitsRules?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  contributionTypeOptions?: Resolver<Array<ResolversTypes['ContributionTypeOption']>, ParentType, ContextType>;
  contributionTypeSelectionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxYearSelectionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxYearSelectionGuidance?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
};

export type CreateAccountRecommendationExplanationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAccountRecommendationExplanationMutationPayload'] = ResolversParentTypes['CreateAccountRecommendationExplanationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
};

export type CreateDirectTradingAccountMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDirectTradingAccountMutationPayload'] = ResolversParentTypes['CreateDirectTradingAccountMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['DirectTradingAccount']>, ParentType, ContextType>;
};

export type CreateDocumentVerificationTokenMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDocumentVerificationTokenMutationPayload'] = ResolversParentTypes['CreateDocumentVerificationTokenMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateEmployeeContributionConfigurationChangeRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateEmployeeContributionConfigurationChangeRequestMutationPayload'] = ResolversParentTypes['CreateEmployeeContributionConfigurationChangeRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['PayrollContributionConfigConnection']>, ParentType, ContextType, Partial<CreateEmployeeContributionConfigurationChangeRequestMutationPayloadResultArgs>>;
};

export type CreateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFinancialSecurityOrderRequestMutationPayload'] = ResolversParentTypes['CreateFinancialSecurityOrderRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialSecurityOrderRequest']>, ParentType, ContextType>;
};

export type CreatePersonalReferralInvitationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePersonalReferralInvitationMutationPayload'] = ResolversParentTypes['CreatePersonalReferralInvitationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ReferralInvitation']>, ParentType, ContextType>;
};

export type CreateRecurringTransactionConfigMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRecurringTransactionConfigMutationPayload'] = ResolversParentTypes['CreateRecurringTransactionConfigMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
};

export type CreateSolo401kInterestSubmissionsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSolo401kInterestSubmissionsMutationPayload'] = ResolversParentTypes['CreateSolo401kInterestSubmissionsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kInterestRequest']>, ParentType, ContextType>;
};

export type CreateTransactionMemoMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTransactionMemoMutationPayload'] = ResolversParentTypes['CreateTransactionMemoMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type CreateTransactionRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTransactionRequestMutationPayload'] = ResolversParentTypes['CreateTransactionRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['TransactionRequest']>, ParentType, ContextType>;
};

export type CreateUserActivityCsvExportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserActivityCsvExportMutationPayload'] = ResolversParentTypes['CreateUserActivityCsvExportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type CryptoAdviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CryptoAdvice'] = ResolversParentTypes['CryptoAdvice']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CryptoPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['CryptoPortfolio'] = ResolversParentTypes['CryptoPortfolio']> = {
  strategy?: Resolver<ResolversTypes['PortfolioStrategy'], ParentType, ContextType>;
  tokenIcons?: Resolver<Array<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CsvExportResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsvExport'] = ResolversParentTypes['CsvExport']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CsvExportStatus'], ParentType, ContextType>;
};

export type CustomizableAssetAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomizableAssetAllocation'] = ResolversParentTypes['CustomizableAssetAllocation']> = {
  assetTypeWeights?: Resolver<Array<ResolversTypes['AssetTypeWeight']>, ParentType, ContextType>;
  diversification?: Resolver<ResolversTypes['AssetAllocationDiversification'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  risk?: Resolver<ResolversTypes['AssetAllocationRisk'], ParentType, ContextType>;
  securityGroups?: Resolver<Array<ResolversTypes['SecurityGroup']>, ParentType, ContextType>;
  securityWeights?: Resolver<Array<ResolversTypes['LegacyWeightedSecurity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateRange'] = ResolversParentTypes['DateRange']> = {
  end?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DebitCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebitCard'] = ResolversParentTypes['DebitCard']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  lockTypeCode?: Resolver<ResolversTypes['DebitCardLockTypeCode'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DebitCardStatus'], ParentType, ContextType>;
};

export type DeferralSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeferralSetting'] = ResolversParentTypes['DeferralSetting']> = {
  account?: Resolver<ResolversTypes['SubAccount'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  taxBenefitsExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['PayrollContributionConfigValue'], ParentType, ContextType>;
};

export type DeferralSettingsEditOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeferralSettingsEditOption'] = ResolversParentTypes['DeferralSettingsEditOption']> = {
  deferralSettings?: Resolver<Array<ResolversTypes['DeferralSetting']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  taxBenefitsExplanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCheckingBeneficiaryMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteCheckingBeneficiaryMutationPayload'] = ResolversParentTypes['DeleteCheckingBeneficiaryMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CheckingCustomerResult']>, ParentType, ContextType>;
};

export type DeletePurposeMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePurposeMutationPayload'] = ResolversParentTypes['DeletePurposeMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type DeleteRecurringTransactionConfigMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteRecurringTransactionConfigMutationPayload'] = ResolversParentTypes['DeleteRecurringTransactionConfigMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type DeleteTrustedContactMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTrustedContactMutationPayload'] = ResolversParentTypes['DeleteTrustedContactMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type DirectTradingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingAccount'] = ResolversParentTypes['DirectTradingAccount']> = {
  accountDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<DirectTradingAccountActivityConnectionArgs, 'filters'>>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  bankAccountEligibleCheckingAccounts?: Resolver<Array<ResolversTypes['CheckingAccount']>, ParentType, ContextType>;
  bankAccountEligibleExternalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  buyOrderBlockedAvailabilityMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<DirectTradingAccountBuyOrderBlockedAvailabilityMessageArgs, 'financialSecurityId'>>;
  cashBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  cashBalances?: Resolver<ResolversTypes['DirectTradingCashBalances'], ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  financialSecuritiesSearch?: Resolver<Array<ResolversTypes['FinancialSecurity']>, ParentType, ContextType, RequireFields<DirectTradingAccountFinancialSecuritiesSearchArgs, 'searchTerm'>>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType, RequireFields<DirectTradingAccountFinancialSecurityArgs, 'id'>>;
  hasReachedOpsBankAccountLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isClosed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurringDepositEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingInflowAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  pendingOrders?: Resolver<Array<ResolversTypes['ActivityItemOrder']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<DirectTradingAccountPerformanceArgs, 'dateRangeOption'>>;
  securityPosition?: Resolver<Maybe<ResolversTypes['DirectTradingSecurityPosition']>, ParentType, ContextType, RequireFields<DirectTradingAccountSecurityPositionArgs, 'id'>>;
  securityPositions?: Resolver<Array<ResolversTypes['DirectTradingSecurityPosition']>, ParentType, ContextType>;
  sellOrderBlockedAvailabilityMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<DirectTradingAccountSellOrderBlockedAvailabilityMessageArgs, 'financialSecurityId'>>;
  transactionOptions?: Resolver<Array<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectTradingCashBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingCashBalances'] = ResolversParentTypes['DirectTradingCashBalances']> = {
  anyPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type DirectTradingInvestableAssetsAdviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingInvestableAssetsAdvice'] = ResolversParentTypes['DirectTradingInvestableAssetsAdvice']> = {
  advice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expandableAdvice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DirectTradingSecurityPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingSecurityPosition'] = ResolversParentTypes['DirectTradingSecurityPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageCost?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageCostV2?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  hasPendingCostBasis?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPendingOrders?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pendingOrders?: Resolver<Array<ResolversTypes['ActivityItemOrder']>, ParentType, ContextType>;
  security?: Resolver<ResolversTypes['SecurityStock'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  todaysReturn?: Resolver<Maybe<ResolversTypes['DirectTradingSecurityPositionReturn']>, ParentType, ContextType>;
  todaysReturnAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  todaysReturnPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  totalCost?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalCostV2?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  totalReturn?: Resolver<Maybe<ResolversTypes['DirectTradingSecurityPositionReturn']>, ParentType, ContextType>;
  totalReturnAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalReturnPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type DirectTradingSecurityPositionReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingSecurityPositionReturn'] = ResolversParentTypes['DirectTradingSecurityPositionReturn']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type DisclosuresResolvers<ContextType = any, ParentType extends ResolversParentTypes['Disclosures'] = ResolversParentTypes['Disclosures']> = {
  advertisingDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  advisorNetworkDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  afterTaxYieldDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  apyDailyRateDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  blended30DayYieldDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bondInvestingDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerageServicesDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cashReserveDisclosures?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkingDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkingDisclosureEcrDecoupled?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  comprehensiveDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  directTradingAccountPerformanceDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  everydayCheckingDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fdicDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  investmentAdvisorDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  investmentInSecuritiesDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  moneyWeightedReturnExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performanceDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pricingDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectionReturnsAssumptionsDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectionReturnsAssumptionsDisclosureIncludingConnectedAccountsImpact?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectionReturnsAssumptionsDisclosureTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectionReturnsDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectionReturnsDisclosureIncludingConnectedAccountsImpact?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeCustomImageDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retailEntityDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rolloverBannerDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secYieldDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortBondDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxLossHarvestingExplanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  timeWeightedReturnExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DismissUserActivityCsvExportBannerMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissUserActivityCsvExportBannerMutationPayload'] = ResolversParentTypes['DismissUserActivityCsvExportBannerMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type DisplayableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayableError'] = ResolversParentTypes['DisplayableError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  availabilityMessageHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  types?: Resolver<Array<ResolversTypes['DocumentFileType']>, ParentType, ContextType>;
};

export type DocumentCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentCategory'] = ResolversParentTypes['DocumentCategory']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['DocumentCategoryDisclosure']>, ParentType, ContextType>;
  filter?: Resolver<Maybe<ResolversTypes['DocumentFilter']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentCategoryDisclosureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentCategoryDisclosure'] = ResolversParentTypes['DocumentCategoryDisclosure']> = {
  expandDisclosureCta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DocumentCategoryGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentCategoryGroup'] = ResolversParentTypes['DocumentCategoryGroup']> = {
  categories?: Resolver<Array<ResolversTypes['DocumentCategory']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentCategoryOrCategoryGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentCategoryOrCategoryGroup'] = ResolversParentTypes['DocumentCategoryOrCategoryGroup']> = {
  __resolveType: TypeResolveFn<'DocumentCategory' | 'DocumentCategoryGroup', ParentType, ContextType>;
};

export type DocumentFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentFile'] = ResolversParentTypes['DocumentFile']> = {
  data?: Resolver<ResolversTypes['Base64'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DocumentFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentFilter'] = ResolversParentTypes['DocumentFilter']> = {
  defaultOption?: Resolver<Maybe<ResolversTypes['DocumentFilterOption']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['DocumentFilterOption']>, ParentType, ContextType>;
};

export type DocumentFilterOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentFilterOption'] = ResolversParentTypes['DocumentFilterOption']> = {
  endDateInclusive?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDateInclusive?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
};

export type DocumentsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentsResult'] = ResolversParentTypes['DocumentsResult']> = {
  documents?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType>;
  unavailabilityMessageHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DocusignSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocusignSignature'] = ResolversParentTypes['DocusignSignature']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DraftEnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftEnvelope'] = ResolversParentTypes['DraftEnvelope']> = {
  editablePurpose?: Resolver<Maybe<ResolversTypes['EditablePurpose']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftEnvelopeAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftEnvelopeAccount'] = ResolversParentTypes['DraftEnvelopeAccount']> = {
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DraftPurposeEmergencyFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftPurposeEmergencyFund'] = ResolversParentTypes['DraftPurposeEmergencyFund']> = {
  buffer?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageData?: Resolver<Maybe<ResolversTypes['Base64']>, ParentType, ContextType>;
  imageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlyExpensesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeSubType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftPurposeMajorPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftPurposeMajorPurchase'] = ResolversParentTypes['DraftPurposeMajorPurchase']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageData?: Resolver<Maybe<ResolversTypes['Base64']>, ParentType, ContextType>;
  imageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeSubType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftPurposeRetirementGrowthResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftPurposeRetirementGrowth'] = ResolversParentTypes['DraftPurposeRetirementGrowth']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageData?: Resolver<Maybe<ResolversTypes['Base64']>, ParentType, ContextType>;
  imageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeSubType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retirementAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  retirementZip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetMonthlySpendingAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftPurposeRetirementIncomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftPurposeRetirementIncome'] = ResolversParentTypes['DraftPurposeRetirementIncome']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageData?: Resolver<Maybe<ResolversTypes['Base64']>, ParentType, ContextType>;
  imageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeSubType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DriftResolvers<ContextType = any, ParentType extends ResolversParentTypes['Drift'] = ResolversParentTypes['Drift']> = {
  explanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  isAboveThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type EditableEnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditableEnvelope'] = ResolversParentTypes['EditableEnvelope']> = {
  __resolveType: TypeResolveFn<'DraftEnvelope', ParentType, ContextType>;
};

export type EditablePurposeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditablePurpose'] = ResolversParentTypes['EditablePurpose']> = {
  __resolveType: TypeResolveFn<'DraftPurposeEmergencyFund' | 'DraftPurposeMajorPurchase' | 'DraftPurposeRetirementGrowth' | 'DraftPurposeRetirementIncome', ParentType, ContextType>;
};

export type EditablePurposeEmergencyFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditablePurposeEmergencyFund'] = ResolversParentTypes['EditablePurposeEmergencyFund']> = {
  __resolveType: TypeResolveFn<'DraftPurposeEmergencyFund', ParentType, ContextType>;
};

export type EditablePurposeMajorPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditablePurposeMajorPurchase'] = ResolversParentTypes['EditablePurposeMajorPurchase']> = {
  __resolveType: TypeResolveFn<'DraftPurposeMajorPurchase', ParentType, ContextType>;
};

export type EditablePurposeRetirementGrowthResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditablePurposeRetirementGrowth'] = ResolversParentTypes['EditablePurposeRetirementGrowth']> = {
  __resolveType: TypeResolveFn<'DraftPurposeRetirementGrowth', ParentType, ContextType>;
};

export type EditablePurposeRetirementIncomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditablePurposeRetirementIncome'] = ResolversParentTypes['EditablePurposeRetirementIncome']> = {
  __resolveType: TypeResolveFn<'DraftPurposeRetirementIncome', ParentType, ContextType>;
};

export type EmailDispatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailDispatch'] = ResolversParentTypes['EmailDispatch']> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  wasEmailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type EmergencyFundCoverageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmergencyFundCoverage'] = ResolversParentTypes['EmergencyFundCoverage']> = {
  buffer?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<EmergencyFundCoverageMessagesArgs, 'location'>>;
  options?: Resolver<Array<ResolversTypes['EmergencyFundCoverageOption']>, ParentType, ContextType>;
};

export type EmergencyFundCoverageOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmergencyFundCoverageOption'] = ResolversParentTypes['EmergencyFundCoverageOption']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  bufferedMonths?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  months?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type EmergencyFundPurposeCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmergencyFundPurposeCreationOption'] = ResolversParentTypes['EmergencyFundPurposeCreationOption']> = {
  defaultMonthlyExpenses?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emergencyFundCoverage?: Resolver<ResolversTypes['EmergencyFundCoverage'], ParentType, ContextType, RequireFields<EmergencyFundPurposeCreationOptionEmergencyFundCoverageArgs, 'monthlyExpensesCents'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyAdviceTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeAsset?: Resolver<ResolversTypes['PurposeAsset'], ParentType, ContextType>;
  recommendation?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employee'] = ResolversParentTypes['Employee']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payFrequency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remainingAnnualPayrolls?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salary?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type EmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']> = {
  address?: Resolver<Maybe<ResolversTypes['PostalAddress']>, ParentType, ContextType>;
  contributionConfig?: Resolver<Maybe<ResolversTypes['EmployerFourOhOneKContributionConfig']>, ParentType, ContextType>;
  federalTaxIdNumber?: Resolver<Maybe<ResolversTypes['TIN']>, ParentType, ContextType>;
  fourOhOneKContributions?: Resolver<Maybe<ResolversTypes['EmployerFourOhOneKContributionsResult']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  soloFourOhOneKPlan?: Resolver<Maybe<ResolversTypes['SoloFourOhOneKPlan']>, ParentType, ContextType>;
};

export type EmployerFourOhOneKContributionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerFourOhOneKContributionConfig'] = ResolversParentTypes['EmployerFourOhOneKContributionConfig']> = {
  ctaDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discretionaryWithTiersDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['EmployerFourOhOneKContributionFrequency'], ParentType, ContextType>;
  hasVesting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includesStudentLoanPayments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDiscretionary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNonElective?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EmployerFourOhOneKContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerFourOhOneKContributions'] = ResolversParentTypes['EmployerFourOhOneKContributions']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['FourOhOneKContributionsLineItem']>, ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['EmployerFourOhOneKContributionsProjection']>, ParentType, ContextType>;
  vested?: Resolver<Maybe<ResolversTypes['EmployerFourOhOneKContributionsVested']>, ParentType, ContextType>;
};

export type EmployerFourOhOneKContributionsProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerFourOhOneKContributionsProjection'] = ResolversParentTypes['EmployerFourOhOneKContributionsProjection']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  upcoming?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type EmployerFourOhOneKContributionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerFourOhOneKContributionsResult'] = ResolversParentTypes['EmployerFourOhOneKContributionsResult']> = {
  allTime?: Resolver<ResolversTypes['EmployerFourOhOneKContributions'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thisYear?: Resolver<ResolversTypes['EmployerFourOhOneKContributions'], ParentType, ContextType>;
};

export type EmployerFourOhOneKContributionsVestedResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerFourOhOneKContributionsVested'] = ResolversParentTypes['EmployerFourOhOneKContributionsVested']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type EnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Envelope'] = ResolversParentTypes['Envelope']> = {
  accounts?: Resolver<Array<ResolversTypes['EnvelopeAccount']>, ParentType, ContextType>;
  accountsDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<EnvelopeActivityConnectionArgs, 'filters'>>;
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, Partial<EnvelopeArticlesArgs>>;
  balance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  balanceProjection?: Resolver<Maybe<ResolversTypes['BalanceProjection']>, ParentType, ContextType>;
  currentMarketingMessage?: Resolver<Maybe<ResolversTypes['MarketingMessage']>, ParentType, ContextType, RequireFields<EnvelopeCurrentMarketingMessageArgs, 'input'>>;
  hasRecurringTransaction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legalSubAccounts?: Resolver<Array<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<EnvelopeMessagesArgs, 'location'>>;
  monthlyNetRecurringCashflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payrollContributionConfigs?: Resolver<Array<ResolversTypes['PayrollContributionConfig']>, ParentType, ContextType>;
  performanceTotals?: Resolver<Maybe<ResolversTypes['PerformanceTotals']>, ParentType, ContextType>;
  purpose?: Resolver<Maybe<ResolversTypes['Purpose']>, ParentType, ContextType>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['EnvelopeStatus']>, ParentType, ContextType>;
  totalAnnualRecurringInflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  totalMonthlyRecurringInflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  totalMonthlyRecurringOutflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  transactionOptions?: Resolver<Array<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
};

export type EnvelopeAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnvelopeAccount'] = ResolversParentTypes['EnvelopeAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'CheckingAccount' | 'DirectTradingAccount' | 'ExternalAccountEnvelopeAssociation' | 'Five29Account' | 'ManagedAccount', ParentType, ContextType>;
};

export type EnvelopeStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnvelopeStatus'] = ResolversParentTypes['EnvelopeStatus']> = {
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  style?: Resolver<ResolversTypes['EnvelopeStatusStyle'], ParentType, ContextType>;
};

export type EstimatedTradeDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeDate'] = ResolversParentTypes['EstimatedTradeDate']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedTradeTimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeTimeRange'] = ResolversParentTypes['EstimatedTradeTimeRange']> = {
  dayDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  timeRangeDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedTradeTimingResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeTiming'] = ResolversParentTypes['EstimatedTradeTiming']> = {
  __resolveType: TypeResolveFn<'EstimatedTradeDate' | 'EstimatedTradeTimeRange', ParentType, ContextType>;
};

export type ExpenseRatioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpenseRatio'] = ResolversParentTypes['ExpenseRatio']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type ExpensesBasedPurposeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpensesBasedPurposeOption'] = ResolversParentTypes['ExpensesBasedPurposeOption']> = {
  defaultMonthlyExpenses?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommendation?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccount'] = ResolversParentTypes['ExternalAccount']> = {
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountTypeAndRedactedAccountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  envelope?: Resolver<Maybe<ResolversTypes['Envelope']>, ParentType, ContextType>;
  envelopeOptions?: Resolver<Array<ResolversTypes['Envelope']>, ParentType, ContextType>;
  goal?: Resolver<Maybe<ResolversTypes['Goal']>, ParentType, ContextType>;
  hasHoldings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPendingRollover?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  investmentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isIntegrated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isManual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isManuallySynced?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUpdatedAtDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<ExternalAccountMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subtype?: Resolver<ResolversTypes['ExternalAccountSubtype'], ParentType, ContextType>;
  transactionOption?: Resolver<Maybe<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountEmployerMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountEmployerMatch'] = ResolversParentTypes['ExternalAccountEmployerMatch']> = {
  employerContributionMax?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  employerContributionPercentage?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ExternalAccountEnvelopeAssociationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountEnvelopeAssociation'] = ResolversParentTypes['ExternalAccountEnvelopeAssociation']> = {
  account?: Resolver<ResolversTypes['SomebodysExternalAccount'], ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountPlanContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountPlanContributions'] = ResolversParentTypes['ExternalAccountPlanContributions']> = {
  employerMatch?: Resolver<ResolversTypes['ExternalAccountEmployerMatch'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  plannedAnnualContributions?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  supportsRothContributions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ExternalAccountSubtypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountSubtype'] = ResolversParentTypes['ExternalAccountSubtype']> = {
  __resolveType: TypeResolveFn<'ExternalAccountSubtypeBasic' | 'ExternalAccountSubtypeEmployerSponsored' | 'ExternalAccountSubtypeIra', ParentType, ContextType>;
};

export type ExternalAccountSubtypeBasicResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountSubtypeBasic'] = ResolversParentTypes['ExternalAccountSubtypeBasic']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountSubtypeEmployerSponsoredResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountSubtypeEmployerSponsored'] = ResolversParentTypes['ExternalAccountSubtypeEmployerSponsored']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCurrentEmployer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planContributions?: Resolver<ResolversTypes['ExternalAccountPlanContributions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountSubtypeIraResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountSubtypeIra'] = ResolversParentTypes['ExternalAccountSubtypeIra']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plannedAnnualContributions?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalTransferOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalTransferOption'] = ResolversParentTypes['ExternalTransferOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternallyAdvisedPlanPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternallyAdvisedPlanPortfolio'] = ResolversParentTypes['ExternallyAdvisedPlanPortfolio']> = {
  allocationBreakdown?: Resolver<Array<ResolversTypes['AllocationBreakdown']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  qdiaFund?: Resolver<ResolversTypes['LegacySecurity'], ParentType, ContextType>;
  strategy?: Resolver<ResolversTypes['PortfolioStrategy'], ParentType, ContextType>;
  weightedSecurities?: Resolver<Array<ResolversTypes['LegacyWeightedSecurity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialCoachingOnboardingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialCoachingOnboardingOption'] = ResolversParentTypes['FinancialCoachingOnboardingOption']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<FinancialCoachingOnboardingOptionImageArgs, 'variant'>>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialProfile'] = ResolversParentTypes['FinancialProfile']> = {
  annualPretaxIncome?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  directTradingInvestableAssetsAdvice?: Resolver<Maybe<ResolversTypes['DirectTradingInvestableAssetsAdvice']>, ParentType, ContextType>;
  federalTaxBracket?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  householdInvestableAssets?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investingExperience?: Resolver<Maybe<ResolversTypes['InvestingExperienceLevel']>, ParentType, ContextType>;
  numberOfDependents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profession?: Resolver<ResolversTypes['Profession'], ParentType, ContextType>;
  retirementAssumptions?: Resolver<Maybe<ResolversTypes['FinancialProfileRetirementAssumptions']>, ParentType, ContextType>;
  spouse?: Resolver<Maybe<ResolversTypes['Spouse']>, ParentType, ContextType>;
  taxFilingStatus?: Resolver<ResolversTypes['TaxFilingStatus'], ParentType, ContextType>;
};

export type FinancialProfileRetirementAssumptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialProfileRetirementAssumptions'] = ResolversParentTypes['FinancialProfileRetirementAssumptions']> = {
  annualAboveTheLineDeductionsAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  annualAdjustedGrossIncomeAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  annualInflation?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  annualItemizedDeductionsAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  annualModifiedAdjustedGrossIncomeAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  annualOtherRetirementIncome?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  annualSalaryGrowthAfterInflation?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  retirementZip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  socialSecurityPayout?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  userAssumptions?: Resolver<ResolversTypes['FinancialProfileRetirementUserAssumptions'], ParentType, ContextType>;
};

export type FinancialProfileRetirementUserAssumptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialProfileRetirementUserAssumptions'] = ResolversParentTypes['FinancialProfileRetirementUserAssumptions']> = {
  currentAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lifeExpectancyAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  retirementAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  socialSecurityAnnualBenefit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  socialSecurityStartAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type FinancialSecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurity'] = ResolversParentTypes['FinancialSecurity']> = {
  __resolveType: TypeResolveFn<'FinancialSecurityFund' | 'FinancialSecurityStock', ParentType, ContextType>;
};

export type FinancialSecurityCompanyProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityCompanyProfile'] = ResolversParentTypes['FinancialSecurityCompanyProfile']> = {
  logo?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
};

export type FinancialSecurityFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFund'] = ResolversParentTypes['FinancialSecurityFund']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundamentals?: Resolver<ResolversTypes['FinancialSecurityFundamentals'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolio?: Resolver<ResolversTypes['FinancialSecurityFundPortfolio'], ParentType, ContextType>;
  priceHistory?: Resolver<ResolversTypes['FinancialSecurityPriceHistory'], ParentType, ContextType, RequireFields<FinancialSecurityFundPriceHistoryArgs, 'dateRangeOption'>>;
  pricePerformance?: Resolver<ResolversTypes['FinancialSecurityPricePerformance'], ParentType, ContextType, RequireFields<FinancialSecurityFundPricePerformanceArgs, 'dateRangeOption'>>;
  prospectusUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  securityType?: Resolver<Maybe<ResolversTypes['FinancialSecuritySecurityType']>, ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['FinancialSecurityStatistics'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSecurityFundPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundPortfolio'] = ResolversParentTypes['FinancialSecurityFundPortfolio']> = {
  holdings?: Resolver<Array<ResolversTypes['FinancialSecurityFundPortfolioHolding']>, ParentType, ContextType>;
};

export type FinancialSecurityFundPortfolioHoldingResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundPortfolioHolding'] = ResolversParentTypes['FinancialSecurityFundPortfolioHolding']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  security?: Resolver<Maybe<ResolversTypes['FinancialSecurity']>, ParentType, ContextType>;
  symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentals'] = ResolversParentTypes['FinancialSecurityFundamentals']> = {
  __resolveType: TypeResolveFn<'FinancialSecurityFundamentalsFund' | 'FinancialSecurityFundamentalsStock', ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsDividendYieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsDividendYield'] = ResolversParentTypes['FinancialSecurityFundamentalsDividendYield']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsDividendsAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsDividendsAmount'] = ResolversParentTypes['FinancialSecurityFundamentalsDividendsAmount']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsEarningsPerShareResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsEarningsPerShare'] = ResolversParentTypes['FinancialSecurityFundamentalsEarningsPerShare']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsEbitdaResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsEbitda'] = ResolversParentTypes['FinancialSecurityFundamentalsEbitda']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsExpenseRatioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsExpenseRatio'] = ResolversParentTypes['FinancialSecurityFundamentalsExpenseRatio']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsFund'] = ResolversParentTypes['FinancialSecurityFundamentalsFund']> = {
  annual?: Resolver<ResolversTypes['FinancialSecurityFundamentalsFundAnnual'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  descriptionMaybe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dividendYield?: Resolver<ResolversTypes['FinancialSecurityFundamentalsDividendYield'], ParentType, ContextType>;
  dividendYieldMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
  dividendsAmount?: Resolver<ResolversTypes['FinancialSecurityFundamentalsDividendsAmount'], ParentType, ContextType>;
  dividendsAmountMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendsAmount']>, ParentType, ContextType>;
  expenseRatio?: Resolver<ResolversTypes['FinancialSecurityFundamentalsExpenseRatio'], ParentType, ContextType>;
  expenseRatioMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsExpenseRatio']>, ParentType, ContextType>;
  marketCap?: Resolver<ResolversTypes['FinancialSecurityFundamentalsMarketCap'], ParentType, ContextType>;
  marketCapMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsMarketCap']>, ParentType, ContextType>;
  trailingTwelveMonths?: Resolver<ResolversTypes['FinancialSecurityFundamentalsFundTrailingTwelveMonths'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsFundAnnualResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsFundAnnual'] = ResolversParentTypes['FinancialSecurityFundamentalsFundAnnual']> = {
  dividendYield?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsFundTrailingTwelveMonthsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsFundTrailingTwelveMonths'] = ResolversParentTypes['FinancialSecurityFundamentalsFundTrailingTwelveMonths']> = {
  dividendYield?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsMarketCapResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsMarketCap'] = ResolversParentTypes['FinancialSecurityFundamentalsMarketCap']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsPriceToEarningsRatioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsPriceToEarningsRatio'] = ResolversParentTypes['FinancialSecurityFundamentalsPriceToEarningsRatio']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsRevenueResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsRevenue'] = ResolversParentTypes['FinancialSecurityFundamentalsRevenue']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsSharesOutstandingResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsSharesOutstanding'] = ResolversParentTypes['FinancialSecurityFundamentalsSharesOutstanding']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsStock'] = ResolversParentTypes['FinancialSecurityFundamentalsStock']> = {
  annual?: Resolver<ResolversTypes['FinancialSecurityFundamentalsStockAnnual'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  descriptionMaybe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dividendYield?: Resolver<ResolversTypes['FinancialSecurityFundamentalsDividendYield'], ParentType, ContextType>;
  dividendYieldMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
  dividendsAmount?: Resolver<ResolversTypes['FinancialSecurityFundamentalsDividendsAmount'], ParentType, ContextType>;
  dividendsAmountMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendsAmount']>, ParentType, ContextType>;
  earningsPerShare?: Resolver<ResolversTypes['FinancialSecurityFundamentalsEarningsPerShare'], ParentType, ContextType>;
  earningsPerShareMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEarningsPerShare']>, ParentType, ContextType>;
  ebitda?: Resolver<ResolversTypes['FinancialSecurityFundamentalsEbitda'], ParentType, ContextType>;
  ebitdaMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEbitda']>, ParentType, ContextType>;
  marketCap?: Resolver<ResolversTypes['FinancialSecurityFundamentalsMarketCap'], ParentType, ContextType>;
  marketCapMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsMarketCap']>, ParentType, ContextType>;
  priceToEarningsRatio?: Resolver<ResolversTypes['FinancialSecurityFundamentalsPriceToEarningsRatio'], ParentType, ContextType>;
  priceToEarningsRatioMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsPriceToEarningsRatio']>, ParentType, ContextType>;
  revenue?: Resolver<ResolversTypes['FinancialSecurityFundamentalsRevenue'], ParentType, ContextType>;
  revenueMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsRevenue']>, ParentType, ContextType>;
  sharesOutstanding?: Resolver<ResolversTypes['FinancialSecurityFundamentalsSharesOutstanding'], ParentType, ContextType>;
  sharesOutstandingMaybe?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsSharesOutstanding']>, ParentType, ContextType>;
  trailingTwelveMonths?: Resolver<ResolversTypes['FinancialSecurityFundamentalsStockTrailingTwelveMonths'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsStockAnnualResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsStockAnnual'] = ResolversParentTypes['FinancialSecurityFundamentalsStockAnnual']> = {
  dividendYield?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
  earningsPerShare?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEarningsPerShare']>, ParentType, ContextType>;
  ebitda?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEbitda']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsRevenue']>, ParentType, ContextType>;
};

export type FinancialSecurityFundamentalsStockTrailingTwelveMonthsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFundamentalsStockTrailingTwelveMonths'] = ResolversParentTypes['FinancialSecurityFundamentalsStockTrailingTwelveMonths']> = {
  dividendYield?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsDividendYield']>, ParentType, ContextType>;
  earningsPerShare?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEarningsPerShare']>, ParentType, ContextType>;
  ebitda?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsEbitda']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['FinancialSecurityFundamentalsRevenue']>, ParentType, ContextType>;
};

export type FinancialSecurityOrderRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityOrderRequest'] = ResolversParentTypes['FinancialSecurityOrderRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type FinancialSecurityPriceHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityPriceHistory'] = ResolversParentTypes['FinancialSecurityPriceHistory']> = {
  returns?: Resolver<ResolversTypes['FinancialSecurityPriceReturns'], ParentType, ContextType>;
  timeSeries?: Resolver<Array<ResolversTypes['FinancialSecurityPricePoint']>, ParentType, ContextType>;
};

export type FinancialSecurityPricePerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityPricePerformance'] = ResolversParentTypes['FinancialSecurityPricePerformance']> = {
  dateRange?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['FinancialSecurityPriceReturns'], ParentType, ContextType>;
  timeSeries?: Resolver<Array<ResolversTypes['FinancialSecurityPricePerformancePricePoint']>, ParentType, ContextType>;
};

export type FinancialSecurityPricePerformancePricePointResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityPricePerformancePricePoint'] = ResolversParentTypes['FinancialSecurityPricePerformancePricePoint']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  dateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  formattedDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['FinancialSecurityPriceReturns'], ParentType, ContextType>;
};

export type FinancialSecurityPricePointResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityPricePoint'] = ResolversParentTypes['FinancialSecurityPricePoint']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  dateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
};

export type FinancialSecurityPriceReturnsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityPriceReturns'] = ResolversParentTypes['FinancialSecurityPriceReturns']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type FinancialSecurityStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStatistics'] = ResolversParentTypes['FinancialSecurityStatistics']> = {
  latestPrice?: Resolver<ResolversTypes['FinancialSecurityStatisticsLatestPrice'], ParentType, ContextType>;
  today?: Resolver<Maybe<ResolversTypes['FinancialSecurityStatisticsComponentIntraDay']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['FinancialSecurityStatisticsComponentDays'], ParentType, ContextType>;
};

export type FinancialSecurityStatisticsComponentDaysResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStatisticsComponentDays'] = ResolversParentTypes['FinancialSecurityStatisticsComponentDays']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  priceRange?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  priceRangeMaybe?: Resolver<Maybe<ResolversTypes['PriceRange']>, ParentType, ContextType>;
};

export type FinancialSecurityStatisticsComponentIntraDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStatisticsComponentIntraDay'] = ResolversParentTypes['FinancialSecurityStatisticsComponentIntraDay']> = {
  currentAsOf?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  openPrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  openPriceMaybe?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  previousClosePrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  previousClosePriceMaybe?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  priceRange?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  priceRangeMaybe?: Resolver<Maybe<ResolversTypes['PriceRange']>, ParentType, ContextType>;
  volume?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  volumeMaybe?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type FinancialSecurityStatisticsLatestPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStatisticsLatestPrice'] = ResolversParentTypes['FinancialSecurityStatisticsLatestPrice']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  currentAsOf?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  formattedCurrentAsOf?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returns?: Resolver<ResolversTypes['FinancialSecurityPriceReturns'], ParentType, ContextType>;
};

export type FinancialSecurityStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStock'] = ResolversParentTypes['FinancialSecurityStock']> = {
  companyProfile?: Resolver<ResolversTypes['FinancialSecurityCompanyProfile'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundamentals?: Resolver<ResolversTypes['FinancialSecurityFundamentals'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceHistory?: Resolver<ResolversTypes['FinancialSecurityPriceHistory'], ParentType, ContextType, RequireFields<FinancialSecurityStockPriceHistoryArgs, 'dateRangeOption'>>;
  pricePerformance?: Resolver<ResolversTypes['FinancialSecurityPricePerformance'], ParentType, ContextType, RequireFields<FinancialSecurityStockPricePerformanceArgs, 'dateRangeOption'>>;
  securityType?: Resolver<Maybe<ResolversTypes['FinancialSecuritySecurityType']>, ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['FinancialSecurityStatistics'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialServiceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialServiceOption'] = ResolversParentTypes['FinancialServiceOption']> = {
  __resolveType: TypeResolveFn<'BettermentAdvisorNetworkOption' | 'BettermentPremiumOption', ParentType, ContextType>;
};

export type FirmResolvers<ContextType = any, ParentType extends ResolversParentTypes['Firm'] = ResolversParentTypes['Firm']> = {
  defaultClientAgreementToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultClientAgreementUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type Five29AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Five29Account'] = ResolversParentTypes['Five29Account']> = {
  accountConnection?: Resolver<Maybe<ResolversTypes['Five29AccountConnection']>, ParentType, ContextType>;
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<Five29AccountActivityConnectionArgs, 'filters'>>;
  ascensusAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccountEligibleCheckingAccounts?: Resolver<Array<ResolversTypes['CheckingAccount']>, ParentType, ContextType>;
  bankAccountEligibleExternalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  beneficiaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  hasReachedOpsBankAccountLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isClosed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurringDepositEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSetupComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Five29AccountConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Five29AccountConnection'] = ResolversParentTypes['Five29AccountConnection']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  hasPendingSsoConnection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFrozen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FiveTwoNineGoalCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FiveTwoNineGoalCreationOption'] = ResolversParentTypes['FiveTwoNineGoalCreationOption']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<FiveTwoNineGoalCreationOptionImageArgs, 'variant'>>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FourOhOneKContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKContributions'] = ResolversParentTypes['FourOhOneKContributions']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  amountRemainingToLimit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['FourOhOneKContributionsLineItem']>, ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['FourOhOneKContributionsProjection']>, ParentType, ContextType>;
};

export type FourOhOneKContributionsLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKContributionsLineItem'] = ResolversParentTypes['FourOhOneKContributionsLineItem']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FourOhOneKContributionsProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKContributionsProjection'] = ResolversParentTypes['FourOhOneKContributionsProjection']> = {
  deferralSettingsEditOption?: Resolver<ResolversTypes['DeferralSettingsEditOption'], ParentType, ContextType>;
  deferralSettingsEditOptionV2?: Resolver<Maybe<ResolversTypes['DeferralSettingsEditOption']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<FourOhOneKContributionsProjectionMessagesArgs, 'location'>>;
  recurringInflows?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  upcoming?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FourOhOneKContributionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKContributionsResult'] = ResolversParentTypes['FourOhOneKContributionsResult']> = {
  allTime?: Resolver<ResolversTypes['FourOhOneKContributions'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thisYear?: Resolver<ResolversTypes['AnnualFourOhOneKContributions'], ParentType, ContextType>;
};

export type FourOhOneKStudentLoanMatchBenefitResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKStudentLoanMatchBenefit'] = ResolversParentTypes['FourOhOneKStudentLoanMatchBenefit']> = {
  currentAttestation?: Resolver<Maybe<ResolversTypes['StudentLoanPaymentAttestation']>, ParentType, ContextType>;
  currentLoanPaymentEstimate?: Resolver<Maybe<ResolversTypes['StudentLoanPaymentEstimate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAttestationEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<FourOhOneKStudentLoanMatchBenefitMessagesArgs, 'location'>>;
};

export type GeneralPurposeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralPurposeOption'] = ResolversParentTypes['GeneralPurposeOption']> = {
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultTargetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GoalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Goal'] = ResolversParentTypes['Goal']> = {
  accountsDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  advice?: Resolver<Maybe<ResolversTypes['Advice']>, ParentType, ContextType>;
  apy?: Resolver<Maybe<ResolversTypes['CashApy']>, ParentType, ContextType>;
  balances?: Resolver<ResolversTypes['GoalBalances'], ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  externalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  fdicInsurance?: Resolver<Maybe<ResolversTypes['CashFdicInsurance']>, ParentType, ContextType>;
  has401kSubAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasIraSubAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasRecurringTransaction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasTraditionalOrRothIraSubAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isPerformanceEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSetupComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<GoalMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performance?: Resolver<Maybe<ResolversTypes['PerformanceTotals']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  statusSummary?: Resolver<ResolversTypes['GoalStatusSummary'], ParentType, ContextType>;
  subAccounts?: Resolver<Array<ResolversTypes['SubAccount']>, ParentType, ContextType>;
};

export type GoalBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoalBalances'] = ResolversParentTypes['GoalBalances']> = {
  excludingExternalAccounts?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  includingExternalAccounts?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type GoalCreationIntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoalCreationIntent'] = ResolversParentTypes['GoalCreationIntent']> = {
  adviceTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isUserSelected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GoalCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoalCreationOption'] = ResolversParentTypes['GoalCreationOption']> = {
  accountOwnershipOption?: Resolver<ResolversTypes['AccountOwnershipOption'], ParentType, ContextType, RequireFields<GoalCreationOptionAccountOwnershipOptionArgs, 'id'>>;
  accountOwnershipOptions?: Resolver<Array<ResolversTypes['AccountOwnershipOption']>, ParentType, ContextType>;
  accountPurposeOption?: Resolver<ResolversTypes['AccountPurposeOption'], ParentType, ContextType, RequireFields<GoalCreationOptionAccountPurposeOptionArgs, 'id'>>;
  accountPurposeOptions?: Resolver<Array<ResolversTypes['AccountPurposeOption']>, ParentType, ContextType>;
  accountTaxationOption?: Resolver<ResolversTypes['AccountTaxationOption'], ParentType, ContextType, RequireFields<GoalCreationOptionAccountTaxationOptionArgs, 'id'>>;
  accountTaxationOptions?: Resolver<Array<ResolversTypes['AccountTaxationOption']>, ParentType, ContextType>;
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  draftEnvelopeAccount?: Resolver<Maybe<ResolversTypes['DraftEnvelopeAccount']>, ParentType, ContextType, RequireFields<GoalCreationOptionDraftEnvelopeAccountArgs, 'ownershipType'>>;
  emergencyFundCoverage?: Resolver<Maybe<ResolversTypes['EmergencyFundCoverage']>, ParentType, ContextType, RequireFields<GoalCreationOptionEmergencyFundCoverageArgs, 'monthlyExpensesCents'>>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<GoalCreationOptionImageArgs, 'variant'>>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modelPortfolioOption?: Resolver<ResolversTypes['ModelPortfolioOption'], ParentType, ContextType, RequireFields<GoalCreationOptionModelPortfolioOptionArgs, 'id'>>;
  modelPortfolioOptions?: Resolver<Array<ResolversTypes['ModelPortfolioOption']>, ParentType, ContextType, RequireFields<GoalCreationOptionModelPortfolioOptionsArgs, 'accountPurposeId'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  recommendTaxCoordination?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<GoalCreationOptionRecommendTaxCoordinationArgs, 'accountType'>>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showInvestingExperience?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  termsAndAgreements?: Resolver<Array<ResolversTypes['LegacyTermsAndAgreements']>, ParentType, ContextType, RequireFields<GoalCreationOptionTermsAndAgreementsArgs, 'accountOwnershipOptionId'>>;
  unavailability?: Resolver<Maybe<ResolversTypes['ProductUnavailability']>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GoalStatusSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoalStatusSummary'] = ResolversParentTypes['GoalStatusSummary']> = {
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<ResolversTypes['GoalStatusStyle'], ParentType, ContextType>;
};

export type GrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Grant'] = ResolversParentTypes['Grant']> = {
  __resolveType: TypeResolveFn<'IraContributionMatchGrant', ParentType, ContextType>;
};

export interface HtmlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HTML'], any> {
  name: 'HTML';
}

export type HistoricalPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoricalPerformance'] = ResolversParentTypes['HistoricalPerformance']> = {
  benchmarkPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timePeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IdentityVerificationChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityVerificationChallenge'] = ResolversParentTypes['IdentityVerificationChallenge']> = {
  agentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IdentityVerificationChallengeStatus'], ParentType, ContextType>;
};

export type IndividualOwnershipOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IndividualOwnershipOption'] = ResolversParentTypes['IndividualOwnershipOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownershipType?: Resolver<ResolversTypes['LegalAccountOwnershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateStudentLoanPaymentBenefitAttestationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateStudentLoanPaymentBenefitAttestationMutationPayload'] = ResolversParentTypes['InitiateStudentLoanPaymentBenefitAttestationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']>, ParentType, ContextType>;
};

export type InstitutionalAdvisorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstitutionalAdvisor'] = ResolversParentTypes['InstitutionalAdvisor']> = {
  calendarLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firm?: Resolver<ResolversTypes['Firm'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvestmentPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentPortfolio'] = ResolversParentTypes['InvestmentPortfolio']> = {
  allocationBreakdown?: Resolver<Array<ResolversTypes['AllocationBreakdown']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  isAutoAdjustAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAutoAdjustEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  relativeRisk?: Resolver<Maybe<ResolversTypes['RelativeRisk']>, ParentType, ContextType>;
  riskLevelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  strategy?: Resolver<ResolversTypes['PortfolioStrategy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IraContributionMatchGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionMatchGrant'] = ResolversParentTypes['IraContributionMatchGrant']> = {
  contributionWindow?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  disclosureUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  earnedMatchAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  grantedEntitiesDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  match?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  matchEligibleAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  projectedMatchAmountV2?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  projectedMatchAmountV3?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  projectedPaymentDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  rewardDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalMatchedAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IraContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributions'] = ResolversParentTypes['IraContributions']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['IraContributionsLineItem']>, ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['IraContributionsProjection']>, ParentType, ContextType>;
};

export type IraContributionsLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionsLineItem'] = ResolversParentTypes['IraContributionsLineItem']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IraContributionsProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionsProjection'] = ResolversParentTypes['IraContributionsProjection']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<IraContributionsProjectionMessagesArgs, 'location'>>;
  recurringInflows?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  upcoming?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type IraContributionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionsResult'] = ResolversParentTypes['IraContributionsResult']> = {
  allTime?: Resolver<ResolversTypes['IraContributions'], ParentType, ContextType>;
  byYear?: Resolver<Array<ResolversTypes['AnnualIraContributions']>, ParentType, ContextType, Partial<IraContributionsResultByYearArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type JointAccountInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JointAccountInvitation'] = ResolversParentTypes['JointAccountInvitation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invitationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JointAccountInvitationStatus'], ParentType, ContextType>;
};

export type JointOwnershipOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JointOwnershipOption'] = ResolversParentTypes['JointOwnershipOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jointAccountHolders?: Resolver<Array<ResolversTypes['OtherUser']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownershipType?: Resolver<ResolversTypes['LegalAccountOwnershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyAllocationAssetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyAllocationAssets'] = ResolversParentTypes['LegacyAllocationAssets']> = {
  assets?: Resolver<Array<ResolversTypes['LegacySuperAssetClass']>, ParentType, ContextType>;
  header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  holdingsPageInfo?: Resolver<Maybe<ResolversTypes['LegacyHoldingsPageInfo']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  namedPortfolioDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LegacyAssetClassResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyAssetClass'] = ResolversParentTypes['LegacyAssetClass']> = {
  holdingsAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securityGroupDetails?: Resolver<ResolversTypes['LegacySecurityGroupDetails'], ParentType, ContextType>;
  tickersDisplay?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LegacyHoldingsPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyHoldingsPageInfo'] = ResolversParentTypes['LegacyHoldingsPageInfo']> = {
  assetClasses?: Resolver<Array<ResolversTypes['LegacySuperAssetClass']>, ParentType, ContextType>;
  info?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface LegacyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LegacyID'], any> {
  name: 'LegacyID';
}

export type LegacyNamedOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyNamedOptions'] = ResolversParentTypes['LegacyNamedOptions']> = {
  bottomSheetContent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bottomSheetHeader?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  namedOptions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LegacyPortfolioDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyPortfolioDetails'] = ResolversParentTypes['LegacyPortfolioDetails']> = {
  isAutoAdjustEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  riskIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LegacyPortfolioInfoRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyPortfolioInfoRow'] = ResolversParentTypes['LegacyPortfolioInfoRow']> = {
  dataDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  info?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trailingSubHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LegacyPortfolioStrategyOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyPortfolioStrategyOption'] = ResolversParentTypes['LegacyPortfolioStrategyOption']> = {
  afterTaxYield?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allocationAssets?: Resolver<ResolversTypes['LegacyAllocationAssets'], ParentType, ContextType>;
  autoglideEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  comparisonDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  disclosuresHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emphasisText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUnavailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<LegacyPortfolioStrategyOptionMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  namedOptions?: Resolver<Maybe<ResolversTypes['LegacyNamedOptions']>, ParentType, ContextType>;
  portfolioDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioInfoRows?: Resolver<Array<ResolversTypes['LegacyPortfolioInfoRow']>, ParentType, ContextType>;
  portfolioSecondaryDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  principalRisk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationDetails?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommendedRiskIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxRecommendationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableActionMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LegacySecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySecurity'] = ResolversParentTypes['LegacySecurity']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expenseAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  expensePercent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grandparentGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  historicalPerformances?: Resolver<Array<ResolversTypes['HistoricalPerformance']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inceptionDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prospectusUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LegacySecurityGroupDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySecurityGroupDetails'] = ResolversParentTypes['LegacySecurityGroupDetails']> = {
  assetClassExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explanationHeader?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  header?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickerDetails?: Resolver<Array<ResolversTypes['Ticker']>, ParentType, ContextType>;
  tickersExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LegacySuperAssetClassResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySuperAssetClass'] = ResolversParentTypes['LegacySuperAssetClass']> = {
  colorHex?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  holdings?: Resolver<Array<ResolversTypes['LegacyAssetClass']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type LegacyTermsAndAgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyTermsAndAgreements'] = ResolversParentTypes['LegacyTermsAndAgreements']> = {
  agreements?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType>;
  disclosure?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  terms?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface LegacyUuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LegacyUUID'], any> {
  name: 'LegacyUUID';
}

export type LegacyWeightedSecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyWeightedSecurity'] = ResolversParentTypes['LegacyWeightedSecurity']> = {
  allocationPercent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['LegacySecurity'], ParentType, ContextType>;
};

export type LegalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalAccount'] = ResolversParentTypes['LegalAccount']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryUpdateInstructions?: Resolver<ResolversTypes['BeneficiaryUpdateInstructions'], ParentType, ContextType>;
  contingentBeneficiaries?: Resolver<Array<ResolversTypes['LegalAccountBeneficiary']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  ownershipType?: Resolver<ResolversTypes['LegalAccountOwnershipType'], ParentType, ContextType>;
  primaryBeneficiaries?: Resolver<Array<ResolversTypes['LegalAccountBeneficiary']>, ParentType, ContextType>;
  taxationType?: Resolver<ResolversTypes['LegalAccountTaxationType'], ParentType, ContextType>;
};

export type LegalAccountBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalAccountBeneficiary'] = ResolversParentTypes['LegalAccountBeneficiary']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  distributionShare?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['BeneficiaryRelationship'], ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['TIN']>, ParentType, ContextType>;
};

export type LegalSubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalSubAccount'] = ResolversParentTypes['LegalSubAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'DirectTradingAccount' | 'Five29Account' | 'ManagedSubAccount', ParentType, ContextType>;
};

export type MajorPurchasePurposeCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MajorPurchasePurposeCreationOption'] = ResolversParentTypes['MajorPurchasePurposeCreationOption']> = {
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultTargetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  defaultTargetDateExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyAdviceTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeAsset?: Resolver<ResolversTypes['PurposeAsset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManageRecurringTransactionsOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManageRecurringTransactionsOption'] = ResolversParentTypes['ManageRecurringTransactionsOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagedAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedAccount'] = ResolversParentTypes['ManagedAccount']> = {
  accountDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<ManagedAccountActivityConnectionArgs, 'filters'>>;
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, Partial<ManagedAccountArticlesArgs>>;
  assetAllocation?: Resolver<ResolversTypes['AssetAllocation'], ParentType, ContextType>;
  autoglide?: Resolver<ResolversTypes['Autoglide'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<ManagedAccountBalanceArgs, 'includePending'>>;
  balanceProjection?: Resolver<Maybe<ResolversTypes['BalanceProjection']>, ParentType, ContextType>;
  cryptoAssetsRecommendation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  hasEverBeenFunded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBondsOnlyPortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRetirementAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxCoordinated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTaxCoordinationEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<ManagedAccountMessagesArgs, 'location'>>;
  minFeeWarning?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  monthlyNetRecurringCashflows?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payrollContributionConfigs?: Resolver<Array<ResolversTypes['PayrollContributionConfig']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<ManagedAccountPerformanceArgs, 'dateRangeOption'>>;
  performanceHistory?: Resolver<ResolversTypes['PerformanceHistory'], ParentType, ContextType, RequireFields<ManagedAccountPerformanceHistoryArgs, 'dateRangeOption'>>;
  performanceTotals?: Resolver<ResolversTypes['PerformanceTotals'], ParentType, ContextType, RequireFields<ManagedAccountPerformanceTotalsArgs, 'dateRangeOption'>>;
  portfolio?: Resolver<ResolversTypes['ManagedPortfolio'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['ManagedAccountProjection']>, ParentType, ContextType, Partial<ManagedAccountProjectionArgs>>;
  recurringDepositMotivation?: Resolver<Maybe<ResolversTypes['RecurringDepositMotivation']>, ParentType, ContextType>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  securityGroupPositions?: Resolver<Array<ResolversTypes['SecurityGroupPosition']>, ParentType, ContextType>;
  subAccounts?: Resolver<Array<ResolversTypes['ManagedSubAccount']>, ParentType, ContextType>;
  transactionOptions?: Resolver<Array<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagedAccountProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedAccountProjection'] = ResolversParentTypes['ManagedAccountProjection']> = {
  balanceTimeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
};

export type ManagedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedPortfolio'] = ResolversParentTypes['ManagedPortfolio']> = {
  __resolveType: TypeResolveFn<'RiskLevelBasedPortfolio' | 'SelfDirectedPortfolio', ParentType, ContextType>;
};

export type ManagedSubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedSubAccount'] = ResolversParentTypes['ManagedSubAccount']> = {
  accountDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<ManagedSubAccountBalanceArgs, 'includePending'>>;
  bankAccountEligibleCheckingAccounts?: Resolver<Array<ResolversTypes['CheckingAccount']>, ParentType, ContextType>;
  bankAccountEligibleExternalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  hasReachedOpsBankAccountLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isClosed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecurringDepositEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  managedAccount?: Resolver<ResolversTypes['ManagedAccount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketSchedule'] = ResolversParentTypes['MarketSchedule']> = {
  closeAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  nextBusinessDay?: Resolver<ResolversTypes['MarketSchedule'], ParentType, ContextType>;
  openAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  previousBusinessDay?: Resolver<ResolversTypes['MarketSchedule'], ParentType, ContextType>;
};

export type MarketingMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessage'] = ResolversParentTypes['MarketingMessage']> = {
  clicked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  extras?: Resolver<Maybe<ResolversTypes['MarketingMessageExtras']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDismissible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  linkText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pinned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type MarketingMessageExtrasResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageExtras'] = ResolversParentTypes['MarketingMessageExtras']> = {
  cardSystem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosureLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  footerDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  goalIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageAltText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interruptiveMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDisclosure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MemoCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemoCreationOption'] = ResolversParentTypes['MemoCreationOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reasonOptions?: Resolver<Array<ResolversTypes['MemoReasonOption']>, ParentType, ContextType>;
  transactionTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MemoReasonOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemoReasonOption'] = ResolversParentTypes['MemoReasonOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  body?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['MessageCta']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDismissible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  style?: Resolver<ResolversTypes['MessageStyle'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MessageCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCta'] = ResolversParentTypes['MessageCta']> = {
  __resolveType: TypeResolveFn<'MessageCtaLink' | 'MessageCtaModal', ParentType, ContextType>;
};

export type MessageCtaLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCtaLink'] = ResolversParentTypes['MessageCtaLink']> = {
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCtaModalResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCtaModal'] = ResolversParentTypes['MessageCtaModal']> = {
  content?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MessageLocationScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MessageLocation'], any> {
  name: 'MessageLocation';
}

export type ModelPortfolioOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioOption'] = ResolversParentTypes['ModelPortfolioOption']> = {
  assetAllocations?: Resolver<Array<ResolversTypes['AssetAllocation']>, ParentType, ContextType>;
  dividendYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  expenseRatio?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecommended?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSociallyResponsibleInvesting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  longDescription?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommendedAllocation?: Resolver<ResolversTypes['AssetAllocation'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MoneyWeightedRateOfReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyWeightedRateOfReturn'] = ResolversParentTypes['MoneyWeightedRateOfReturn']> = {
  annualized?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  cumulative?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptAdvisoryRelationshipApprovalRequest?: Resolver<ResolversTypes['AcceptAdvisoryRelationshipApprovalRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationAcceptAdvisoryRelationshipApprovalRequestArgs, 'input'>>;
  addEnvelopeExternalAccounts?: Resolver<ResolversTypes['AddEnvelopeExternalAccountsMutationPayload'], ParentType, ContextType, RequireFields<MutationAddEnvelopeExternalAccountsArgs, 'input'>>;
  cancelTransactionRequest?: Resolver<ResolversTypes['CancelTransactionRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationCancelTransactionRequestArgs, 'input'>>;
  capturePackageSignature?: Resolver<ResolversTypes['CapturePackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationCapturePackageSignatureArgs, 'input'>>;
  completeDraftPurposeFlow?: Resolver<ResolversTypes['CompleteDraftPurposeFlowMutationPayload'], ParentType, ContextType, RequireFields<MutationCompleteDraftPurposeFlowArgs, 'input'>>;
  completeSolo401kClientEnvelopeFlow?: Resolver<ResolversTypes['SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload'], ParentType, ContextType, RequireFields<MutationCompleteSolo401kClientEnvelopeFlowArgs, 'input'>>;
  completeTaxCoordinatedAccountCreationFlowMutation?: Resolver<ResolversTypes['CompleteTaxCoordinatedAccountCreationFlowMutationPayload'], ParentType, ContextType, RequireFields<MutationCompleteTaxCoordinatedAccountCreationFlowMutationArgs, 'input'>>;
  confirmIdentityVerificationChallenge?: Resolver<ResolversTypes['ConfirmIdentityVerificationChallengeMutationPayload'], ParentType, ContextType, RequireFields<MutationConfirmIdentityVerificationChallengeArgs, 'input'>>;
  createAccountRecommendationExplanation?: Resolver<ResolversTypes['CreateAccountRecommendationExplanationMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateAccountRecommendationExplanationArgs, 'input'>>;
  createDirectTradingAccount?: Resolver<ResolversTypes['CreateDirectTradingAccountMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateDirectTradingAccountArgs, 'input'>>;
  createDocumentVerificationToken?: Resolver<ResolversTypes['CreateDocumentVerificationTokenMutationPayload'], ParentType, ContextType>;
  createEmployeeContributionConfigurationChangeRequest?: Resolver<ResolversTypes['CreateEmployeeContributionConfigurationChangeRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateEmployeeContributionConfigurationChangeRequestArgs, 'input'>>;
  createFinancialSecurityOrderRequest?: Resolver<ResolversTypes['CreateFinancialSecurityOrderRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateFinancialSecurityOrderRequestArgs, 'input'>>;
  createPersonalReferralInvitation?: Resolver<ResolversTypes['CreatePersonalReferralInvitationMutationPayload'], ParentType, ContextType, RequireFields<MutationCreatePersonalReferralInvitationArgs, 'input'>>;
  createRecurringTransactionConfig?: Resolver<ResolversTypes['CreateRecurringTransactionConfigMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateRecurringTransactionConfigArgs, 'input'>>;
  createSolo401kInterestSubmissions?: Resolver<ResolversTypes['CreateSolo401kInterestSubmissionsMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateSolo401kInterestSubmissionsArgs, 'input'>>;
  createTransactionMemo?: Resolver<ResolversTypes['CreateTransactionMemoMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateTransactionMemoArgs, 'input'>>;
  createTransactionRequest?: Resolver<ResolversTypes['CreateTransactionRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateTransactionRequestArgs, 'input'>>;
  createUserActivityCsvExport?: Resolver<ResolversTypes['CreateUserActivityCsvExportMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateUserActivityCsvExportArgs, 'input'>>;
  deleteCheckingBeneficiary?: Resolver<ResolversTypes['DeleteCheckingBeneficiaryMutationPayload'], ParentType, ContextType>;
  deletePurpose?: Resolver<ResolversTypes['DeletePurposeMutationPayload'], ParentType, ContextType, RequireFields<MutationDeletePurposeArgs, 'input'>>;
  deleteRecurringTransactionConfig?: Resolver<ResolversTypes['DeleteRecurringTransactionConfigMutationPayload'], ParentType, ContextType, RequireFields<MutationDeleteRecurringTransactionConfigArgs, 'input'>>;
  deleteTrustedContact?: Resolver<ResolversTypes['DeleteTrustedContactMutationPayload'], ParentType, ContextType>;
  dismissUserActivityCsvExportBanner?: Resolver<ResolversTypes['DismissUserActivityCsvExportBannerMutationPayload'], ParentType, ContextType, RequireFields<MutationDismissUserActivityCsvExportBannerArgs, 'input'>>;
  initiateStudentLoanPaymentBenefitAttestation?: Resolver<ResolversTypes['InitiateStudentLoanPaymentBenefitAttestationMutationPayload'], ParentType, ContextType>;
  processCapitalizeWindowEvent?: Resolver<ResolversTypes['ProcessCapitalizeWindowEventMutationPayload'], ParentType, ContextType, RequireFields<MutationProcessCapitalizeWindowEventArgs, 'input'>>;
  removeTheirExternalAccountEnvelope?: Resolver<ResolversTypes['RemoveTheirExternalAccountEnvelopeMutationPayload'], ParentType, ContextType, RequireFields<MutationRemoveTheirExternalAccountEnvelopeArgs, 'input'>>;
  resendPersonalReferralInvitation?: Resolver<ResolversTypes['ResendPersonalReferralInvitationMutationPayload'], ParentType, ContextType, RequireFields<MutationResendPersonalReferralInvitationArgs, 'input'>>;
  revokeMobileToken?: Resolver<ResolversTypes['RevokeMobileTokenMutationPayload'], ParentType, ContextType, RequireFields<MutationRevokeMobileTokenArgs, 'input'>>;
  sendEmailVerificationEmail?: Resolver<ResolversTypes['SendEmailVerificationEmailMutationPayload'], ParentType, ContextType>;
  sendWireTransferInstructionsEmail?: Resolver<ResolversTypes['SendWireTransferInstructionsEmailMutationPayload'], ParentType, ContextType, RequireFields<MutationSendWireTransferInstructionsEmailArgs, 'input'>>;
  sendWireTransferInstructionsEmailV2?: Resolver<ResolversTypes['SendWireTransferInstructionsEmailV2MutationPayload'], ParentType, ContextType, RequireFields<MutationSendWireTransferInstructionsEmailV2Args, 'input'>>;
  submitAdhocDocumentVerification?: Resolver<ResolversTypes['SubmitAdhocDocumentVerificationMutationPayload'], ParentType, ContextType, RequireFields<MutationSubmitAdhocDocumentVerificationArgs, 'input'>>;
  submitDocumentVerification?: Resolver<ResolversTypes['SubmitDocumentVerificationMutationPayload'], ParentType, ContextType, RequireFields<MutationSubmitDocumentVerificationArgs, 'input'>>;
  submitFeedback?: Resolver<ResolversTypes['SubmitFeedbackMutationPayload'], ParentType, ContextType, RequireFields<MutationSubmitFeedbackArgs, 'input'>>;
  updateAccountName?: Resolver<ResolversTypes['UpdateAccountNameMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateAccountNameArgs, 'input'>>;
  updateAdvisorNetworkIntent?: Resolver<ResolversTypes['UpdateAdvisorNetworkIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateAdvisorNetworkIntentArgs, 'input'>>;
  updateCheckingBeneficiary?: Resolver<ResolversTypes['UpdateCheckingBeneficiaryMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateCheckingBeneficiaryArgs, 'input'>>;
  updateEnvelopeOrders?: Resolver<ResolversTypes['UpdateEnvelopeOrdersMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateEnvelopeOrdersArgs, 'input'>>;
  updateExternalAccountVisibility?: Resolver<ResolversTypes['UpdateExternalAccountVisibilityMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateExternalAccountVisibilityArgs, 'input'>>;
  updateFinancialProfileRetirementAssumptions?: Resolver<ResolversTypes['UpdateFinancialProfileRetirementAssumptionsMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateFinancialProfileRetirementAssumptionsArgs, 'input'>>;
  updateLegalAccountBeneficiaries?: Resolver<ResolversTypes['UpdateLegalAccountBeneficiariesMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateLegalAccountBeneficiariesArgs, 'input'>>;
  updateSecuritiesLendingEnrollment?: Resolver<ResolversTypes['UpdateSecuritiesLendingEnrollmentMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateSecuritiesLendingEnrollmentArgs, 'input'>>;
  updateStudentLoanPaymentBenefitAttestation?: Resolver<ResolversTypes['UpdateStudentLoanPaymentBenefitAttestationMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateStudentLoanPaymentBenefitAttestationArgs, 'input'>>;
  updateStudentLoanPaymentBenefitEstimate?: Resolver<ResolversTypes['UpdateStudentLoanPaymentBenefitEstimateMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateStudentLoanPaymentBenefitEstimateArgs, 'input'>>;
  updateTrustedContact?: Resolver<ResolversTypes['UpdateTrustedContactMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateTrustedContactArgs, 'input'>>;
  updateUserInvestingExperience?: Resolver<ResolversTypes['UpdateUserInvestingExperienceMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateUserInvestingExperienceArgs, 'input'>>;
  updateUserPostalAddress?: Resolver<ResolversTypes['UpdateUserPostalAddressMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateUserPostalAddressArgs, 'input'>>;
  updateUserProfile?: Resolver<ResolversTypes['UpdateUserProfileMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateUserProfileArgs, 'input'>>;
  uploadAddressChangeDocument?: Resolver<ResolversTypes['UploadAddressChangeDocumentMutationPayload'], ParentType, ContextType, RequireFields<MutationUploadAddressChangeDocumentArgs, 'input'>>;
  validateDirectTradingJointAccountSecondaryUser?: Resolver<ResolversTypes['ValidateDirectTradingJointAccountSecondaryUserMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateDirectTradingJointAccountSecondaryUserArgs, 'input'>>;
  validateDirectTradingTrustDetails?: Resolver<ResolversTypes['ValidateDirectTradingTrustDetailsMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateDirectTradingTrustDetailsArgs, 'input'>>;
  validateFinancialSecurityOrderRequest?: Resolver<ResolversTypes['ValidateFinancialSecurityOrderRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateFinancialSecurityOrderRequestArgs, 'input'>>;
  validateLegalAccountBeneficiary?: Resolver<ResolversTypes['ValidateLegalAccountBeneficiaryMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateLegalAccountBeneficiaryArgs, 'input'>>;
};

export type NetWorthResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetWorth'] = ResolversParentTypes['NetWorth']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  externalSubtotal?: Resolver<ResolversTypes['NetWorthSubtotal'], ParentType, ContextType>;
  internalSubtotal?: Resolver<ResolversTypes['NetWorthSubtotal'], ParentType, ContextType>;
};

export type NetWorthSubtotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetWorthSubtotal'] = ResolversParentTypes['NetWorthSubtotal']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['NetWorthSubtotalItem']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NetWorthSubtotalItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetWorthSubtotalItem'] = ResolversParentTypes['NetWorthSubtotalItem']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OtherUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['OtherUser'] = ResolversParentTypes['OtherUser']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PayrollContributionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfig'] = ResolversParentTypes['PayrollContributionConfig']> = {
  account?: Resolver<ResolversTypes['PayrollContributionConfigAccount'], ParentType, ContextType>;
  bonusValue?: Resolver<Maybe<ResolversTypes['PayrollContributionConfigValue']>, ParentType, ContextType>;
  destinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  notEditableReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['PayrollContributionConfigValue'], ParentType, ContextType>;
};

export type PayrollContributionConfigAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigAccount'] = ResolversParentTypes['PayrollContributionConfigAccount']> = {
  __resolveType: TypeResolveFn<'Five29Account' | 'ManagedSubAccount', ParentType, ContextType>;
};

export type PayrollContributionConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigConnection'] = ResolversParentTypes['PayrollContributionConfigConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PayrollContributionConfigEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PayrollContributionConfig']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
};

export type PayrollContributionConfigEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigEdge'] = ResolversParentTypes['PayrollContributionConfigEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PayrollContributionConfig'], ParentType, ContextType>;
};

export type PayrollContributionConfigValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValue'] = ResolversParentTypes['PayrollContributionConfigValue']> = {
  __resolveType: TypeResolveFn<'PayrollContributionConfigValueAmount' | 'PayrollContributionConfigValuePercent', ParentType, ContextType>;
};

export type PayrollContributionConfigValueAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValueAmount'] = ResolversParentTypes['PayrollContributionConfigValueAmount']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrollContributionConfigValuePercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValuePercent'] = ResolversParentTypes['PayrollContributionConfigValuePercent']> = {
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PendingDocumentVerificationRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PendingDocumentVerificationRequest'] = ResolversParentTypes['PendingDocumentVerificationRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export interface PercentScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Percent'], any> {
  name: 'Percent';
}

export type PerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Performance'] = ResolversParentTypes['Performance']> = {
  accounts?: Resolver<Array<ResolversTypes['PerformanceAccount']>, ParentType, ContextType>;
  benchmarks?: Resolver<Array<ResolversTypes['PerformanceBenchmark']>, ParentType, ContextType, Partial<PerformanceBenchmarksArgs>>;
  history?: Resolver<ResolversTypes['PerformanceHistory'], ParentType, ContextType>;
  simpleRateOfReturn?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  timeWeightedReturns?: Resolver<ResolversTypes['PerformanceTimeWeightedReturns'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['PerformanceTotals'], ParentType, ContextType>;
};

export type PerformanceAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceAccount'] = ResolversParentTypes['PerformanceAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'DirectTradingAccount' | 'ManagedAccount', ParentType, ContextType>;
};

export type PerformanceBenchmarkResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceBenchmark'] = ResolversParentTypes['PerformanceBenchmark']> = {
  group?: Resolver<ResolversTypes['PerformanceBenchmarkGroup'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeWeightedReturns?: Resolver<ResolversTypes['PerformanceBenchmarkTimeWeightedReturns'], ParentType, ContextType>;
};

export type PerformanceBenchmarkGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceBenchmarkGroup'] = ResolversParentTypes['PerformanceBenchmarkGroup']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PerformanceBenchmarkTimeWeightedReturnsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceBenchmarkTimeWeightedReturns'] = ResolversParentTypes['PerformanceBenchmarkTimeWeightedReturns']> = {
  timeSeries?: Resolver<Array<ResolversTypes['PerformanceHistoryTimeWeightedReturnItem']>, ParentType, ContextType>;
};

export type PerformanceHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceHistory'] = ResolversParentTypes['PerformanceHistory']> = {
  recencyDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeSeries?: Resolver<Array<ResolversTypes['PerformanceHistoryItem']>, ParentType, ContextType>;
};

export type PerformanceHistoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceHistoryItem'] = ResolversParentTypes['PerformanceHistoryItem']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  earned?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  invested?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceHistoryTimeWeightedReturnItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceHistoryTimeWeightedReturnItem'] = ResolversParentTypes['PerformanceHistoryTimeWeightedReturnItem']> = {
  cumulativeReturn?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
};

export type PerformanceInterestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceInterest'] = ResolversParentTypes['PerformanceInterest']> = {
  accrued?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  accruedExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceInvestingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceInvesting'] = ResolversParentTypes['PerformanceInvesting']> = {
  adjustments?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  allTimeTlhEstimatedTaxSavings?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  dividends?: Resolver<Maybe<ResolversTypes['PerformanceTotalsDividends']>, ParentType, ContextType>;
  earned?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  marketChanges?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  taxLossesHarvested?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  tlhEstimatedTaxSavingsDescription?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
};

export type PerformanceTimeWeightedReturnsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTimeWeightedReturns'] = ResolversParentTypes['PerformanceTimeWeightedReturns']> = {
  timeSeries?: Resolver<Array<ResolversTypes['PerformanceHistoryTimeWeightedReturnItem']>, ParentType, ContextType>;
};

export type PerformanceTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotals'] = ResolversParentTypes['PerformanceTotals']> = {
  earned?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  endingBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['PerformanceTotalsFees'], ParentType, ContextType>;
  interest?: Resolver<Maybe<ResolversTypes['PerformanceInterest']>, ParentType, ContextType>;
  invested?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  investing?: Resolver<Maybe<ResolversTypes['PerformanceInvesting']>, ParentType, ContextType>;
  moneyWeightedRateOfReturn?: Resolver<ResolversTypes['MoneyWeightedRateOfReturn'], ParentType, ContextType>;
  startingBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  timeWeightedRateOfReturn?: Resolver<ResolversTypes['TimeWeightedRateOfReturn'], ParentType, ContextType>;
  userTransactions?: Resolver<ResolversTypes['PerformanceTotalsUserTransactions'], ParentType, ContextType>;
};

export type PerformanceTotalsDividendsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotalsDividends'] = ResolversParentTypes['PerformanceTotalsDividends']> = {
  pending?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  reinvested?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceTotalsFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotalsFees'] = ResolversParentTypes['PerformanceTotalsFees']> = {
  management?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  trading?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceTotalsUserTransactionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotalsUserTransactions'] = ResolversParentTypes['PerformanceTotalsUserTransactions']> = {
  deposits?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netDeposits?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  pending?: Resolver<ResolversTypes['PerformanceTotalsUserTransactionsPending'], ParentType, ContextType>;
  withdrawals?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceTotalsUserTransactionsPendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotalsUserTransactionsPending'] = ResolversParentTypes['PerformanceTotalsUserTransactionsPending']> = {
  depositsAndTransfersIn?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  withdrawalsAndTransfersOut?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Portfolio'] = ResolversParentTypes['Portfolio']> = {
  __resolveType: TypeResolveFn<'CryptoPortfolio' | 'ExternallyAdvisedPlanPortfolio' | 'InvestmentPortfolio', ParentType, ContextType>;
};

export type PortfolioStrategyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioStrategy'] = ResolversParentTypes['PortfolioStrategy']> = {
  descriptionHtml?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType, RequireFields<PortfolioStrategyDescriptionHtmlArgs, 'includeLegacyDisclosureLink'>>;
  icon?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PostalAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostalAddress'] = ResolversParentTypes['PostalAddress']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['AddressState'], ParentType, ContextType>;
};

export type PremiumAdvisorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PremiumAdvisor'] = ResolversParentTypes['PremiumAdvisor']> = {
  calendarLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PremiumOnboardingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PremiumOnboardingOption'] = ResolversParentTypes['PremiumOnboardingOption']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  feeDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  hasScheduledMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<PremiumOnboardingOptionImageArgs, 'variant'>>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroup'] = ResolversParentTypes['PriceGroup']> = {
  accountsDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  minFee?: Resolver<Maybe<ResolversTypes['PriceGroupMinFee']>, ParentType, ContextType>;
  premiumPricing?: Resolver<Maybe<ResolversTypes['PriceGroupPremiumPricing']>, ParentType, ContextType>;
  priceDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pricingCta?: Resolver<Maybe<ResolversTypes['PriceGroupPricingCta']>, ParentType, ContextType>;
  pricingTier?: Resolver<Maybe<ResolversTypes['PriceGroupPricingTier']>, ParentType, ContextType>;
};

export type PriceGroupMinFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroupMinFee'] = ResolversParentTypes['PriceGroupMinFee']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PriceGroupPremiumPricingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroupPremiumPricing'] = ResolversParentTypes['PriceGroupPremiumPricing']> = {
  breakdowns?: Resolver<Array<ResolversTypes['PriceGroupPricingTierBreakdown']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PriceGroupPricingCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroupPricingCta'] = ResolversParentTypes['PriceGroupPricingCta']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PriceGroupPricingTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroupPricingTier'] = ResolversParentTypes['PriceGroupPricingTier']> = {
  breakdowns?: Resolver<Array<ResolversTypes['PriceGroupPricingTierBreakdown']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PriceGroupPricingTierBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceGroupPricingTierBreakdown'] = ResolversParentTypes['PriceGroupPricingTierBreakdown']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PriceRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceRange'] = ResolversParentTypes['PriceRange']> = {
  highPrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  lowPrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type ProcessCapitalizeWindowEventMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessCapitalizeWindowEventMutationPayload'] = ResolversParentTypes['ProcessCapitalizeWindowEventMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type ProductBundleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductBundle'] = ResolversParentTypes['ProductBundle']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productOnboardingOptions?: Resolver<Array<ResolversTypes['ProductOnboardingOption']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['ProductOnboardingStep']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProductOnboardingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductOnboardingOption'] = ResolversParentTypes['ProductOnboardingOption']> = {
  __resolveType: TypeResolveFn<'CheckingAccountCreationOption' | 'FinancialCoachingOnboardingOption' | 'FiveTwoNineGoalCreationOption' | 'GoalCreationOption' | 'PremiumOnboardingOption' | 'Solo401kOnboardingOption', ParentType, ContextType>;
};

export type ProductOnboardingStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductOnboardingStep'] = ResolversParentTypes['ProductOnboardingStep']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ProductOnboardingStepState'], ParentType, ContextType>;
};

export type ProductUnavailabilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductUnavailability'] = ResolversParentTypes['ProductUnavailability']> = {
  body?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProfessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profession'] = ResolversParentTypes['Profession']> = {
  employmentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProgressChecklistResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgressChecklist'] = ResolversParentTypes['ProgressChecklist']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['MessageCta']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProgressChecklistStatus'], ParentType, ContextType>;
  trackingName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PurposeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Purpose'] = ResolversParentTypes['Purpose']> = {
  __resolveType: TypeResolveFn<'PurposeEmergencyFund' | 'PurposeMajorPurchase' | 'PurposeRetirementGrowth' | 'PurposeRetirementIncome', ParentType, ContextType>;
};

export type PurposeAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeAsset'] = ResolversParentTypes['PurposeAsset']> = {
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyImageKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PurposeCreationOptionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeCreationOptionInterface'] = ResolversParentTypes['PurposeCreationOptionInterface']> = {
  __resolveType: TypeResolveFn<'EmergencyFundPurposeCreationOption' | 'MajorPurchasePurposeCreationOption' | 'RetirementGrowthPurposeCreationOption' | 'RetirementIncomePurposeCreationOption', ParentType, ContextType>;
};

export type PurposeEmergencyFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeEmergencyFund'] = ResolversParentTypes['PurposeEmergencyFund']> = {
  adviceTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  monthlyExpensesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  monthsExpensesCovered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projection?: Resolver<ResolversTypes['PurposeEmergencyFundProjection'], ParentType, ContextType, Partial<PurposeEmergencyFundProjectionArgs>>;
  target?: Resolver<Maybe<ResolversTypes['Target']>, ParentType, ContextType>;
  target2?: Resolver<Maybe<ResolversTypes['PurposeEmergencyFundTarget']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeEmergencyFundProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeEmergencyFundProjection'] = ResolversParentTypes['PurposeEmergencyFundProjection']> = {
  balanceTimeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
  monthsExpensesCovered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recommendedMonthlyInflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type PurposeEmergencyFundTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeEmergencyFundTarget'] = ResolversParentTypes['PurposeEmergencyFundTarget']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  buffer?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  monthsExpensesCovered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PurposeMajorPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeMajorPurchase'] = ResolversParentTypes['PurposeMajorPurchase']> = {
  adviceTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['PurposeMajorPurchaseProjection']>, ParentType, ContextType, Partial<PurposeMajorPurchaseProjectionArgs>>;
  target?: Resolver<Maybe<ResolversTypes['Target']>, ParentType, ContextType>;
  target2?: Resolver<ResolversTypes['PurposeMajorPurchaseTarget'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeMajorPurchaseProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeMajorPurchaseProjection'] = ResolversParentTypes['PurposeMajorPurchaseProjection']> = {
  balanceTimeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
  completion?: Resolver<Maybe<ResolversTypes['PurposeMajorPurchaseProjectionCompletion']>, ParentType, ContextType>;
};

export type PurposeMajorPurchaseProjectionCompletionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeMajorPurchaseProjectionCompletion'] = ResolversParentTypes['PurposeMajorPurchaseProjectionCompletion']> = {
  confidencePercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  isOnTrack?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommendedMonthlyInflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  recommendedOneTimeInflow?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type PurposeMajorPurchaseTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeMajorPurchaseTarget'] = ResolversParentTypes['PurposeMajorPurchaseTarget']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
};

export type PurposeRetirementGrowthResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementGrowth'] = ResolversParentTypes['PurposeRetirementGrowth']> = {
  adviceTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  financialProfile?: Resolver<ResolversTypes['FinancialProfile'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['PurposeRetirementGrowthProjection']>, ParentType, ContextType, Partial<PurposeRetirementGrowthProjectionArgs>>;
  target?: Resolver<Maybe<ResolversTypes['Target']>, ParentType, ContextType>;
  target2?: Resolver<Maybe<ResolversTypes['PurposeRetirementGrowthTarget']>, ParentType, ContextType>;
  targetMonthlySpendingAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeRetirementGrowthProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementGrowthProjection'] = ResolversParentTypes['PurposeRetirementGrowthProjection']> = {
  balanceTimeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
  completion?: Resolver<ResolversTypes['PurposeRetirementGrowthProjectionCompletion'], ParentType, ContextType>;
  monthlySpendingAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  savingsPlan?: Resolver<ResolversTypes['SavingsPlan'], ParentType, ContextType>;
};

export type PurposeRetirementGrowthProjectionCompletionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementGrowthProjectionCompletion'] = ResolversParentTypes['PurposeRetirementGrowthProjectionCompletion']> = {
  confidencePercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  isOnTrack?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recommendedTotalAnnualContributions?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  targetTotalSpendingAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PurposeRetirementGrowthTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementGrowthTarget'] = ResolversParentTypes['PurposeRetirementGrowthTarget']> = {
  monthlySpendingAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  spendingAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PurposeRetirementIncomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementIncome'] = ResolversParentTypes['PurposeRetirementIncome']> = {
  adviceTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  isDeletionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  lifeExpectancyAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projection?: Resolver<ResolversTypes['PurposeRetirementIncomeProjection'], ParentType, ContextType, Partial<PurposeRetirementIncomeProjectionArgs>>;
  target?: Resolver<Maybe<ResolversTypes['Target']>, ParentType, ContextType>;
  yearsRemaining?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeRetirementIncomeProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementIncomeProjection'] = ResolversParentTypes['PurposeRetirementIncomeProjection']> = {
  balanceTimeSeries?: Resolver<Array<ResolversTypes['BalanceProjectionItem']>, ParentType, ContextType>;
  recommendedMonthlyOutflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  yearsOfSpending?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accountRecommendationOption?: Resolver<Maybe<ResolversTypes['AccountRecommendationOption']>, ParentType, ContextType>;
  activeRewards?: Resolver<Array<ResolversTypes['ActiveReward']>, ParentType, ContextType>;
  activeVerificationChallenge?: Resolver<Maybe<ResolversTypes['IdentityVerificationChallenge']>, ParentType, ContextType>;
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<QueryActivityConnectionArgs, 'filters'>>;
  activityDateRangeOptions?: Resolver<Array<ResolversTypes['ActivityDateRangeOption']>, ParentType, ContextType>;
  activityItemTypeOptions?: Resolver<Array<ResolversTypes['ActivityItemTypeFilterOption']>, ParentType, ContextType>;
  activityItemTypeOptionsV2?: Resolver<Array<ResolversTypes['ActivityItemTypeFilterOptionV2']>, ParentType, ContextType>;
  activityItemsForId?: Resolver<Array<ResolversTypes['ActivityItem']>, ParentType, ContextType, RequireFields<QueryActivityItemsForIdArgs, 'id'>>;
  addressStateOptions?: Resolver<Array<ResolversTypes['AddressState']>, ParentType, ContextType>;
  advisedSoloFourOhOneKClientInvite?: Resolver<Maybe<ResolversTypes['AdvisedSoloFourOhOneKClientInvite']>, ParentType, ContextType, RequireFields<QueryAdvisedSoloFourOhOneKClientInviteArgs, 'token'>>;
  advisor?: Resolver<Maybe<ResolversTypes['Advisor']>, ParentType, ContextType>;
  article?: Resolver<ResolversTypes['Article'], ParentType, ContextType, RequireFields<QueryArticleArgs, 'id'>>;
  articles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, Partial<QueryArticlesArgs>>;
  checkingAccount?: Resolver<ResolversTypes['CheckingAccount'], ParentType, ContextType, RequireFields<QueryCheckingAccountArgs, 'id'>>;
  checkingAccounts?: Resolver<Array<ResolversTypes['CheckingAccount']>, ParentType, ContextType>;
  checkingCustomer?: Resolver<ResolversTypes['CheckingCustomerResult'], ParentType, ContextType>;
  checkingReceivedInvitations?: Resolver<Array<ResolversTypes['JointAccountInvitation']>, ParentType, ContextType>;
  clientEnvelopeApprovalRequest?: Resolver<ResolversTypes['ClientEnvelopeApprovalRequest'], ParentType, ContextType, RequireFields<QueryClientEnvelopeApprovalRequestArgs, 'id'>>;
  currentMarketingMessage?: Resolver<Maybe<ResolversTypes['MarketingMessage']>, ParentType, ContextType, RequireFields<QueryCurrentMarketingMessageArgs, 'input'>>;
  deferralSetting?: Resolver<ResolversTypes['DeferralSetting'], ParentType, ContextType, RequireFields<QueryDeferralSettingArgs, 'id'>>;
  deferralSettings?: Resolver<Array<ResolversTypes['DeferralSetting']>, ParentType, ContextType>;
  deferralSettingsEditOption?: Resolver<ResolversTypes['DeferralSettingsEditOption'], ParentType, ContextType, RequireFields<QueryDeferralSettingsEditOptionArgs, 'id'>>;
  directTradingAccount?: Resolver<ResolversTypes['DirectTradingAccount'], ParentType, ContextType, RequireFields<QueryDirectTradingAccountArgs, 'id'>>;
  disclosures?: Resolver<ResolversTypes['Disclosures'], ParentType, ContextType>;
  document?: Resolver<ResolversTypes['DocumentFile'], ParentType, ContextType, RequireFields<QueryDocumentArgs, 'id' | 'type'>>;
  documentCategories?: Resolver<Array<ResolversTypes['DocumentCategoryOrCategoryGroup']>, ParentType, ContextType>;
  documentCategory?: Resolver<ResolversTypes['DocumentCategory'], ParentType, ContextType, RequireFields<QueryDocumentCategoryArgs, 'id'>>;
  documents?: Resolver<ResolversTypes['DocumentsResult'], ParentType, ContextType, RequireFields<QueryDocumentsArgs, 'categoryId'>>;
  educationArticle?: Resolver<ResolversTypes['Article'], ParentType, ContextType, RequireFields<QueryEducationArticleArgs, 'id'>>;
  educationArticles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, Partial<QueryEducationArticlesArgs>>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType, RequireFields<QueryEmployeeArgs, 'employerId'>>;
  employerFourOhOneKContributions?: Resolver<Maybe<ResolversTypes['EmployerFourOhOneKContributionsResult']>, ParentType, ContextType>;
  employers?: Resolver<Array<ResolversTypes['Employer']>, ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType, RequireFields<QueryEnvelopeArgs, 'id'>>;
  envelopeAccount?: Resolver<ResolversTypes['EnvelopeAccount'], ParentType, ContextType, RequireFields<QueryEnvelopeAccountArgs, 'id'>>;
  envelopes?: Resolver<Array<ResolversTypes['Envelope']>, ParentType, ContextType>;
  externalAccounts?: Resolver<Array<ResolversTypes['ExternalAccount']>, ParentType, ContextType, Partial<QueryExternalAccountsArgs>>;
  financialProfile?: Resolver<Maybe<ResolversTypes['FinancialProfile']>, ParentType, ContextType>;
  financialServiceOptions?: Resolver<Array<ResolversTypes['FinancialServiceOption']>, ParentType, ContextType>;
  five29Account?: Resolver<ResolversTypes['Five29Account'], ParentType, ContextType, RequireFields<QueryFive29AccountArgs, 'id'>>;
  fiveTwoNineOnboardingOption?: Resolver<Maybe<ResolversTypes['FiveTwoNineGoalCreationOption']>, ParentType, ContextType>;
  fourOhOneKContributions?: Resolver<Maybe<ResolversTypes['FourOhOneKContributionsResult']>, ParentType, ContextType>;
  fourOhOneKStudentLoanMatchBenefit?: Resolver<Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']>, ParentType, ContextType>;
  goal?: Resolver<ResolversTypes['Goal'], ParentType, ContextType, RequireFields<QueryGoalArgs, 'id'>>;
  goalCreationIntents?: Resolver<Array<ResolversTypes['GoalCreationIntent']>, ParentType, ContextType>;
  goalCreationOption?: Resolver<ResolversTypes['GoalCreationOption'], ParentType, ContextType, RequireFields<QueryGoalCreationOptionArgs, 'id'>>;
  goals?: Resolver<Array<ResolversTypes['Goal']>, ParentType, ContextType, Partial<QueryGoalsArgs>>;
  iraContributionMatchGrants?: Resolver<Array<ResolversTypes['IraContributionMatchGrant']>, ParentType, ContextType, Partial<QueryIraContributionMatchGrantsArgs>>;
  iraContributions?: Resolver<Maybe<ResolversTypes['IraContributionsResult']>, ParentType, ContextType>;
  isEarnedRewardsEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleRewardsEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReferralEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType, RequireFields<QueryLegalAccountArgs, 'id'>>;
  legalAccounts?: Resolver<Array<ResolversTypes['LegalAccount']>, ParentType, ContextType>;
  legalSubAccounts?: Resolver<Array<ResolversTypes['LegalSubAccount']>, ParentType, ContextType, Partial<QueryLegalSubAccountsArgs>>;
  managedAccount?: Resolver<ResolversTypes['ManagedAccount'], ParentType, ContextType, RequireFields<QueryManagedAccountArgs, 'id'>>;
  marketSchedule?: Resolver<ResolversTypes['MarketSchedule'], ParentType, ContextType, Partial<QueryMarketScheduleArgs>>;
  memoCreationOption?: Resolver<ResolversTypes['MemoCreationOption'], ParentType, ContextType, RequireFields<QueryMemoCreationOptionArgs, 'id'>>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryMessagesArgs, 'location'>>;
  netWorth?: Resolver<Maybe<ResolversTypes['NetWorth']>, ParentType, ContextType>;
  payrollContributionConfigs?: Resolver<Array<ResolversTypes['PayrollContributionConfig']>, ParentType, ContextType, Partial<QueryPayrollContributionConfigsArgs>>;
  pendingDocumentVerificationRequest?: Resolver<Maybe<ResolversTypes['PendingDocumentVerificationRequest']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<QueryPerformanceArgs, 'accountIds' | 'dateRangeOption'>>;
  performanceTotals?: Resolver<ResolversTypes['PerformanceTotals'], ParentType, ContextType, RequireFields<QueryPerformanceTotalsArgs, 'dateRangeOption'>>;
  portfolioStrategyOption?: Resolver<Maybe<ResolversTypes['LegacyPortfolioStrategyOption']>, ParentType, ContextType, RequireFields<QueryPortfolioStrategyOptionArgs, 'adviceTypeId' | 'limitedAdviceEligible' | 'targetDate'>>;
  portfolioStrategyOptions?: Resolver<Array<ResolversTypes['LegacyPortfolioStrategyOption']>, ParentType, ContextType, RequireFields<QueryPortfolioStrategyOptionsArgs, 'adviceTypeId' | 'limitedAdviceEligible' | 'productCategory' | 'targetDate'>>;
  premiumOnboardingOption?: Resolver<Maybe<ResolversTypes['PremiumOnboardingOption']>, ParentType, ContextType>;
  priceGroups?: Resolver<Array<ResolversTypes['PriceGroup']>, ParentType, ContextType>;
  productBundles?: Resolver<Array<ResolversTypes['ProductBundle']>, ParentType, ContextType>;
  productOnboardingOptions?: Resolver<Array<ResolversTypes['ProductOnboardingOption']>, ParentType, ContextType, Partial<QueryProductOnboardingOptionsArgs>>;
  purpose?: Resolver<ResolversTypes['Purpose'], ParentType, ContextType, RequireFields<QueryPurposeArgs, 'id'>>;
  purposeAssets?: Resolver<Array<ResolversTypes['PurposeAsset']>, ParentType, ContextType>;
  purposeCreationOption?: Resolver<ResolversTypes['PurposeCreationOptionInterface'], ParentType, ContextType, RequireFields<QueryPurposeCreationOptionArgs, 'id'>>;
  purposeCreationOptions?: Resolver<Array<ResolversTypes['PurposeCreationOptionInterface']>, ParentType, ContextType, RequireFields<QueryPurposeCreationOptionsArgs, 'intent'>>;
  purposes?: Resolver<Array<ResolversTypes['Purpose']>, ParentType, ContextType, Partial<QueryPurposesArgs>>;
  recurringTransactionConfig?: Resolver<ResolversTypes['RecurringTransactionConfig'], ParentType, ContextType, RequireFields<QueryRecurringTransactionConfigArgs, 'id'>>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  recurringTransactionSchedule?: Resolver<ResolversTypes['RecurringTransactionSchedule'], ParentType, ContextType, RequireFields<QueryRecurringTransactionScheduleArgs, 'frequency'>>;
  referralProgram?: Resolver<Maybe<ResolversTypes['ReferralProgram']>, ParentType, ContextType>;
  scheduledEventConfiguration?: Resolver<ResolversTypes['ScheduledEventConfiguration'], ParentType, ContextType, RequireFields<QueryScheduledEventConfigurationArgs, 'scheduleEvent'>>;
  somebodysExternalAccount?: Resolver<ResolversTypes['SomebodysExternalAccount'], ParentType, ContextType, RequireFields<QuerySomebodysExternalAccountArgs, 'id'>>;
  subAccount?: Resolver<ResolversTypes['SubAccount'], ParentType, ContextType, RequireFields<QuerySubAccountArgs, 'id'>>;
  taxCoordinationAccountOptions?: Resolver<Array<ResolversTypes['TaxCoordinationAccountOption']>, ParentType, ContextType>;
  termsAndAgreements?: Resolver<Array<ResolversTypes['TermsAndAgreements']>, ParentType, ContextType, RequireFields<QueryTermsAndAgreementsArgs, 'filter'>>;
  transactionOptions?: Resolver<Array<ResolversTypes['TransactionOption']>, ParentType, ContextType>;
  transferableAccount?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType, RequireFields<QueryTransferableAccountArgs, 'id'>>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userActivityCsvExport?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
  userLevelSettings?: Resolver<ResolversTypes['UserLevelSettings'], ParentType, ContextType>;
  wireTransferOption?: Resolver<ResolversTypes['WireTransferOption'], ParentType, ContextType, RequireFields<QueryWireTransferOptionArgs, 'id'>>;
};

export type RebalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rebalance'] = ResolversParentTypes['Rebalance']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type RecordNotFoundResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordNotFoundResult'] = ResolversParentTypes['RecordNotFoundResult']> = {
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordUnavailableResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordUnavailableResult'] = ResolversParentTypes['RecordUnavailableResult']> = {
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringDepositMotivationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringDepositMotivation'] = ResolversParentTypes['RecurringDepositMotivation']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  longDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  shortDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
};

export type RecurringTransactionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionConfig'] = ResolversParentTypes['RecurringTransactionConfig']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  amountPerMonth?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  destination?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  destinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['RecurringTransactionFrequency'], ParentType, ContextType>;
  frequencyDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['LegacyID']>, ParentType, ContextType>;
  legacyTransferType?: Resolver<ResolversTypes['LegacyTransferType'], ParentType, ContextType>;
  legacyUuid?: Resolver<Maybe<ResolversTypes['LegacyUUID']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<RecurringTransactionConfigMessagesArgs, 'location'>>;
  nextTransactionDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  sourceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RecurringTransactionConfigLifecycleStatus'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['RecurringTransactionConfigStatus']>, ParentType, ContextType>;
};

export type RecurringTransactionConfigStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionConfigStatus'] = ResolversParentTypes['RecurringTransactionConfigStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  style?: Resolver<ResolversTypes['RecurringTransactionConfigStatusStyle'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RecurringTransactionFrequencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequency'] = ResolversParentTypes['RecurringTransactionFrequency']> = {
  __resolveType: TypeResolveFn<'RecurringTransactionFrequencyAnnually' | 'RecurringTransactionFrequencyEveryOtherWeek' | 'RecurringTransactionFrequencyMonthly' | 'RecurringTransactionFrequencyTwiceAMonth' | 'RecurringTransactionFrequencyWeekly', ParentType, ContextType>;
};

export type RecurringTransactionFrequencyAnnuallyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyAnnually'] = ResolversParentTypes['RecurringTransactionFrequencyAnnually']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyEveryOtherWeekResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyEveryOtherWeek'] = ResolversParentTypes['RecurringTransactionFrequencyEveryOtherWeek']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyMonthlyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyMonthly'] = ResolversParentTypes['RecurringTransactionFrequencyMonthly']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyTwiceAMonthResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyTwiceAMonth'] = ResolversParentTypes['RecurringTransactionFrequencyTwiceAMonth']> = {
  firstDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secondDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyWeeklyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyWeekly'] = ResolversParentTypes['RecurringTransactionFrequencyWeekly']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionSchedule'] = ResolversParentTypes['RecurringTransactionSchedule']> = {
  nextTransactionDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  upcomingTransactableDates?: Resolver<Array<ResolversTypes['Date']>, ParentType, ContextType>;
};

export type ReferralInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralInvitation'] = ResolversParentTypes['ReferralInvitation']> = {
  emailAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSentAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReferralInvitationStatus'], ParentType, ContextType>;
};

export type ReferralProgramResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralProgram'] = ResolversParentTypes['ReferralProgram']> = {
  disclosureDescription?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  featuredImage?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  hasReachedMaxReferralRewards?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  longDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxReferralRewards?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralInvitations?: Resolver<Maybe<Array<ResolversTypes['ReferralInvitation']>>, ParentType, ContextType>;
  referralKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralRewards?: Resolver<Maybe<Array<ResolversTypes['ReferralReward']>>, ParentType, ContextType>;
  referralRewardsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  referrerInvitationContent?: Resolver<ResolversTypes['ReferrerInvitationContent'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ReferralRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralReward'] = ResolversParentTypes['ReferralReward']> = {
  activePeriod?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  offerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardType?: Resolver<ResolversTypes['ReferralRewardType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReferralRewardStatus'], ParentType, ContextType>;
};

export type ReferrerInvitationContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferrerInvitationContent'] = ResolversParentTypes['ReferrerInvitationContent']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosureDescription?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
};

export type RelativeRiskResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelativeRisk'] = ResolversParentTypes['RelativeRisk']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RemoteCheckingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoteCheckingAccount'] = ResolversParentTypes['RemoteCheckingAccount']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  customer?: Resolver<ResolversTypes['CheckingCustomer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOnlyAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSpendingAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jointAccountHolders?: Resolver<Array<ResolversTypes['OtherUser']>, ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sentInvitations?: Resolver<Array<ResolversTypes['JointAccountInvitation']>, ParentType, ContextType>;
};

export type RemoveTheirExternalAccountEnvelopeMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveTheirExternalAccountEnvelopeMutationPayload'] = ResolversParentTypes['RemoveTheirExternalAccountEnvelopeMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Envelope']>, ParentType, ContextType>;
};

export type ResendPersonalReferralInvitationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendPersonalReferralInvitationMutationPayload'] = ResolversParentTypes['ResendPersonalReferralInvitationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ReferralInvitation']>, ParentType, ContextType>;
};

export type RetirementContributionRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetirementContributionRecommendation'] = ResolversParentTypes['RetirementContributionRecommendation']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['MessageCtaLink']>, ParentType, ContextType>;
  eligibilityAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RetirementGrowthPurposeCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetirementGrowthPurposeCreationOption'] = ResolversParentTypes['RetirementGrowthPurposeCreationOption']> = {
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultRetirementAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  defaultRetirementMonthlySpending?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyAdviceTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeAsset?: Resolver<ResolversTypes['PurposeAsset'], ParentType, ContextType>;
  recommendedMonthlySpending?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RetirementIncomePurposeCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetirementIncomePurposeCreationOption'] = ResolversParentTypes['RetirementIncomePurposeCreationOption']> = {
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyAdviceTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeAsset?: Resolver<ResolversTypes['PurposeAsset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RevokeMobileTokenMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeMobileTokenMutationPayload'] = ResolversParentTypes['RevokeMobileTokenMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type RewardProgressStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['RewardProgressStatus'] = ResolversParentTypes['RewardProgressStatus']> = {
  briefDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detailedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RewardTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['RewardTier'] = ResolversParentTypes['RewardTier']> = {
  conditionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentTier?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fulfillmentStatus?: Resolver<Maybe<ResolversTypes['RewardTierFulfillmentStatus']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rewardDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RiskBasedAssetAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskBasedAssetAllocation'] = ResolversParentTypes['RiskBasedAssetAllocation']> = {
  assetTypeWeights?: Resolver<Array<ResolversTypes['AssetTypeWeight']>, ParentType, ContextType>;
  autoAdjustOptions?: Resolver<Array<ResolversTypes['AutoAdjustOption']>, ParentType, ContextType>;
  diversification?: Resolver<ResolversTypes['AssetAllocationDiversification'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  risk?: Resolver<ResolversTypes['AssetAllocationRisk'], ParentType, ContextType>;
  securityGroups?: Resolver<Array<ResolversTypes['SecurityGroup']>, ParentType, ContextType>;
  securityWeights?: Resolver<Array<ResolversTypes['LegacyWeightedSecurity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskLevel'] = ResolversParentTypes['RiskLevel']> = {
  bondYields?: Resolver<Maybe<ResolversTypes['BondPortfolioYields']>, ParentType, ContextType>;
  dividendYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  dividendYieldExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securityGroups?: Resolver<Array<ResolversTypes['SecurityGroup']>, ParentType, ContextType>;
  stockAllocationPercent?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
};

export type RiskLevelBasedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskLevelBasedPortfolio'] = ResolversParentTypes['RiskLevelBasedPortfolio']> = {
  configurationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosureUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  drift?: Resolver<ResolversTypes['Drift'], ParentType, ContextType>;
  expenseRatio?: Resolver<ResolversTypes['ExpenseRatio'], ParentType, ContextType>;
  hasPendingPortfolioChangeRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAllocationEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCryptoPortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStrategySelectionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rebalance?: Resolver<ResolversTypes['Rebalance'], ParentType, ContextType>;
  riskLevel?: Resolver<ResolversTypes['RiskLevel'], ParentType, ContextType>;
  strategy?: Resolver<ResolversTypes['PortfolioStrategy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RolloverOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolloverOption'] = ResolversParentTypes['RolloverOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPartiallyAcatsable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RothIraConversionOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RothIraConversionOption'] = ResolversParentTypes['RothIraConversionOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavingsPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SavingsPlan'] = ResolversParentTypes['SavingsPlan']> = {
  contributionRecommendations?: Resolver<Array<ResolversTypes['RetirementContributionRecommendation']>, ParentType, ContextType>;
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ScheduledEventConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledEventConfiguration'] = ResolversParentTypes['ScheduledEventConfiguration']> = {
  calendarLink?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  embedSource?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
};

export type SecuritiesLendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuritiesLending'] = ResolversParentTypes['SecuritiesLending']> = {
  canUserSelfUpdate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disclosures?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  expectedArrival?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  longDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SecuritiesLendingStatus'], ParentType, ContextType>;
};

export type SecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Security'] = ResolversParentTypes['Security']> = {
  __resolveType: TypeResolveFn<'SecurityFund' | 'SecurityStock', ParentType, ContextType>;
};

export type SecurityFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityFund'] = ResolversParentTypes['SecurityFund']> = {
  expenseRatio?: Resolver<ResolversTypes['ExpenseRatio'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prospectusUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tlhPriority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityGroup'] = ResolversParentTypes['SecurityGroup']> = {
  description?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>;
  targetWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type SecurityGroupPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityGroupPosition'] = ResolversParentTypes['SecurityGroupPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageExpenseRatioPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  currentWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  drift?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  fundFees?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  securityGroup?: Resolver<ResolversTypes['SecurityGroup'], ParentType, ContextType>;
  securityPositions?: Resolver<Array<ResolversTypes['SecurityPosition']>, ParentType, ContextType>;
  securityPositionsBySecurity?: Resolver<Array<ResolversTypes['SecurityPositionsBySecurity']>, ParentType, ContextType>;
};

export type SecurityPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPosition'] = ResolversParentTypes['SecurityPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type SecurityPositionsBySecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPositionsBySecurity'] = ResolversParentTypes['SecurityPositionsBySecurity']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  currentWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  securityPositionsBySubAccount?: Resolver<Array<ResolversTypes['SecurityPositionsBySubAccount']>, ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SecurityPositionsBySubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPositionsBySubAccount'] = ResolversParentTypes['SecurityPositionsBySubAccount']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  securityPositions?: Resolver<Array<ResolversTypes['SecurityPosition']>, ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
};

export type SecurityStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityStock'] = ResolversParentTypes['SecurityStock']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfDirectedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfDirectedPortfolio'] = ResolversParentTypes['SelfDirectedPortfolio']> = {
  configurationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disclosureUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  diversificationScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dividendYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  dividendYieldExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drift?: Resolver<ResolversTypes['Drift'], ParentType, ContextType>;
  expenseRatio?: Resolver<ResolversTypes['ExpenseRatio'], ParentType, ContextType>;
  hasPendingPortfolioChangeRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAllocationEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCryptoPortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExternallyAdvised?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStrategySelectionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rebalance?: Resolver<ResolversTypes['Rebalance'], ParentType, ContextType>;
  targetAllocation?: Resolver<Array<ResolversTypes['SecurityGroup']>, ParentType, ContextType>;
  targetAllocationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendEmailVerificationEmailMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendEmailVerificationEmailMutationPayload'] = ResolversParentTypes['SendEmailVerificationEmailMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['EmailDispatch']>, ParentType, ContextType>;
};

export type SendWireTransferInstructionsEmailMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendWireTransferInstructionsEmailMutationPayload'] = ResolversParentTypes['SendWireTransferInstructionsEmailMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SubAccount']>, ParentType, ContextType>;
};

export type SendWireTransferInstructionsEmailV2MutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendWireTransferInstructionsEmailV2MutationPayload'] = ResolversParentTypes['SendWireTransferInstructionsEmailV2MutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SubAccount']>, ParentType, ContextType>;
};

export type SignablePackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignablePackage'] = ResolversParentTypes['SignablePackage']> = {
  docusignSignature?: Resolver<Maybe<ResolversTypes['DocusignSignature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  signed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type Solo401kInterestRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kInterestRequest'] = ResolversParentTypes['Solo401kInterestRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type Solo401kOnboardingOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kOnboardingOption'] = ResolversParentTypes['Solo401kOnboardingOption']> = {
  disclosure?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  hasScheduledMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType, RequireFields<Solo401kOnboardingOptionImageArgs, 'variant'>>;
  isInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlanBenefit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyProductCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCategory?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType>;
  reasonsToBelieve?: Resolver<Array<ResolversTypes['HTML']>, ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProductOnboardingStep']>>, ParentType, ContextType>;
  yieldDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload'] = ResolversParentTypes['SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['AdvisedSoloFourOhOneKClientInvite']>, ParentType, ContextType>;
};

export type SoloFourOhOneKParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['SoloFourOhOneKParticipant'] = ResolversParentTypes['SoloFourOhOneKParticipant']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPlanOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['OtherUser'], ParentType, ContextType>;
};

export type SoloFourOhOneKPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SoloFourOhOneKPlan'] = ResolversParentTypes['SoloFourOhOneKPlan']> = {
  autoEnrollment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  b4bPlanId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  distributionsAllowance?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  eligibilityDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loansAllowed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originallyEffectiveOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  participants?: Resolver<Array<ResolversTypes['SoloFourOhOneKParticipant']>, ParentType, ContextType>;
  startOn?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  vestingDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SomebodysExternalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SomebodysExternalAccount'] = ResolversParentTypes['SomebodysExternalAccount']> = {
  __resolveType: TypeResolveFn<'ExternalAccount' | 'TheirExternalAccount', ParentType, ContextType>;
};

export type SpouseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Spouse'] = ResolversParentTypes['Spouse']> = {
  annualPretaxIncome?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retirementUserAssumptions?: Resolver<Maybe<ResolversTypes['FinancialProfileRetirementUserAssumptions']>, ParentType, ContextType>;
};

export type StudentLoanPaymentAttestationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudentLoanPaymentAttestation'] = ResolversParentTypes['StudentLoanPaymentAttestation']> = {
  attestedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  entries?: Resolver<Array<ResolversTypes['StudentLoanPaymentAttestationEntry']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isUpdateEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  planYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updateEligibilityWindow?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
};

export type StudentLoanPaymentAttestationEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudentLoanPaymentAttestationEntry'] = ResolversParentTypes['StudentLoanPaymentAttestationEntry']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  eligibilityPeriod?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StudentLoanPaymentEstimateResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudentLoanPaymentEstimate'] = ResolversParentTypes['StudentLoanPaymentEstimate']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  computedAnnualAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  period?: Resolver<ResolversTypes['StudentLoanPaymentEstimationPeriod'], ParentType, ContextType>;
};

export type SubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubAccount'] = ResolversParentTypes['SubAccount']> = {
  anticipatedBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  contributionTypeSelectionOption?: Resolver<Maybe<ResolversTypes['ContributionTypeSelectionOption']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goal?: Resolver<ResolversTypes['Goal'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType, Partial<SubAccountRecurringTransactionConfigsArgs>>;
};

export type SubmitAdhocDocumentVerificationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitAdhocDocumentVerificationMutationPayload'] = ResolversParentTypes['SubmitAdhocDocumentVerificationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SubmitAdhocDocumentVerificationMutationResult']>, ParentType, ContextType>;
};

export type SubmitAdhocDocumentVerificationMutationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitAdhocDocumentVerificationMutationResult'] = ResolversParentTypes['SubmitAdhocDocumentVerificationMutationResult']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SubmitDocumentVerificationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitDocumentVerificationMutationPayload'] = ResolversParentTypes['SubmitDocumentVerificationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SubmitDocumentVerificationMutationResult']>, ParentType, ContextType>;
};

export type SubmitDocumentVerificationMutationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitDocumentVerificationMutationResult'] = ResolversParentTypes['SubmitDocumentVerificationMutationResult']> = {
  status?: Resolver<ResolversTypes['DocumentVerificationStatus'], ParentType, ContextType>;
};

export type SubmitFeedbackMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitFeedbackMutationPayload'] = ResolversParentTypes['SubmitFeedbackMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export interface TinScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TIN'], any> {
  name: 'TIN';
}

export type TargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['Target'] = ResolversParentTypes['Target']> = {
  __resolveType: TypeResolveFn<'TargetAmountAndDate' | 'TargetMonthlyExpenses' | 'TargetRetirementSavings' | 'TargetRetirementSpending', ParentType, ContextType>;
};

export type TargetAmountAndDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetAmountAndDate'] = ResolversParentTypes['TargetAmountAndDate']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetBasedPurposeOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetBasedPurposeOption'] = ResolversParentTypes['TargetBasedPurposeOption']> = {
  defaultName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultTargetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  defaultTargetDateExplanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetMonthlyExpensesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetMonthlyExpenses'] = ResolversParentTypes['TargetMonthlyExpenses']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  bufferPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  monthlyExpensesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetRetirementSavingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetRetirementSavings'] = ResolversParentTypes['TargetRetirementSavings']> = {
  financialProfile?: Resolver<ResolversTypes['FinancialProfile'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  monthlySpendingAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetRetirementSpendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetRetirementSpending'] = ResolversParentTypes['TargetRetirementSpending']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lifeExpectancyAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yearsRemaining?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxCoordinationAccountOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxCoordinationAccountOption'] = ResolversParentTypes['TaxCoordinationAccountOption']> = {
  envelopeAccount?: Resolver<ResolversTypes['EnvelopeAccount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLongTermHorizon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyPortfolioDetails?: Resolver<Maybe<ResolversTypes['LegacyPortfolioDetails']>, ParentType, ContextType>;
};

export type TaxImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxImpact'] = ResolversParentTypes['TaxImpact']> = {
  copy?: Resolver<ResolversTypes['TaxImpactCopy'], ParentType, ContextType>;
  hasNonCoveredTaxLots?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasTransactionPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isGain?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLossWithWashed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  longTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  mayImpactGainsAllowance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  netEstimatedTaxes?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netGainBeforeWash?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netLongTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netLongTermBeforeWash?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netShortTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netShortTermBeforeWash?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netWashedLosses?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type TaxImpactCopyResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxImpactCopy'] = ResolversParentTypes['TaxImpactCopy']> = {
  buyOnlyWashSaleExplanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  estimatedTaxImpactBanner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedTaxImpactBannerLinkText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedTaxImpactDisclosure?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  estimatedTaxImpactInfoHtml?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  howWeEstimateTaxImpact?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  longTermGainEstimation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortTermGainEstimation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxMinExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  washSaleExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TaxYearResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxYear'] = ResolversParentTypes['TaxYear']> = {
  endsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  fourOhOneKContributionLimit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  iraContributionLimit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  isEligibleFor401kContributions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForEmployerContributions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForFourOhOneKContributionCatchUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForIraContributionCatchUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForIraContributions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startsAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TermsAndAgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TermsAndAgreements'] = ResolversParentTypes['TermsAndAgreements']> = {
  terms?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TheirExternalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TheirExternalAccount'] = ResolversParentTypes['TheirExternalAccount']> = {
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountTypeAndRedactedAccountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  envelope?: Resolver<Maybe<ResolversTypes['Envelope']>, ParentType, ContextType>;
  goal?: Resolver<Maybe<ResolversTypes['Goal']>, ParentType, ContextType>;
  hasPendingRollover?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  investmentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isManual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUpdatedAtDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<TheirExternalAccountMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subtype?: Resolver<ResolversTypes['ExternalAccountSubtype'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TheirLegalSubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TheirLegalSubAccount'] = ResolversParentTypes['TheirLegalSubAccount']> = {
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameOverride?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferSourceAccountOptions?: Resolver<Array<ResolversTypes['TransferableAccountOption']>, ParentType, ContextType>;
  wireTransferInstructions?: Resolver<Maybe<ResolversTypes['WireTransferInstructions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThemedAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThemedAsset'] = ResolversParentTypes['ThemedAsset']> = {
  dark?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  light?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
};

export type TickerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ticker'] = ResolversParentTypes['Ticker']> = {
  expenseRatio?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tlhPriority?: Resolver<ResolversTypes['TlhPriority'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TimeWeightedRateOfReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeWeightedRateOfReturn'] = ResolversParentTypes['TimeWeightedRateOfReturn']> = {
  annualized?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  cumulative?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
};

export type TransactionOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionOption'] = ResolversParentTypes['TransactionOption']> = {
  __resolveType: TypeResolveFn<'CharitableDonationOption' | 'DeferralSettingsEditOption' | 'ExternalTransferOption' | 'ManageRecurringTransactionsOption' | 'RolloverOption' | 'RothIraConversionOption' | 'TransferOption' | 'WireTransferOption', ParentType, ContextType>;
};

export type TransactionRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionRequest'] = ResolversParentTypes['TransactionRequest']> = {
  estimatedCompletionOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  memoCreationOption?: Resolver<Maybe<ResolversTypes['MemoCreationOption']>, ParentType, ContextType>;
  transactionSuccessGuidance?: Resolver<Maybe<ResolversTypes['TransactionSuccessGuidance']>, ParentType, ContextType>;
};

export type TransactionSuccessGuidanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionSuccessGuidance'] = ResolversParentTypes['TransactionSuccessGuidance']> = {
  detailedDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullDisclosureDetailsHtml?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullDisclosureHeadline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  progressChecklist?: Resolver<Array<ResolversTypes['ProgressChecklist']>, ParentType, ContextType>;
  progressShortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDisclosureHtml?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supportingDisclosureHtml?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TransferOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferOption'] = ResolversParentTypes['TransferOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyTransferType?: Resolver<ResolversTypes['LegacyTransferType'], ParentType, ContextType>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransferableAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferableAccount'] = ResolversParentTypes['TransferableAccount']> = {
  __resolveType: TypeResolveFn<'BankAccount' | 'CashAccount' | 'CheckingAccount' | 'CheckingExternalAccount' | 'DirectTradingAccount' | 'Five29Account' | 'ManagedSubAccount' | 'TheirLegalSubAccount', ParentType, ContextType>;
};

export type TransferableAccountOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransferableAccountOption'] = ResolversParentTypes['TransferableAccountOption']> = {
  account?: Resolver<ResolversTypes['TransferableAccount'], ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Status'], ParentType, ContextType>;
};

export type TrustResolvers<ContextType = any, ParentType extends ResolversParentTypes['Trust'] = ResolversParentTypes['Trust']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TrustOwnershipOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustOwnershipOption'] = ResolversParentTypes['TrustOwnershipOption']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  existingTrusts?: Resolver<Array<ResolversTypes['Trust']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownershipType?: Resolver<ResolversTypes['LegalAccountOwnershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustedContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustedContact'] = ResolversParentTypes['TrustedContact']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export type UpdateAccountNameMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAccountNameMutationPayload'] = ResolversParentTypes['UpdateAccountNameMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['EnvelopeAccount']>, ParentType, ContextType>;
};

export type UpdateAdvisorNetworkIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAdvisorNetworkIntentMutationPayload'] = ResolversParentTypes['UpdateAdvisorNetworkIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['AdvisorNetworkIntent']>, ParentType, ContextType>;
};

export type UpdateCheckingBeneficiaryMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCheckingBeneficiaryMutationPayload'] = ResolversParentTypes['UpdateCheckingBeneficiaryMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CheckingCustomerResult']>, ParentType, ContextType>;
};

export type UpdateEnvelopeOrdersMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateEnvelopeOrdersMutationPayload'] = ResolversParentTypes['UpdateEnvelopeOrdersMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type UpdateExternalAccountVisibilityMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateExternalAccountVisibilityMutationPayload'] = ResolversParentTypes['UpdateExternalAccountVisibilityMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ExternalAccount']>, ParentType, ContextType>;
};

export type UpdateFinancialProfileRetirementAssumptionsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateFinancialProfileRetirementAssumptionsMutationPayload'] = ResolversParentTypes['UpdateFinancialProfileRetirementAssumptionsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialProfile']>, ParentType, ContextType>;
};

export type UpdateLegalAccountBeneficiariesMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateLegalAccountBeneficiariesMutationPayload'] = ResolversParentTypes['UpdateLegalAccountBeneficiariesMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['LegalAccount']>, ParentType, ContextType>;
};

export type UpdateSecuritiesLendingEnrollmentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSecuritiesLendingEnrollmentMutationPayload'] = ResolversParentTypes['UpdateSecuritiesLendingEnrollmentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['UserLevelSettings']>, ParentType, ContextType>;
};

export type UpdateStudentLoanPaymentBenefitAttestationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStudentLoanPaymentBenefitAttestationMutationPayload'] = ResolversParentTypes['UpdateStudentLoanPaymentBenefitAttestationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']>, ParentType, ContextType>;
};

export type UpdateStudentLoanPaymentBenefitEstimateMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStudentLoanPaymentBenefitEstimateMutationPayload'] = ResolversParentTypes['UpdateStudentLoanPaymentBenefitEstimateMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FourOhOneKStudentLoanMatchBenefit']>, ParentType, ContextType>;
};

export type UpdateTrustedContactMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTrustedContactMutationPayload'] = ResolversParentTypes['UpdateTrustedContactMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type UpdateUserInvestingExperienceMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserInvestingExperienceMutationPayload'] = ResolversParentTypes['UpdateUserInvestingExperienceMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialProfile']>, ParentType, ContextType>;
};

export type UpdateUserPostalAddressMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserPostalAddressMutationPayload'] = ResolversParentTypes['UpdateUserPostalAddressMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
};

export type UpdateUserProfileMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserProfileMutationPayload'] = ResolversParentTypes['UpdateUserProfileMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialProfile']>, ParentType, ContextType>;
};

export type UploadAddressChangeDocumentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadAddressChangeDocumentMutationPayload'] = ResolversParentTypes['UploadAddressChangeDocumentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  advisorNetworkIntent?: Resolver<Maybe<ResolversTypes['AdvisorNetworkIntent']>, ParentType, ContextType>;
  commonFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasBondsOnlyProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasOneDepositEligibleAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAppReviewPromptEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCheckingCustomer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCheckingDocumentVerificationRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDepositEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEmailVerificationEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFirstProductAdoptionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMailingSameAsResidentialAddress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isProfileSetupRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSuspended?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logTags?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  loggingIdentifier?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mailingAddress?: Resolver<Maybe<ResolversTypes['PostalAddress']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<UserPhoneNumberArgs, 'isRedacted'>>;
  portfolioStrategySelectionAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  premiumOnboardingOption?: Resolver<Maybe<ResolversTypes['PremiumOnboardingOption']>, ParentType, ContextType>;
  residentialAddress?: Resolver<Maybe<ResolversTypes['PostalAddress']>, ParentType, ContextType>;
  testTrackIdentifier?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  trustedContact?: Resolver<Maybe<ResolversTypes['TrustedContact']>, ParentType, ContextType>;
};

export type UserLevelSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLevelSettings'] = ResolversParentTypes['UserLevelSettings']> = {
  isTaxLossHarvestingEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  securityLending?: Resolver<ResolversTypes['SecuritiesLending'], ParentType, ContextType>;
};

export type ValidateDirectTradingJointAccountSecondaryUserMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateDirectTradingJointAccountSecondaryUserMutationPayload'] = ResolversParentTypes['ValidateDirectTradingJointAccountSecondaryUserMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ValidateDirectTradingTrustDetailsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateDirectTradingTrustDetailsMutationPayload'] = ResolversParentTypes['ValidateDirectTradingTrustDetailsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ValidateFinancialSecurityOrderRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateFinancialSecurityOrderRequest'] = ResolversParentTypes['ValidateFinancialSecurityOrderRequest']> = {
  estimatedTradeTiming?: Resolver<ResolversTypes['EstimatedTradeTiming'], ParentType, ContextType>;
  orderWillBeCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  saleOver90Percent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  taxImpactPreview?: Resolver<Maybe<ResolversTypes['TaxImpact']>, ParentType, ContextType>;
};

export type ValidateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateFinancialSecurityOrderRequestMutationPayload'] = ResolversParentTypes['ValidateFinancialSecurityOrderRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ValidateFinancialSecurityOrderRequest']>, ParentType, ContextType>;
};

export type ValidateLegalAccountBeneficiaryMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateLegalAccountBeneficiaryMutationPayload'] = ResolversParentTypes['ValidateLegalAccountBeneficiaryMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type WireTransferInstructionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WireTransferInstructions'] = ResolversParentTypes['WireTransferInstructions']> = {
  address?: Resolver<ResolversTypes['PostalAddress'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['WireTransferInstructionsItem']>, ParentType, ContextType>;
};

export type WireTransferInstructionsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['WireTransferInstructionsItem'] = ResolversParentTypes['WireTransferInstructionsItem']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type WireTransferOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['WireTransferOption'] = ResolversParentTypes['WireTransferOption']> = {
  accountOptions?: Resolver<Array<ResolversTypes['SubAccount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  instructions?: Resolver<ResolversTypes['WireTransferInstructions'], ParentType, ContextType, RequireFields<WireTransferOptionInstructionsArgs, 'accountId'>>;
  transactionUnavailableMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YieldBasedAssetAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['YieldBasedAssetAllocation'] = ResolversParentTypes['YieldBasedAssetAllocation']> = {
  afterTaxYield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  assetTypeWeights?: Resolver<Array<ResolversTypes['AssetTypeWeight']>, ParentType, ContextType>;
  diversification?: Resolver<ResolversTypes['AssetAllocationDiversification'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  risk?: Resolver<ResolversTypes['AssetAllocationRisk'], ParentType, ContextType>;
  securityGroups?: Resolver<Array<ResolversTypes['SecurityGroup']>, ParentType, ContextType>;
  securityWeights?: Resolver<Array<ResolversTypes['LegacyWeightedSecurity']>, ParentType, ContextType>;
  yield?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AcceptAdvisoryRelationshipApprovalRequestMutationPayload?: AcceptAdvisoryRelationshipApprovalRequestMutationPayloadResolvers<ContextType>;
  AcceptAdvisoryRelationshipApprovalRequestMutationResult?: AcceptAdvisoryRelationshipApprovalRequestMutationResultResolvers<ContextType>;
  AccountOwnershipOption?: AccountOwnershipOptionResolvers<ContextType>;
  AccountPurposeOption?: AccountPurposeOptionResolvers<ContextType>;
  AccountRecommendation?: AccountRecommendationResolvers<ContextType>;
  AccountRecommendationOption?: AccountRecommendationOptionResolvers<ContextType>;
  AccountTaxationOption?: AccountTaxationOptionResolvers<ContextType>;
  ActiveReward?: ActiveRewardResolvers<ContextType>;
  ActivityDateRangeOption?: ActivityDateRangeOptionResolvers<ContextType>;
  ActivityItem?: ActivityItemResolvers<ContextType>;
  ActivityItemAllocationChange?: ActivityItemAllocationChangeResolvers<ContextType>;
  ActivityItemConnection?: ActivityItemConnectionResolvers<ContextType>;
  ActivityItemDeposit?: ActivityItemDepositResolvers<ContextType>;
  ActivityItemDividend?: ActivityItemDividendResolvers<ContextType>;
  ActivityItemDividendGroup?: ActivityItemDividendGroupResolvers<ContextType>;
  ActivityItemEdge?: ActivityItemEdgeResolvers<ContextType>;
  ActivityItemFee?: ActivityItemFeeResolvers<ContextType>;
  ActivityItemOrder?: ActivityItemOrderResolvers<ContextType>;
  ActivityItemOther?: ActivityItemOtherResolvers<ContextType>;
  ActivityItemRollover?: ActivityItemRolloverResolvers<ContextType>;
  ActivityItemStatus?: ActivityItemStatusResolvers<ContextType>;
  ActivityItemTrade?: ActivityItemTradeResolvers<ContextType>;
  ActivityItemTradeGroup?: ActivityItemTradeGroupResolvers<ContextType>;
  ActivityItemTransfer?: ActivityItemTransferResolvers<ContextType>;
  ActivityItemTransferGroup?: ActivityItemTransferGroupResolvers<ContextType>;
  ActivityItemWithdrawal?: ActivityItemWithdrawalResolvers<ContextType>;
  ActivityTransactionMemo?: ActivityTransactionMemoResolvers<ContextType>;
  AddEnvelopeExternalAccountsMutationPayload?: AddEnvelopeExternalAccountsMutationPayloadResolvers<ContextType>;
  AddressState?: AddressStateResolvers<ContextType>;
  Advice?: AdviceResolvers<ContextType>;
  AdvisedSoloFourOhOneKClientInvite?: AdvisedSoloFourOhOneKClientInviteResolvers<ContextType>;
  Advisor?: AdvisorResolvers<ContextType>;
  AdvisorNetworkIntent?: AdvisorNetworkIntentResolvers<ContextType>;
  Agreement?: AgreementResolvers<ContextType>;
  AllocationBreakdown?: AllocationBreakdownResolvers<ContextType>;
  AnnualFourOhOneKContributions?: AnnualFourOhOneKContributionsResolvers<ContextType>;
  AnnualIraContributions?: AnnualIraContributionsResolvers<ContextType>;
  Article?: ArticleResolvers<ContextType>;
  ArticleAuthor?: ArticleAuthorResolvers<ContextType>;
  ArticleCta?: ArticleCtaResolvers<ContextType>;
  ArticleDisclosures?: ArticleDisclosuresResolvers<ContextType>;
  AssetAllocation?: AssetAllocationResolvers<ContextType>;
  AssetAllocationDiversification?: AssetAllocationDiversificationResolvers<ContextType>;
  AssetAllocationRisk?: AssetAllocationRiskResolvers<ContextType>;
  AssetTypeWeight?: AssetTypeWeightResolvers<ContextType>;
  AutoAdjustOption?: AutoAdjustOptionResolvers<ContextType>;
  Autoglide?: AutoglideResolvers<ContextType>;
  BalanceProjection?: BalanceProjectionResolvers<ContextType>;
  BalanceProjectionItem?: BalanceProjectionItemResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  Base64?: GraphQLScalarType;
  BeneficiaryUpdateInstructions?: BeneficiaryUpdateInstructionsResolvers<ContextType>;
  BettermentAdvisorNetworkOption?: BettermentAdvisorNetworkOptionResolvers<ContextType>;
  BettermentPremiumOption?: BettermentPremiumOptionResolvers<ContextType>;
  BondPortfolioYields?: BondPortfolioYieldsResolvers<ContextType>;
  CancelTransactionRequestMutationPayload?: CancelTransactionRequestMutationPayloadResolvers<ContextType>;
  CapturePackageSignatureMutationPayload?: CapturePackageSignatureMutationPayloadResolvers<ContextType>;
  CashAccount?: CashAccountResolvers<ContextType>;
  CashApy?: CashApyResolvers<ContextType>;
  CashFdicInsurance?: CashFdicInsuranceResolvers<ContextType>;
  Cents?: GraphQLScalarType;
  CharitableDonationOption?: CharitableDonationOptionResolvers<ContextType>;
  CheckingAccount?: CheckingAccountResolvers<ContextType>;
  CheckingAccountCreationOption?: CheckingAccountCreationOptionResolvers<ContextType>;
  CheckingBeneficiary?: CheckingBeneficiaryResolvers<ContextType>;
  CheckingCustomer?: CheckingCustomerResolvers<ContextType>;
  CheckingCustomerResult?: CheckingCustomerResultResolvers<ContextType>;
  CheckingExternalAccount?: CheckingExternalAccountResolvers<ContextType>;
  ClientEnvelopeApprovalAdvisorFee?: ClientEnvelopeApprovalAdvisorFeeResolvers<ContextType>;
  ClientEnvelopeApprovalAgreement?: ClientEnvelopeApprovalAgreementResolvers<ContextType>;
  ClientEnvelopeApprovalAgreements?: ClientEnvelopeApprovalAgreementsResolvers<ContextType>;
  ClientEnvelopeApprovalFeeTier?: ClientEnvelopeApprovalFeeTierResolvers<ContextType>;
  ClientEnvelopeApprovalFirm?: ClientEnvelopeApprovalFirmResolvers<ContextType>;
  ClientEnvelopeApprovalRateBasedFee?: ClientEnvelopeApprovalRateBasedFeeResolvers<ContextType>;
  ClientEnvelopeApprovalRequest?: ClientEnvelopeApprovalRequestResolvers<ContextType>;
  ClientEnvelopeApprovalTieredFee?: ClientEnvelopeApprovalTieredFeeResolvers<ContextType>;
  CompleteDraftPurposeFlowMutationPayload?: CompleteDraftPurposeFlowMutationPayloadResolvers<ContextType>;
  CompleteTaxCoordinatedAccountCreationFlowMutationPayload?: CompleteTaxCoordinatedAccountCreationFlowMutationPayloadResolvers<ContextType>;
  ConfirmIdentityVerificationChallengeMutationPayload?: ConfirmIdentityVerificationChallengeMutationPayloadResolvers<ContextType>;
  ContributionTypeOption?: ContributionTypeOptionResolvers<ContextType>;
  ContributionTypeSelectionOption?: ContributionTypeSelectionOptionResolvers<ContextType>;
  CreateAccountRecommendationExplanationMutationPayload?: CreateAccountRecommendationExplanationMutationPayloadResolvers<ContextType>;
  CreateDirectTradingAccountMutationPayload?: CreateDirectTradingAccountMutationPayloadResolvers<ContextType>;
  CreateDocumentVerificationTokenMutationPayload?: CreateDocumentVerificationTokenMutationPayloadResolvers<ContextType>;
  CreateEmployeeContributionConfigurationChangeRequestMutationPayload?: CreateEmployeeContributionConfigurationChangeRequestMutationPayloadResolvers<ContextType>;
  CreateFinancialSecurityOrderRequestMutationPayload?: CreateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType>;
  CreatePersonalReferralInvitationMutationPayload?: CreatePersonalReferralInvitationMutationPayloadResolvers<ContextType>;
  CreateRecurringTransactionConfigMutationPayload?: CreateRecurringTransactionConfigMutationPayloadResolvers<ContextType>;
  CreateSolo401kInterestSubmissionsMutationPayload?: CreateSolo401kInterestSubmissionsMutationPayloadResolvers<ContextType>;
  CreateTransactionMemoMutationPayload?: CreateTransactionMemoMutationPayloadResolvers<ContextType>;
  CreateTransactionRequestMutationPayload?: CreateTransactionRequestMutationPayloadResolvers<ContextType>;
  CreateUserActivityCsvExportMutationPayload?: CreateUserActivityCsvExportMutationPayloadResolvers<ContextType>;
  CryptoAdvice?: CryptoAdviceResolvers<ContextType>;
  CryptoPortfolio?: CryptoPortfolioResolvers<ContextType>;
  CsvExport?: CsvExportResolvers<ContextType>;
  CustomizableAssetAllocation?: CustomizableAssetAllocationResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateRange?: DateRangeResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DebitCard?: DebitCardResolvers<ContextType>;
  DeferralSetting?: DeferralSettingResolvers<ContextType>;
  DeferralSettingsEditOption?: DeferralSettingsEditOptionResolvers<ContextType>;
  DeleteCheckingBeneficiaryMutationPayload?: DeleteCheckingBeneficiaryMutationPayloadResolvers<ContextType>;
  DeletePurposeMutationPayload?: DeletePurposeMutationPayloadResolvers<ContextType>;
  DeleteRecurringTransactionConfigMutationPayload?: DeleteRecurringTransactionConfigMutationPayloadResolvers<ContextType>;
  DeleteTrustedContactMutationPayload?: DeleteTrustedContactMutationPayloadResolvers<ContextType>;
  DirectTradingAccount?: DirectTradingAccountResolvers<ContextType>;
  DirectTradingCashBalances?: DirectTradingCashBalancesResolvers<ContextType>;
  DirectTradingInvestableAssetsAdvice?: DirectTradingInvestableAssetsAdviceResolvers<ContextType>;
  DirectTradingSecurityPosition?: DirectTradingSecurityPositionResolvers<ContextType>;
  DirectTradingSecurityPositionReturn?: DirectTradingSecurityPositionReturnResolvers<ContextType>;
  Disclosures?: DisclosuresResolvers<ContextType>;
  DismissUserActivityCsvExportBannerMutationPayload?: DismissUserActivityCsvExportBannerMutationPayloadResolvers<ContextType>;
  DisplayableError?: DisplayableErrorResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentCategory?: DocumentCategoryResolvers<ContextType>;
  DocumentCategoryDisclosure?: DocumentCategoryDisclosureResolvers<ContextType>;
  DocumentCategoryGroup?: DocumentCategoryGroupResolvers<ContextType>;
  DocumentCategoryOrCategoryGroup?: DocumentCategoryOrCategoryGroupResolvers<ContextType>;
  DocumentFile?: DocumentFileResolvers<ContextType>;
  DocumentFilter?: DocumentFilterResolvers<ContextType>;
  DocumentFilterOption?: DocumentFilterOptionResolvers<ContextType>;
  DocumentsResult?: DocumentsResultResolvers<ContextType>;
  DocusignSignature?: DocusignSignatureResolvers<ContextType>;
  DraftEnvelope?: DraftEnvelopeResolvers<ContextType>;
  DraftEnvelopeAccount?: DraftEnvelopeAccountResolvers<ContextType>;
  DraftPurposeEmergencyFund?: DraftPurposeEmergencyFundResolvers<ContextType>;
  DraftPurposeMajorPurchase?: DraftPurposeMajorPurchaseResolvers<ContextType>;
  DraftPurposeRetirementGrowth?: DraftPurposeRetirementGrowthResolvers<ContextType>;
  DraftPurposeRetirementIncome?: DraftPurposeRetirementIncomeResolvers<ContextType>;
  Drift?: DriftResolvers<ContextType>;
  EditableEnvelope?: EditableEnvelopeResolvers<ContextType>;
  EditablePurpose?: EditablePurposeResolvers<ContextType>;
  EditablePurposeEmergencyFund?: EditablePurposeEmergencyFundResolvers<ContextType>;
  EditablePurposeMajorPurchase?: EditablePurposeMajorPurchaseResolvers<ContextType>;
  EditablePurposeRetirementGrowth?: EditablePurposeRetirementGrowthResolvers<ContextType>;
  EditablePurposeRetirementIncome?: EditablePurposeRetirementIncomeResolvers<ContextType>;
  EmailDispatch?: EmailDispatchResolvers<ContextType>;
  EmergencyFundCoverage?: EmergencyFundCoverageResolvers<ContextType>;
  EmergencyFundCoverageOption?: EmergencyFundCoverageOptionResolvers<ContextType>;
  EmergencyFundPurposeCreationOption?: EmergencyFundPurposeCreationOptionResolvers<ContextType>;
  Employee?: EmployeeResolvers<ContextType>;
  Employer?: EmployerResolvers<ContextType>;
  EmployerFourOhOneKContributionConfig?: EmployerFourOhOneKContributionConfigResolvers<ContextType>;
  EmployerFourOhOneKContributions?: EmployerFourOhOneKContributionsResolvers<ContextType>;
  EmployerFourOhOneKContributionsProjection?: EmployerFourOhOneKContributionsProjectionResolvers<ContextType>;
  EmployerFourOhOneKContributionsResult?: EmployerFourOhOneKContributionsResultResolvers<ContextType>;
  EmployerFourOhOneKContributionsVested?: EmployerFourOhOneKContributionsVestedResolvers<ContextType>;
  Envelope?: EnvelopeResolvers<ContextType>;
  EnvelopeAccount?: EnvelopeAccountResolvers<ContextType>;
  EnvelopeStatus?: EnvelopeStatusResolvers<ContextType>;
  EstimatedTradeDate?: EstimatedTradeDateResolvers<ContextType>;
  EstimatedTradeTimeRange?: EstimatedTradeTimeRangeResolvers<ContextType>;
  EstimatedTradeTiming?: EstimatedTradeTimingResolvers<ContextType>;
  ExpenseRatio?: ExpenseRatioResolvers<ContextType>;
  ExpensesBasedPurposeOption?: ExpensesBasedPurposeOptionResolvers<ContextType>;
  ExternalAccount?: ExternalAccountResolvers<ContextType>;
  ExternalAccountEmployerMatch?: ExternalAccountEmployerMatchResolvers<ContextType>;
  ExternalAccountEnvelopeAssociation?: ExternalAccountEnvelopeAssociationResolvers<ContextType>;
  ExternalAccountPlanContributions?: ExternalAccountPlanContributionsResolvers<ContextType>;
  ExternalAccountSubtype?: ExternalAccountSubtypeResolvers<ContextType>;
  ExternalAccountSubtypeBasic?: ExternalAccountSubtypeBasicResolvers<ContextType>;
  ExternalAccountSubtypeEmployerSponsored?: ExternalAccountSubtypeEmployerSponsoredResolvers<ContextType>;
  ExternalAccountSubtypeIra?: ExternalAccountSubtypeIraResolvers<ContextType>;
  ExternalTransferOption?: ExternalTransferOptionResolvers<ContextType>;
  ExternallyAdvisedPlanPortfolio?: ExternallyAdvisedPlanPortfolioResolvers<ContextType>;
  FinancialCoachingOnboardingOption?: FinancialCoachingOnboardingOptionResolvers<ContextType>;
  FinancialProfile?: FinancialProfileResolvers<ContextType>;
  FinancialProfileRetirementAssumptions?: FinancialProfileRetirementAssumptionsResolvers<ContextType>;
  FinancialProfileRetirementUserAssumptions?: FinancialProfileRetirementUserAssumptionsResolvers<ContextType>;
  FinancialSecurity?: FinancialSecurityResolvers<ContextType>;
  FinancialSecurityCompanyProfile?: FinancialSecurityCompanyProfileResolvers<ContextType>;
  FinancialSecurityFund?: FinancialSecurityFundResolvers<ContextType>;
  FinancialSecurityFundPortfolio?: FinancialSecurityFundPortfolioResolvers<ContextType>;
  FinancialSecurityFundPortfolioHolding?: FinancialSecurityFundPortfolioHoldingResolvers<ContextType>;
  FinancialSecurityFundamentals?: FinancialSecurityFundamentalsResolvers<ContextType>;
  FinancialSecurityFundamentalsDividendYield?: FinancialSecurityFundamentalsDividendYieldResolvers<ContextType>;
  FinancialSecurityFundamentalsDividendsAmount?: FinancialSecurityFundamentalsDividendsAmountResolvers<ContextType>;
  FinancialSecurityFundamentalsEarningsPerShare?: FinancialSecurityFundamentalsEarningsPerShareResolvers<ContextType>;
  FinancialSecurityFundamentalsEbitda?: FinancialSecurityFundamentalsEbitdaResolvers<ContextType>;
  FinancialSecurityFundamentalsExpenseRatio?: FinancialSecurityFundamentalsExpenseRatioResolvers<ContextType>;
  FinancialSecurityFundamentalsFund?: FinancialSecurityFundamentalsFundResolvers<ContextType>;
  FinancialSecurityFundamentalsFundAnnual?: FinancialSecurityFundamentalsFundAnnualResolvers<ContextType>;
  FinancialSecurityFundamentalsFundTrailingTwelveMonths?: FinancialSecurityFundamentalsFundTrailingTwelveMonthsResolvers<ContextType>;
  FinancialSecurityFundamentalsMarketCap?: FinancialSecurityFundamentalsMarketCapResolvers<ContextType>;
  FinancialSecurityFundamentalsPriceToEarningsRatio?: FinancialSecurityFundamentalsPriceToEarningsRatioResolvers<ContextType>;
  FinancialSecurityFundamentalsRevenue?: FinancialSecurityFundamentalsRevenueResolvers<ContextType>;
  FinancialSecurityFundamentalsSharesOutstanding?: FinancialSecurityFundamentalsSharesOutstandingResolvers<ContextType>;
  FinancialSecurityFundamentalsStock?: FinancialSecurityFundamentalsStockResolvers<ContextType>;
  FinancialSecurityFundamentalsStockAnnual?: FinancialSecurityFundamentalsStockAnnualResolvers<ContextType>;
  FinancialSecurityFundamentalsStockTrailingTwelveMonths?: FinancialSecurityFundamentalsStockTrailingTwelveMonthsResolvers<ContextType>;
  FinancialSecurityOrderRequest?: FinancialSecurityOrderRequestResolvers<ContextType>;
  FinancialSecurityPriceHistory?: FinancialSecurityPriceHistoryResolvers<ContextType>;
  FinancialSecurityPricePerformance?: FinancialSecurityPricePerformanceResolvers<ContextType>;
  FinancialSecurityPricePerformancePricePoint?: FinancialSecurityPricePerformancePricePointResolvers<ContextType>;
  FinancialSecurityPricePoint?: FinancialSecurityPricePointResolvers<ContextType>;
  FinancialSecurityPriceReturns?: FinancialSecurityPriceReturnsResolvers<ContextType>;
  FinancialSecurityStatistics?: FinancialSecurityStatisticsResolvers<ContextType>;
  FinancialSecurityStatisticsComponentDays?: FinancialSecurityStatisticsComponentDaysResolvers<ContextType>;
  FinancialSecurityStatisticsComponentIntraDay?: FinancialSecurityStatisticsComponentIntraDayResolvers<ContextType>;
  FinancialSecurityStatisticsLatestPrice?: FinancialSecurityStatisticsLatestPriceResolvers<ContextType>;
  FinancialSecurityStock?: FinancialSecurityStockResolvers<ContextType>;
  FinancialServiceOption?: FinancialServiceOptionResolvers<ContextType>;
  Firm?: FirmResolvers<ContextType>;
  Five29Account?: Five29AccountResolvers<ContextType>;
  Five29AccountConnection?: Five29AccountConnectionResolvers<ContextType>;
  FiveTwoNineGoalCreationOption?: FiveTwoNineGoalCreationOptionResolvers<ContextType>;
  FourOhOneKContributions?: FourOhOneKContributionsResolvers<ContextType>;
  FourOhOneKContributionsLineItem?: FourOhOneKContributionsLineItemResolvers<ContextType>;
  FourOhOneKContributionsProjection?: FourOhOneKContributionsProjectionResolvers<ContextType>;
  FourOhOneKContributionsResult?: FourOhOneKContributionsResultResolvers<ContextType>;
  FourOhOneKStudentLoanMatchBenefit?: FourOhOneKStudentLoanMatchBenefitResolvers<ContextType>;
  GeneralPurposeOption?: GeneralPurposeOptionResolvers<ContextType>;
  Goal?: GoalResolvers<ContextType>;
  GoalBalances?: GoalBalancesResolvers<ContextType>;
  GoalCreationIntent?: GoalCreationIntentResolvers<ContextType>;
  GoalCreationOption?: GoalCreationOptionResolvers<ContextType>;
  GoalStatusSummary?: GoalStatusSummaryResolvers<ContextType>;
  Grant?: GrantResolvers<ContextType>;
  HTML?: GraphQLScalarType;
  HistoricalPerformance?: HistoricalPerformanceResolvers<ContextType>;
  IdentityVerificationChallenge?: IdentityVerificationChallengeResolvers<ContextType>;
  IndividualOwnershipOption?: IndividualOwnershipOptionResolvers<ContextType>;
  InitiateStudentLoanPaymentBenefitAttestationMutationPayload?: InitiateStudentLoanPaymentBenefitAttestationMutationPayloadResolvers<ContextType>;
  InstitutionalAdvisor?: InstitutionalAdvisorResolvers<ContextType>;
  InvestmentPortfolio?: InvestmentPortfolioResolvers<ContextType>;
  IraContributionMatchGrant?: IraContributionMatchGrantResolvers<ContextType>;
  IraContributions?: IraContributionsResolvers<ContextType>;
  IraContributionsLineItem?: IraContributionsLineItemResolvers<ContextType>;
  IraContributionsProjection?: IraContributionsProjectionResolvers<ContextType>;
  IraContributionsResult?: IraContributionsResultResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JointAccountInvitation?: JointAccountInvitationResolvers<ContextType>;
  JointOwnershipOption?: JointOwnershipOptionResolvers<ContextType>;
  LegacyAllocationAssets?: LegacyAllocationAssetsResolvers<ContextType>;
  LegacyAssetClass?: LegacyAssetClassResolvers<ContextType>;
  LegacyHoldingsPageInfo?: LegacyHoldingsPageInfoResolvers<ContextType>;
  LegacyID?: GraphQLScalarType;
  LegacyNamedOptions?: LegacyNamedOptionsResolvers<ContextType>;
  LegacyPortfolioDetails?: LegacyPortfolioDetailsResolvers<ContextType>;
  LegacyPortfolioInfoRow?: LegacyPortfolioInfoRowResolvers<ContextType>;
  LegacyPortfolioStrategyOption?: LegacyPortfolioStrategyOptionResolvers<ContextType>;
  LegacySecurity?: LegacySecurityResolvers<ContextType>;
  LegacySecurityGroupDetails?: LegacySecurityGroupDetailsResolvers<ContextType>;
  LegacySuperAssetClass?: LegacySuperAssetClassResolvers<ContextType>;
  LegacyTermsAndAgreements?: LegacyTermsAndAgreementsResolvers<ContextType>;
  LegacyUUID?: GraphQLScalarType;
  LegacyWeightedSecurity?: LegacyWeightedSecurityResolvers<ContextType>;
  LegalAccount?: LegalAccountResolvers<ContextType>;
  LegalAccountBeneficiary?: LegalAccountBeneficiaryResolvers<ContextType>;
  LegalSubAccount?: LegalSubAccountResolvers<ContextType>;
  MajorPurchasePurposeCreationOption?: MajorPurchasePurposeCreationOptionResolvers<ContextType>;
  ManageRecurringTransactionsOption?: ManageRecurringTransactionsOptionResolvers<ContextType>;
  ManagedAccount?: ManagedAccountResolvers<ContextType>;
  ManagedAccountProjection?: ManagedAccountProjectionResolvers<ContextType>;
  ManagedPortfolio?: ManagedPortfolioResolvers<ContextType>;
  ManagedSubAccount?: ManagedSubAccountResolvers<ContextType>;
  MarketSchedule?: MarketScheduleResolvers<ContextType>;
  MarketingMessage?: MarketingMessageResolvers<ContextType>;
  MarketingMessageExtras?: MarketingMessageExtrasResolvers<ContextType>;
  MemoCreationOption?: MemoCreationOptionResolvers<ContextType>;
  MemoReasonOption?: MemoReasonOptionResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageCta?: MessageCtaResolvers<ContextType>;
  MessageCtaLink?: MessageCtaLinkResolvers<ContextType>;
  MessageCtaModal?: MessageCtaModalResolvers<ContextType>;
  MessageLocation?: GraphQLScalarType;
  ModelPortfolioOption?: ModelPortfolioOptionResolvers<ContextType>;
  MoneyWeightedRateOfReturn?: MoneyWeightedRateOfReturnResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NetWorth?: NetWorthResolvers<ContextType>;
  NetWorthSubtotal?: NetWorthSubtotalResolvers<ContextType>;
  NetWorthSubtotalItem?: NetWorthSubtotalItemResolvers<ContextType>;
  OtherUser?: OtherUserResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PayrollContributionConfig?: PayrollContributionConfigResolvers<ContextType>;
  PayrollContributionConfigAccount?: PayrollContributionConfigAccountResolvers<ContextType>;
  PayrollContributionConfigConnection?: PayrollContributionConfigConnectionResolvers<ContextType>;
  PayrollContributionConfigEdge?: PayrollContributionConfigEdgeResolvers<ContextType>;
  PayrollContributionConfigValue?: PayrollContributionConfigValueResolvers<ContextType>;
  PayrollContributionConfigValueAmount?: PayrollContributionConfigValueAmountResolvers<ContextType>;
  PayrollContributionConfigValuePercent?: PayrollContributionConfigValuePercentResolvers<ContextType>;
  PendingDocumentVerificationRequest?: PendingDocumentVerificationRequestResolvers<ContextType>;
  Percent?: GraphQLScalarType;
  Performance?: PerformanceResolvers<ContextType>;
  PerformanceAccount?: PerformanceAccountResolvers<ContextType>;
  PerformanceBenchmark?: PerformanceBenchmarkResolvers<ContextType>;
  PerformanceBenchmarkGroup?: PerformanceBenchmarkGroupResolvers<ContextType>;
  PerformanceBenchmarkTimeWeightedReturns?: PerformanceBenchmarkTimeWeightedReturnsResolvers<ContextType>;
  PerformanceHistory?: PerformanceHistoryResolvers<ContextType>;
  PerformanceHistoryItem?: PerformanceHistoryItemResolvers<ContextType>;
  PerformanceHistoryTimeWeightedReturnItem?: PerformanceHistoryTimeWeightedReturnItemResolvers<ContextType>;
  PerformanceInterest?: PerformanceInterestResolvers<ContextType>;
  PerformanceInvesting?: PerformanceInvestingResolvers<ContextType>;
  PerformanceTimeWeightedReturns?: PerformanceTimeWeightedReturnsResolvers<ContextType>;
  PerformanceTotals?: PerformanceTotalsResolvers<ContextType>;
  PerformanceTotalsDividends?: PerformanceTotalsDividendsResolvers<ContextType>;
  PerformanceTotalsFees?: PerformanceTotalsFeesResolvers<ContextType>;
  PerformanceTotalsUserTransactions?: PerformanceTotalsUserTransactionsResolvers<ContextType>;
  PerformanceTotalsUserTransactionsPending?: PerformanceTotalsUserTransactionsPendingResolvers<ContextType>;
  Portfolio?: PortfolioResolvers<ContextType>;
  PortfolioStrategy?: PortfolioStrategyResolvers<ContextType>;
  PostalAddress?: PostalAddressResolvers<ContextType>;
  PremiumAdvisor?: PremiumAdvisorResolvers<ContextType>;
  PremiumOnboardingOption?: PremiumOnboardingOptionResolvers<ContextType>;
  PriceGroup?: PriceGroupResolvers<ContextType>;
  PriceGroupMinFee?: PriceGroupMinFeeResolvers<ContextType>;
  PriceGroupPremiumPricing?: PriceGroupPremiumPricingResolvers<ContextType>;
  PriceGroupPricingCta?: PriceGroupPricingCtaResolvers<ContextType>;
  PriceGroupPricingTier?: PriceGroupPricingTierResolvers<ContextType>;
  PriceGroupPricingTierBreakdown?: PriceGroupPricingTierBreakdownResolvers<ContextType>;
  PriceRange?: PriceRangeResolvers<ContextType>;
  ProcessCapitalizeWindowEventMutationPayload?: ProcessCapitalizeWindowEventMutationPayloadResolvers<ContextType>;
  ProductBundle?: ProductBundleResolvers<ContextType>;
  ProductOnboardingOption?: ProductOnboardingOptionResolvers<ContextType>;
  ProductOnboardingStep?: ProductOnboardingStepResolvers<ContextType>;
  ProductUnavailability?: ProductUnavailabilityResolvers<ContextType>;
  Profession?: ProfessionResolvers<ContextType>;
  ProgressChecklist?: ProgressChecklistResolvers<ContextType>;
  Purpose?: PurposeResolvers<ContextType>;
  PurposeAsset?: PurposeAssetResolvers<ContextType>;
  PurposeCreationOptionInterface?: PurposeCreationOptionInterfaceResolvers<ContextType>;
  PurposeEmergencyFund?: PurposeEmergencyFundResolvers<ContextType>;
  PurposeEmergencyFundProjection?: PurposeEmergencyFundProjectionResolvers<ContextType>;
  PurposeEmergencyFundTarget?: PurposeEmergencyFundTargetResolvers<ContextType>;
  PurposeMajorPurchase?: PurposeMajorPurchaseResolvers<ContextType>;
  PurposeMajorPurchaseProjection?: PurposeMajorPurchaseProjectionResolvers<ContextType>;
  PurposeMajorPurchaseProjectionCompletion?: PurposeMajorPurchaseProjectionCompletionResolvers<ContextType>;
  PurposeMajorPurchaseTarget?: PurposeMajorPurchaseTargetResolvers<ContextType>;
  PurposeRetirementGrowth?: PurposeRetirementGrowthResolvers<ContextType>;
  PurposeRetirementGrowthProjection?: PurposeRetirementGrowthProjectionResolvers<ContextType>;
  PurposeRetirementGrowthProjectionCompletion?: PurposeRetirementGrowthProjectionCompletionResolvers<ContextType>;
  PurposeRetirementGrowthTarget?: PurposeRetirementGrowthTargetResolvers<ContextType>;
  PurposeRetirementIncome?: PurposeRetirementIncomeResolvers<ContextType>;
  PurposeRetirementIncomeProjection?: PurposeRetirementIncomeProjectionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Rebalance?: RebalanceResolvers<ContextType>;
  RecordNotFoundResult?: RecordNotFoundResultResolvers<ContextType>;
  RecordUnavailableResult?: RecordUnavailableResultResolvers<ContextType>;
  RecurringDepositMotivation?: RecurringDepositMotivationResolvers<ContextType>;
  RecurringTransactionConfig?: RecurringTransactionConfigResolvers<ContextType>;
  RecurringTransactionConfigStatus?: RecurringTransactionConfigStatusResolvers<ContextType>;
  RecurringTransactionFrequency?: RecurringTransactionFrequencyResolvers<ContextType>;
  RecurringTransactionFrequencyAnnually?: RecurringTransactionFrequencyAnnuallyResolvers<ContextType>;
  RecurringTransactionFrequencyEveryOtherWeek?: RecurringTransactionFrequencyEveryOtherWeekResolvers<ContextType>;
  RecurringTransactionFrequencyMonthly?: RecurringTransactionFrequencyMonthlyResolvers<ContextType>;
  RecurringTransactionFrequencyTwiceAMonth?: RecurringTransactionFrequencyTwiceAMonthResolvers<ContextType>;
  RecurringTransactionFrequencyWeekly?: RecurringTransactionFrequencyWeeklyResolvers<ContextType>;
  RecurringTransactionSchedule?: RecurringTransactionScheduleResolvers<ContextType>;
  ReferralInvitation?: ReferralInvitationResolvers<ContextType>;
  ReferralProgram?: ReferralProgramResolvers<ContextType>;
  ReferralReward?: ReferralRewardResolvers<ContextType>;
  ReferrerInvitationContent?: ReferrerInvitationContentResolvers<ContextType>;
  RelativeRisk?: RelativeRiskResolvers<ContextType>;
  RemoteCheckingAccount?: RemoteCheckingAccountResolvers<ContextType>;
  RemoveTheirExternalAccountEnvelopeMutationPayload?: RemoveTheirExternalAccountEnvelopeMutationPayloadResolvers<ContextType>;
  ResendPersonalReferralInvitationMutationPayload?: ResendPersonalReferralInvitationMutationPayloadResolvers<ContextType>;
  RetirementContributionRecommendation?: RetirementContributionRecommendationResolvers<ContextType>;
  RetirementGrowthPurposeCreationOption?: RetirementGrowthPurposeCreationOptionResolvers<ContextType>;
  RetirementIncomePurposeCreationOption?: RetirementIncomePurposeCreationOptionResolvers<ContextType>;
  RevokeMobileTokenMutationPayload?: RevokeMobileTokenMutationPayloadResolvers<ContextType>;
  RewardProgressStatus?: RewardProgressStatusResolvers<ContextType>;
  RewardTier?: RewardTierResolvers<ContextType>;
  RiskBasedAssetAllocation?: RiskBasedAssetAllocationResolvers<ContextType>;
  RiskLevel?: RiskLevelResolvers<ContextType>;
  RiskLevelBasedPortfolio?: RiskLevelBasedPortfolioResolvers<ContextType>;
  RolloverOption?: RolloverOptionResolvers<ContextType>;
  RothIraConversionOption?: RothIraConversionOptionResolvers<ContextType>;
  SavingsPlan?: SavingsPlanResolvers<ContextType>;
  ScheduledEventConfiguration?: ScheduledEventConfigurationResolvers<ContextType>;
  SecuritiesLending?: SecuritiesLendingResolvers<ContextType>;
  Security?: SecurityResolvers<ContextType>;
  SecurityFund?: SecurityFundResolvers<ContextType>;
  SecurityGroup?: SecurityGroupResolvers<ContextType>;
  SecurityGroupPosition?: SecurityGroupPositionResolvers<ContextType>;
  SecurityPosition?: SecurityPositionResolvers<ContextType>;
  SecurityPositionsBySecurity?: SecurityPositionsBySecurityResolvers<ContextType>;
  SecurityPositionsBySubAccount?: SecurityPositionsBySubAccountResolvers<ContextType>;
  SecurityStock?: SecurityStockResolvers<ContextType>;
  SelfDirectedPortfolio?: SelfDirectedPortfolioResolvers<ContextType>;
  SendEmailVerificationEmailMutationPayload?: SendEmailVerificationEmailMutationPayloadResolvers<ContextType>;
  SendWireTransferInstructionsEmailMutationPayload?: SendWireTransferInstructionsEmailMutationPayloadResolvers<ContextType>;
  SendWireTransferInstructionsEmailV2MutationPayload?: SendWireTransferInstructionsEmailV2MutationPayloadResolvers<ContextType>;
  SignablePackage?: SignablePackageResolvers<ContextType>;
  Solo401kInterestRequest?: Solo401kInterestRequestResolvers<ContextType>;
  Solo401kOnboardingOption?: Solo401kOnboardingOptionResolvers<ContextType>;
  SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayload?: SoloFourOhOneKClientEnvelopeFlowCompletionMutationPayloadResolvers<ContextType>;
  SoloFourOhOneKParticipant?: SoloFourOhOneKParticipantResolvers<ContextType>;
  SoloFourOhOneKPlan?: SoloFourOhOneKPlanResolvers<ContextType>;
  SomebodysExternalAccount?: SomebodysExternalAccountResolvers<ContextType>;
  Spouse?: SpouseResolvers<ContextType>;
  StudentLoanPaymentAttestation?: StudentLoanPaymentAttestationResolvers<ContextType>;
  StudentLoanPaymentAttestationEntry?: StudentLoanPaymentAttestationEntryResolvers<ContextType>;
  StudentLoanPaymentEstimate?: StudentLoanPaymentEstimateResolvers<ContextType>;
  SubAccount?: SubAccountResolvers<ContextType>;
  SubmitAdhocDocumentVerificationMutationPayload?: SubmitAdhocDocumentVerificationMutationPayloadResolvers<ContextType>;
  SubmitAdhocDocumentVerificationMutationResult?: SubmitAdhocDocumentVerificationMutationResultResolvers<ContextType>;
  SubmitDocumentVerificationMutationPayload?: SubmitDocumentVerificationMutationPayloadResolvers<ContextType>;
  SubmitDocumentVerificationMutationResult?: SubmitDocumentVerificationMutationResultResolvers<ContextType>;
  SubmitFeedbackMutationPayload?: SubmitFeedbackMutationPayloadResolvers<ContextType>;
  TIN?: GraphQLScalarType;
  Target?: TargetResolvers<ContextType>;
  TargetAmountAndDate?: TargetAmountAndDateResolvers<ContextType>;
  TargetBasedPurposeOption?: TargetBasedPurposeOptionResolvers<ContextType>;
  TargetMonthlyExpenses?: TargetMonthlyExpensesResolvers<ContextType>;
  TargetRetirementSavings?: TargetRetirementSavingsResolvers<ContextType>;
  TargetRetirementSpending?: TargetRetirementSpendingResolvers<ContextType>;
  TaxCoordinationAccountOption?: TaxCoordinationAccountOptionResolvers<ContextType>;
  TaxImpact?: TaxImpactResolvers<ContextType>;
  TaxImpactCopy?: TaxImpactCopyResolvers<ContextType>;
  TaxYear?: TaxYearResolvers<ContextType>;
  TermsAndAgreements?: TermsAndAgreementsResolvers<ContextType>;
  TheirExternalAccount?: TheirExternalAccountResolvers<ContextType>;
  TheirLegalSubAccount?: TheirLegalSubAccountResolvers<ContextType>;
  ThemedAsset?: ThemedAssetResolvers<ContextType>;
  Ticker?: TickerResolvers<ContextType>;
  TimeWeightedRateOfReturn?: TimeWeightedRateOfReturnResolvers<ContextType>;
  TransactionOption?: TransactionOptionResolvers<ContextType>;
  TransactionRequest?: TransactionRequestResolvers<ContextType>;
  TransactionSuccessGuidance?: TransactionSuccessGuidanceResolvers<ContextType>;
  TransferOption?: TransferOptionResolvers<ContextType>;
  TransferableAccount?: TransferableAccountResolvers<ContextType>;
  TransferableAccountOption?: TransferableAccountOptionResolvers<ContextType>;
  Trust?: TrustResolvers<ContextType>;
  TrustOwnershipOption?: TrustOwnershipOptionResolvers<ContextType>;
  TrustedContact?: TrustedContactResolvers<ContextType>;
  URL?: GraphQLScalarType;
  UpdateAccountNameMutationPayload?: UpdateAccountNameMutationPayloadResolvers<ContextType>;
  UpdateAdvisorNetworkIntentMutationPayload?: UpdateAdvisorNetworkIntentMutationPayloadResolvers<ContextType>;
  UpdateCheckingBeneficiaryMutationPayload?: UpdateCheckingBeneficiaryMutationPayloadResolvers<ContextType>;
  UpdateEnvelopeOrdersMutationPayload?: UpdateEnvelopeOrdersMutationPayloadResolvers<ContextType>;
  UpdateExternalAccountVisibilityMutationPayload?: UpdateExternalAccountVisibilityMutationPayloadResolvers<ContextType>;
  UpdateFinancialProfileRetirementAssumptionsMutationPayload?: UpdateFinancialProfileRetirementAssumptionsMutationPayloadResolvers<ContextType>;
  UpdateLegalAccountBeneficiariesMutationPayload?: UpdateLegalAccountBeneficiariesMutationPayloadResolvers<ContextType>;
  UpdateSecuritiesLendingEnrollmentMutationPayload?: UpdateSecuritiesLendingEnrollmentMutationPayloadResolvers<ContextType>;
  UpdateStudentLoanPaymentBenefitAttestationMutationPayload?: UpdateStudentLoanPaymentBenefitAttestationMutationPayloadResolvers<ContextType>;
  UpdateStudentLoanPaymentBenefitEstimateMutationPayload?: UpdateStudentLoanPaymentBenefitEstimateMutationPayloadResolvers<ContextType>;
  UpdateTrustedContactMutationPayload?: UpdateTrustedContactMutationPayloadResolvers<ContextType>;
  UpdateUserInvestingExperienceMutationPayload?: UpdateUserInvestingExperienceMutationPayloadResolvers<ContextType>;
  UpdateUserPostalAddressMutationPayload?: UpdateUserPostalAddressMutationPayloadResolvers<ContextType>;
  UpdateUserProfileMutationPayload?: UpdateUserProfileMutationPayloadResolvers<ContextType>;
  UploadAddressChangeDocumentMutationPayload?: UploadAddressChangeDocumentMutationPayloadResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserLevelSettings?: UserLevelSettingsResolvers<ContextType>;
  ValidateDirectTradingJointAccountSecondaryUserMutationPayload?: ValidateDirectTradingJointAccountSecondaryUserMutationPayloadResolvers<ContextType>;
  ValidateDirectTradingTrustDetailsMutationPayload?: ValidateDirectTradingTrustDetailsMutationPayloadResolvers<ContextType>;
  ValidateFinancialSecurityOrderRequest?: ValidateFinancialSecurityOrderRequestResolvers<ContextType>;
  ValidateFinancialSecurityOrderRequestMutationPayload?: ValidateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType>;
  ValidateLegalAccountBeneficiaryMutationPayload?: ValidateLegalAccountBeneficiaryMutationPayloadResolvers<ContextType>;
  WireTransferInstructions?: WireTransferInstructionsResolvers<ContextType>;
  WireTransferInstructionsItem?: WireTransferInstructionsItemResolvers<ContextType>;
  WireTransferOption?: WireTransferOptionResolvers<ContextType>;
  YieldBasedAssetAllocation?: YieldBasedAssetAllocationResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  maxSupportedVersion?: MaxSupportedVersionDirectiveResolver<any, any, ContextType>;
  operationServiceConfig?: OperationServiceConfigDirectiveResolver<any, any, ContextType>;
  owned?: OwnedDirectiveResolver<any, any, ContextType>;
};
